import itLocale from '@one/one-vue/dist/locale/it.mjs'
import { no } from 'element-plus/es/locales.mjs'

export default {
  cmr_draft: {
    new: {
      origin_place: 'Luogo di origine',
      destination_place: 'Luogo di destinazione',
      title: 'Nuova bozza documento di trasporto',
      btn_create: 'Crea',
      cmrNumber: 'NNumero documento di trasporto',
      cmrNumber_required: 'Il numero del documento di trasporto è obbligatorio',
      sendDate: 'Data di invio',
      sendDate_future: 'La data di invio deve essere uguale o successiva alla data attuale',
      vehiclePlate: 'Targa veicolo',
      trailerPlate: 'Targa rimorchio',
      nameTransportist: 'Azienda trasportatore',
      observations: 'Osservazioni',
      save_ok: 'Bozza creata correttamente',
      step_header: 'Intestazione',
      step_lines: 'Righe',
      authorization_section: 'Autorizzazione',
      authorizationNumber: 'Numero di autorizzazione',
      senderAgency: 'Organismo emittente',
      validityPeriod: 'Periodo di validità',
      cargo_general_data: 'Dati generali del carico',
      nature: 'Natura',
      weight: 'Peso',
      unitOfMeasure: 'Unità di misura',
      validityDateFrom: 'Periodo di validità da',
      validityDateTo: 'Periodo di validità a',
      validityDateTo_future: 'La data "a" deve essere successiva alla data attuale',
      origin_place_seller_centres_exclusive: 'Se compili il luogo di origine non puoi aggiungere centri venditore',
      destination_place_seller_centres_exclusive: 'Se compili il luogo di destinazione non puoi aggiungere centri venditore',
      destination_place_buyer_centres_exclusive: 'Se compili il luogo di destinazione non puoi aggiungere centri acquirente'
    },
    stops: {
      title: 'Fermate',
      no_stops: 'Nessuna fermata',
      add_stop: 'Aggiungi fermata',
      add_stop_title: 'Aggiungi fermata',
      delete_stop: 'Elimina fermata',
      ship_from: 'Origine',
      final_destination: 'Fermata per destinazione finale',
      stop_place: 'Destinazione',
      final_destination_required: 'Non e stata creata alcuna fermata per la destinazione finale. E obbligatorio creare la fermata corrispondente a questa destinazione e il valore deve coincidere esattamente con il dato indicato nel campo Luogo di destinazione (virgole, punti, altri caratteri, ecc.). Controlla i dati e aggiungi la fermata per la destinazione finale.',
      lines_required_for_stops: 'Se e presente una o piu fermate:<br>- Deve esserci obbligatoriamente una o piu righe<br>- Non possono esserci righe senza riferimento a una fermata<br>- Deve esserci almeno una riga che faccia riferimento a ciascuna delle fermate definite',
      creation_date: 'Data di creazione',
      confirm_delete_stop: 'Desideri eliminare questa fermata?',
      stop_added: 'Fermata aggiunta correttamente',
      stop_deleted: 'Fermata eliminata correttamente'
    },
    buttons: {
      delete_draft_tooltip: 'Elimina bozza',
      duplicate_tooltip: 'Copia bozza'
    },
    messages: {
      duplicate_confirm: 'Vuoi copiare questa bozza?',
      duplicate_ok: 'Bozza copiata correttamente'
    }
  },
  cmr_lines: {
    table: {
      line_number: 'Numero riga',
      description: 'Descrizione/Natura',
      article_code: 'Codice articolo',
      article_code_seller: 'Codice venditore',
      quantity: 'Quantità',
      weight: 'Peso',
      unit_of_measure: 'Unità di misura'
    },
    form: {
      title: 'Riga del documento di trasporto',
      description: 'Descrizione',
      article_code: 'Codice articolo',
      article_code_seller: 'Codice venditore',
      quantity: 'Quantità',
      weight: 'Peso',
      unit_of_measure: 'Unità di misura'
    },
    buttons: {
      add_line: 'Aggiungi riga',
      add_line_tooltip: 'Aggiungi una nuova riga al documento',
      update_line: 'Aggiorna riga',
      update_line_tooltip: 'Aggiorna la riga selezionata',
      delete: 'Elimina',
      delete_tooltip: 'Elimina righe selezionate',
      submit_for_acceptance: 'Elabora per accettazione',
      delete_draft_tooltip: 'Elimina la bozza del documento di trasporto'
    },
    confirm_delete_line: 'Sei sicuro di voler eliminare questa riga?',
    confirm_delete_lines: 'Sei sicuro di voler eliminare {count} righe?',
    line_added: 'Riga aggiunta correttamente',
    line_updated: 'Riga aggiornata correttamente',
    line_deleted: 'Riga eliminata correttamente',
    lines_deleted: 'Righe eliminate correttamente',
    no_lines_warning: 'Devi aggiungere almeno una riga',
    confirm_pending_status: 'La bozza passerà allo stato in attesa di elaborazione dalla schermata del Documento di trasporto',
    confirm_pending_status_transportist: 'Le informazioni complete sul trasporto non sono incluse (dati obbligatori del trasportatore e targhe). Puoi fornirle in seguito, ma sempre prima dell\'invio. Fai clic su Conferma per continuare e potrai compilare i dati mancanti dalla schermata del Documento di trasporto o Annulla se preferisci aggiungere le informazioni dai bozze.'
  },
  new_coacsu: {
    title: 'Nuovo riepilogo conto commerciale',
    seller: 'Venditore',
    buyer: 'Acquirente',
    summary_number: 'Numero riepilogo conto commerciale',
    issue_date: 'Data di emissione',
    delivery_date: 'Data di consegna',
    additional_data: 'Dati aggiuntivi',
    select_seller: 'Seleziona venditore',
    select_buyer: 'Seleziona acquirente',
    payment_method: 'Metodo di pagamento',
    select_payment_method: 'Seleziona metodo di pagamento',
    payment_date: 'Data di scadenza',
    currency: 'Valuta',
    registration_date: 'Data di registrazione',
    code: 'Codice',
    role: 'Ruolo',
    steps: {
      header: 'Intestazione',
      lines: 'Righe'
    },
    seller_code: 'Codice venditore',
    seller_role: 'Ruolo venditore',
    buyer_code: 'Codice acquirente',
    buyer_role: 'Ruolo acquirente',
    lines: {
      title: 'Righe',
      insert: 'Aggiungere',
      insert_tooltip: 'Aggiungi riga',
      line_number: 'N. riga',
      document_number: 'N. documento',
      issue_date: 'Data di emissione',
      payment_date: 'Data di scadenza',
      total: 'Totale',
      currency: 'Valuta',
      status: 'Stato',
      delete_tooltip: 'Elimina riga',
      back: 'Indietro',
      save: 'Salva',
      save_tooltip: 'Salva le modifiche senza inviare a Editrack',
      generate: 'Crea',
      generate_tooltip: 'Salva e invia COACSU a Editrack',
      generating: 'Invio a Editrack in corso...',
      generate_ok: 'COACSU inviato a Editrack con successo.',
      cancel: 'Annulla',
      dialog_title: 'Seleziona fatture',
      loading_invoices: 'Caricamento fatture...',
      no_invoices: 'Nessuna fattura disponibile con i filtri COACSU attuali.',
      add: 'Aggiungi ({count})',
      delete_confirm: 'Si desidera eliminare questa riga COACSU?',
      delete_confirm_button: 'Conferma',
      lines_saved: 'Righe salvate con successo.'
    },
    duplicate: {
      title: 'Fattura già inclusa',
      message: 'La fattura {invoiceNumber} appartiene già a un riepilogo conto commerciale esistente (ID: {coacsuId}). Vuoi crearne uno nuovo comunque?',
      confirm: 'Crea comunque',
      cancel: 'Annulla'
    },
    errors: {
      summary_number_required: 'Il numero del riepilogo conto commerciale è obbligatorio',
      issue_date_required: 'La data di emissione è obbligatoria',
      payment_date_required: 'La data di scadenza è obbligatoria',
      payment_method_required: 'Il metodo di pagamento è obbligatorio',
      save_error: 'Impossibile salvare il COACSU.',
      load_error: 'Impossibile caricare il dettaglio del COACSU.',
      update_error: 'Impossibile aggiornare il COACSU.',
      create_error: 'Impossibile creare il COACSU.',
      load_invoices: "Impossibile caricare l'elenco delle fatture.",
      save_lines: 'Impossibile salvare le righe.'
    }
  },
  ...itLocale,
  label: 'Italiano',

  date_format: 'DD/MM/YYYY',
  date_format_long: 'DD/MM/YYYY HH:mm:ss',
  date_format_calendar: 'DD/MM/YYYY',
  date_format_month: 'MM/YYYY',
  date_format_long_calendar: '@:date_format_calendar - HH:mm',
  date_format_long_datepicker: '@:date_format_calendar - HH:mm:ss',
  buttons: {
    btnRecovery: 'Reimpostare la password',
    btnEnter: 'Entrare',
    btnNext: 'Successivo',
    btnSend: 'Inviare',
    btnFinish: 'Terminare',
    btnDelete: 'Eliminare',
    btnDeleteAll: 'Eliminare tutti',
    btnDeleteSelected: 'Elimina selezione',
    btnAdd: 'Aggiungere',
    btnSave: 'Salvare',
    btnBack: 'Tornare indietro',
    btnSaveChanges: 'Salvare',
    btnCancelChanges: 'Reset',
    btnCancelChanges_tooltip: 'Annulla modifiche',
    btnSaveChanges_tooltip: 'Salvare modifiche',
    btnSendSaveChanges_tooltip: 'Salva e invia',
    btnCancel: 'Cancellare',
    btnCancel_tooltip: 'Cancellare modifiche',
    btnOk: 'Accettare',
    btnConfirm: 'Confermare',
    btnContinue: 'Continuare',
    btnSign: 'Firmare',
    btnBiometricSign: 'Firma biometrica',
    btnClear: 'Pulito',
    btnDownloadXSL: 'Vedi XSL',
    btnViewMetadata: 'Scarica metadatos',
    btnDownloadLabels: 'Scarica etichette',
    btnDownload: 'Scarica',
    btnDownloadPdf: 'Scarica PDF',
    btnDownloadOrderRsp: 'Scarica la risposta dell ordine',
    btnReSend: 'Invia di nuovo',
    btnCreateInvoice: 'Create rectificative invoice',
    btnShow: 'Mostra',
    btnShow_tooltip: 'Mostra i risultati',
    refresh_tooltip: 'Aggiorna i risultati',
    inicialize_tooltip: 'Ricalcolare',
    btnChangestatus: 'Cambiare stato',
    btnCoacsu: 'Coacsu',
    btnCoacsu_error_different_parties: 'Impossibile creare il COACSU: le fatture selezionate devono avere lo stesso acquirente e lo stesso venditore',
    btnCoacsu_success: 'COACSU creato correttamente',
    btnClose: 'Chiudi',
    btnUpdate: 'Aggiornare'
  },

  msg_generics: {
    no: 'No',
    yes: 'Sì',
    deleting: 'Eliminazione in corso...',
    sending: 'Sta inviando...',
    send_ok: 'Inviato correttamente',
    request_success: 'Richiesta eseguita con successo',
    actual_version: 'Versione corrente',
    error_not_found: 'Il file / i non è stato trovato',
    error_download_not_found: 'Errore nel scaricare. Il file / i non è stato trovato',
    error_download_pdf: 'Impossibile scaricare il PDF. Verificare con il proprio amministratore',
    no_match: 'Nessun risultato',
    delveryNoteLines_selected: 'Le righe selezionate sono le righe che verranno inviate sulla bolla di consegna',
    field_required: 'Campo obbligatorio',
    element_selected: 'Seleziona un elemento',
    min_three_letters: 'Minimo tre lettere',
    number_required: 'E\' richiesto un numero',
    min_num_character: '{min} minimo di caratteri',
    max_num_character: '{max} massimo di caratteri',
    max_value: 'Deve essere inferiore a {max}',
    no_file_selected: 'Nessun file selezionato',
    format_invalid: 'Formato non valido',
    format_invalid_req_csv: "Formato non valido, deve contenere l'estensione CSV",
    quantity_exceded: 'La quantità spedita non può superare la quantità pendente {max}',
    character_invalid: 'carattere non valido',
    max_decimals: 'Massimo {max} decimale',
    max_numeric: 'Massimo {max} cifre',
    format_goods_code_invalid: 'Il formato deve essere XXXX XX XX (4 cifre, uno spazio, due cifre, uno spazio, due cifre).',
    filter_selected: 'Aggiungere il filtro selezionato alla ricerca ...',
    filter_no_selected: 'Devi selezionare un filtro per la ricerca',
    filter_date_required: 'Non puoi eliminarlo. È richiesta una data di intervallo',
    filter_date: 'Cambiare la data della ricerca ...',
    filter_delete: 'Eliminare il filtro e caricare nuovi dati ...',
    filter_delete_all: 'Eliminare tutti i filtri di ricerca ...',
    filter_table_menu: 'Che cosa vuoi visualizzare nella tabella?',
    order_table: 'Ordinare la tabella ...',
    size_table: 'Modificare le dimensioni della tabella ...',
    pagination_table: 'Modificare l\'impaginazione della tabella ...',
    table_select_rows: 'Contiene {num} voci della tabella selezionate',
    load_init: 'Caricamento dati ...',
    loading: 'Caricamento...',
    no_date: 'Non c\'è una data',
    no_quantity: 'Nessuna quantità',
    no_price: 'Nessun prezzo',
    information: 'Informazioni',
    invoiceDetails: 'Dettagli fattura ',
    download_pdf: 'Scaricare PDF...',
    download_csv: 'Scaricare CSV...',
    load_download: 'Scaricare documento...',
    success: 'Successo',
    saving: 'Salvataggio delle modifiche ...',
    warning: 'Attenzione',
    document_downloaded: 'Documento scaricato',
    download_file_ok: 'Scaricare del file {filename} avvenuto con successo',
    download_files_ok: 'Scaricare dei documenti avvenuto con successo',
    download_metadata_ok: 'Scaricare dei metadati avvenuto con successo.',
    success_download: 'Il file {file} è stato scaricato con successo',
    error_download: 'Errore durante lo scaricamento del file',
    error_invalid_link: 'Il collegamento fornito non è valido',
    error_load_data: 'Errore durante il caricamento dei dati',
    error_unauthorized: 'Non hai accesso alle informazioni richieste. Il collegamento è scaduto.',
    order_response_ok: 'L invio della risposta è avvenuto con successo per la ordine {order}',
    update_party: 'Aggiornamento delle aziende...',
    update_party_ok: 'Aggiornamento aziendale riuscito',
    delete_file_ok: 'Eliminazione del file avvenuta con successo',
    download_ok: 'Scaricare avvenuto con successo',
    date_required: 'Seleziona una date',
    date_range_required: 'Seleziona un intervallo di date',
    date_diff_error: 'Non è possibile selezionare un intervallo superiore a un anno',
    date_last_connection: 'Data ultima connessione:',
    download_invoice_original: 'Scaricare....',
    processing: 'In lavorazione....',
    download_invoice_formatted: 'Scaricare l\'custodito formattato....',
    download_metadata: 'Scaricare metadati....',
    upload_invoice: 'Carica factura ...',
    upload_attachment: 'Carica ...',
    upload_parties_massive: 'Aziende di trasformazione ...',
    upload_centres_massive: 'Aziende dei centri ...',
    upload_centre_approval_flow_massive: 'Elaborazione dei flussi di approvazione ...',
    upload_attachment_ok: 'Il caricamento dell\'allegato è avvenuto con successo.',
    upload_issue: 'Creare incidenza...',
    upload_issue_ok: 'Problema creato con successo.',
    issues_load_delete: 'Eliminazione degli incidenti ...',
    redigitize: 'Invio richiesta di redigitalizzante fattura...',
    redigitize_ok: 'La richiesta di ridigitalizzazione è stata inviata con successo',
    load_document: 'Caricare',
    upload_attachment_interlocutor: 'Allegato non visibile all\'interlocutore.',
    add_all_projects: 'Per tutti i servizi',
    all_centres: 'Qualunque società / centro',
    file_selected: 'Seleziona un file',
    iban: 'Il campo Iban è obbligatorio',
    ibanKo: 'L Iban introdotto non è corretto',
    bic: 'Il campo Bic è obbligatorio',
    accountTitular: 'Il campo Titolare del conto è obbligatorio',
    email: 'Il campo email è obbligatorio',
    emailKo: 'L email inserita non è corretta',
    donwloadModelo: 'Scarica la richiesta di modifica dei dati del modello',
    popover_clean_filters: 'Rimuovere i filtri',
    no_pending_task_status: 'Non sono stati trovati stati configurati per il servizio selezionato.',
    what_show: 'Che cosa vuoi visualizzare nella tabella?',
    alter_configuration: 'Este cambio puede alterar las configuraciones del servicio.',
    placeholder: {
      datepicker: 'Seleziona una data'
    },
    date_filter: 'Data',
    date: 'Risoluzione data',
    datepicker: {
      start_placeholder: 'Da',
      separator: '',
      separator_empty: ' ',
      end_placeholder: 'Fino a',
      last_week: 'Ultima settimana',
      last_month: 'Ultimo mese',
      last_three_months: 'Ultimi tre mesi',
      last_year: 'Ultimo anno',
      today: 'Oggi',
      last_two_year: 'Ultimi due anni'

    },
    advanced_search: 'Ricerca avanzata',
    question: {
      yes: 'Si',
      no: 'No'
    },
    validating_data: 'Convalidare i dati',
    all: 'Tutto',
    onlyUserAdmin: 'Solo un utente SuperAdmin può selezionare tutti i servizi.',
    nameDuplicate: 'Nome profilo duplicato',
    taxDuplicate: 'Imposta duplicato',
    tax_legal_text_used: 'Sono presenti righe della fattura con il testo legale rimosso dall\'imposta',
    hostDuplicate: 'Host duplicato',
    detail: 'Dettaglio',
    global: 'Global'
  },

  lateral_menu: {
    invoices: {
      title: 'Fatture',
      emitted: 'Emesse',
      received: 'Ricevute',
      third: 'Terzi',
      drafts: 'Bozze',
      accounting_closes: 'Chiusure contabili',
      draft_accounting_closes: 'Chiusura bozza di contabilità',
      pending_tasks: 'Cose da fare'
    },
    receptions: {
      title: 'Ricevimenti',
      emitted: 'Emessi',
      received: 'Ricevuti'
    },
    carta: {
      title: 'CMR',
      emitted: 'Lettera di vettura'
    },
    delivery: {
      title: 'Note di consegna',
      emitted: 'Emessi',
      received: 'Ricevuti'
    },
    orders: {
      title: 'Ordini',
      emitted: 'Emessi',
      received: 'Ricevuti'
    },
    genrals: {
      title: 'Genrals',
      emitted: 'Emessi',
      received: 'Ricevuti'
    },
    auditory: {
      title: 'Revisione',
      documents: 'Documentazione',
      actions: 'Azioni'
    },
    administration: {
      title: 'Amministrazione',
      projects: 'Servizi',
      parties: 'Aziende',
      users: 'Utenti',
      plannedProcesses: 'Processi pianificati',
      mailTemplates: 'Modello di email',
      profiles: 'Profili',
      taxes: 'Le tasse',
      mailServer: 'Server di posta elettronica',
      communication_method: 'Metodi di comunicazione',
      articles: 'Articoli'
    },
    sales_report: {
      title: 'Rapporto di vendita',
      view: 'Visualizza rapporto'
    },
    inventory_report: {
      title: 'Rapporto di inventario',
      view: 'Visualizza rapporto'
    },
    remadv: {
      title: 'Avviso di liquidazione',
      view: 'Visualizza avviso di liquidazione'
    },
    coacsu: {
      title: 'Riepilogo conto commerciale',
      view: 'Visualizza riepilogo conto commerciale'
    }
  },

  breadcrumb: {
    empty: '',
    details: 'Dettaglio',

    // PERFIL
    profile_init: 'Profilo',
    profile_general_data: 'Informazioni generali',
    profile_password: 'Password',
    profile_media_contact: 'Contatti',
    profile_parties: 'Aziende',
    profile_signature: 'Delega della firma',

    // FACTURAS
    invoices_init: 'Fatture',
    invoices_emitted: '@:breadcrumb.invoices_init' + ' - Emesse',
    invoices_received: '@:breadcrumb.invoices_init - Ricevute',
    invoices_third: '@:breadcrumb.invoices_init - Terzi',
    invoices_drafts: '@:breadcrumb.invoices_init - Bozze',
    invoices_ocr: '@:breadcrumb.invoices_init - In attesa di convalida',
    invoices_new_invoice: 'Nuova fattura',
    invoices_accounting_closes: '@:breadcrumb.invoices_init - Chiusure contabili',
    reports_init: 'Report',
    reports_emitted: '@:breadcrumb.reports_init - Emessi',
    reports_received: '@:breadcrumb.reports_init - Ricevuti',
    invoices_draft_accounting_closes: '@:breadcrumb.invoices_init - Bozza di chiusure contabi',
    invoices_pending_tasks_title: '@:breadcrumb.invoices_init - Cose da fare',
    invoices_pending_tasks_cover: 'Creare copertura',
    invoices_new_draft_accounting_closes: 'Nuovo chiusure contabili',
    cmr_draft_edit: 'Nuovo documento di trasporto',
    
    // RECEPCIONES
    receptions_init: 'Ricevimenti',
    receptions_emitted: '@:breadcrumb.receptions_init - Emesse',
    receptions_received: '@:breadcrumb.receptions_init - Ricevute',
    receptions_new_invoice: 'Nuova fattura',

    // ALBARANES
    delivery_notes_init: 'Note di consegna',
    delivery_notes_emitted: '@:breadcrumb.delivery_notes_init - Emesse',
    delivery_notes_received: '@:breadcrumb.delivery_notes_init - Ricevute',
    deliverynote_new_invoice: 'Nuova fattura',

    // CMR
    cmr_init: 'Lettere di vettura',
    cmr_draft_init: 'Bozza documento di trasporto',
    cmr_draft_new: 'Nuova bozza',

    // PEDIDOS
    orders_init: 'Ordini',
    orders_emitted: '@:breadcrumb.orders_init - Emesse',
    orders_received: '@:breadcrumb.orders_init - Ricevute',
    orders_new_invoice: 'Nuova fattura',
    orders_new_deliveryNote: 'Nuova bolla di consegna',

    // GENRALS
    genrals_init: 'Genrals',
    genrals_emitted: '@:breadcrumb.genrals_init - Emesse',
    genrals_received: '@:breadcrumb.genrals_init - Ricevute',

    // AUDITORIA
    auditory_init: 'Revisione',
    auditory_documents: '@:breadcrumb.auditory_init - Documentazione',
    auditory_actions: '@:breadcrumb.auditory_init - Azioni',

    // ADMINISTRACION
    administration_init: 'Administration',
    administration_project_projects: '@:breadcrumb.administration_init - Servizi',
    administration_party_parties: '@:breadcrumb.administration_init - Aziende',
    administration_project_add_project: 'Aggiungi servizio',
    administration_project_projectparties: 'Imprese associate',
    administration_project_add_party: 'Aggiungi impresa',
    administration_project_admin_channels: 'Relazioni commerciali',
    administration_project_admin_channels_detail: 'Dettaglio',
    administration_project_admin_centres: 'Centri',
    administration_project_admin_centresOfBuyer: 'Centri acquirenti',
    administration_project_admin_centresOfSeller: 'Centri fornitori',
    administration_project_admin_centresbuyer: 'Centro acquirente',
    administration_project_admin_centresdelivery: 'Luoghi di consegna',
    administration_project_admin_centresinvoicee: 'Centri fatturati',
    administration_users: '@:breadcrumb.administration_init - Utenti',
    administration_users_add_user: 'Aggiungi utenti',
    administration_project_add_centre: 'Aggiungi centro',
    administration_plannedProcesses: '@:breadcrumb.administration_init - Processi pianificati',
    administration_mailTemplates: '@:breadcrumb.administration_init - Modello di posta',
    administration_profiles: '@:breadcrumb.administration_init - Profili',
    administration_taxes: '@:breadcrumb.administration_init - Le tasse',
    administration_mailServer: '@:breadcrumb.administration_init - Server di posta elettronica',
    administration_user_information: '@:breadcrumb.administration_init - Messaggio informativo',
    administration_mailServer_add_new: 'Crear configurazione',
    administration_new: 'Nuovo',
    administration_communication_method: '@:breadcrumb.administration_init - Metodi di comunicazione',
    administration_articles: '@:breadcrumb.administration_init - Articoli',

    // ISSUES
    issues_init: 'Problemi',
    issues_issues: '@:breadcrumb.issues_init',
    issues_add_issue: 'Crear problemi',

    // DOCUMENTACION
    documentation_init: 'Documentazione',
    documentation_documents: '@:breadcrumb.documentation_init',

    // ESTADISTICAS
    statistic_init: 'Estatísticas',
    statistic_emitted: '@:breadcrumb.statistic_init - Volume delle fatture emesse',
    statistic_received: '@:breadcrumb.statistic_init - Volume delle fatture ricevute',
    statistic_other: '@:breadcrumb.statistic_init - Fatture generate da un altro documento, ordine, ricevuta o bolla di consegna',
    statistic_topseller: '@:breadcrumb.statistic_init - I 20 principali fornitori per volume economico e numero di fatture',
    statistic_parties: '@:breadcrumb.statistic_init - Volume di società registrate',
    statistic_rejected: '@:breadcrumb.statistic_init - Fatture: Tipologie di scarto e motivi della risgittonatura',

    // SALESREPORT
    salesreport_init: 'Rapporto di vendita',
    salesreport_view: '@:breadcrumb.salesreport_init',

    // INVENTORY REPORT
    inventoryreport_init: 'Rapporto di inventario',
    inventoryreport_view: '@:breadcrumb.inventoryreport_init',

    // REMADV
    remadv_init: 'Avviso di liquidazione',
    remadv_view: '@:breadcrumb.remadv_init',

    // COACSU
    coacsu_init: 'Riepilogo del conto commerciale',
    coacsu_emitted: '@:breadcrumb.coacsu_init - Emessi',
    coacsu_received: '@:breadcrumb.coacsu_init - Ricevuti',
    coacsu_view: '@:breadcrumb.coacsu_init',
    coacsu_detail: 'Riepilogo conto commerciale',
    new_coacsu: {
      title: 'Nuovo riepilogo del conto commerciale'
    }
  },

  nav_header: {
    profile: 'Profilo',
    logout: 'Terminare la sessione'
  },

  login: {
    welcome: 'Effettuare l\'accesso',
    twoFactorAuth: 'Autenticazione a due fattori',
    cautext: 'TELEFONO ASSISTENZA AGLI UTENTI',
    cautelephone: '91 191 00 00',
    canalcautext: 'Assistenza clienti: 900 365 365',
    titlevocento: 'Portale per l’invio e la consultazione delle fatture',
    textvocento: 'Vocento mette a disposizione di fornitori e clienti una piattaforma online che risponde alle loro esigenze in un unico spazio.',
    titlevocento2: 'SUPPORTO TECNICO',
    horariovocento: 'Orari del servizio clienti',
    horario2vocento: 'Dal lunedì al venerdì: 9:00 - 19:00',
    horario3vocento: 'Orario della Spagna (UTC/GMT +1).',
    horario4vocento: 'Il servizio non è disponibile nei giorni festivi nazionali',
    avisolegal: 'Note legali',
    politica: 'Informativa sulla privacy',
    cookies: 'Politica sui cookie',
    userLabel: 'Utente',
    passLabel: 'Password',
    codeLabel: 'Inserisci il codice di verifica ricevuto nella tua email',
    contratLabel: 'Ancora non godono i benefici di questo servizio?',
    contratLabelRef: 'Chiedici ...',
    helpLabelRef: 'Hai bisogno di aiuto?',
    labelRef1: 'Informazioni di base sulla protezione dei dati:',
    labelRef2: "Redeia tratterà i dati per gestire la registrazione e l'utilizzo del tuo account. Puoi esercitare i tuoi diritti in materia di protezione dei dati scrivendo una e-mail al seguente indirizzo di posta elettronica digame@redeia.com e accedere a tutte le informazioni sul trattamento nella nostra Privacy Policy.",
    labelRef3: 'Premendo “Invio” dichiari di aver letto e compreso il ',
    labelRef4: 'Informativa sulla privacy e condizioni generali.',
    rules: {
      username: 'Inserisci nome utente',
      password: 'Inserisci password',
      email: 'Inserisci una email',
      code: {
        required: 'Inserisci il codice a 5 cifre',
        pattern: 'Il codice deve essere composto da 5 cifre alfanumeriche'
      }
    },
    logging: 'Avvio della sessione...',
    title_new_pass: 'Ripristinare la password',
    message_new_pass: 'Inserire un nome utente relativo al prodotto per continuare',
    emailLabel: 'Email',
    sending: 'Sta inviando...',
    questionLabel: 'Domanda',
    answerLabel: 'Risposta',
    passRecovery: 'Reimpostare la password',
    backLoginForm: 'Tornare indietro',
    error: {
      invalid_user: 'La combinazione nome utente/password non è valida',
      user_not_found: 'Nome utente non trovato.',
      email_without_account: 'Non esiste nessun account relativo a questo nome utente',
      email_sended: 'E\' stata inviata una mail con la nuova password',
      bad_final_form: 'Le informazioni fornite non sono valide',
      invalid_code: 'Il codice è stato utilizzato o è scaduto',
      reeProv_2: 'Errore dnie',
      reeProv_3: 'Errore smartcard',
      reeProv_1: 'Errore. Non c\'è nessun utente inserito',
      reeProv_4: 'Errore certificate',
      reeProv_5: 'Nome utente o password errati Ricorda che hai 3 tentativi',
      reeProv_locked: 'Utente bloccato',
      reeProv_renew: 'credenziali scadute',
      reeProv_exceptionTranslationFilter: 'ExceptionTranslationFilter',
      reeProv_expired: 'Sessione scaduta'
    },
    messageMail: 'Se i dati inseriti sono corretti, il tuo indirizzo email riceverà la tua nuova password.',
    reeClientes: 'Accesso e-Factura client',
    reeCliText: 'Se sei già un cliente registrato puoi accedere al servizio di fatturazione elettronica utilizzando il tuo nome utente e la password',
    reeProveedores: 'Accesso e-Factura al fornitore',
    reeProvText: 'Se sei già un fornitore registrato, puoi accedere al servizio di fatturazione elettronica utilizzando il tuo nome utente e la password',
    logout_correct: 'Sessione terminata correttamente',
    infoBrowser: 'Ottimizzato per Firefox v.67 / Chrome v.74 / Edge v.18'
  },

  // Perfil
  profile: {
    tabs: {
      general_data: 'Informazioni generali',
      password: 'Password',
      contact_data: 'Informazioni di contatto',
      parties: 'Aziende',
      signature_delegation: 'Delega della firma'
    },

    general_data: {
      username: 'Username',
      profile_form: {
        name: {
          label: 'Nome',
          placeholder: 'Nome'
        },
        first_surname: {
          label: 'Primo cognome',
          placeholder: 'Cognome'
        },
        second_surname: {
          label: 'Secondo cognome',
          placeholder: 'Cognome'
        },
        identification_tax_number: {
          label: 'Codice fiscale',
          placeholder: 'Codice fiscale'
        },
        creation_date: {
          label: 'Data di creazione'
        },
        last_connection_date: {
          label: 'Ultima connessione'
        },
        departament: {
          label: 'Reparto'
        }
      },
      load: {
        updating: 'Aggiornamento del profilo ...'
      }
    },

    password: {
      change_password: 'Cambio della password',
      change_first_password: 'È necessario aggiornare la password per continuare',
      change_password_form: {
        old_password: {
          label: 'Password attuale',
          placeholder: 'Password attuale'
        },
        new_password: {
          label: 'Nuova password',
          placeholder: 'Nuova password'
        },
        confirm_password: {
          label: 'Conferma nuova password',
          placeholder: 'Conferma nuova password'
        },
        secret_question: {
          label: 'Domanda segreta',
          placeholder: 'Domanda segreta'
        },
        current_secret_answer: {
          label: 'Risposta segreta attuale',
          placeholder: 'Risposta segreta attuale'
        },
        new_secret_answer: {
          label: 'Risposta segreta nuova',
          placeholder: 'Risposta segreta nuova'
        },
        confirm_secret_answer: {
          label: 'Conferma della nuova risposta segreta',
          placeholder: 'Nuova risposta segreta'
        }
      },
      rules_form: {
        pattern: "La password deve contenere almeno una cifra, una maiuscola, una minuscola e un carattere speciale (!{'@'}#$%^&*_=+-/).",
        pass_eqaul_newpass: 'La nuova password non può essere uguale a quella attuale',
        fobidden_words: 'La nuova password contiene parole proibite',
        pass_equal_user: 'La nuova password non può essere uguale al nome utente',
        newpass_not_equals_confirmation: 'Le password non corrispondono',
        response_equal_newresponse: 'La nuova risposta non può essere la stessa di quella attuale',
        newresponse_not_equals_confirmation: 'Le risposte non coicidono',
        validation_error: 'Errore di validazione. Controllare il modulo.'
      }
    },
    error: {
      password: {
        required: {
          actual: 'Campo obbligatorio: Password attuale',
          nueva: 'Campo obbligatorio: Nuova password',
          repetida: 'Campo obbligatorio: Conferma nuova password',
          pregunta_secreta: 'Campo obbligatorio: Domanda segreta',
          oldSecretAnswer: 'Campo obbligatorio: Risposta segreta attuale',
          newSecretAnswer: 'Campo obbligatorio: Risposta segreta nuova',
          renewSecretAnswer: 'Campo obbligatorio: Conferma della nuova risposta segreta'
        },
        wrongPassword: 'La password corrente inserita non è corretta.',
        format_ko: 'Password errata. La nuova password deve essere compresa tra 12 e 64 caratteri e deve contenere almeno un numero, una lettera minuscola, una lettera maiuscola e un tipo di simbolo alternativo %_.@.',
        forbidden_word: 'Cambia la password. Non puoi usare quel valore per la password.',
        sameAsToday: 'La nuova password inserita è la stessa di quella corrente.',
        sameAsOne: 'La nuova password inserita è già stata utilizzata in precedenza.',
        sameAsUsername: 'La nuova password inserita è uguale al nome utente.',
        wrongConfirmation: 'La conferma della nuova password deve essere uguale alla nuova password.',
        secretAnswer_wrongSecretAnswer: "L'attuale risposta segreta inserita non è corretta.",
        secretAnswer_wrongConfirmation: 'La conferma della risposta segreta non corrisponde a quella precedentemente inserita.',
        maxLength_nueva: 'Lunghezza massima del campo "Nuova password": 64 caratteri',
        minLength_nueva: 'Lunghezza minima del campo "Nuova password": 12 caratteri',
        maxLength_repetida: 'Lunghezza massima del campo "Conferma nuova password": 64 caratteri',
        minLength_repetida: 'Lunghezza minima del campo "Conferma nuova password": 12 caratteri',
        maxLength_secretQuestion: 'Lunghezza massima del campo "Domanda segreta": 255 caratteri',
        maxLength_oldAnswer: 'Lunghezza massima del campo "Risposta segreta attuale": 64 caratteri',
        maxLength_newSecretAnswer: 'Lunghezza massima del campo "Nuova risposta segreta": 64 caratteri',
        maxLength_renewSecretAnswer: 'Lunghezza massima del campo "Conferma nuova risposta segreta": 64 caratteri'
      },
      contact_data: {
        format_email: "Il formato dell'e-mail non è corretto.",
        format_phone: 'Il formato del telefono non è corretto.',
        user_media_exist: "Il supporto selezionato esiste già per l'utente.",
        user_media_not_found: 'Il supporto selezionato non esiste',
        required_id: 'Il parametro userMediaId è richiesto',
        required_type: 'Il tipo di parametro è richiesto',
        required_value: 'È richiesto il valore del parametro'
      },
      general_data: {
        required: {
          name: 'Campo obbligatorio: Nome',
          first_surname: 'Campo obbligatorio: Primo cognome'
        },
        validation: {
          maxLength: {
            name: 'Lunghezza massima del campo "Nome": 50 caratteri',
            first_surname: 'Lunghezza massima del campo Primo cognome": 50 caratteri',
            second_surname: 'Lunghezza massima del campo "Secondo cognome": 50 caratteri',
            id_number: 'Lunghezza massima del campo "Codice fiscale": 20 caratteri'
          }
        }
      },
      parties: {
        validation: {
          maxLength_TaxID: 'Lunghezza massima del campo "Numero di identificazione fiscale": 50 caratteri',
          maxLength_tradeName: 'Lunghezza massima del campo "Nome": 150 caratteri',
          maxLength_gln: 'Lunghezza massima del campo "GLN": 15 caratteri',
          date: "La 'data di registrazione' deve essere antecedente a quella indicata"
        }
      },
      tamanominimo_name: 'Nome: la dimensione minima è di 3 caratteri.',
      tamanominimo_id: 'ID: la dimensione minima è di 3 caratteri.',
      global: 'Si è verificato un errore. Contatta il tuo amministratore.'
    },
    contact: {
      contact_data_form: {
        type: {
          placeholder: 'Seleziona un carattere...'
        }
      },
      rules_form: {
        phone_format: 'Il formato non corrisponde con un numero di telefono',
        email_format: 'Il formato non corrisponde a una email',
        contact_media_exist: 'Lo strumento selezionato esiste già per l\'utente',
        no_contact_media_exist: 'Le informazioni di contatto del tipo di email sono obbligatorie'
      },
      load: {
        add_user_media: 'Aggiungere informazioni di contatto...'
      }
    },

    signature: {
      presentation_title: 'INFORMAZIONI',
      presentation_text: "L'autorizzazione alla firma elettronica concessa a Indra Soluciones Tecnologías de la Información SL (ESB88018098) consente di apporre una firma elettronica alle fatture emesse e generate dalla vostra azienda. Questa firma elettronica garantisce l'origine e assicura l'integrità del contenuto per i vostri clienti, in conformità con l'articolo 2 del Decreto",
      presentation_text2: 'EHA / 962/2007 del 10 aprile.',
      instructions_title: 'ISTRUZIONI',
      instructions_text1: "Una volta compilati i campi di questa voce manuale, verrà generato un documento PDF che dovrà essere firmato elettronicamente con il certificato dell'azienda che emette le fatture.",
      instructions_text2: 'Una volta firmato potrai caricare questo documento PDF in questo ',
      instructions_text2_link: 'collegamento',
      instructions_text2_dir: 'https://servicedesk-onesait.atlassian.net/servicedesk/customer/portal/68',
      instructions_text2b: " di attivare la delega di firma senza alcun costo per l'emittente.",
      instructions_text4: 'Se le fatture elettroniche vengono consegnate a questo servizio con una firma elettronica nel formato richiesto, questa delega di firma non è richiesta.',
      dialog_add_pdf: {
        title: 'Carica documento PDF firmato',
        select_file: 'Seleziona documento',
      },
      profile_signature_form: {
        valueNif: {
          placeholder: 'Inserisci 3 caratteri'
        },
        cargoFir: {
          placeholder: 'Scegli la posizione del firmatario'
        },
        valueFechaDD: {
          placeholder: 'Giorno - Formato DD'
        },
        valueFechaMM: {
          placeholder: 'Mese - Formato MM'
        },
        valueFechaAAAA: {
          placeholder: 'Anno - Formato AAAA'
        },
        resolucion: {
          placeholder: 'Optional'
        }
      },
      cFirman: {
        adm: 'Amministratore',
        apo: 'Procuratore',
        con: 'Amministratore Delegato',
        dir: 'Direttore',
        ger: 'Responsabile',
        rep: 'Rappresentante legale',
        tit: 'Titolare (autonomo)'
      },
      taxIdentificationNumber: {
        label: 'AZIENDA NIF',
        placeholder: 'taxIdentificationNumber'
      },
      corporateName: {
        label: 'RAGIONE SOCIALE AZIENDALE',
        placeholder: 'corporateName'
      },
      cargoFirmante: {
        label: 'QUOTA DI FIRMA',
        placeholder: 'cargoFirmante'
      },
      name: {
        label: 'NOME DEL FIRMER',
        placeholder: 'Nombre'
      },
      first_surname: {
        label: 'PRIMO PRIMO ULTIMO NOME',
        placeholder: 'Apellido'
      },
      second_surname: {
        label: 'SECONDO ULTIMO NOME DEL FIRMA',
        placeholder: 'Apellido'
      },
      dni: {
        label: 'ID FIRMATARIO',
        placeholder: 'ID Firmatario'
      },
      resolucion: {
        label: 'RISOLUZIONE',
        placeholder: 'resolucion'
      },
      fecha: {
        label: 'DATA',
        placeholder: 'fecha'
      },
      poblacionFirma: {
        label: 'POPOLAZIONE IN CUI SARÀ REALIZZATA LA FIRMA',
        placeholder: 'poblacionFirma'
      },
      address: {
        label: 'STREET / AVENUE DELLA SOCIETÀ',
        placeholder: 'address'
      },
      town: {
        label: 'POPOLAZIONE AZIENDALE',
        placeholder: 'town'
      },
      postcode: {
        label: 'CARTOLINA AZIENDALE',
        placeholder: 'postcode'
      },
      province: {
        label: 'PROVINCIA AZIENDALE',
        placeholder: 'province'
      },
      countryName: {
        label: 'PAESE AZIENDALE',
        placeholder: 'countryName'
      },
      countryNameUser: {
        label: 'PAESE DEL FIRMATARIO',
        placeholder: 'countryName'
      },
      dniError: 'Dati errati, si prega di controllare l\'ID del firmatario'
    },

    parties: {
      filters: {
        country: {
          value: 'Nazione',
          placeholder: 'Nazione'
        },
        enabled: {
          value: 'Abilitato/Disabilitato',
          placeholder: 'Scegli...',
          enabled: 'Abilitato',
          disabled: 'Disabilitato'
        },
        person: {
          value: 'Tipologia di persona',
          placeholder: 'Tipologia',
          physical: 'Persona fisica',
          legal: 'Persona giuridica'
        },
        project: {
          value: 'Servizio',
          placeholder: 'Servizio'
        },
        name: {
          value: 'Nome',
          placeholder: 'Nome'
        },
        tax_identification_number: {
          value: 'ID fiscale',
          placeholder: 'ID fiscale'
        }
      },
      entity_table: {
        name: 'Nome',
        tax_identification_number: 'ID fiscale',
        gln: 'GLN',
        enabled: 'Attivo',
        country: 'Stato',
        province: 'Provincia',
        creation_date: 'Creazione',
        business_register: 'R. commerciale',
        project: 'Servizio'
      }
    },

    notify: {
      changes_ok: 'Modifiche salvate con successo'
    }
  },
  // Incidencias
  issues: {
    filters: {
      creation_date: {
        value: 'Data-ora di registrazione',
        placeholder: 'Data di registrazione'
      },
      buyer: {
        value: 'Acquirente',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      issue_type: {
        value: 'Tipo di problemi',
        placeholder: 'Tipo'
      },
      subject: {
        value: 'Affari',
        placeholder: 'Affari'
      },
      priority: {
        value: 'Priorità',
        placeholder: 'Priorità'
      },
      description: {
        value: 'Descrizione',
        placeholder: 'Descrizione'
      }
    },
    historic: {
      title: 'Storia dello Stato',
      no_data: 'Non ci sono stati',
      creationDateTime: 'Data',
      status: 'Stato',
      comment: 'Commenta',
      user: 'Utente',
      addStatus_tooltip: 'Carica nuovo stato',
      addStatus: 'Carica'
    },
    confirm: {
      title_delete: 'Sei sicuro di voler eliminare questo problema?',
      confirm_button_delete: 'Elimina',
      title_add_status: 'Creare nuovo stato',
      confirm_button_add_status: 'Ok'
    },
    notify: {
      delete_ok: 'Il problema è stato eliminato con successo.',
      add_status_ok: 'Lo stato è stato creato con successo.'
    },
    load: {
      delete: 'Eliminazione incidente...',
      add_status: 'Creazione stato...'
    },
    dialog_add_issue: {
      title: 'Creare incidente',
      form_add: {
        type: 'Tipo',
        priority: 'Priorità',
        project: 'Servizio',
        buyer: 'Acquirente',
        seller: 'Venditore',
        subject: 'Soggetto',
        description: 'Descrizione'
      },
      notify: {
        error_issue_unique: "C'è già un problema con quei dati"
      },
      button_add: 'Carica',
      button_add_tooltip: 'Problema di caricamento'
    },
    dialog_add_status: {
      status: 'Stato',
      comment: 'Commenta',
      load_status: 'Creare stato'
    }
  },
  // Facturas emitidas y recibidas
  invoices: {
    filters: {
      creation_date: {
        value: 'Data-ora di registrazione',
        placeholder: 'Data di registrazione'
      },
      buyer: {
        value: 'Acquirente',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      third: {
        value: 'Terzo',
        placeholder: 'Inserisci 3 caratteri'
      },
      issue_date: {
        value: 'Intervallo di date di rilascio',
        placeholder: 'Data di rilascio'
      },
      operation_date: {
        value: 'Intervallo di date di funzionamento',
        placeholder: 'Date di funzionamento'
      },
      modification_date: {
        value: 'Intervallo di date di ultimo stato',
        placeholder: 'Date di stato'
      },
      invoice_number: {
        value: 'Numero di fattura',
        placeholder: 'Numero di fattura'
      },
      client_invoice_number: {
        value: 'Nº/Dati fattura cliente',
        placeholder: 'Nº/Dati fattura cliente'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      document_class: {
        value: 'Classe di fattura',
        placeholder: 'Classe di fattura'
      },
      communication_method: {
        send: {
          value: 'Met. Consegna',
          placeholder: 'Metodo'
        },
        reception: {
          value: 'Met. immissione',
          placeholder: 'Metodo'
        }
      },
      tax_type: {
        value: 'Tipo di imposta',
        placeholder: 'Imposta'
      },
      currency: {
        value: 'Valuta',
        placeholder: 'Valuta'
      },
      order_number: {
        value: 'N° di ordinativo',
        placeholder: 'Ordinativo'
      },
      contract_number: {
        value: 'N° contratto',
        placeholder: 'Contratto'
      },
      delivery_note: {
        value: 'Bolla di consegna',
        placeholder: 'Consegna'
      },
      file_number: {
        value: 'N° pratica',
        placeholder: 'Pratica'
      },
      invoice_series_code: {
        value: 'N° codice di serie',
        placeholder: 'Codice di serie'
      },
      corrective_invoice_number: {
        value: 'N° fattura rettificata',
        placeholder: 'N° fattura rettificata'
      },
      channel: {
        value: 'Canale',
        placeholder: 'Canale'
      },
      register_number: {
        value: 'Nº di registrazione',
        placeholder: 'Nº di registrazione'
      },
      id_invoice: {
        value: 'Id interno',
        placeholder: 'Id interno'
      },
      no_error_status: {
        value: 'Stati esclusi',
        placeholder: 'Stati esclusi',
        rejected: 'Stati rifiutati',
        final: 'Stati finali'
      },
      invoice_type: {
        value: 'Subtipo di fattura',
        placeholder: 'Subtipo'
      },
      invoice_type_document: {
        value: 'Tipo di documento fattura',
        placeholder: 'Tipo'
      },
      total_executable_amount_from: {
        value: 'Importi da',
        placeholder: 'Importi'
      },
      total_executable_amount_to: {
        value: 'Importi fino a',
        placeholder: 'Importi'
      },
      attachments: {
        value: 'Allegati',
        placeholder: 'Scegli...'
      },
      sent: {
        value: 'Inviata',
        placeholder: 'Scegli...'
      },
      rate: {
        value: 'Tasso',
        placeholder: 'Tasso'
      },
      cancellationRequest: {
        value: 'Autorità di cancellazione',
        placeholder: 'Scegli...'
      }
    },
    dialog_add_invoice: {
      title: 'Caricare fattura',
      project: {
        label: 'Servizio',
        placeholder: 'Scegli un servizio'
      },
      format: {
        label: 'Formato',
        placeholder: 'Scegli un formato'
      },
      communication_method: {
        label: 'Metodo di comunicazione',
        placeholder: 'Scegli metodo'
      },
      attachments: {
        label: 'Seleziona allegato',
        error_attachment_extension: 'Formato file non supportato',
        error_attachment_extension_values: 'Il formato deve essere: ',
        error_attachment_size: 'Taglia non consentita. La dimensione massima è {argumento}',
        error_attachment_empty: 'L\'allegato è vuoto, ha dimensione 0',
        error_attachment_duplicated: 'Esiste già un allegato con lo stesso nome'
      },
      button_select_invoice: 'Scegli fattura',
      button_upload: 'Caricare'
    },
    attachment: {
      error_attachment_not_found: 'L\'allegato non esiste.'
    },
    invoices_entity_table: {
      buyer: 'Acquirente',
      seller: 'Venditore',
      thirdParty: 'Terzo',
      invoice_class: 'Classe di fattura',
      invoice_number: 'N° fattura',
      issue_date: 'Data emissione',
      creation_date: 'Data registrazione',
      amount: 'Importo',
      status: 'Stato',
      reception_method: 'Met. immissione',
      communication_method: 'Met. consegna',
      currency: 'Moneta',
      register_number: 'N° di registro',
      series_code: 'Nº serie',
      buyer_generic_centre: 'Centri acquirenti',
      buyer_delivery_centre: 'Luogo di consegna',
      buyer_invoicee_centre: 'Centro di fatturazione',
      buyer_centre: 'Centro dell\'acquirente',
      seller_centre: 'Centri venditori',
      cancellation: 'Cancellazione',
      project: 'Servizio',
      channel: 'Canale',
      id_invoice: 'Id interno',
      accountingDate: 'Data di pubblicazione',
      paymentDate: 'Data di pagamento prevista',
      paymentMethod: 'Metodo di pagamento',
      clientInvoiceNumber: 'Nº/Dati fattura cliente',
      csv_title: 'Esporta in CSV. informazione',
      csv_message: 'Impossibile esportare più di 180.000 record, restringere la ricerca'
      // csv_message: 'Quando si esportano grandi volumi di record, i limiti di tempo e / o dimensione possono essere superati e il file non può essere generato. In questo caso, riprova con meno risultati'

    },
    tooltip: {
      attachments: 'Allegati',
      events: 'Eventi',
      detail: 'Dettaglio',
      downloadPDF: 'Scarica PDF',
      addBuyerCenter: 'Aggiungi centro acquirente',
      original: 'Scarica custodito',
      viewCSV: 'Vedi XSL',
      sent: 'Inviata',
      withTaxes: 'Con imposta',
      withoutTaxes: 'Senza imposta rimbalzate',
      adminApprovalFlow: 'Flusso di approvazione'
    },
    buttons: {
      upload_invoice: 'Carica una fattura',
      upload_invoice_tooltip: 'Carica una fattura',
      upload_profile_tooltip: 'Creare profil0',
      download_invoices: 'PDF',
      download_invoices_tooltip: 'Scaricare fattura in formato PDF',
      download_invoice_signed: 'Custodito',
      download_invoice_signed_tooltip: 'Scaricare custodito',
      download_csv_tooltip: 'Scaricare CSV',
      download_csv_details_tooltip: 'Scarica i dettagli CSV',
      download_csv_details: 'Dettaglio CSV',
      refresh_tooltip: 'Aggiorna le fatture',
      refresh_invoice: 'Aggiornare'
    },
    loading: {
      download_invoices: 'Scaricare fattura in formato PDF...',
      download_invoices_original: 'Scaricare gli custodito...',
      upload_wait: 'Aggiornamento in corso ...'

    },
    error: {
      validation: {
        upload_file_formatoinvalido: 'Il formato del documento non è valido. Il formato consentito è EDI, XML o XSIG.',
        parametro_obligatorio_invoice: 'Il file delle fatture è obbligatorio.',
        parametro_obligatorio_projectId: "L'ID del progetto è obbligatorio.",
        valor_no_en_lista: 'Formato sbagliato; valori possibili: {argumento}',
        parametro_obligatorio_format: 'Il formato è obbligatorio.',
        proyecto_noexiste_noasociado: "Il progetto con ID {argumento} non esiste o non è associato all'utente."
      },
      auditoryEventsSearch_event_code_invalidFormat: 'La fattura non è conforme al formato selezionato.',
      notSupported: 'La versione 1.0 dell\'estensione non è supportata'
    }
  },
  invoice_related_documents_table: {
    date: 'Data di relazione',
    destinationDocument: 'Dº documento',
    destinationDocumentType: 'Tipo di documento'
  },
  invoice_detail: {
    related_documents_no_data: 'Questa fattura non ha documenti correlati',
    source_related_documents: 'Documenti correlati',
    info_message: 'Alcuni campi sono modificabili. Ricorda di premere il pulsante "Salva" per memorizzare le modifiche',
    info_message_download: 'Ricorda che è necessario scaricare il modello per inviare e / o salvare le modifiche',
    buttons: {
      download_invoice: 'PDF',
      download_labels: 'Etichette',
      download_invoice_tooltip: 'Scaricare PDF',
      download_original_signed: 'Orignale',
      download_original_signed_tooltip: 'Scaricare orignale firmato',
      download_original_formatted: 'Formattato',
      download_original_formatted_tooltip: "Scarica l'custodito formattato",
      download_metadata: 'Metadati',
      resend_invoice: 'Inviare nuovamente',
      add_attachment: 'Caricare',
      cancel_invoice: 'Annullamento della fattura',
      visualize_with_xsl: 'XSL',
      redigitize_invoice: 'Ridigitare',
      download_metadata_tooltip: 'Scaricare metadati',
      generate_metadata_tooltip: 'Generare metadatos',
      download_PDF: 'GENERARE PDF CON I DATI INTRODOTTI',
      resend_invoice_tooltip: 'Inviare nuovamente la fattura',
      add_attachment_tooltip: 'Caricare allegato',
      cancel_invoice_tooltip: 'Annullamento della fattura',
      visualize_with_xsl_tooltip: 'Visualizza XSL',
      visualize_with_xml: 'File',
      visualize_with_xml_tooltip: 'Fattura elettronica',
      redigitize_invoice_tooltip: 'Invia richiesta di ridigitare della fattura',
      check_status: 'Stato',
      check_status_tooltip: 'Controlla lo stato',
      check_payment_emit: 'Incasso',
      check_payment_emit_tooltip: 'Dettagli riscossione',
      check_payment: 'Pagamento',
      check_payment_tooltip: 'Dettagli pagamento',
      accept_order: 'Accettare',
      accept_order_tooltip: 'Accettare ordine',
      error_rules_tooltip: 'Rapporto di convalida'

    },
    dialog_error_rules: {
      title: 'Rapporto di convalida',
      code: 'Campo',
      description: 'Descrizione',
      location: 'Percorso'
    },
    dialog_add_buyer_center: {
      // 'Añadir centro comprador'
      title: 'Aggiungi centro acquirente',
      centres: {
        label: 'Centro',
        // 'Elige centro de comprador'
        placeholder: 'Scegli centro acquirente',
		required: 'Centro acquirente obbligatorio'
      }
    },
    dialog_resend_invoice: {
      title: 'Inviare nuovamente la fattura',
      communication_method: {
        label: 'Metodo di consegna',
        placeholder: 'Scegli metodo di consegna'
      },
      get_emails: 'Ricevere e-mail...',
      new_emails: 'Nuove e-mail da inviare (separate da ;)',
      max_emails: 'Massimo 5 e-mail',
      no_emails: 'Inserire almeno un indirizzo e-mail',
      email_format: 'Formato errato delle email inserite (usare ; come separatore, l ultima email non deve finire con ; )',
      multiple_emails: 'Se non sono state inserite e-mail, verranno inoltrate alle e-mail predefinite associate. Se sono state inserite delle e-mail, verranno inviate alle e-mail appena inserite.'
    },
    dialog_redigitize: {
      title: 'Richiesta di redigitalizzante fattura',
      checkboxes: {
        label: 'Motivo dell errore',
        field_bad_captured: 'Campo male catturato',
        field_no_captured: 'Campo non catturato',
        field_incorrect: 'Campo catturato errato (ha un altra posizione nel PDF)',
        field_others: 'Altrui'
      },
      commentary: 'Commento per la scansione'
    },
    dialog_cancel_invoice: {
      title: 'Richiedi la cancellazione della fattura',
      motive: 'Motivo della richiesta di cancellazione'
    },
    dialog_status_data: {
      title: 'Informazioni del stato',
      status: 'Stato',
      motive: 'Motivo',
      description: 'Descrizione',
      date: 'Data',
      registrationCode: 'Codice di registrazione'
    },
    error_code: {
      ERROR_PARTY: 'Mancano dati obbligatori dell\'azienda o non rispetta la validazione prevista.',
      ERROR_LINE_DESCRIPTION: 'Manca la descrizione obbligatoria in qualche riga.',
      ERROR_DIR_CODE: 'Manca il codice DIR3 dell\'ente destinatario.',
      ERROR_PARTY_ENABLE: 'L\'azienda è disattivata.',
      ERROR_SELLER_ADDRESS: 'L\'indirizzo del venditore non è coerente con il suo paese.',
      ERROR_BUYER_ADDRESS: 'L\'indirizzo dell\'acquirente non è coerente con il suo paese.',
      ERROR_PROJECT_PARTY_ENABLE: 'Il rapporto azienda-progetto è disattivato.',
      ERROR_COMMERCIAL_RELATION: 'Non esiste un rapporto commerciale valido tra le due aziende.',
      ERROR_SPONSOR: 'Nessuna delle aziende ha una configurazione sponsor valida.',
      ERROR_CENTRE: 'Manca il centro richiesto oppure quello indicato non è valido.',
      ERROR_UNIQUE_CENTRE: 'I centri indicati non sono unici.',
      ERROR_DUPLICATE_INVOICE: 'Esiste già una fattura duplicata.',
      ERROR_DUPLICATE_RECADV: 'Esiste già una ricezione duplicata.',
      ERROR_DUPLICATE_ORDER: 'Esiste già un ordine duplicato.',
      ERROR_DUPLICATE_ORDER_RSP: 'Esiste già una risposta ordine duplicata.',
      ERROR_DUPLICATE_DELIVERY: 'Esiste già una bolla duplicata.',
      ERROR_DUPLICATE_CMR: 'Esiste già un documento di trasporto duplicato.',
      ERROR_DELIVERY_LINE_BATCH: 'Manca il lotto in qualche riga di bolla.',
      ERROR_DELIVERY_LINE_SERIAL_NUMBER: 'Manca il numero di serie in qualche riga di bolla.',
      ERROR_DELIVERY_LINE_EXPIRATION_DATE: 'Manca la data di scadenza in qualche riga di bolla.',
      ERROR_SEND_DATE: 'La data di invio non può essere precedente ad oggi.',
      ERROR_DELIVERY_LINE_DATES: 'La data di scadenza non è coerente con la data di consegna.',
      ERROR_DELIVERY_LINE_QUANTITY: 'La quantità delle sottorighe non corrisponde alla riga padre.',
      ERROR_DELIVERY_LINE_SUBLINE_REQUIRED: 'Ogni riga deve avere almeno una sottoriga.',
      ERROR_DELIVERY_LINE_PACKAGE_GTIN14: 'Le righe dello stesso imballaggio devono condividere lo stesso GTIN14.',
      ERROR_DOCUMENT_SIGN: 'Il documento deve essere firmato o con firma delegata valida.',
      ERROR_ORDER: 'Manca l\'ordine obbligatorio.',
      ERROR_UNIQUE_ORDER: 'L\'ordine deve essere unico.',
      ERROR_ORDER_FORMAT: 'Il formato dell\'ordine non è valido.',
      ERROR_ISSUER_ORDER: 'Manca l\'ordine dell\'emittente.',
      ERROR_ISSUER_UNIQUE_ORDER: 'L\'ordine dell\'emittente deve essere unico.',
      ERROR_ISSUER_ORDER_FORMAT: 'Il formato dell\'ordine dell\'emittente non è valido.',
      ERROR_INVOICE_NUMBER_FORMAT: 'Il numero di fattura non ha un formato valido.',
      ERROR_EXP: 'Manca il fascicolo obbligatorio.',
      ERROR_UNIQUE_EXP: 'Il fascicolo deve essere unico.',
      ERROR_EXP_FORMAT: 'Il formato del fascicolo non è valido.',
      ERROR_CONTRACT: 'Manca il contratto obbligatorio.',
      ERROR_UNIQUE_CONTRACT: 'Il contratto deve essere unico.',
      ERROR_CONTRACT_FORMAT: 'Il formato del contratto non è valido.',
      ERROR_INVOICE_DATE: 'La data della fattura non è valida.',
      ERROR_OPERATION_DATE: 'La data di operazione non soddisfa la validazione.',
      ERROR_INVOICING_PERIOD: 'Il periodo di fatturazione non è coerente.',
      ERROR_CORRECTIVE_INVOICE: 'La fattura correttiva non soddisfa le condizioni di base.',
      ERROR_CORRECTIVE_INVOICE_MANDATORY: 'Manca il blocco correttivo obbligatorio.',
      ERROR_ISSUER_TYPE: 'Il tipo di emittente non è valido per il documento.',
      ERROR_MODALITY_TYPE: 'La modalità di fattura non è valida.',
      ERROR_PROJECT: 'Manca il progetto oppure quello indicato non è valido.',
      ERROR_INVOICE_PROJECT: 'Il progetto della fattura non è valido.',
      ERROR_INTRASTAT_REQUIRED: 'Mancano i dati Intrastat obbligatori.',
      ERROR_INVOICE_COMMUNICATION_METHOD: 'Il metodo di comunicazione della fattura non è valido.',
      ERROR_SPANISH_TAX_IDENTIFICATION_NUMBER: 'Il NIF o CIF spagnolo non è valido.',
      ERROR_ISSUE_DATE_FUTURE: 'La data di emissione non può essere successiva alla data di registrazione o creazione.',
      ERROR_ISSUE_DATE_PAST: 'La data di emissione non può essere antecedente alla data di registrazione o creazione.',
      ERROR_SIGN: 'Il documento deve essere firmato.',
      ERROR_PROJECT_ATTACHMENT_DIRECTORY: 'Non esiste la directory degli allegati del progetto per la data indicata.',
      ERROR_NUMBER_EXP_FIRST_LINE: 'Il numero del fascicolo può essere indicato solo nella prima riga o in testata.',
      ERROR_NUMBER_CONTRACT_FIRST_LINE: 'Il numero del contratto può essere indicato solo nella prima riga o in testata.',
      ERROR_NUMBER_TRANSACTION_FIRST_LINE: 'Il numero della transazione può essere indicato solo nella prima riga o in testata.',
      ERROR_CHANNEL: 'Il canale o il documento del canale non è valido.',
      ERROR_TOTAL_LINES_WITHOUT_TAXES: 'Il totale delle righe senza imposte non corrisponde.',
      ERROR_TOTAL_LINES_DISCOUNTS_AND_CHARGES: 'Il totale delle righe con sconti e oneri non corrisponde.',
      ERROR_TOTAL_INVOICE: 'Il totale della fattura non corrisponde.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_AND_CHARGES: 'Il totale della fattura con sconti e oneri non corrisponde.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_CHARGES_AND_TAXES: 'Il totale della fattura con sconti, oneri e imposte non corrisponde.',
      ERROR_TOTAL_EXECUTABLE_INVOICE: 'Il totale eseguibile della fattura non corrisponde.',
      ERROR_TOTAL_INVOICE_TAXES: 'Il totale delle imposte della fattura non corrisponde.',
      ERROR_CENTRE_ROLE_TYPE: 'Il ruolo del centro indicato non è valido.',
      ERROR_CENTRE_ROLE_TYPE_BY_VALUES: 'Il centro non soddisfa i valori consentiti per il ruolo indicato.',
      ERROR_DRAFT_CENTRE_ROLE_TYPE_BY_VALUES: 'La bozza del centro non soddisfa i valori consentiti per il ruolo indicato.',
      ERROR_CENTRE_ROLE_TYPE_MANDATORY: 'Manca il centro con il ruolo obbligatorio.',
      ERROR_LINE: 'Il documento deve includere almeno una riga.',
      ERROR_LINE_CODE: 'Manca il codice articolo o riga.',
      ERROR_LINE_ORDER_EXIST: 'Qualche riga non ha un ordine associato.',
      ERROR_PERIOD_DATE_INVOICE: 'Le date del periodo di fattura non sono coerenti.',
      ERROR_SIGNATURE: 'La firma del documento non è valida o non esiste.',
      ERROR_LINE_TRANSACTION_REFERENCE: 'Manca il numero dell\'ordine o il riferimento della transazione in qualche riga.',
      ERROR_RECEIVER_TRANSACTION_REFERENCE: 'Manca il riferimento dell\'ordine del destinatario in testata o righe.',
      ERROR_CENTRE_VOCENTO_WS: 'La convalida dei centri contro il servizio Vocento non è riuscita.',
      ERROR_CURRENCY_EXCHANGE: 'Il tasso di cambio non è valido o mancante.',
      ERROR_IBAN: 'L\'IBAN non è valido.',
      ERROR_VALID_IBAN: 'L\'IBAN non supera la validazione formale.',
      ERROR_LINE_SEQUENCE_NUMBER: 'Il numero di sequenza della riga non è valido.',
      ERROR_PAYMENT_MEAN: 'Il metodo di pagamento non è consentito.',
      ERROR_FILE_SIZE: 'La dimensione totale dei file supera il massimo consentito.',
      ERROR_REGISTRATION_DATA: 'I dati di registrazione non sono validi o sono incompleti.',
      ERROR_REGISTRATION_DATA_INDRAFE: 'I dati di registrazione Indrafe non sono validi o sono incompleti.',
      ERROR_SEQUENCE_NUMBER: 'Il numero di sequenza non è valido.',
      ERROR_INVOICE_BUYER_CENTRE: 'Il centro dell\'acquirente non è valido.',
      ERROR_INVOICE_CENTRE_MASK: 'La maschera del centro di fattura non è valida.',
      ERROR_INVOICE_CENTRE_ROL: 'Il ruolo del centro di fattura non è valido.',
      ERROR_EIFFAGE_VALIDATION_INVOICE_SERVICE: 'La chiamata al servizio esterno di validazione Eiffage non è riuscita.',
      ERROR_INVOICE_BUYER_DIRE: 'Manca o è invalido il codice DIR3 dell\'acquirente.',
      ERROR_CORRECTIVE_SIGN: 'La firma della fattura correttiva non è valida.',
      ERROR_PARTY_NAME: 'Il nome dell\'azienda non è valido o non rispetta il formato.',
      ERROR_LINE_DOCUMENT_CANAL: 'Il documento del canale della riga non è valido.',
      ERROR_INVOICE_CORRECTIVE_METHOD: 'Il metodo di correzione della fattura correttiva non è valido.',
      ERROR_NIF_CODPAIS: 'Il NIF deve includere il prefisso del paese.',
      ERROR_WITHHOLDING_AMOUNT_WITH_TAXABLE_BASE: 'L\'importo della ritenuta non corrisponde alla base imponibile.',
      ERROR_NON_SIMULTANEOUS_TRANSACTION_AND_CONTRACT: 'Non è possibile indicare contemporaneamente ordine e contratto.',
      ERROR_CONTRACT_AND_TRANSACTION_IN_RECADV: 'L\'ordine e il contratto non corrispondono alla ricezione registrata.',
      ERROR_EUR_CURRENCY: 'La valuta deve essere euro.',
      ERROR_CENTRE_PERMANENT_ESTABLISHMENT: 'Il centro permanente non soddisfa la configurazione territoriale.',
      ERROR_IGIC_FROM_CANARY_ISLANDS: 'Manca o non corrisponde l\'IGIC per le Canarie.',
      ERROR_IPSI_FROM_CEUTA: 'Manca o non corrisponde l\'IPSI per Ceuta.',
      ERROR_NUMBER_OF_ATTACHED_FILES: 'Il numero di allegati non è valido.',
      ERROR_ATTACHED_FILES_EXTENSION: 'L\'estensione degli allegati non è consentita.',
      ERROR_TAXES_IN_PROJECT: 'Le imposte indicate non sono consentite per il progetto.',
      ERROR_FILE_FORMAT: 'Il formato del file non è valido.',
      ERROR_TAX_CERO_LEGAL_TEXT: 'Un\'operazione con tipo 0 deve includere un testo legale.',
      ERROR_CORRECTIVE_INVOICE_ORDER_OR_CONTRACT: 'La fattura correttiva deve indicare ordine o contratto.',
      ERROR_CORRECTIVE_REQUIRED: 'Manca il blocco correttivo obbligatorio nella fattura correttiva.',
      ERROR_PARTY_BUYER_ADDRESS_VALUE: 'Il valore dell\'indirizzo dell\'acquirente non è valido.',
      ERROR_SPECIFIC_CANARY: 'La fattura non soddisfa le validazioni specifiche delle Canarie.',
      ERROR_SPECIFIC_CEUTA: 'La fattura non soddisfa le validazioni specifiche di Ceuta.',
      ERROR_PHYSICAL_GLN_REQUIRED: 'Manca il GLN fisico obbligatorio.',
      ERROR_NO_IGIC_IVA: 'Non è possibile indicare contemporaneamente IGIC e IVA.',
      ERROR_EXITS_PAYMENT_DETAILS: 'Mancano informazioni sui metodi di pagamento.',
      ERROR_LINE_FROM_RECADV_PRICE_QUANTITITY_POSITIVE: 'Nelle fatture da ricezione, quantità e prezzo devono essere positivi.',
      ERROR_INVOICE_LINES_NO_NEGATIVE: 'Nelle fatture manuali, quantità e prezzo non possono essere negativi.',
      ERROR_LINE_CORRECTIVE_PRICE_NEGATIVE: 'Nelle fatture correttive, il prezzo deve essere negativo.',
      ERROR_LINE_NO_SAME_TAX: 'Una stessa riga non può ripetere lo stesso tributo.',
      ERROR_INVOICE_FROM_RECADV: 'Non esiste una ricezione corrispondente per la fattura.',
      ERROR_INVOICE_ADDITIONAL_INFO_FROM_RECADV: 'La fattura non corrisponde alle informazioni aggiuntive della ricezione.',
      ERROR_INVOICE_DOCUMENT_VALUES_FROM_RECADV: 'La fattura non corrisponde ai valori del documento della ricezione.',
      ERROR_INVOICE_LINE_DATA_FROM_RECADV: 'La fattura non corrisponde ai dati di riga della ricezione.',
      ERROR_INVOICE_ISSUE_DATE_REJECTED: 'La fattura esiste già con un\'altra data di emissione.',
      ERROR_GENERIC: 'Errore generico'
    },
    invoice_detail_edit_form: {
      status: 'Stato della fattura',
      internalStatus: 'Stato interno della fattura',
      invoice_number: 'Numero della fattura',
      buyer: 'Compratore',
      issue_date: 'Data di emissione',
      communication_send_method: 'Metodo di consegna',
      change_state: {
        label: 'Cambio di stato',
        placeholder: 'Scegli uno stato della fattura'
      },
      change_internal_state: {
        label: 'Cambio di stato interno',
        placeholder: 'Scegli uno stato interno della fattura'
      },
      change_sent_flag: {
        label: 'Stato di spedizione',
        placeholder: 'Scegli uno stato di spedizione'
      },
      total_executable_amount: 'Importo',
      seller: 'Venditore',
      creation_date_time: 'Data di registrazione',
      communication_reception_method: 'Metodo di immissione',
      observations: 'Motivo del cambiamento dello stato',
      internal_observations: 'Motivo del cambiamento dello stato interno',
      pending_task: 'Cose da fare',
      internal_notes: 'Note interne',
      registerNumber: 'Numero di registrazione'
    },
    error: {
      validation: {
        id_invoice_empty: 'L\'identificatore della fattura non può essere nullo',
        field_category_empty: 'Categoria non può essere vuota',
        field_category_incorrect: 'Categoria indicata errata'
      }
    },
    attachment: 'Allegati',
    no_attachment: 'Non ci sono file allegati associati',
    attachments_table: {
      filename: 'Nome',
      category: 'Categoria',
      size: 'Dimensioni',
      compressed_size: 'Misura compressa',
      creation_date: 'Creazione',
      author: 'Creatore'
    },
    payment_table: {
      remasa: 'Spedizione',
      invoice_number: 'N. fattura',
      banco: 'Banca',
      desBanco: 'Descrizione della banca',
      viaPago: 'Metodo di pagamento',
      desViaPago: 'Descrizione del metodo di pagamento',
      fechaAcept: 'Data di accettazione',
      fechaVenc: 'Data di scadenza',
      fechaValor: 'Data valuta',
      moneda: 'Valuta',
      importeDivisa: 'Importo in valuta',
      importeComDivi: 'Importo compensato',
      situacion: 'Stato',
      codigoFianza: 'Codice cauzionale',
      numeroDocumento: 'Documento',
      importe: 'Importo EUR',
      receptorAlternativo: 'Ricevitore alternativo',
      detalleCompensacion: 'Detalle de compensación',
      detalleCompensacionPago: 'Documento/s pago',
      detalleCompensacionCobro: 'Documento/s cobro'

    },
    dialog_add_invoice_attachment: {
      title: 'Carica allegato',
      load_document: 'Carica',
      file_selected: 'Seleziona allegato'
    },
    events: {
      title: 'Eventi',
      code: {
        SIGNED: 'Firmato',
        description: {
          SIGNED: 'Firmato elettronicamente'
        },
        REJECTED: 'Respinta',
        VALIDATE_SIGNATURE: 'Verifica della firma',
        reject: 'Respinta',
        DISAGREEMENT: 'Non conforme',
        PENDING_OF_SIGNING: 'In attesa di firma',
        PENDING_OF_SEND: 'In attesa di invio',
        UPDATE_STATUS: 'Aggiornamento dello stato',
        UPDATE_INTERNAL_STATUS: 'Aggiornamento dello stato interno',
        ADD_ATTACHMENT: 'Aggiungi allegato',
        DELETE_ATTACHMENT: 'Eliminazione allegato',
        RECEIVED: 'Ricevuto',
        SEND_INVOICE: 'Invio della fattura',
        SEND_INVOICE_ORIGIN: 'Spedizione della fattura di origine',
        SEND_STATE: 'Invio dello stato',
        SEND_CANCELINVOICE: 'Domanda di cancellazione',
        PENDING_OF_VERIFYING: 'In attesa di verifica',
        PENDING_OF_GENERATE: 'Generazione in attesa',
        PENDING_OF_VALIDATION: 'In attesa di convalida',
        FORWARD_INVOICE: 'Inoltro fattura',
        CHECK_STATUS_ONLINE: 'Controllo dello stato online',
        NOTIFICATION: 'Notifica',
        RECEPTION_INVOICE: 'Accoglienza di fattura',
        RECEPTION_ORIGINAL_INVOICE: 'Accoglienza di fattura originale',
        YIELDED: 'Ceduto',
        COMPENSATED: 'Compensato',
        PENDING_OF_COMPENSATION: 'Risarcimento in corso',
        PENDING_OF_CONFIRM: 'Essere confermato',
        COLLECTED: 'Addebitato',
        PENDING: 'In attesa di',
        RETAINED_PAYMENT: 'Pagamento trattenuto'
      },
      property: {
        FILE_NAME: 'Nome del file',
        REASON: 'Causa',
        ORIGINAL_STATUS: 'Stato originale',
        FINAL_STATUS: 'Stato finale',
        SIGNATURE_DATE: 'Data della firma',
        DATE: 'Data di validazione in sospeso',
        DISAGREEMENT: 'Non conforme',
        PENDING_OF_SIGNING_DATE: 'Data da firmare',
        PENDING_OF_VERIFYING_DATE: 'Data da verificare',
        RECEPTION_DATE: 'Data di ricezione',
        REJECT_DATE: 'Data del rifiuto',
        MOTIVE: 'Motivo',
        STATUS_BEFORE: 'Stato iniziale',
        LAST_STATUS: 'Stato finale',
        INTERNAL_MOTIVE: 'Motivo interno',
        INTERNAL_STATUS_BEFORE: 'Stato interno iniziale',
        LAST_INTERNAL_STATUS: 'Stato interno finale',
        MESSAGE_RESULT: 'Messaggio di risposta',
        ERROR_CODE: 'Codice di errore',
        ERROR_DESCRIPTION: 'Descrizione del errore',
        ENDPOINT_STATUS: 'Stato cliente',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        DOCUMENT_INTEGRATED: 'Documento integrato',
        INVOICE_ACCEPTED: 'Fattura accettata',
        INVOICE_OPENED: 'Fattura aperta',
        REJECT_CODE: 'Codice di rifiuto',
        REJECT_DESCRIPTION: 'Descrizione del rifiuto',
        REGISTRATION_CODE_PROPERTY: 'Codice di registrazione',
        REGISTRATION_DATE_PROPERTY: 'Data di registrazione',
        ERROR_DOWNLOAD_PROPERTY: 'Motivo del fallimento',
        DOWNLOAD_PROPERTY: 'Motivo del successo',
        DELETE_DIR: 'Cancellato',
        REJECT: 'Rifiutato',
        reject: 'Rifiutato',
        USER: 'Utente',
        USER_NAME: 'Utente',
        signature: {
          no: {
            such: {
              algorithm: {
                exception: {
                  creating: {
                    signature: 'Errore nella firma'
                  }
                }
              }
            }
          }
        },
        PROPERTY_REJECT_CODE: 'Codice di rifiuto',
        PROPERTY_ERROR_CODE: 'Codice di errore',
        PROPERTY_REJECT_DESCRIPTION: 'Descrizione del rifiuto',
        PROPERTY_ERROR_DESCRIPTION: 'Descrizione del errore',
        SIGNATURE_ERROR: 'errore di firma',
        MESSAGE: 'Messaggio',
        RECEPTION_DATE_PLATFORM: 'Data di accoglienza in piattaforma',
        RECEPTION_ORIGINAL_DATE_PLATFORM: 'Data di accoglienza originale in piattaforma',
        SEND_DATE: 'Fattura inviata. Data di invio'
      },
      no_events: 'Non ci sono eventi associati'
    },
    eventsbpm: {
      title: 'Eventi del flusso di approvazione'
    },
    load: {
      update_invoice: 'Aggiornamento informazioni della fattura...',
      resend_invoice: 'Inoltraare questa fattura...',
      collecting_buyer_center: 'Raccogliendo centri dell\'acquirente...',
      add_buyer_center: 'Aggiungere centro dell\'acquirente...',
      download_attachment: 'Scaricare allegato...',
      delete_attachment: 'Eliminare allegati...',
      checking: 'Consulenza ...'
    },
    notification: {
      resend_invoice_ok: 'La fattura è stata inoltrata correttamente',
      resend_invoice_warn_suffix: ' ma si è verificato un errore durante l\'invio',
      add_buyer_center_ok: 'Il centro dell\'acquirente è stato aggiunto correttamente',
      cancel_invoice_ok: 'La fattura è stata cancellata correttamente',
      submit_edit_invoice_ok: 'La fattura è stata pubblicata correttamente',
      resend_invoice_ko_retained: 'La fattura non è stata inviata perché era in uno stato di fermo',
      check_status_invoice_ok: 'Lo stato della fattura è stato verificato correttamente',
      resend_same_project: 'Tutte le fatture devono appartenere allo stesso servizio',
      resend_same_country: 'Le fatture devono avere lo stesso paese destinatario',
      resend_same_emission: 'Tutte le fatture devono essere emesse o ricevute',
      resend_invoices_ok: 'Le fatture sono state inviate con successo',
      resend_not_all: 'Alcune delle fatture non soddisfano le condizioni per il reinvio',
      resend_any: 'Nessuna delle fatture selezionate soddisfa le condizioni di inoltro',
      submit_edit_invoices_ok: 'Stati della fattura aggiornati correttamente',
      no_results_payment: 'Nessun dato trovato per questa fattura'
    }
  },

  // Documentos OCR
  ocr: {
    filters: {
      creation_date: {
        value: 'Fecha de registro',
        placeholder: ''
      },
      ocr_process_date: {
        value: 'Fecha de procesamiento OCR',
        placeholder: ''
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Venditore'
      },
      document_name: {
        value: 'Nome documento',
        placeholder: 'Nome documento'
      },
      document_number: {
        value: 'Nº documento',
        placeholder: 'Nº documento'
      },
      email: {
        value: 'Email emisor',
        placeholder: 'Email emisor'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      documenttype: {
        value: 'Tipo documento',
        placeholder: 'Tipo documento'
      },
      mail_server: {
        value: 'Email receptor',
        placeholder: 'Email receptor'
      }
    },
    documents_entity_table: {
      locked_icon: 'Bloccato',
      document_name: 'Nome documento',
      document_number: 'N° documento',
      email_from: 'Email',
      status_document: 'Stato',
      project: 'Servizio',
      seller: 'Venditore',
      mail_server: 'Email receptor',
      document_type: 'Tipo di documento',
      message_status: 'Messaggio',
      creation_date: 'Data creazione',
      ocr_process_date: 'Data processo OCR',
      locked_at: 'Data blocco',
      locked_by: 'Bloccato da',
      attachments: 'Allegati'
    },
    attachments_table: {
      filename: 'Nome',
      size: 'Tamanho',
      compressed_size: 'T compactado',
      creation_date: 'D. creazione'
    },
    select_placeholder: 'Selezionare...',
    title_ocr_document_validation_page: 'Convalida del documento',
    document_block_label_info: 'Sei in modalità di visualizzazione. Documento bloccato da un altro utente.',
    block_tooltip: 'Bloccato',
    no_ocr_attachment_data: 'Non sono presenti allegati associati',
    ocr_attachment: 'Allegati',
    no_ocr_lines_data: 'Non sono presenti righe associate al documento',
    ocr_lines: 'Righe del documento',
    buttons: {
      reject: 'Rifiutare',
      approve: 'Approvare',
      permanent_lock: 'Bloccare',
      permanent_unlock: 'Sbloccare'
    },
    permanent_lock: {
      confirm_lock: 'Sei sicuro di voler attivare il blocco permanente su questo documento?',
      confirm_unlock: 'Sei sicuro di voler disattivare il blocco permanente su questo documento?',
      locking: 'Bloccando il documento...',
      unlocking: 'Sbloccando il documento...',
      locked_success: 'Documento bloccato permanentemente',
      unlocked_success: 'Documento sbloccato con successo'
    },
    // Formulario de pantalla de validación de documentos
    detail_form: {
      // Información de bloques
      general_data: 'Informazioni sull intestazione',
      supplier_data: 'Informazioni sul fornitore',
      receiver_data: 'Informazioni sul cliente',
      total_data: 'Totali',
      taxes: 'Tasse',
      // Campos información de cabecera
      invoiceNumber: 'Numero della fattura',
      invoiceSeriesCode: 'Codice di serie',
      invoiceDate: 'Data della fattura',
      invoiceType: 'Tipo di fattura',
      invoiceType_ocrValue: 'Valore riconosciuto: ',
      correctiveInvoiceId: 'Rettifica fattura',
      deliveryDate: 'Data di consegna',
      purchaseOrder: 'Ordine',
      // Campos información del proveedor
      nif_tooltip: 'Il NIF è normalizzato, potrebbe non corrispondere al formato indicato nel PDF',
      supplierTaxId: 'identificativo fiscale',
      supplierName: 'Nome',
      supplierAddress: 'Indirizzo',
      supplierIban: 'Conto bancario',
      supplierEmail: 'E-mail',
      // Campos información del cliente
      receiverTaxId: 'identificativo fiscale',
      receiverName: 'Nome',
      receiverAddress: 'Indirizzo',
      buyerCentreCode: 'Codice centro acquisti',
      // Campos totales
      netAmount: 'Base imponibile',
      totalTaxAmount: 'Tasse totali',
      totalAmount: 'Fattura totale',
      totalDisbursements: 'Totale anticipazioni',
      currency: 'Distintivo di valuta'
    },
    taxes_table: {
      // Campos impuestos
      amount: 'Base imponibile',
      taxRate: 'Valutare(%)',
      taxAmount: 'Tassare',
      categoryCode: 'Tipologia fiscale'
    },
    lines_table: {
      // Campos líneas
      productCode: 'Codice',
      amount: 'Quantità',
      description: 'Descrizione',
      quantity: 'Quantità',
      unit: 'Unità',
      unitPrice: 'Prezzo unitario',
      purchaseOrder: 'Ordine'
    },
    document_class: {
      ORIGINAL: 'Originale',
      RECTIFICATIVA: 'Rettificativa'
    },
    send_ocr_document: {
      confirm: {
        params_required: 'Parametri richiesti non trovati',
        title_approve: 'Vuoi approvare la fattura?',
        title_reject: 'Vuoi rifiutare la fattura?',
        confirm_button_send_document: 'Confermare',
        approving: 'Approvazione fattura ...',
        rejecting: 'Rifiuto della fattura ...',
        nextDocumentInfo: 'Il documento successivo è stato caricato per la convalida',
        approve_notification: 'Documento approvato con successo',
        form_notification_error: 'Convalida i campi del modulo errati',
        reject_notification: 'Documento rifiutato con successo'
      }
    }
  },

  // Borradores
  drafts: {
    filters: {
      creation_date: {
        value: 'Data di registrazione',
        placeholder: ''
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      buyer: {
        value: 'Compratore',
        placeholder: 'Inserisci 3 caratteri'
      },
      buyer_centre: {
        value: 'Centro del compratore',
        placeholder: 'Centro'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller_centre: {
        value: 'Centro del venditore',
        placeholder: 'Centro'
      },
      invoice_number: {
        value: 'N° fattura',
        placeholder: 'N° fattura'
      },
      invoice_series_code: {
        value: 'N° di serie',
        placeholder: 'Codice'
      },
      currency: {
        value: 'Valuta',
        placeholder: 'Valuta'
      },
      issue_date: {
        value: 'Intervallo date di emissione',
        placeholder: 'Data eventi'
      },
      operation_date: {
        value: 'Intervallo date di operazione',
        placeholder: 'Data operazione'
      }
    },
    drafts_entity_table: {
      project: 'Servizio',
      buyer: 'Compratore',
      seller: 'Venditore',
      issue_date: 'Data emissione',
      invoice_number: 'N° fattura',
      operation_date: 'Data operazione',
      creation_date: 'Data registrazione',
      total_outstanding_amount: 'Importo totale da pagare',
      total_executable_amount: 'Importo totale eseguibile',
      currency: 'Valuta'
    },
    buttons: {
      create_invoice: 'Creare la fattura'
    }
  },

  draft_detail: {
    info_draft: 'Informazione',
    info_message: 'Alcuni dei campi di informazione della fattura sono modificabili. Ricorda di fare clic sul pulsante Salva per applicare le modifiche',
    copy_draft: 'Copiare',
    edit_draft: 'Modificare',
    copy_draft_tooltip: 'Copiare la bozza della fattura',
    edit_draft_tooltip: 'Modificare la bozza della fattura',
    delete_draft: 'Eliminare',
    delete_draft_tooltip: 'Eliminare la bozza della fattura',
    csv_title: 'Esporta in CSV. Informazione',
    csv_message: 'Impossibile esportare più di {argumento} record, restringere la ricerca',
    draft_detail_edit_form: {
      invoice_number: 'Numero della fattura: ',
      buyer: 'Compratore: ',
      issue_date: 'Data di emissione: ',
      total_executable_amount: 'Importo ({code}): ',
      seller: 'Venditore: ',
      creation_date_time: 'Data di registrazione: ',
      invoice_additional_information: 'Osservazioni: ',
      other_additional_information: 'Altre osservazioni: '
    },
    attachment: 'Allegati',
    no_attachment: 'Non ci sono file allegati associati',
    add_attachment: 'Caricare',
	add_attachment_tooltip: 'Caricare file allegato',

    attachments_table: {
      filename: 'Nome',
      category: 'Categoria',
      size: 'Dimensioni',
      compressedSize: 'Dimensione compressa',
      creationDate: 'Creazione',
      author: 'Autore'
    },
    dialog_copy_draft: {
      title: 'Copiare fattura',
      invoice_number: 'Numero della fattura',
      issue_date: 'Data di emissione',
      copy_documents: 'Copiare allegati',
      button_copy: 'Copiare fattura'
    },
    dialog_add_attachment: {
      title: 'Caricare un file allegato',
      form_dialog_add_attachment: {
        select_file: 'SELEZIONA ALLEGATO'
      },
      button_upload: 'Caricare',
      button_upload_tooltip: 'Caricare un file'
    },
    confirm: {
      title_delete_draft: 'Sei sicuro di voler eliminare questa bozza?',
      confirm_button_delete_draft: 'Eliminare',
      title_delete_attachment: 'Sei sicuro di voler eliminare questo allegato?',
      confirm_button_delete_attachment: 'Eliminare',
      delete_draft: 'Eliminando bozza ...'
    },
    load: {
      init_draft_data: 'Caricare le informazioni della bozza...',
      cancel_edit_draft_data: 'Ripristinare le informazioni della bozza...',
      copy_draft: 'Copiare la bozza...',
      delete_draft: 'Eliminare la bozza...',
      delete_attachment: 'Eliminare allegato...',
      download_attachment: 'Scaricare allegato...'
    },
    notify: {
      copy_draft_ok: 'La bozza è stata copiata correttamente.',
      copy_draft_partial_one: 'La bozza è stata copiata, ma 1 allegato non è stato possibile copiare.',
      copy_draft_partial_many: 'La bozza è stata copiata, ma {count} allegati non è stato possibile copiare.',
      delete_draft_ok: 'La bozza è stata eliminata correttamente.',
      download_attachment_ok: 'Il Scaricare del file "{filename}" è avvenuto con successo.',
      download_attachment_error: 'Impossibile scaricare l\'allegato.',
      delete_attachment_ok: 'Allegato eliminato correttamente.',
      create_cmr_ok: 'Il documento di trasporto è stato creato correttamente.',
      create_draft_ok: 'La bozza è stata creata correttamente.',
    }
  },

  new_invoice: {
    title: 'Nuova fattura',
    steps: {
      header: 'Intestazione',
      extension: 'Estensione',
      lines: 'Righe',
      totals: 'Totali'
    },
    new_invoice_form: {
      select_placeholder: 'Inserisci 3 caratteri',
      format: 'Formato',
      document_class: {
        title: 'Tipo di file',
        COPY: 'Copy',
        ORIGINAL: 'Originale',
        DUPLICATE: 'Duplicate',
        ADDITIONAL_TRANSMISSION: 'Additional',
        REPLACE: 'Rettificativa',
        ADDITION: 'Addition'
      },
      seller: 'Venditore',
      table_centre: {
        code: 'Codice',
        role: 'Ruolo'
      },
      invoice_number: 'Numero di fattura',
      issue_date: 'Data di emissione',
      invoicing_date_from: 'Data iniziale periodo di fatturazione',
      invoicing_date_from_pickerAll: 'Data del periodo di fatturazione',
      currency: 'Valuta',
      exchange_rate: "Tasso di cambio alla valuta dell'acquirente",
      exchange_rate_date: 'Exchange Rate Date',
      extension_type: 'Aggiungere estensione',

      document_type: 'Tipo di documento',
      service: 'Servizio',
      buyer: 'Compratore',
      invoice_series_code: 'Numero di serie',
      operation_date: 'Data di operazione',
      invoicing_date_to: 'Data finale del periodo di fatturazione',
      communication_method: {
        title: 'Metodi di invio',
        placeholder: ''
      },

      additional_data: 'Osservazioni',
      other_additional_data: 'Dati del documento precedente',
      place_issue_description: 'Descrizione luogo di spedizione',
      pc_issue: 'Codice postale del luogo della spedizione',

      corrective_number: 'Numero di fattura rettificata',
      corrective_tax_period_from: 'Data iniziale periodo d\'imposta',
      corrective_tax_period_from_pickerAll: 'Data del periodo d\'imposta',
      corrective_method: {
        title: 'Metodo di rettifica',
        '01': 'Completa rettifica',
        '02': 'Rettifica basata sulle differenze',
        '03': 'Rettifica mediante lo sconto del volume di trading su un periodo',
        '04': 'Autorizzata dall\'agenzia tributaria'
      },

      corrective_series_code: 'Numero di serie',
      corrective_tax_period_to: 'Data finale del periodo d\'imposta',
      corrective_reason: {
        title: 'Motivo della rettifica',
        '01': 'Numero della fattura',
        '02': 'Serie della fattura',
        '03': 'Data della spedizione',
        '04': 'Nome e Cognome/Ragione sociale-emittente',
        '05': 'Nome e cognome/Ragione sociale-ricevente',
        '06': 'Identificazione fiscale emittente/obbligato',
        '07': 'Identificazione fiscale ricevente',
        '08': 'Domicilio emittente/obbligato',
        '09': 'Domicilio ricevente',
        '10': 'Dettaglio operazione',
        '11': 'Percentuale di imponibile da applicare',
        '12': 'Quota tributaria da applicare',
        '13': 'Data/Periodo da applicare',
        '14': 'Tipologia di fattura',
        '15': 'Resoconti legali',
        '16': 'Base imponibile',
        '80': 'Calcolo delle quote trasferite',
        '81': 'Calcolo delle quote ritenute',
        '82': 'Base imponibile modificata per la resa degli imballaggi/confezioni',
        '83': 'Base imponibile modificata per sconti e agevolazioni',
        '84': 'Base imponibile modificata per decisione definitiva, giudiziale o amministrativa',
        '85': 'Base imponibile modificata: commissioni addebitate, non pagate. Dichiarazione di auto constest'
      },
      corrective_invoice: 'Correzione fattura',
      dialog_add_centre: {
        title: 'Aggiungere centro',
        form_add_centre: {
          centre: {
            label: 'Centro',
            placeholder: 'Selezioni centro'
          },
          role: {
            label: 'Ruolo',
            placeholder: 'Selezioni ruolo'
          }
        },
        button_add_centre: 'Aggiungere centro'
      },
      detail_centre: {
        name: 'Nome',
        country: 'Nazione',
        province: 'Provincia',
        town: 'Cittadino',
        address: 'Indirizzo',
        postcode: 'C.Postale'
      },
      rules_form: {
        select_project_first: 'Devi selezionare prima un servizio',
        select_seller_first: 'Devi selezionare prima un venditore',
        issue_date: 'La data di emissione non può essere posteriore alla data attuale',
        operation_date_vs_actual_date: 'La data dell\'operazione non può essere posteriore alla data attuale',
        operation_date_lower_issue_date: 'La data dell\'operazione deve essere antecedente alla data di emissione',
        field_required_corrective_invoice: 'Campo obbligatorio per le fatture rettificative',
        select_cp_first: 'Devi inserire un CP per inserire una descrizione del luogo di rilascio',
        select_cpDescription: 'È necessario inserire una descrizione CP se è stato inserito un CP',
        cp_error: 'Il campo "CP luogo di spedizione" non è valido. Deve essere un valore di 5 cifre'
      },
      load: {
        text_load_data: 'Caricamento dati...',
        text_load_parties: 'Caricamento delle società venditrici e compratrici...',
        text_load_communications_method: 'Caricamento metodi di invio ...',
        text_save_invoice_data: 'Salvataggio informazioni della fattura...',
        text_load_init_data: 'Caricamento delle informazioni iniziali...'
      },
      error: {
        validation: {
          iban: "L'IBAN non è valido",
          swift: 'Il codice SWIFT non è valido'
        },
        required: {
          formatDocumentId: 'Il parametro ID formato è richiesto',
          invoiceId: "L'ID fattura è richiesto",
          swift_code: 'Il codice SWIFT è obbligatorio.',
          country: 'Il Paese è obbligatorio'
        },
        not_found: {
          invoice: 'La fattura non esiste',
          invoiceExtension: "L'estensione associata a questa fattura non esiste"
        },
        recadv_rejected: 'Impossibile fatturare la ricezione perché è rifiutata',
        duplicated_invoice_error_recadv: 'Esiste già una fattura per la ricezione selezionata',
        duplicated_line_invoice_status_error: 'Una delle linee è già fatturata o non può essere fatturata'
      }
    },
    extension: {
      title: 'Aggiungere estensione',
      faceb2b: {
        general_data: 'Dati generali',
        public_sector_information: {
          public_organism_code: 'Codice di organismo pubblico - DIR3',
          contract_reference: 'Riferimento appaltatore della Pubblica Amministrazione'
        },
        buyer_data: 'Dati del compratore',
        receiver_administrative_centre: {
          code: 'Codice del centro ricevente - DIRe',
          name: 'Nome del centro ricevente'
        },
        seller_data: 'Dati del venditore',
        dialog_add_centre: {
          buyer_title: 'Aggiungere centro compratore',
          seller_title: 'Aggiungere centro venditore',
          code: {
            label: 'Codice',
            placeholder: 'Codice'
          },
          name: {
            label: 'Nome',
            placeholder: 'Nome'
          },
          role: {
            label: 'Ruolo',
            placeholder: 'Selezioni ruolo'
          },
          address: {
            label: 'Direzione'
          }
        },
        roles: {
          FISCAL: 'Fiscale',
          PAYER: 'Pagatore',
          BUYER: 'Compratore',
          COLLECTOR: 'Riscossore',
          SELLER: 'Venditore',
          PAYMENT_RECEIVER: 'Recettore di pagamento',
          COLLECTION_RECEIVER: 'Recettore di riscossione',
          ISSUER: 'Emittente'
        },
        validations: {
          public_organism_code_required: 'Questo campo è obbligatorio quando il riferimento del contratto è specificato.'
        },
        add_centre_button: 'Aggiungere centro',
        load: {
          saving_data: 'Conservando dati dell\'estensione'
        }
      }
    },
    new_line_invoice: {
      title: 'Nuova riga di fattura',
      delivery_title: 'Nueva riga di bolla di consegna',
      buttons: {
        add_line: 'Aggiungere',
        update_line: 'Aggiornare',
        add_line_tooltip: 'Aggiungere riga',
        update_line_tooltip: 'Aggiornare riga'
      },
      new_line_invoice_table: {
        concept: 'Descrizione concetto',
        article_code: 'Codice articolo',
        article_code_seller: 'Codice venditore',
        article_code_buyer: 'Codice compratore',
        quantity: 'Quantità',
        quantityTradeUnit: 'Quantità di imballaggio',
        unitOfMeasure: 'Unità di misura',
        measureTradeUnit: 'Unità di misura confezione',
        net_price: 'Prezzo netto',
        total_cost: 'Costo totale',
        batch: 'Lotto',
        serial: 'Numero serie',
        bestbefore: 'Data di scadenza',
        gtin14: 'Codice GTIN14',
        grossAmount: 'Importo lordo',
        grossAmount_tooltip: 'Costo totale con oneri e sconti'
      },
      new_line_invoice_form: {
        description: 'Descrizione',
        article_code: 'Codice articolo',
        quantity: 'Quantità',
        quantityShipped: 'Quantità spedita',
        quantityPending: 'Quantità in sospeso',
        net_price: 'Prezzo netto',
        unit_of_measure: {
          title: 'Unità di misura',
          '01': 'Unità',
          UN: 'Unità',
          '02': 'Ore',
          '03': 'Kilogrammi',
          '04': 'Litri',
          '05': 'Altri',
          '06': 'Casse',
          '07': 'Vassoi',
          '08': 'Barili',
          '09': 'Bidoni',
          '10': 'Buste',
          '11': 'Bombole',
          '12': 'Bottiglie',
          '13': 'Barattoli',
          '14': 'Tetra briks',
          '15': 'Centilitri',
          '16': 'Centimetri',
          '17': 'Secchielli',
          '18': 'Dozzine',
          '19': 'Astucci',
          '20': 'Damigiane',
          '21': 'Grammi',
          '22': 'Kilometri',
          '23': 'Lattine',
          '24': 'Mazzi',
          '25': 'Metri',
          '26': 'Millimetri',
          '27': '6-Packs',
          '28': 'Pacchetti',
          '29': 'Razioni',
          '30': 'Rotoli',
          '31': 'Buste',
          '32': 'Terrine',
          '33': 'Metro cubico-MTQ',
          '34': 'Secondo-SEC',
          '35': 'Watt-WTT',
          PCE: 'Pezzi',
          KGM: 'Chilogrammi',
          MTR: 'Metro lineare',
          TNE: 'Tonnellata',
          LTR: 'Litro',
          MTQ: 'Metro cubo',
          DMQ: 'Dcm. cubo',
          CENT: 'Centinaia',
          MILL: 'Millares',
          MTK: 'M. quadri',
          BOX: 'Scatola',
          BOTL: 'Bottiglia',
          NTBK: 'Taccuino',
          GRM: 'Grammo',
          GRSA: 'Lordo',
          SHEE: 'Foglia',
          GAME: 'Gioco',
          PAR: 'Paio',
          OVLL: 'Palla',
          CARR: 'Reel',
          PACK: 'Pacchetto',
          DOCE: 'Dozzina',
          K: 'K',
          R: 'R',
          B: 'B',
          C62: 'Pezzi'
        },
        additional_data: 'Osservazioni',
        goods_code: 'Codice prodotto',
        goods_code_placeholder: 'Inserisci 3 caratteri',
        weight: 'Peso'
      },
      documents: {
        title: 'Documenti',
        no_documents: 'Non ci sono documenti associati',
        button_add_document: 'Carica',
        button_add_document_tooltip: 'Carica il documento associato'
      },
      documents_table: {
        name: 'Nome',
        seller_receiver: 'Venditore/Ricevitore',
        value: 'Valore',
        date: 'Data',
        line_number: 'Nº riga'
      },
      dialog_add_document: {
        title: 'Aggiungere file',
        form_add: {
          invoice_document: {
            label: 'Documento',
            CONTRACT: 'Contratto / ricezione',
            TRANSACTION: 'Ordine',
            DELIVERY_NOTE: 'Bolla d\'accompagnamento',
            FILE: 'Record',
            ORDER_LINE: 'Nº sequenza / linea',
            DESADV_LINE: 'Riga della bolla di consegna'
          },
          seller: 'Emettitore/Ricevitore',
          value: 'Valore',
          date: 'Data'
        },
        notify: {
          error_type_document_uniqueER: 'Il tipo di documento selezionato deve essere univoco per emettitore / ricevitore',
          error_type_document_unique: 'Il tipo di documento selezionato deve essere univoco'
        },
        button_add: 'Caricare file'
      },
      taxes: {
        title: 'Tasse',
        no_taxes: 'Non ha imposte associate. Devi aggiungerne almeno una.',
        button_add_tax: 'Caricare',
        button_add_tax_tooltip: 'Caricare imposta'
      },
      chargeDiscount: {
        title: 'Aggiungi oneri e sconti',
        table: {
          bi: 'Base imponibile',
          type: 'Tipo',
          description: 'Descrizione',
          rate: 'Aliquota (%)',
          amount: 'Importo'
        },
        form_add: {
          base_amount: 'Base imponibile',
          indicator: 'Indicatore di onere o sconto',
          type: 'Tipo',
          rate: 'Aliquota %',
          amount: 'Importo'
        },
        no_chargeDiscount: 'Non ci sono oneri o sconti associati.',
        button_add_chargeDiscount: 'Carica',
        button_add_chargeDiscount_tooltip: 'Carica onere o sconto',
        types: {
          TD: "Sconto commerciale",
          DPPROPAGO: "Sconto per pagamento anticipato",
          DRAPPEL: "Sconto per volume o rappels",
          CCANSGAE: "Canone società autori (SGAE)"
        },
        indicator: {
          charge: "Onere",
          discount: "Sconto"
        }

      },
      taxes_table: {
        tax_type: 'Imposta',
        rate: 'Tasso (in %)',
        bi: 'Base imponibile',
        amount: 'Importo tassabile',
        type_exemption: {
          title: 'Tipo di esenzione',
          SUBJECT_AND_EXEMPT: 'Oggetto ed esente',
          NOT_SUBJECT: 'Non soggetto',
          SUBJECT_AND_NOT_EXEMPT: 'Oggetto e non esente'
        },
        legal_text: 'Motive'
      },
      dialog_add_tax: {
        title: 'Caricare imposta',
        response: 'Le linee sono state aggiornate con successo',
        responsewithtax: "Le linee sono state aggiornate con successo. Alcune righe avevano già selezionato l'imposta.",
        form_add: {
          tax: 'Tax',
          rate: 'Rate (in %)',
          bi: 'Tax base',
          amount: 'Taxable amount',
          type_exemption: 'Exemption type',
          legal_text: 'Motive',
          motive: 'Motive',
          legaltextlong: 'Motivo o testo legale (campo facoltativo, selezionare solo per operazioni esenti, non imponibili o in regime speciale)'
        },
        validations: {
          no_quantity_no_net_price: 'Deve introdurre prima quantità e prezzo',
          quantity_net_price_incorrect: 'Deve introdurre correttamente quantità e prezzo'
        },
        notify: {
          invoice_line_tax_already_added: 'L\'imposta selezionata è già stata inclusa'
        },
        button_add: 'Caricare',
        button_add_tooltip: 'Caricare imposta'
      },
      load: {
        text_go_detail: 'Caricando dati della linea della fattura...',
        text_go_deliveryNote_detail: 'Caricando dati della linea ...',
        text_add_invoice_line: 'Salvataggio della nuova riga della fattura...',
        text_update_invoice_line: 'Aggiornamento della riga della fattura...',
        text_add_deliveryNote_line: 'Salvataggio della nuova riga ...',
        text_update_deliveryNote_line: 'Aggiornamento della riga ...',
        text_invoice_lines: 'Caricando dati della linea della fattura...',
        text_deliveryNote_lines: 'Caricando dati della linea...',
        text_delete_invoice_line: 'Eliminazione della riga della fattura...',
        text_delete_deliveryNote_line: 'Eliminazione della riga della bolla di consegna...',
        text_add_article: 'Recupero dati dell\'articolo...'
      },
      notify: {
        no_lines_added: 'La fattura deve avere almeno una riga',
        update_deliveryNote_line: 'La quantità di riga è stata aggiornata'
      },
      lines: {
        button_delete_tooltip: 'Elimina le righe selezionate',
        button_delete: 'Elimina'
      },
      confirm: {
        title_delete_invoice_line: 'Vuoi eliminare questa/s linea/s della fattura?',
        confirm_button_delete_invoice_line: 'Confermare',
        title_delete_deliveryNote_line: 'Vuoi eliminare questa linea della bolla di consegna?',
        confirm_button_delete_deliveryNote_line: 'Confermare',
        pending_changes_title: 'Conferma',
        pending_changes_message: 'Ci sono modifiche in sospeso da salvare. Vuoi continuare senza aggiornare?',
        pending_changes_confirm: 'Sì',
        pending_changes_cancel: 'No'
      }
    },
    invoice_totals: {
      title: 'Totale di fattura',
      invoice_totals_form: {
        total_gross_amount: 'Importo netto',
        total_gross_amount_invoice: 'Importo totale lordo della fattura',
        total_general_discounts: 'Totale degli sconti globali',
        total_general_surcharges: 'Totale oneri globali',
        total_gross_amount_before_taxes: 'Importo lordo A.I.',
        total_tax_outputs: 'Totale tasse rimbalzati',
        total_taxes_withheld: 'Totale imposte ritenute',
        invoice_total: 'Totale fattura',
        total_payments_on_account: 'Totale anticipi',
        irpf: '% IRPF',
        total_irpf: 'Totale IRPF',
        payments_on_account_date: 'Data dell\'anticipo',
        subsidies_total: 'Totali sub-versioni',
        total_outstanding_amount: 'Totale da pagare',
        withholding_amount: 'Ritenute',
        withholding_amount_tooltip: 'Importi trattenuti dal pagatore fino al completamento della transazione.',
        withholding_reason: 'Motivo',
        total_reimbursable_expenses: 'Forniture totali',
        total_financial_expenses: 'Spese finanziarie',
        total_executable_amount: 'Totale a riscuotere',
        currency: 'Moneta'
      },
      dialog_global_discounts: {
        title: 'Totale sconti globali',
        add_title: 'Aggiungi sconto globale',
        button_add: 'Aggiungi',
        load: {
          text_add_discount: 'Salvataggio dello sconto globale ...'
        }
      },
      dialog_global_surcharges: {
        title: 'Totale sovrapprezzi globali',
        add_title: 'Aggiungi sovrapprezzo globale',
        button_add: 'Aggiungi',
        text_add_surcharge: 'Salvataggio del sovrapprezzo globale ...'
      },
      dialog_tax_outputs: {
        title: 'Imposte a debito',
        title_with_held: 'Imposte ritenute',
        bi: 'Base imponibile',
        tax_type: 'Tipo di imposta',
        tax_rate: '% Imposta',
        tax_output: 'Tasse applicate',
        tax_with_held: 'Tasse ritenute'
      },
      installments: {
        title: 'Informazioni di scadenza',
        no_installments: 'Non ha dati di scadenza associati.',
        button_add_tax: 'Caricare',
        button_add_tax_tooltip: 'Caricare scadenza',
        no_rate: 'Nessuna tariffa selezionata'
      },
      table_installments: {
        due_date: 'Data',
        amount: 'Importo',
        payment_means: 'Metodo di pagamento',
        iban: 'IBAN',
        bic: 'SWIFT'
      },
      dialog_add_installment: {
        title: 'Caricare i dati della scadenza',
        form_add_installment: {
          due_date: 'Data',
          amount: 'Importo',
          payment_means: {
            title: 'Metodo di pagamento',
            '01': 'In contanti',
            '02': 'Ricevuta domiciliata',
            '03': 'Ricevuta',
            '04': 'Bonifico',
            '05': 'Lettera accettata',
            '06': 'Credito documentario',
            '07': 'Contratto d\'aggiudicazione',
            '08': 'Cambiale',
            '09': 'Cambiale all\'ordine',
            '10': 'Cambiale non all\'ordine',
            '11': 'Assegno',
            '12': 'Sostituzione',
            '13': 'Speciali',
            '14': 'Indennizzo',
            '15': 'Giro postale',
            '16': 'Formato assegno',
            '17': 'Assegno bancario formato',
            '18': 'Pagamento contrassegno',
            '19': 'Pagamento tramite carta',
            '20': 'Pagaré',
            '21': 'Pago a cuenta bancaria',
            '22': 'Efectivo',
            '23': 'Confirming'
          },
          iban: 'IBAN',
          bic: 'SWIFT'
        },
        load: {
          text_add_installment: 'Conservando dato di scadenza...',
          text_delete_installment: 'Elimina scadenza...'
        },
        notify: {
          error_add_installment: 'L\'importo selezionato non può essere maggiore del totale ad eseguire',
          error_add_installment_0: 'L\'importo selezionato non può essere 0',
          error_add_installment_sepa_no_swift: 'Il Paese del codice IBAN non è un Paese del tipo SEPA, devi inserire il codice SWIFT',
          error_add_installment_sepa_no_correct_lenght: 'Il paese con codice "{code"} non è un paese con codice SEPA ' +
            'il codice SWIFT deve avere una lunghezza di 8 o 11.',
          error_add_installment_no_correct_country: 'Il codice del Paese dell\'IBAN non è corretto',
          error_add_installment_incorrect_iban: 'L\'IBAN inserito non è corretto',
          error_character_incorrect_iban: "L'IBAN inserito non è corretto. Non sono consentiti trattini o caratteri speciali"
        },
        button_add: 'Caricare scadenza',
        button_add_tooltip: 'Caricare scadenza'
      },
      button_finish: 'Inviare',
      button_recalculate: 'Ricalcolare',
      button_finish_tooltip: 'Inviare la bozza',
      button_recalculate_tooltip: 'Ricalcolare totali',
      send_invoice: {
        confirm: {
          title_send_invoice: 'Vuoi inviare la fattura?',
          confirm_button_send_invoice: 'Conferma'
        },
        add_attachments: {
          tittle_add_attachments: 'Prima di inviare la fattura, vuoi aggiungere degli allegati?',
          confirm_button_add_attachments: 'Allegare'
        },
        error_no_taxes: 'Non può continuare se non si aggiunge almeno 1 imposta rimbalzate per ogni linea della fattura',
        load: {
          sending_invoice: 'Invio fattura...'
        },
        sendOK: 'La spedizione è andata a buon fine'
      },
      send_delivery: {
        confirm: {
          title_send_delivery: 'Vuoi inviare la bolla di consegna?',
          confirm_button_send_delivery: 'Conferma'
        },
        load: {
          sending_delivery: 'Invio bolla di consegna ...'
        },
        sendOK: 'La spedizione è andata a buon fine'
      },
      tooltip: {
        tax_output: 'Vedere tavola di imposte rimbalzate',
        tax_with_held: 'Vedere tavola di imposte ritenute',
        preview_pdf_title: 'Anteprima di PDF',
        preview_xsl_title: 'Anteprima di XSL',
        preview_xml_title: 'File di metadata',
        preview_label_title: 'Anteprima etichetta'
      },
      load: {
        text_invoice_totals: 'Caricamento totali della fattura...',
        text_recalculate_totals: 'Ricalcolo totali'
      },
      notify: {
        recalculate_totals_ok: 'I totale si ha correttamente recalculado'
      },
      error_no_withholding_amount_when_withholding_reason: 'Questo campo è obbligatorio si se applica ritenzione',
      error_no_payments_on_account_date: 'Questo campo è obbligatorio se viene applicato un anticipo'
    }
  },
  new_deliveryNote: {
    title: 'Nuova bolla di consegna',
    generate_line: 'Genera linea',
    delete_line: 'Elimina linea',
    steps: {
      header: 'Intestazione',
      extension: 'Estensione',
      lines: 'Righe',
      totals: 'Totali'
    },
    new_deliveryNote_form: {
      select_placeholder: 'Inserisci 3 caratteri',
      format: 'Formato',
      document_class: {
        title: 'Tipo di file',
        COPY: 'Copy',
        ORIGINAL: 'Originale',
        DUPLICATE: 'Duplicate',
        ADDITIONAL_TRANSMISSION: 'Additional',
        REPLACE: 'Rettificativa',
        ADDITION: 'Addition'
      },
      seller: 'Venditore',
      table_centre: {
        code: 'Codice',
        role: 'Ruolo'
      },
      deliveryNote_number: 'Numero di bolla di consegna',
      issue_date: 'Data di emissione',
      delivery_date: 'Data di consegna',
      invoicing_date_from: 'Data iniziale periodo di fatturazione',
      invoicing_date_from_pickerAll: 'Data del periodo di fatturazione',
      currency: 'Valuta',
      exchange_rate: "Tasso di cambio alla valuta dell'acquirente",
      exchange_rate_date: 'Exchange Rate Date',
      extension_type: 'Aggiungere estensione',

      document_type: 'Tipo di documento',
      deliveryNote_type: 'Tipo di Albaran',
      service: 'Servizio',
      buyer: 'Compratore',
      deliveryNote_series_code: 'Numero di serie',
      operation_date: 'Data di operazione',
      invoicing_date_to: 'Data finale del periodo di fatturazione',
      communication_method: {
        title: 'Metodi di invio',
        placeholder: ''
      },

      additional_data: 'Osservazioni',
      other_additional_data: 'Altre osservazioni',
      place_issue_description: 'Descrizione luogo di spedizione',
      pc_issue: 'Codice postale del luogo della spedizione',
      buttons: {
        add_package_tooltip: 'Aggiungi nuovo imballaggio',
        delete_package_tooltip: 'Rimuovere imballaggio',
        show_package_lines_tooltip: 'Mostra le righe associate all\'imballaggio',
        show_all_lines: {
          label: 'Mostra linee',
          tooltip: 'Mostra tutte le righe della bolla di consegna'
        }
      },
      dialog_add_package: {
        title: 'Aggiungere imballaggio',
        load_registration: 'Generazione del codice SSCC',
        form_add_package: {
          package_type: {
            label: 'Tipo di imballaggio',
            placeholder: 'Selezioni tipo'
          },
          sscc: {
            label: {
              seller: 'Codice SSCC generato dal provider. Opzionale',
              auto: 'Codice SSCC generato dalla piattaforma'
            },
            placeholder: 'SSCC',
            noexist: 'Non è possibile aggiungere un nuovo pacchetto perché il codice azienda e il numero del pacchetto iniziale non sono stati impostati. Rivolgersi all\'amministratore.'
          }
        }
      },
      dialog_add_centre: {
        title: 'Aggiungere centro',
        form_add_centre: {
          centre: {
            label: 'Centro',
            placeholder: 'Selezioni centro'
          },
          role: {
            label: 'Ruolo',
            placeholder: 'Selezioni ruolo'
          }
        },
        button_add_centre: 'Aggiungere centro'
      },
      detail_centre: {
        name: 'Nome',
        country: 'Nazione',
        province: 'Provincia',
        town: 'Cittadino',
        address: 'Indirizzo',
        postcode: 'C.Postale'
      },
      rules_form: {
        select_project_first: 'Devi selezionare prima un servizio',
        select_seller_first: 'Devi selezionare prima un venditore',
        issue_date: 'La data di emissione non può essere posteriore alla data attuale',
        operation_date_vs_actual_date: 'La data dell\'operazione non può essere posteriore alla data attuale',
        operation_date_lower_issue_date: 'La data dell\'operazione deve essere antecedente alla data di emissione',
        select_cp_first: 'Devi inserire un CP per inserire una descrizione del luogo di rilascio',
        select_cpDescription: 'È necessario inserire una descrizione CP se è stato inserito un CP',
        cp_error: 'Il campo "CP luogo di spedizione" non è valido. Deve essere un valore di 5 cifre',
        select_centre_delivery_point: 'Selezionare un punto di consegna per visualizzare le linee'
      },
      load: {
        text_load_data: 'Caricamento dati...',
        text_load_parties: 'Caricamento delle società venditrici e compratrici...',
        text_load_communications_method: 'Caricamento metodi di invio ...',
        text_save_deliveryNote_data: 'Salvataggio informazioni della bolla di consegna...',
        text_load_init_data: 'Caricamento delle informazioni iniziali...',
        delete_load_deliveryNote: 'Eliminazione della bolla di consegna...'
      },
      notify: {
        deliverynote_data_saved: 'I dati della bolla di consegna sono stati salvati correttamente',
        delete_deliveryNote: 'Eliminare la bolla di consegna?',
        delete_tooltip: 'Elimina bolla di consegna',
        confirm_delete_deliveryNote: 'Elimina',
        delete_deliveryNote_ok: 'Elimina la bozza con successo.'
      },
      error: {
        validation: {
          iban: "L'IBAN non è valido",
          swift: 'Il codice SWIFT non è valido'
        },
        required: {
          formatDocumentId: 'Il parametro ID formato è richiesto',
          deliveryNoteId: "L'ID bolla di consegna è richiesto",
          swift_code: 'Il codice SWIFT è obbligatorio.',
          country: 'Il Paese è obbligatorio'
        },
        not_found: {
          deliveryNote: 'La bolla di consegna non esiste',
          deliveryNoteExtension: "L'estensione associata a questa bolla di consegna non esiste"
        },
        recadv_rejected: 'Impossibile fatturare la ricezione perché è rifiutata',
        duplicated_deliveryNote_error_recadv: 'Esiste già una bolla di consegna per la ricezione selezionata',
        duplicated_line_deliveryNote_error_recadv: 'Una delle linee è già fatturata o non può essere fatturata'
      }
    },
    deliveryNote_package: {
      title: 'Imballaggi',
      form_package: 'Imballaggio',
      popover: {
        all_packages_has_subpackages: 'Tutti gli imballaggi di secondo livello dovranno avere un imballaggio interno',
        all_packages_has_lines: 'Tutti gli imballaggi di ultimo livello devono avere almeno una riga associata',
        all_lines_has_package: 'A tutte le linee deve essere assegnato un imballaggio'
      },
      dialog_move_line_package: {
        title: 'Assegnare l\'imballaggio alle righe',
        buttons: {
          move_line_package: {
            label: 'Assegnare l\'imballaggio',
            tooltip: 'Assegnare l\'imballaggio alle righe'
          }
        }
      },
      load: {
        get_all_lines: 'Caricamento di tutte le righe ...',
        remove_package: 'Rimozione dell\'imballaggio ...',
        get_package_lines: 'Caricamento delle linee di imballaggio ...',
        new_package: 'Aggiunta dell\'imballaggio ...',
        move_line_package: 'Assegnazione degli imballaggi alle linee ...'
      },
      notify: {
        remove_package: 'Vuoi rimuovere l\'imballaggio?'
      }
    }
  },

  // Cierres contables y borradores de cierres contables
  accounting_closes: {
    filters: {
      close_date: {
        value: 'Data di chiusura'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      buyer: {
        value: 'Compratore',
        placeholder: 'Inserisci 3 caratteri'
      },
      invoice_number: {
        value: 'N° fattura',
        placeholder: 'N° fattura'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      accounting_close_name: {
        value: 'Nome chiusura controllata',
        placeholder: 'Nome chiusura'
      },
      start_date: {
        value: 'Data di inizio',
        placeholder: 'Data'
      },
      end_date: {
        value: 'Data di fine',
        placeholder: 'Data'
      }
    },
    entity_table: {
      project: 'Servizio',
      buyer: 'Compratore',
      name: 'Nome',
      close_date_time: 'Data chiusura',
      status: 'Stato',
      start_date: 'Data inizio',
      end_date: 'Data fine',
      child_accounting_close_name: 'Chiusura controllata',
      date_info: 'Data di divulgazione',
      description: 'Descrizione',
      add: 'Aggiungi chiusura',
      close_accounting: 'Chiusura contabile'
    },
    notify: {
      save_changes: 'La chiusura contabile è stata creata correttamente',
      update_changes: 'La chiusura contabile è stata aggiornato correttamente',
      invoices_added: 'Fatture aggiunte correttamente',
      verification_ok: 'La firma di chiusura è corretta',
      verification_ko: 'La firma di chiusura non è corretta',
      result_exceded: 'Non ammessi È necessario restringere la ricerca ad almeno 1000 risultati'
    },
    add_invoices: 'Aggiungi fatture',
    add_selected: 'Aggiungi selezione',
    add_all_invoices: 'Aggiungi tutti fatture',
    new_accounting: 'Nuova chiusura',
    new_accounting_tooltip: 'Creare nuova chiusura contabile',
    validate_signature: 'Verifica della firma'
  },
  accounting_closes_detail: {
    invoices: {
      title: 'Elenco delle fatture',
      no_data: 'Non esistono fatture associate a questa chiusura contabile',
      buyer: 'Compratore',
      seller: 'Venditore',
      invoice_number: 'N° fattura',
      issue_date: 'Data emissione',
      creation_date_time: 'Data registrazione',
      total_executable_amount: 'Importo',
      currency: 'Valuta',
      status: 'Stato',
      project: 'Servizio',
      reception_method: 'Metodo ricezione'
    },
    confirm: {
      title_delete_draft: 'Sei sicuro di voler eliminare questa bozza di chiusura contabile?',
      title_close_draft: 'Sei sicuro di chiudere la chiusura della contabilità?',
      close_ok: 'Bozza chiusa correttamente',
      close_ko: 'Non è stato possibile chiudere la bozza. Contatta il tuo amministratore'
    },
    notify: {
      delete_draft_ok: 'Bozza eliminata'
    }
  },
  issue: {
    type: {
      ERROR_PORTAL: 'Errore del portale',
      PRICE_ERROR: 'Errore di prezzo',
      QUANTITY_ERROR: 'Errore di quantità'
    },
    status: {
      OPEN: 'Apri',
      IN_PROGRESS: 'In corso',
      RESOLVED: 'Risolto'
    },
    priority: {
      value_0: 'Nessuno',
      value_1: 'Basso',
      value_2: 'Media',
      value_3: 'Alto'
    }
  },
  // Tareas pendientes
  pendingtask: {
    error: {
      reject_action: 'Non è possibile rifiutare la fattura al fornitore se non è stata precedentemente rifiutata nel gestionale.'
    },
    filters: {
      creation_date: {
        value: 'Data-ora di registrazione'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      buyer: {
        value: 'Compratore',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      invoice_number: {
        value: 'N° fattura',
        placeholder: 'N° fattura'
      },
      invoice_series_code: {
        value: 'N° codice di serie',
        placeholder: 'Codice'
      },
      corrective_invoice_number: {
        value: 'N° fattura rettificata',
        placeholder: 'N° fattura rettificata'
      },
      total_executable_amount_from: {
        value: 'Importi da',
        placeholder: 'Importi'
      },
      total_executable_amount_to: {
        value: 'Importi fino a',
        placeholder: 'Importi'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      document_class: {
        value: 'Classe di fattura',
        placeholder: 'Classe di fattura'
      },
      registration_number: {
        value: 'N° di registro',
        placeholder: 'Registro'
      },
      reception_method: {
        value: 'Met. immissione',
        placeholder: 'Metodo'
      },
      attachments: {
        value: 'Allegati',
        placeholder: 'Scegli...'
      },
      internal_status: {
        value: 'Stato interno',
        placeholder: 'Stato'
      },
      pending_task: {
        value: 'Attività in sospeso',
        placeholder: 'Scegliere...'
      },
      invoice_type: {
        value: 'Tipo di fattura',
        placeholder: 'Tipo'
      },
      tax_type: {
        value: 'Tipo d\'imposta',
        placeholder: 'Imposta'
      },
      rate: {
        value: 'Tasso',
        placeholder: 'Tasso'
      },
      currency_type: {
        value: 'Tipo di valuta',
        placeholder: 'Valuta'
      },
      order_number: {
        value: 'N° richiesta',
        placeholder: 'Richiesta'
      },
      contract_number: {
        value: 'N° contratto',
        placeholder: 'Contratto'
      },
      delivery_note: {
        value: 'N° bolla di consegna',
        placeholder: 'Bolla di consegna'
      },
      file_number: {
        value: 'N° pratica',
        placeholder: 'Pratica'
      },
      issue_date: {
        value: 'Intervallo date di emissione',
        placeholder: 'Intervallo date'
      },
      operation_date: {
        value: 'Intervallo date operazione',
        placeholder: 'Intervallo date'
      }
    },

    buttons: {
      btnDownloadPdf: 'PDF',
      btnDownloadOriginal: 'Custodito',
      btnDownloadOriginal_tooltip: 'Scaricare custodito',
      btnDownloadMetadata: 'Metadati',
      btnSendInvoice: 'Inviare fattura',
      btnPaymentProposal: 'Inviare proposta',
      btnDownloadPdf_tooltip: 'Scaricare fattura in formato PDF',
      btnDownloadMetadata_tooltip: 'Scaricare metadata',
      btnSendInvoice_tooltip: 'Invia fattura',
      btnPaymentProposal_tooltip: 'Invia lo stato della proposta di pagamento',
      btnApprove: 'Approva',
      btnSend: 'Invia',
      btnCreate: 'Crea/Riavvia',
      btnRejected: 'Rifiutare'
    },

    createcover: {
      noCoverPP: 'Non esiste una copertina per la proposta di pagamento per la fattura ',
      noSendCoverPP: '. Impossibile inviare lo stato della proposta di pagamento.',
      createcover_multiple_ko: 'Le seguenti fatture devono essere in sospeso: ',
      title: 'Flusso di approvazione del documento',
      rbInvoice: 'Copertura della fattura',
      rbPaymentProposal: 'Proposta di pagamento',
      cover: {
        steps: {
          creation: 'Creazione',
          send: 'Inviare'
        },
        titleaux: '1. Seleziona un documento: ',
        title: '1. Documento: ',
        create_ok: 'Le cover sono state create correttamente',
        create: 'Creare una cover',
        btnCover: 'Creare una cover',
        send_ok: 'La/e fattura/e è/sono stata/e inviata/e correttamente',
        send_multiple_ko: 'Se ha enviado correctamente el estado de la propuesta de pago ',
        send_multiple_ko_all: 'No se ha enviado el estado de las propuesta de pago. Revise los errores',

        aprroval: {
          btnAprroval: 'Invia per approvazione',
          notify: 'Invio all\'approvazione'
        },

        signature: {
          btnSignature: 'Invia alla firma',
          notify: 'Inviato alla firma'
        },
        user: {
          title: '2. Utente: ',
          placeholder: 'Introduce un utente',
          user_required: 'Seleziona utente'
        }
      }
    },

    pendingtask_entity_table: {
      buyer: 'Acquirente',
      buyer_centres: 'Centri d\'acquisto',
      seller: 'Venditore',
      num_pendingtask: 'N° fattura',
      issue_date: 'Data emissione',
      creation_date: 'Data registrazione',
      import: 'Importo',
      divisa: 'Divisa',
      status: 'Stati',
      reception_method: 'Met. immissione',
      pendingtask: 'Attività in sospeso',
      internal_status: 'Stato interno',
      internal_notes: 'Note interne',
      register_number: 'Nº di registrazione',
      level_approval: 'Livello di approvazione'

    },

    pendingtask_entity_table_detail: {
      code: 'Codice articolo',
      description: 'Descrizione',
      order: 'Richiesta',
      despatch_quantity: 'Quantità pubblicizzata',
      received_quantity: 'Importo ricevuto',
      accepted_quantity: 'Importo accettato',
      measure: 'Unità di misura',
      price: 'Prezzo unitario',
      currency: 'Divisa',
      status: 'Stati'
    },
    pendingtask_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Scarica PDF',
      download_pdfmultiple_buttons: 'PDF/s',
      download_originalmultiple_buttons: 'Custodito/i',
      download_createrestar_buttons: 'Crea/Riavvia',
      download_sendinvoice_buttons: 'Inviare',
      download_sendstatus_buttons: 'Invia la proposta',

      event_table: {
        events: 'Eventi',
        action: 'Quanto',
        date: 'Date event',
        category: 'Categoria',
        user_origin: 'Utente originario',
        user_destiny: 'Utente destinatario',
        observations: 'Osservazioni',
        no_date: 'Questa fattura non ha eventi'
      },

      attachments_table: {
        attachments: 'Allegati',
        fiename: 'Nome',
        category: 'Categoria',
        size: 'Dimensioni',
        compressedSize: 'Dimensioni compresse',
        hidden: 'Occulto',
        creationDate: 'Data creacione',
        author: 'Creatore',
        no_date: 'Questa fattura non ha un documento allegato',
        load: 'Caricare',
        load_tooltip: 'Caricare allegato',
        Scaricare: 'Scaricare del documento allegato alla fattura...',
        delete: 'Aggiungi allegato alla fattura...',
        delete_ok: 'Il file è stato eliminato correttamente.',
        fileselected: 'Seleziona il file.'
      },

      sap: {
        send: 'Invio della fattura',
        send_ok: 'Fattura inviata',
        send_multiple_ko: 'La factura {fact} debe estar en estado pendiente y no haber sido enviadas previamente.',
        send_multiple_ko_all: 'No se han enviado las facturas. Revise los errores',
        maxselected: 'No puede realizar el envío de más de 10 facturas a la vez.'

      },

      paymentproposal: {
        send: 'Invio dello stato di pagamento proposto',
        send_ok: 'Inviato stato proposto',
        name: 'Nome proposta di pagamento',
        invoicenumber: 'N° fattura',
        status: 'Stato',
        description: 'Descrizione',
        title: 'Proposta di pagamento',
        btnsend: 'Sottoscrivi'
      },

      rejectedinvoice: {
        title: 'Rifiuta fattura',
        status: 'Stato attuale',
        statusnext: 'Prossimo stato',
        category: 'Categoria',
        motive: 'Motivo del rifiuto',
        motive_required: 'Motivo obbligatorio',
        categoryselected: 'Seleziona categoria',
        rejected: 'Rifiuta fattura',
        rejected_ok: 'La fattura è stata respinta correttamente',
        statusrejected: 'Respinto'
      },

      approveinvoice: {
        title1: 'Approvare la fattura',
        title2: 'Invia fattura',
        status: 'Livello attuale',
        statusnext: 'Livello successivo',
        category: 'Categoría',
        motive: 'Commento',
        motive_required: 'Commento obbligatorio',
        categoryselected: 'Selezionare',
        approved: 'Approvazione della fattura',
        approved_ok: 'La fattura è stata approvata con successo',
        send: 'Invio della fattura',
        send_ok: 'La fattura è stata inviata con successo',
        field: 'Campo',
        value: 'Valore'
      },

      internal_notes: {
        title: 'Note interne'
      },

      notify: {
        save: 'Aggiornamento dei dati di fatturazione',
        download: 'Il scaricare del file {file} era corretto.',
        download_multiple: 'Il Scaricare è andato a buon fine.',
        selected_service: ' Seleziona un servizio',
        save_field: 'Salvataggio dei campi...',
        save_field_ok: 'Campi salvati correttamente.',
        delete_fields: 'Eliminazione campi...',
        delete_fields_ok: 'I campi sono stati rimossi con successo.'
      }
    }
  },

  auditory: {
    filters: {
      input_date: {
        value: 'Data-ora di inserimento'
      },
      sender: {
        value: 'Emittente',
        placeholder: 'Emittente'
      },
      receiver: {
        value: 'Ricevitore',
        placeholder: 'Ricevitore'
      },
      filename: {
        value: 'Nome del file',
        placeholder: 'Nome del file'
      },
      document_number: {
        value: 'Numero del documento',
        placeholder: 'Numero del documento'
      },
      document_type: {
        value: 'Tipo di documento',
        placeholder: 'Tipo'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      batch: {
        value: 'Lotto',
        placeholder: 'Selezionare...'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      inFormat: {
        value: 'Formato di input',
        placeholder: 'Formato di input'
      },
      outFormat: {
        value: 'Formato di output',
        placeholder: 'Formato di output'
      },
      visible: {
        value: 'Visible',
        placeholder: 'Scegliere...'
      },
      sonFrom: {
        value: 'N. docs. bambini di',
        placeholder: 'N. di doc. bambini di'
      },
      sonTo: {
        value: 'N. docs. bambini su',
        placeholder: 'N. di doc. bambini su'
      },
      processingTimeFrom: {
        value: 'Tempo di elaborazione a partire da',
        placeholder: 'Tempo di elaborazione a partire da'
      },
      processingTimeTo: {
        value: 'Tempo di elaborazione fino a',
        placeholder: 'Tempo di elaborazione fino a'
      },
      communication_method: {
        value: 'Protocollo di comunicazione',
        placeholder: 'Protocollo'
      },
      audit_document_module: {
        value: 'Modulo',
        placeholder: 'Modulo'
      },
      user: {
        value: 'Utente',
        placeholder: 'Utente'
      },
      action: {
        value: 'Azione',
        placeholder: 'Azione'
      },
      group: {
        value: 'Gruppo funzionale',
        placeholder: 'Gruppo funzionale'
      },
      value: {
        value: 'Valore',
        placeholder: 'Valore'
      }
    },
    parent: 'Accedi al file genitore',
    son: 'Accedi ai file generati',
    auditory_entity_table: {
      project: 'Servizio',
      sender: 'Emittente',
      receiver: 'Ricevente',
      date: 'Data',
      filename: 'Nome del file',
      document_number: 'N. Documento',
      document_type: 'T. Documento',
      status: 'Stato',
      communication_protocol: 'Comunicazione',
      audit_document_module: 'Modulo',
      batch: 'Lotto',
      processingTime: 'Tempo di elaborazione',
      group: 'Gruppo',
      user: 'Utente',
      action: 'Azione',
      value: 'Valore',
      csv_title: 'Esporta in CSV. Informazione',
      csv_message: 'Impossibile esportare più di {argumento} record, restringere la ricerca'
    },
    download_multiple: {
      multiple_ko: 'Las siguientes auditorias no se pueden descargar'
    },

    load: {
      download_request_file: 'Scaricare del file di input...',
      download_response_file: 'Scaricare del file di output...',
      download_incoming_file: 'Scaricare del file di input...',
      download_integrated_file: 'Scaricare di file integrati...'
    },

    buttons: {
      btn_request: 'Richiesta',
      btn_response: 'Risposta',
      btn_incoming_file: 'File in arrivo',
      btn_integrated_file: 'File integrati',
      btn_request_tooltip: 'Scaricare richiesta',
      btn_response_tooltip: 'Scaricare risposta',
      btn_incoming_file_tooltip: 'Scaricare file in arrivo',
      btn_integrated_file_tooltip: 'Scaricare file integrati'
    }
  },

  auditory_detail: {
    info_auditory: 'Eventi',

    buttons: {
      request: 'Richiesta',
      response: 'Risposta',
      incoming_file: 'File in arrivo',
      integrated_file: 'File integrati',
      request_tooltip: 'Scaricare richiesta',
      response_tooltip: 'Scaricare risposta',
      incoming_file_tooltip: 'Scaricare file in arrivo',
      integrated_file_tooltip: 'Scaricare file integrati'
    },

    load: {
      download_request_file: 'Scaricare della richiesta di iscrizione...',
      download_response_file: 'Scaricare della richiesta di uscita...',
      download_original_file: 'Scaricare del file custodito...',
      download_incoming_file: 'Scaricare del file di input...',
      download_integrated_file: 'Scaricare di file integrati...'
    },

    notify: {
      error_download_not_found: 'Error en la descarga. No se ha encontrado el fichero'
    },

    events: {
      code: {
        RECEPTION_INVOICE: 'Ricezione fattura',
        RECEPTION_ORIGINAL_INVOICE: 'Ricezione fattura originale',
        SUMMARY_ALTCLI: 'Riassunto clienti alti',
        SUMMARY_ALTPRO: 'Sommario alti fornitori',
        ERROR_LINE_LENGTH: 'Linea mal formata',
        DELETE_DIR: 'Cancellato',
        invalidFormat: 'La fattura non rispetta il formato Fattura selezionato',
        FILE_BASE64_ERROR: 'Errore inaspettato nel formato della fattura',
        'VALIDATION.DUPLICATION': 'La convalida della fattura duplicata non è avvenuta',
        'VALIDATION.DUPLICATION.ISSUEYEAR': 'La convalida della fattura duplicata non è avvenuta nell\'anno corrente',
        SIGNED: 'Firmato',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        DISAGREEMENT: 'Non conforme',
        PENDING_OF_SIGNING: 'In attesa di firma',
        PENDING_OF_SEND: 'In attesa di invio',
        UPDATE_STATUS: 'Aggiornamento dello stato',
        UPDATE_INTERNAL_STATUS: 'Aggiornamento dello stato interno',
        CHECK_STATUS_ONLINE: 'Controlla lo stato online',
        DOCUMENT_INTEGRATED: 'Documento inserito',
        INVOICE_INTEGRATED: 'Fattura inserita correttamente',
        INVOICE_INTEGRATED_WS: 'Fattura inserita per Web service',
        INVOICE_INTEGRATED_REST: 'Fattura inserita per Rest',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Fattura digitalizzata convalidata per Web service',
        RECOGNITION: 'Riconoscimento',
        VALIDATE_SIGNATURE: 'Verifica della firma',
        TRANSFORMATION: 'Trasformazione',
        SIGNATURE: 'Sottoscrizione',
        DELIVERY: 'Consegna',
        CHANGE_STATUS_RECADV_WS: 'Cambio ricezione WS',
        CHECK_STATUS_RECADV_WS: 'Controlla lo stato dei ricevimenti WS',
        INTEGRATION_RECADV_WS: 'Integrazione ricezione WS',
        ERROR: 'Errore',
        FACTURAE_INVALID: 'Fattura non valida',
        PARTY_SENDER_NOTFOUND: 'Impresa emittente non trovata',
        CENTRE_SELLER_NOTFOUND: 'Sede dell\'impresa fornitrice non trovata',
        PARTY_RECEIVER_NOTFOUND: 'Impresa ricevente non trovata',
        CENTRE_BUYER_NOTFOUND: 'Sede impresa del cliente non trovata',
        CURRENCY_NOTFOUND: 'Valuta non trovata',
        TAXTYPE_NOTFOUND: 'Timpo di imposta non trovato',
        COUNTRY_BUYER_NOTFOUND: 'Paese dell\'impresa cliente non trovato',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'Il Paese indicato nel prefisso della Partita IVA non esiste',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Prefisso della Partita Iva fornitore non trovato',
        COUNTRY_CENTRE_NOTFOUND: 'Paese della sede non trovato',
        MEDIA_TYPE_NOTFOUND: 'Media type non trovato',
        CONTRACT_BUYER_ERROR: 'Errore inaspettato nella contrattazione dell\'impresa cliente',
        CONTRACT_PARTYMEDIA_ERROR: 'Error in hiring party_media',
        DB_ERROR: 'Errore imprevisto in connessione al DB',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Impossibile copiare il file nel repository fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Errore durante la decompressione degli allegati in temporanea',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Impossibile copiare il file ricevuto nel repository fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Si è verificato un errore durante l\'acquisizione o la decompressione del file dal repository editrack',
        NOTE_INVOICE_ERROR: 'Errore imprevisto durante la creazione della nota di fatturazione',
        AUDIT_DOCUMENT_ERROR: 'Errore imprevisto durante l\'inserimento di informazioni nella verifica',
        GETFORMAT_ERROR: 'Errore imprevisto nel determinare il formato del documento da integrare',
        SEND_MAIL_ERROR: 'Si è verificato un errore nell\'invio dell\'email',
        RETRY_MAIL_ERROR: 'Errore durante il salvataggio delle informazioni per riprovare ad inviare l\'email',
        UNEXPECTED_ERROR: 'Errore inaspettato',
        REQUEST_EMPTY: 'Richiesta vuota',
        DOCUMENT_CLASS_NOTFOUND: 'Classe di documento non trovata',
        STATUS_DOCUMENT_NOTFOUND: 'Stato del documento non trovato',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Tipo di documento di fatturazione non trovato',
        INVOICE_TYPE_NOTFOUND: 'Tipo di fattura non trovato',
        INSTANCES_REQUEST_EMPTY: 'Le istanze del documento non possono essere vuote',
        DOCUMENT_FORMAT_EMPTY: 'L\'elemento Documentformat non può essere vuoto o nullo',
        DOCUMENT_FORMAT_UNRECOGNIZED: 'Formato del documento non riconosciuto',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'L\'elemento Repositorylocator dell\'istanza ATTACHMENT non può essere nullo o vuoto',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'L\'elemento originalfilename dell\'istanza ATTACHMENT non può essere nullo o vuoto',
        DOCUMENT_FORMAT_ERROR: 'Il formato del documento da integrare (contenuto nella richiesta) non è corretto',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Sponsor non trovato tra le aziende nella fattura',
        PROJECT_PARTY_SPONSOR_ERROR: 'Errore imprevisto durante la ricerca dello sponsor tra le aziende fornitore/clienti della fattura',
        VALIDITY_DOCUMENT_NOTFOUND: 'Non esiste una validità del documento per il tipo di documento e il paese della fattura',
        STATUS_AUDIT_NOTFOUND: 'Stato di controllo non trovato',
        SEMANTICDOCUMENTID_EMPTY: 'L\'elemento semanticdocumentid non può essere nullo o vuoto',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'L\'elemento Repositorylocator dell\'istanza RECEIVED non può essere nullo o vuoto',
        INCOMINGDATETIME_EMPTY: 'L\'elemento incomingdatetime non può essere nullo o vuoto',
        RECEIVERID_NOTFOUND: 'La società la cui Partita Iva è indicata nell\'elemento ricevente non esiste',
        SENDERID_NOTFOUND: 'La società la cui Partita Iva è indicata nell\'elemento senderid non esiste',
        DOCUMENT_TYPE_NOTFOUND: 'Tipo di documento non trovato',
        DOCUMENT_PARENT_NOTFOUND: 'Documento padre non trovato',
        COMMUNICATION_PROTOCOL_EMPTY: 'Il protocollo di comunicazione non può essere nullo o vuoto',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Protocollo di comunicazione non trovato',
        REPOSITORY_ERROR: 'Impossibile ottenere il file del repository',
        CONNECTION_ERROR: 'Errore di connessione la DB imprevisto',
        PROJECT_COMMUNITYID_NOTFOUND: 'Servizio con codice communityid non trovato',
        DOCUMENT_FORMAT_NOTFOUND: 'Formato del documento non trovato',
        INPUTDATETIME_EMPTY: 'L\'elemento inputdatetime non può essere nullo o vuoto',
        DELIVERYCHECK: 'Conferma di consegna',
        DUPLICATED_INVOICE_ERROR: 'Errore per fattura duplicata',
        CORRECTIVE_NUMBER_REQUIRED: 'Il numero di fattura di rettifica è obbligatorio per il metodo di rettifica 01 o 02',
        DIR_ATTACHMENT_NOTFOUND: 'Non esiste la directory degli allegati della fattura da integrare',
        996: '996',
        CIF_REQUIRED: 'La Partita Iva è un campo obbligatorio',
        ACTION_REQUIRED: 'L\'azione è un campo obbligatorio',
        DESCRIPTION_REQUIRED: 'La descrizione è un campo obbligatorio',
        CANAL_REQUIRED: 'Il canale è un campo obbligatorio',
        EMAIL_REQUIRED: 'The email is a required field',
        PARTY_BUYER_NOTFOUND: 'The buyer party does not exist',
        PROJECT_PARTY_DISABLED: 'The party is disabled for the indicated project',
        PROJECT_PARTY_BUYER_NOTFOUND: 'The buyer party is not associated or is disabled for the service indicated',
        PROJECT_PARTY_SELLER_NOTFOUND: 'The seller party is not associated or is disabled for the service indicated',
        COMMUNICATION_METHOD_NOTFOUND: 'Communication method does not exist',
        EMAIL_INVALID: 'L\'email è un campo obbligatorio',
        ACTION_UNEXPECTED: 'L\'operazione non è corretta',
        READ_FILE_BUYERS_ERROR: 'Errore imprevisto durante la lettura del file di contrattazione delle imprese clienti',
        UPDATE_PARTY_ERROR: 'Errore di aggiornamento dei dati dell\'impresa',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Errore durante la creazione del metodo di consegna associato alla società',
        CREATE_PARTY_MEDIA_ERROR: 'Errore durante la creazione dell\'email associata alla società cliente',
        CREATE_USER_PARTY_ERROR: 'Errore durante la creazione dell\'utente associato alla società cliente',
        CREATE_USER_ERROR: 'Errore durante la creazione dell\'utente',
        CREATE_PARTY_ERROR: 'Errore durante la creazione della società',
        CREATE_PROJECT_PARTY_ERROR: 'Errore durante la creazione della relazione tra il progetto e la società',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Errore nella creazione della relazione commerciale tra l\'impresa sponsor e l\'impresa cliente',
        CREATION_PARTY_WS: 'Recupero del business',
        UPDATE_PARTY_WS: 'Aggiornamento dell\'impresa',
        CREATION_USER_WS: 'Gestione di utenti',
        REMOVE_USER_WS: 'Eliminazione degli utenti',
        UPDATE_USER_WS: 'Modifica degli utenti',
        UNLOCK_USER_WS: 'Sbloccare gli utenti',
        RESET_USER_WS: 'Gli utenti resettati',
        PROJECT_NOSENDER: 'Metodo di spedizione errato. Il progetto non è trasmesso',
        SELLER_NOSPONSOR: 'Metodo di spedizione errato. La società non è uno sponsor.',
        PROJECT_NO_DELIVERY_METHOD: 'Metodo di spedizione non trovato per il progetto.',
        NO_LINES: 'Ricezione senza linee',
        ITEM_PRICE_NOTFOUND: 'La linea non contiene un prezzo',
        ITEM_NOTFOUND: 'L\'articolo è mancante',
        INVALID_MEASURE: 'Unità di misura errata',
        RECADV_ERROR: 'Errore',
        DUPLICATED_RECADV: 'Ricezione duplicata',
        INVOICE_VALIDATION: 'Errore nella convalida della fattura',
        UPDATE_PARTY: "Aggiornamento dell'azienda",
        SIGN: 'Signature',
        hermes: {
          integration: {
            invoice: 'Fattura integrata riuscita'
          },
          download: {
            invoice: 'Fattura scaricata'
          }
        },

        // Categorías

        CARATULA_FACTURA: 'Copertura della fattura',
        CARATULA_PROPUESTA_PAGO: 'Copertina della proposta di pagamento',
        PROPUESTA_PAGO: 'Proposta di pagamento',
        DISPLAY_INVOICE: 'PDF della fattura',
        APPROVAL_FLOW: 'Flusso di approvazione',

        // Acciones

        SEND_SIGNED: 'Spedizione in azienda',
        SEND_APPROVAL: "Spedizione all'approvazione",
        CREATE_COVER: 'Creazione di copertina',
        RESTART_CREATE_COVER: 'Riavvio della copertine',
        ACCEPTED: 'Accettato',
        REJECTED: 'Rifiutato',
        SEND_INVOICE: 'Spedizione della fattura',
        SEND_INVOICE_ORIGIN: 'Spedizione della fattura di origine',
        SEND_STATE: 'Spedizione dello stato',
        SEND_PROPOSED_STATE: 'Inviato stato proposta',
        INVOICE_SIGNATURE: 'Fattura in firma',
        PROPOSALS_SIGNATURE: 'Proposta in firme',

        // Códigos para eventos de auditorías de webservices
        unexpected: {
          error: 'Errore imprevisto durante l\'elaborazione della richiesta o del suo documento'
        },
        document: {
          integration: {
            error: 'Errore di integrazione del documento di richiesta'
          }
        },
        repository: {
          error: 'Errore durante il tentativo di salvare o ottenere il documento di richiesta'
        },
        validation: {
          error: 'Errore di convalida del documento di richiesta',
          retry: 'Riprovare la convalida'
        },
        invoice: {
          integrated: {
            b2bintegration: 'Numero di fattura B2B correttamente integrato',
            ws: 'Fattura per webservice integrato con successo',
            upload: 'Fattura integrata con successo'
          },
          format: {
            error: 'Errore di formato della fattura'
          },
          schema: {
            error: 'Errore dello schema di fattura XML'
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Numero di ricezione B2B correttamente integrato'
          },
          format: {
            error: 'Errore nel formato di avviso di ricevimento'
          },
          schema: {
            error: 'Errore dello schema di avviso di ricevimento XML'
          }
        },
        csvparties: {
          integrated: {
            b2bintegration: 'CSV di aziende integrate con successo'
          },
          format: {
            error: 'Errore nel formato del CSV delle aziende'
          },
          schema: {
            error: 'Errore nel contenuto del CSV delle aziende'
          }
        }
      },

      property: {
        NUMLINES_TOTAL: 'Numero di linee contenute',
        NUMLINES_ERROR: 'Numero di righe con errore',
        NUMLINES_OK: 'Numero di linee corrette',
        UPDATE_PARTY: "Aggiornamento dell'azienda",
        UPDATED_PARTY: 'Aggiornato',
        SEND_FILE: 'Documento di invio',
        ERROR_LINE_LENGTH: 'Linea mal formata',
        DELETE_DIR: 'Cancellato',
        REASON: 'Ragionare',
        ORIGINAL_STATUS: 'Stato originale',
        FINAL_STATUS: 'Stato finale',
        SEND_MAIL_ERROR: 'Errore durante l\'invio della posta',
        NOTE_INVOICE_ERROR: 'Errore imprevisto durante la creazione della nota di fatturazione',
        DOCUMENT_INTEGRATED: 'Numero di documento integrato',
        DIGITIZEDINVOICE_VALIDATED: 'Fattura convalidata',
        ATTACHMENT_INTEGRATED: 'Nome del file degli allegati',
        INVOICE_INTEGRATED_WS: 'Numero di fattura integrato',
        INVOICE_INTEGRATED: 'Numero di fattura integrato',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Fattura digitalizzata convalidata per Web service',
        documentinstance: {
          filename: 'Nome del file'
        },
        MOTIVE: 'Motivo',
        STATUS_BEFORE: 'Stato iniziale',
        LAST_STATUS: 'Stato finale',
        USER_NAME: 'Utente',
        INTERNAL_MOTIVE: 'Motivo interno',
        INTERNAL_STATUS_BEFORE: 'Stato interno iniziale',
        LAST_INTERNAL_STATUS: 'Stato interno finale',
        MESSAGE_RESULT: 'Messaggio di risposta',
        CHANGE_STATUS_RECADV_WS: 'Cambio di stato',
        FACTURAE_INVALID: 'Fattura non valida',
        PARTY_SENDER_NOTFOUND: 'Impresa emittente non trovata',
        CENTRE_SELLER_NOTFOUND: 'Sede dell\'impresa fornitrice non trovata',
        PARTY_RECEIVER_NOTFOUND: 'Impresa ricevente non trovata',
        CENTRE_BUYER_NOTFOUND: 'Sede impresa del cliente non trovata',
        CURRENCY_NOTFOUND: 'Valuta non trovata',
        TAXTYPE_NOTFOUND: 'Timpo di imposta non trovato',
        COUNTRY_BUYER_NOTFOUND: 'Paese dell\'impresa cliente non trovato',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'Il Paese indicato nel prefisso della Partita IVA non esiste',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Prefisso della Partita Iva fornitore non trovato',
        COUNTRY_CENTRE_NOTFOUND: 'Paese della sede non trovato',
        MEDIA_TYPE_NOTFOUND: 'Media type non trovato',
        CONTRACT_BUYER_ERROR: 'Errore inaspettato nella contrattazione dell\'impresa cliente',
        CONTRACT_PARTYMEDIA_ERROR: 'Errore nel contratto di party_media',
        DB_ERROR: 'Errore imprevisto in connessione al DB',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Impossibile copiare il file nel repository fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Errore durante la decompressione degli allegati in temporanea',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Impossibile copiare il file ricevuto nel repository fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Si è verificato un errore durante l\'acquisizione o la decompressione del file dal repository editrack',
        AUDIT_DOCUMENT_ERROR: 'Errore imprevisto durante l\'inserimento di informazioni nella verifica',
        RETRY_MAIL_ERROR: 'Errore durante il salvataggio delle informazioni per riprovare ad inviare l\'email',
        UNEXPECTED_ERROR: 'Errore inaspettato',
        REQUEST_EMPTY: 'Richiesta vuota',
        CORRECTIVE_NUMBER_REQUIRED: 'Il numero di fattura di rettifica è obbligatorio per il metodo di rettifica 01 o 02',
        DOCUMENT_CLASS_NOTFOUND: 'Classe di documento non trovata',
        STATUS_DOCUMENT_NOTFOUND: 'Stato del documento non trovato',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Tipo di documento di fatturazione non trovato',
        INVOICE_TYPE_NOTFOUND: 'Tipo di fattura non trovato',
        INSTANCES_REQUEST_EMPTY: 'Le istanze del documento non possono essere vuote',
        DOCUMENT_FORMAT_EMPTY: 'L\'elemento Documentformat non può essere vuoto o nullo',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'L\'elemento Repositorylocator dell\'istanza ATTACHMENT non può essere nullo o vuoto',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'L\'elemento originalfilename dell\'istanza ATTACHMENT non può essere nullo o vuoto',
        DOCUMENT_FORMAT_ERROR: 'Formato del documento non riconosciuto',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Sponsor non trovato tra le aziende nella fattura',
        PROJECT_PARTY_SPONSOR_ERROR: 'Errore imprevisto durante la ricerca dello sponsor tra le aziende fornitore/clienti della fattura',
        VALIDITY_DOCUMENT_NOTFOUND: 'Non esiste una validità del documento per il tipo di documento e il paese della fattura',
        STATUS_AUDIT_NOTFOUND: 'Stato di controllo non trovato',
        SEMANTICDOCUMENTID_EMPTY: 'L\'elemento semanticdocumentid non può essere nullo o vuoto',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'L\'elemento Repositorylocator dell\'istanza RECEIVED non può essere nullo o vuoto',
        INCOMINGDATETIME_EMPTY: 'L\'elemento incomingdatetime non può essere nullo o vuoto',
        RECEIVERID_NOTFOUND: 'La società la cui Partita Iva è indicata nell\'elemento ricevente non esiste',
        SENDERID_NOTFOUND: 'La società la cui Partita Iva è indicata nell\'elemento senderid non esiste',
        DOCUMENT_TYPE_NOTFOUND: 'Tipo di documento non trovato',
        DOCUMENT_PARENT_NOTFOUND: 'Documento padre non trovato',
        COMMUNICATION_PROTOCOL_EMPTY: 'Il protocollo di comunicazione non può essere nullo o vuoto',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Protocollo di comunicazione non trovato',
        REPOSITORY_ERROR: 'Impossibile ottenere il file del repository',
        CONNECTION_ERROR: 'Errore di connessione la DB imprevisto',
        PROJECT_COMMUNITYID_NOTFOUND: 'Servizio con codice communityid non trovato',
        DOCUMENT_FORMAT_NOTFOUND: 'Formato del documento non trovato',
        INPUTDATETIME_EMPTY: 'L\'elemento inputdatetime non può essere nullo o vuoto',
        TRANSFORMATION: 'Fase di trasformazione della fattura',
        EXTRACTION: 'Fase di estrazione della fattura',
        ATTACHMENT: 'Fase di estrazione degli allegati della fattura',
        DELIVERY: 'Fase di consegna del file',
        DIR_ATTACHMENT_NOTFOUND: 'Non esiste la directory degli allegati della fattura da integrare',
        VALIDATION_ERROR: 'Errore di validazione',
        translation: {
          instances: {
            added: 'Aggiunta traduzione di istanze'
          },
          processingtime: 'Durata nel completamento della traduzione'
        },
        error: {
          document: {
            entrieszip: {
              '': 'Impossibile decomprimere lo zip',
              format: {
                invalid: 'Struttura/formato del file di input errato'
              }
            },
            attachments: {
              directory: {
                name: {
                  invalid: 'Il nome della directory degli allegati non è valido'
                }
              }
            },
            file: {
              name: {
                invalid: 'Il nome di uno dei file di input non è valido'
              },
              format: 'Errore nel formato del file di input'
            },
            read: {
              country: 'Errore durante la lettura del file, non è possibile determinare il Paese'
            }
          },
          ai: {
            translationfail: 'Errore nella traduzione AI del file'
          },
          ruleinformation: {
            notfound: 'Regola non trovata'
          }
        },
        EXTRACTION_INVOICE: {
          ERROR: 'Si è verificato un errore durante l\'estrazione della fattura dal file compresso'
        },
        EXTRACTION_ATTACHMENT: {
          ERROR: 'Si è verificato un errore durante l\'estrazione degli allegati dal file compresso'
        },
        TRANSLATION_MAP: {
          ERROR: 'Si è verificato un errore durante l\'applicazione della mappa alla fattura'
        },
        SIGNATURE: {
          '': 'Fase della firma del file',
          ERROR: 'Si è verificato un errore durante la firma della fattura'
        },
        signature: {
          sax: {
            exception: {
              parsing: {
                document: 'Si è verificato un errore durante la firma della fattura, formato errato'
              }
            }
          },
          signature: {
            exception: {
              signing: 'Si è verificato un errore durante la firma della fattura'
            }
          }
        },
        RECOGNITION: {
          '': 'Fase di riconoscimento del file di input',
          ERROR: 'Si è verificato un errore durante il riconoscimento del file'
        },
        vltrader: {
          senddt: 'Data di invio',
          sender: {
            host: 'Ospite',
            mailbox: 'Mailbox'
          },
          sendid: 'Invio identificativo',
          totalattempts: 'Numero di tentativi',
          transfer: {
            enddt: 'Data di fine della spedizione',
            resulttext: 'Risultato di spedizione',
            startdt: 'Data di inizio della spedizione',
            status: 'Invio dello stato dei risultati',
            transferid: 'Identificatore di consegna'
          }
        },
        wsserver: {
          profile: 'Profilo',
          requestid: 'Identificatore della richiesta'
        },
        DUPLICATED_INVOICE_ERROR: 'Errore per fattura  duplicata',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        996: '996',
        CIF_REQUIRED: 'La Partita Iva è un campo obbligatorio',
        ACTION_REQUIRED: 'L\'azione è un campo obbligatorio',
        DESCRIPTION_REQUIRED: 'La descrizione è un campo obbligatorio',
        CANAL_REQUIRED: 'Il canale è un campo obbligatorio',
        EMAIL_REQUIRED: 'L\'email è un campo obbligatorio',
        PARTY_BUYER_NOTFOUND: 'L\'impresa del cliente non esiste',
        PROJECT_PARTY_DISABLED: 'L\'azienda è disabilitata per il servizio indicato',
        PARTY_DISABLED: 'L\'azienda è disabilitata',
        COMMUNICATION_METHOD_NOTFOUND: 'Il metodo di comunicazione non esiste',
        EMAIL_INVALID: 'L\'email non è corretta',
        ACTION_UNEXPECTED: 'L\'operazione non è corretta',
        READ_FILE_BUYERS_ERROR: 'Errore imprevisto durante la lettura del file di contrattazione delle imprese clienti',
        UPDATE_PARTY_ERROR: 'Errore di aggiornamento dei dati dell\'impresa',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Errore durante la creazione del metodo di consegna associato alla società',
        CREATE_PARTY_MEDIA_ERROR: 'Errore durante la creazione dell\'email associata alla società cliente',
        CREATE_USER_PARTY_ERROR: 'Errore durante la creazione dell\'utente associato alla società cliente',
        CREATE_PARTY_ERROR: 'Errore durante la creazione della società',
        CREATE_USER_ERROR: 'Errore durante la creazione dell\'utente',
        CREATE_PROJECT_PARTY_ERROR: 'Errore durante la creazione della relazione tra il progetto e la società',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Errore nella creazione della relazione commerciale tra l\'impresa sponsor e l\'impresa cliente',
        EDICOM_ACK_NEGATIVE: 'ACK negativo',
        NO_PERSON_CODE_VALID: 'Codice persona non valido',
        PARTY_NIF_EXIST: 'La società NIF esiste già',
        PARTY_GLN_EXIST: 'La società GLN esiste già',
        WITHOUT_DATA_REQUIRED: 'Dati obbligatori mancanti',
        LOGO_ERROR: 'Errore con il logo',
        MIME_TYPE_LOGO_ERROR: 'Errore di formato del logo',
        FILE_BASE64_ERROR: 'Errore del file Base64',
        NO_COUNTRY_CODE_VALID: 'Codice del paese non valido',
        CENTRE_ERROR: 'Errore del centro',
        COMMUNICATION_METHOD_ERROR: 'Errore del metodo di comunicazione',
        EMAIL_ERROR: 'Errore di posta elettronica',
        PARTY_USER_ERROR: 'Impossibile assegnare l\'utente all\'entità',
        PROJECT_PARTY_NIF_NOT_EXIST: 'Non cè compagnia con questo NIF',
        CREATED: 'Creato',
        DELETED: 'Eliminato',
        UPDATED: 'Aggiornato',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        CENTRE_NOT_EXIST: 'Non esiste la sede',
        USER_EXIST: 'L\'utente esiste già',
        USER_NOT_EXIST: 'L\'utente non esiste',
        USER_NOT_LOCKED: 'Utente non bloccato',
        USER_NOT_REMOVED: 'Utente non rimosso',
        USER_NOT_PROJECT: 'L\'utente non è del servizio',
        USER_NIF_EXIST: 'C\'è già un utente con questo NIF',
        PROJECT_NOSENDER: 'Metodo di spedizione errato. Il progetto non è trasmesso',
        SELLER_NOSPONSOR: 'Metodo di spedizione errato. La società non è uno sponsor.',
        PROJECT_NO_DELIVERY_METHOD: 'Metodo di spedizione non trovato per il progetto.',
        REGISTRATION_CODE_PROPERTY: 'Codice di registrazione',
        REGISTRATION_DATE_PROPERTY: 'Data di registrazione',
        CHANGE_STATUS: 'Cambio di stato',
        CHANGE_STATUS_PROPERTY: 'Cambio di stato',
        DOWNLOAD_PROPERTY: 'Scarica',

        // Códigos para propiedades de auditorías
        invoice: {
          integrated: {
            b2bintegration: 'Numero di fattura B2B correttamente integrato',
            ws: 'Numero di fattura per webservice integrato con successo',
            upload: 'Numero di fattura integrato con successo'
          },
          note: {
            media: {
              type: {
                not: {
                  found: 'Media type non trovato'
                }
              },
              invalid: {
                email: {
                  format: 'Email media della fattura non valida'
                }
              }
            },
            document: {
              not: {
                found: 'Documento fattura non trovato'
              }
            },
            recadv: {
              not: {
                found: 'Avviso sulla ricevuta della nota della fattura non trovata'
              }
            },
            attachment: {
              category: {
                not: {
                  found: 'Categoria allegato nota fattura non trovata'
                }
              },
              user: {
                not: {
                  found: 'Utente allegato nota fattura non trovato'
                }
              }
            }
          },
          project: {
            not: {
              found: 'Servizio di fattura non trovato'
            },
            category: {
              not: {
                found: 'Categoria del progetto di fattura non trovata'
              }
            }
          },
          sender: {
            not: {
              found: 'Mittente del destinatario della fattura non trovato'
            }
          },
          receiver: {
            not: {
              found: 'Ricevitore di fatture non trovato'
            }
          },
          thirdparty: {
            not: {
              found: 'Fattura di terze parti non trovata'
            }
          },
          status: {
            not: {
              found: 'Stato fattura non trovato'
            }
          },
          currency: {
            not: {
              found: 'Valuta della fattura non trovata'
            }
          },
          document: {
            format: {
              not: {
                found: 'Formato del documento di fattura non trovato'
              }
            },
            class: {
              not: {
                found: 'Classe del documento di fattura non trovata'
              }
            },
            type: {
              not: {
                found: 'Tipo di documento di fattura non trovato'
              }
            }
          },
          type: {
            not: {
              found: 'Tipo di fattura non trovato'
            }
          },
          validity: {
            document: {
              not: {
                found: 'Documento di validità della fattura non trovato'
              }
            }
          },
          communication: {
            method: {
              not: {
                found: 'Metodo di comunicazione della fattura non trovato'
              }
            }
          },
          auditdocument: {
            not: {
              found: 'Documento di revisione fattura non trovato'
            }
          },
          accounting: {
            close: {
              not: {
                found: 'Conteggio fattura chiuso non trovato'
              }
            }
          },
          recept: {
            comm: {
              method: {
                not: {
                  found: 'Metodo di comunicazione per la ricezione della fattura non trovato'
                }
              }
            }
          },
          internal: {
            status: {
              not: {
                found: 'Stato interno fattura non trovato'
              }
            }
          },
          batch: {
            not: {
              found: 'Fattura della fattura non trovata'
            }
          },
          channel: {
            not: {
              found: 'Canale di fattura non trovato'
            }
          },
          seller: {
            centre: {
              not: {
                found: 'Centro venditore non trovato'
              },
              roletype: {
                not: {
                  found: 'Tipo di ruolo del centro venditore non trovato'
                }
              }
            }
          },
          buyer: {
            centre: {
              not: {
                found: 'Centro acquisti non trovato'
              },
              roletype: {
                not: {
                  found: 'Tipo di ruolo centrale acquirente non trovato'
                }
              }
            }
          },
          tax: {
            type: {
              not: {
                found: 'Tipo di imposta sulla fattura non trovata'
              }
            },
            currency: {
              not: {
                found: 'Valuta imposta fattura non trovata'
              }
            }
          },
          user: {
            does: {
              not: {
                belong: {
                  to: {
                    party: 'L\'utente della richiesta non appartiene alla parte del suo codice fiscale del venditore'
                  }
                }
              }
            }
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Numero di consigli di ricevimento B2B integrati'
          },
          status: {
            not: {
              found: 'Stato dell\'avviso di ricevimento non trovato'
            }
          },
          validity: {
            document: {
              not: {
                found: 'Documento di validità del consiglio di ricezione non trovato'
              }
            }
          },
          document: {
            format: {
              not: {
                found: 'Formato del documento di consiglio di ricevimento non trovato'
              }
            }
          },
          centre: {
            not: {
              found: 'Centro di consulenza per le ricevute non trovato'
            }
          }
        },
        unexpected: {
          error: 'Errore imprevisto durante l\'elaborazione della richiesta o del suo documento'
        },
        validation: {
          noDocumentType: 'Il tipo di documento deve essere impostato',
          retry: 'Le convalide devono riprovarsi',
          invoicePeriodDates: 'La data di inizio del periodo di fatturazione deve essere precedente alla data di fine',
          invoiceCorrectivePeriodDates: 'La data di inizio del periodo di rettifica deve essere precedente alla data di fine',
          signature: 'La fattura non è firmata',
          nif: 'Partita Iva non valida',
          attachmentformat: 'Tipo di allegato non consentito, sono supportate solo le estensioni: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
          attachmentformat321: 'Tipo di allegato non consentito, sono supportate solo le estensioni: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
          error: 'Formato file errato',
          party: {
            noTaxId: 'Il numero di identificazione fiscale deve essere impostato',
            noProject: 'Servizio deve essere impostato',
            buyer: {
              notInProject: 'Il venditore non esiste nel progetto o è disabilitato'
            },
            seller: {
              notInProject: 'Il acquirente non esiste nel progetto o è disabilitato'
            },
            noSeller: 'Il numero di identificazione fiscale del venditore deve essere impostato',
            noBuyer: 'Il numero di identificazione fiscale dell\'acquirente deve essere impostato',
            noRelation: 'Nel progetto non esiste una relazione commerciale tra venditore e acquirente',
            noSponsor: 'Il partecipante non è sponsor nel progetto',
            disabled: 'Il partecipante è disabilitata',
            disabledInProject: 'Il partecipante è disabilitato nel progetto'
          },
          parties: {
            noSponsor: 'Nessuna delle due parti è uno sponsor nel progetto.'
          },
          centre: {
            role: {
              type: 'Il ruolo del centro non è valido per il formato della fattura'
            },
            noCentreCode: 'Il codice Center deve essere impostato',
            noParty: 'Il partecipante deve essere impostata',
            buyer: {
              notInParty: 'Uno o più centri acquirenti non esistono per l\'azienda o sono disabilitati'
            },
            seller: {
              notInParty: 'Uno o più centri venditti non esistono per l\'azienda o sono disabilitati'
            },
            noCentreUnique: 'I centri devono essere unici'
          },
          document: {
            noDocument: 'Le documento devono essere impostate'
          },
          invoice: {
            currency: 'Valuta non inclusa',
            currencyExchange: 'Tasso di cambio errato o non riportato',
            currencyExchangeDate: 'Data del tasso di cambio errata o non riportata',
            iban: 'Il formato del IBAN sbagliato',
            ibanNull: 'IBAN disinformato',
            registrationData: 'I dati del registro di commercio inseriti in fattura non corrispondono ai dati registrati nel B2B',
            sequenceNumber: 'La posizione dell ordine è obbligatoria per l ordine indicato',
            correctiveSign01pos: 'Factura rectificativa de tipo Rectificación Integra deben ser positivas',
            correctiveSign02pos: 'Factura rectificativa de tipo Rectificación por diferencias deben ser positivas',
            correctiveSign03pos: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser positivas',
            correctiveSign04pos: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser positivas',
            correctiveSign01neg: 'Factura rectificativa de tipo Rectificación Integra deben ser negativas',
            correctiveSign02neg: 'Factura rectificativa de tipo Rectificación por diferencias deben ser negativas',
            correctiveSign03neg: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser negativas',
            correctiveSign04neg: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser negativas',
            noInvoice: 'Nessuna compagnia è stata inserit',
            noInvoiceLine: 'Nessuna riga di fattura è stata inclusa o uno o più sono nulle',
            noInvoiceNumber: 'Nessun numero di fattura è stato inserito',
            noParty: 'Nessuna compagnia è stata inserita',
            noProject: 'Nessun servizio è stato inserito',
            duplicate: 'Fattura  duplicata',
            issuedate: 'La data della fattura non corrisponde alla fattura precedente ricevuta con la data di emissione {argumento}',
            dates: 'La data dell\'operazione deve essere inferiore o uguale alla data di rilascio',
            noIssueDate: 'Nessuna data di emissione è stata inserita',
            noOperationDate: 'Nessuna data di operazione è stata inserita',
            noIssuerType: 'Nessun tipo di emittente è stato inserito',
            issuerType: 'Il tipo di emittente della fattura non è valido',
            issuerTypeError: 'I dati necessari non sono inseriti per eseguire la convalida',
            noModalityType: 'La modalità fattura non corrisponde a uno dei valori accettati',
            modalityType: 'Il tipo di fattura deve essere individuale',
            modalityTypeError: 'I dati necessari non sono inseriti per eseguire la convalida',
            project: {
              notSender: 'Il progetto non ha attivato il ruolo di emissione indicato per la fattura',
              notReceiver: 'Il progetto non ha attivato il ruolo di ricezione indicato per la fattura'
            },
            noRole: 'Il ruolo della fattura (emittente o destinatario) deve essere stabilito',
            communication: {
              method: 'Il metodo di comunicazione della fattura non è contratto per il tuo progetto'
            },
            lines: {
              total: {
                error: 'La riga totale senza tasse non corrisponde al prodotto della quantità per prezzo unitario',
                discountscharges: {
                  error: 'La riga totale con addebiti e sconti non corrisponde all\'importo lordo della riga'
                }
              }
            },
            total: {
              error: 'La fattura totale senza addebiti o sconti generali non corrisponde alla somma delle righe totali con sconti e addebiti',
              discountscharges: {
                error: 'La fattura totale con spese generali e sconti non corrisponde alla fattura totale al lordo delle imposte',
                taxes: {
                  error: 'Il totale della fattura non corrisponde al totale della fattura al lordo delle imposte più le imposte totali passate e meno le imposte totali trattenute'
                }
              }
            },
            totalexecutable: {
              error: 'Il totale eseguibile della fattura non corrisponde al totale da pagare meno sussidi, anticipazioni e ritenute e più forniture e spese finanziarie'
            },
            accounting: {
              error: 'La fattura non soddisfa nessuna delle convalide contabili'
            }
          },
          recadv: {
            noRecadv: 'Nessuna ricezione è stata inserita',
            noRecadvNumber: 'Nessun numero di ricezione è stato inserito',
            noSeller: 'Nessuna società di vendita è stata inserita',
            noBuyer: 'Nessuna compagnia acquirente è stata inserita',
            duplicate: 'Ricev duplicato'
          },
          cmr: {
            noCmr: 'Non è stato incluso alcun documento di trasporto',
            noCmrNumber: 'Non è stato incluso alcun numero di documento di trasporto',
            noSeller: 'Non è stata inclusa alcuna azienda venditrice',
            noBuyer: 'Non è stata inclusa alcuna azienda acquirente',
            noshipfrom: 'Il luogo di origine deve essere impostato',
            noshipto: 'Il luogo di destinazione deve essere impostato',
            duplicate: {
              '': 'Esiste già un documento di trasporto con lo stesso numero in stato corretto',
              issueyear: 'Esiste già un documento di trasporto con lo stesso numero in stato corretto nell\'anno in corso'
            },
          },
          sign: {
            noParty: 'Nessuna compagnia è stata inserita',
            noSign: 'La società emittente non ha una firma delegata'
          },
          order: {
            noOrder: 'Il numero dell\'ordine è obbligatorio',
            noUnique: 'Il numero dell\'ordine deve essere univoco sulla fattura',
            noOrderIssuer: 'Il numero dell\'emittente dell\'ordine è obbligatorio',
            noUniqueIssuer: 'Il numero d\'ordine dell\'emittente deve essere univoco sulla fattura',
            invalidPatternIssuer: 'Il formato del numero dell\'ordine dell\'emittente non è valido',
            noPattern: 'Il modello non è configurato',
            invalidPattern: 'Il numero dell\'ordine incluso non è conforme al formato richiesto dal destinatario',
            error: 'Sono necessari più dati da convalidare'
          },
          expediente: {
            noExp: 'Il numero del file è obbligatorio',
            noUnique: 'Il numero del file deve essere univoco sulla fattura',
            noPattern: 'Il modello non è configurato',
            invalidPattern: 'Il numero di file incluso non è conforme al formato richiesto dal destinatario',
            error: 'Sono necessari più dati da convalidare il numero di file'
          },
          contract: {
            noContract: 'Il numero di contratto è obbligatorio',
            invalidPattern: 'Il numero di contratto incluso non è conforme al formato richiesto dal destinatario',
            noUnique: 'Il numero del file deve essere univoco sulla fattura',
            noPattern: 'Il modello non è configurato',
            error: 'Sono necessari più dati da convalidare il numero di contratto'
          },
          transaction: {
            noTransaction: 'Il numero della transazione è obbligatorio'
          },
          invoiceCorrective: {
            dates: 'La data iniziale e finale del periodo fiscale non sono valide',
            number: 'Il numero di fattura è obbligatorio per le fatture di tipo rettifica completa e rettifica per differenze',
            noNumber: 'Il numero della fattura è obbligatorio per le fatture di tipo rettifica',
            invalidPattern: 'Il formato del numero di fattura rettificato non è valido',
            noValue: 'Non è stato allegato alcun documento con valore',
            noOrderValue: 'Deve indicare l ordine del destinatario',
			required: 'Il campo "Correzione" è obbligatorio per una fattura rettificativa'
          },

          project: {
            disabled: 'Servizio non esiste o è disabilitato',
            noProject: 'Servizio deve essere impostato',
            attachment: {
              notfound: 'La directory degli allegati della fattura del progetto da integrare non esiste'
            }
          },
          issue: {
            date: {
              future: 'La data di emissione è successiva alla sua data di creazione',
              past: 'La data di emissione è precedente alla sua data di creazione'
            }
          },
          commercial: {
            relation: {
              channel: 'La relazione commerciale tra venditore, acquirente e canale non esiste'
            }
          },
          channel: {
            not: {
              found: 'Il canale non esiste'
            }
          },
          invoiceNumber: {
            error: 'Non è stato possibile convalidare il formato del numero di fattura: mancano i dati richiesti',
            noPattern: 'Nessun modello di numero di fattura configurato',
            invalidPattern: 'Formato numero di fattura non valido'
          },
          b2bvalidationws: {
            nourl: 'Non esiste una URL associata al WS o non è valida',
            metadataerror: 'Si prodursi un errore cercando di ottenere l\'archivio di metadati.',
            connectionerror: 'Si prodursi un errore durante la connessione col servizio del cliente.',
            wrongresponse: 'Il WS cliente restituì una respesta scorretta.',
            errorresponse: 'Il WS cliente restituì una risposta di ERRORE.'
          }
        },
        invalid: {
          validation: {
            code: {
              exception: 'Uno o più codici di convalida mancano di un metodo di convalida collegato'
            }
          },
          persontypecode: 'Si è verificato un errore durante la creazione della festa. Codice del tipo di persona non valido',
          name: {
            format: 'Nome del partecipante non valido, i caratteri devono essere in utf8'
          },
          facturae32: {
            xml: {
              format: 'Il formato del file di fattura Facturae 3.2 non è corretto o .xml'
            },
            schema: 'La fattura Facturae 3.2 contiene campi che non superano la convalida dello schema: '
          },
          facturae321: {
            xml: {
              format: 'Il formato del file di fattura Facturae 3.2.1 non è corretto o .xml'
            },
            schema: 'La fattura Facturae 3.2.1 contiene campi che non superano la convalida dello schema: '
          },
          facturae322: {
            xml: {
              format: 'Il formato del file di fattura Facturae 3.2.2 non è corretto o .xml'
            },
            schema: 'Il tipo di fattura Facturae 3.2.2 contiene campi che non superano la convalida dello schema: '
          },
          facturapdf: {
            xml: {
              format: 'Il formato del file di fattura PDF non è corretto o .xml'
            },
            schema: 'La fattura PDF contiene campi che non superano la convalida dello schema: '
          },
          edi: {
            date: {
              format: 'El formato de la fecha no es correcto'
            }
          },
          facturad01b: {
            edi: {
              format: 'Il formato del file di fatturazione non è corretto o .edi'
            }
          },
          facturad93a: {
            edi: {
              format: 'Il formato del file di fatturazione non è corretto o .edi'
            }
          },
          facturad96a: {
            edi: {
              format: 'Il formato del file di fatturazione non è corretto o .edi'
            }
          },
          facturad97a: {
            edi: {
              format: 'Il formato del file di fatturazione non è corretto o .edi'
            }
          },
          fatturapa12: {
            xml: {
              format: 'Il formato del file di fatturazione non è corretto o .xml'
            },
            schema: 'La fattura di tipo fatturapa12 contiene campi che non superano la convalida dello schema: '
          },
          recadv: {
            xml: {
              format: 'Il formato del file di consigli di ricevimento non è corretto o .xml'
            },
            schema: 'L\'avviso di ricevimento contiene campi che non superano la convalida dello schema: {0}'
          },
          fatturapaSemplificata1: {
            xml: {
              format: 'Il formato del file di fatturapa semplificato non è corretto o .xml'
            },
            schema: 'La fattura di tipo fatturapa sempleficato contiene campi che non superano la convalida dello schema: {0}'
          },
          fatturapa12cades: {
            xml: {
              format: 'Il formato del file di fatturapa 1.2 cades non è corretto o .xml'
            },
            schema: 'La fattura di tipo fatturapa 1.2 cades contiene campi che non superano la convalida dello schema: {0}'
          },
          fatturapaSemplificatacades: {
            xml: {
              format: 'Il formato del file di fatturapa semplificato non è corretto o .xml'
            },
            schema: 'La fattura di tipo fatturapa semplificato contiene campi che non superano la convalida dello schema: {0}'
          }
        },
        unable: {
          to: {
            save: {
              file: {
                in: {
                  repository: 'Il file non può essere salvato'
                }
              }
            },
            get: {
              repository: {
                file: 'Si è verificato un errore durante il recupero del file'
              }
            },
            delete: {
              repository: {
                file: 'Il file non può essere cancellato'
              }
            }
          }
        },
        no: {
          repository: {
            date: 'È necessaria una data per salvare il file',
            project: {
              name: 'È necessario un nome di progetto per salvare il file'
            },
            file: 'Il file deve essere impostato per salvarlo',
            subpath: 'Subpath deve essere impostato per salvare il file'
          },
          file: {
            to: {
              save: {
                extension: 'L\'estensione del file deve essere impostata per salvare il file'
              }
            }
          },
          pathcomplete: {
            flag: 'Il percorso completo deve essere impostato per salvare il file'
          }
        },
        repository: {
          path: {
            not: {
              found: 'Percorso non trovato per salvare il file'
            }
          }
        },
        missing: {
          required: {
            party: {
              data: 'Si è verificato un errore durante la creazione del partecipante. I dati dei partecipanti devono essere impostati (CIF, nome e paese)',
              commercial: {
                relation: {
                  data: 'Mancano dati relativi alle relazioni commerciali dei partecipanti'
                }
              },
              media: {
                value: 'Il valore del supporto del partecipante deve essere impostato',
                type: 'Il tipo di media del partecipante deve essere impostato',
                to: {
                  delete: 'Si è verificato un errore durante l\'eliminazione dei supporti dei partecipanti. Manca il media dei partecipanti'
                }
              }
            },
            partyproject: 'Si è verificato un errore durante la creazione del partecipante. Servizio deve essere impostato',
            projectparty: {
              data: 'Dati del partecipante al progetto mancanti',
              role: 'I ruoli dei partecipanti devono essere impostati',
              role_required: 'I ruoli dei partecipanti devono essere impostati',
              enable: 'Il flag attivo del progetto deve essere impostato'
            },
            communicationmethod: {
              data: 'Mancano i dati del metodo di comunicazione del partecipante'
            },
            partycentre: {
              roletype: {
                data: 'Mancano dati di ruolo al centro'
              }
            },
            centre: {
              role: 'Ruoli al centro mancanti',
              data: 'Dati centrali mancanti',
              media: {
                value: 'Il valore del supporto centrale deve essere impostato',
                type: 'Il tipo di supporto centrale deve essere impostato',
                to: {
                  delete: 'Si è verificato un errore durante l\'eliminazione del centro intermedio. Manca il supporto centrale'
                }
              }
            },
            invoice: {
              note: {
                media: {
                  value: 'Il valore del supporto della fattura deve essere impostato',
                  type: 'Il tipo di supporto della fattura deve essere impostato',
                  default: {
                    flag: 'L\'impostazione predefinita del valore del supporto della fattura deve essere impostata'
                  },
                  role: 'Il ruolo dei media delle fatture deve essere impostato'
                },
                issue: {
                  date: 'Manca la data di emissione della fattura richiesta'
                },
                document: {
                  name: 'Nome del documento della nota di fattura mancante mancante',
                  format: 'Formato del documento della nota di fattura mancante mancante',
                  type: 'Tipo di documento nota di fattura mancante mancante'
                },
                recadv: {
                  data: 'Mancano i dati di avviso relativi alla ricevuta della nota di fatturazione'
                }
              },
              integration: {
                file: {
                  '': 'Manca il file della fattura',
                  extension: 'Estensione del file di integrazione della fattura richiesta mancante',
                  size: 'Dimensione del file di integrazione della fattura mancante mancante'
                }
              },
              project: 'Manca la fattura del servizio',
              seller: {
                '': 'Partecipante venditore di fattura non trovato',
                centre: {
                  code: 'Codice centro venditore del venditore richiesto mancante'
                }
              },
              buyer: {
                '': 'Parte acquirente della fattura non trovata',
                centre: {
                  code: 'Codice centro acquisti acquirente fattura mancante'
                }
              },
              number: 'Numero della fattura mancante',
              sender: 'Manca la festa del mittente della fattura',
              receiver: 'Manca la parte ricevente della fattura',
              status: 'Manca lo stato della fattura',
              document: {
                format: 'Formato del documento di fattura richiesto mancante',
                class: 'Classe di documento di fattura richiesta mancante',
                type: 'Tipo di documento di fattura richiesto mancante'
              },
              validity: {
                document: 'Documento di validità della fattura richiesto mancante'
              },
              correctedflag: 'Manca la flag di correzione della fattura richiesta',
              metadata: {
                file: {
                  extension: 'Estensione del file di metadati della fattura richiesta mancante'
                }
              },
              attachment: {
                extension: 'Manca l\'estensione per l\'allegato della fattura richiesta'
              },
              tax: {
                type: 'Manca il tipo di imposta sulla fattura richiesta',
                baseamount: 'Importo della base imponibile della fattura richiesto mancante',
                currency: 'Manca la valuta di imposta della fattura richiesta'
              },
              event: 'Evento di fattura richiesto',
              property: {
                '': 'Manca la proprietà della fattura richiesta',
                value: 'Valore di proprietà fattura richiesto mancante'
              },
              outstanding: {
                amount: 'Importo residuo della fattura richiesta mancante'
              },
              executable: {
                amount: 'Importo eseguibile fattura mancante mancante'
              },
              communication: {
                reception: {
                  name: 'Nome di ricezione della comunicazione richiesto mancante'
                }
              }
            },
            media: {
              type: 'Il tipo di supporto deve essere impostato'
            },
            centremedia: {
              project: 'Il centro di servizio deve essere impostato',
              role: 'Center media rol deve essere impostato'
            },
            partymedia: {
              role: 'Il ruolo dei media dei partecipanti deve essere impostato'
            }
          },
          update: {
            party: {
              taxid: 'Si è verificato un errore durante l\'aggiornamento della parte. Il numero di identificazione fiscale deve essere impostato'
            }
          },
          search: {
            party: {
              taxid: 'Si è verificato un errore durante la ricerca della parte. Il numero di identificazione fiscale deve essere impostato'
            }
          },
          commercial: {
            relation: {
              partytaxid: 'Il numero di identificazione fiscale deve essere impostato',
              role: 'Il ruolo del partecipante deve essere impostato'
            }
          },
          recadv: {
            integration: {
              file: {
                '': 'Manca il file di integrazione del consiglio di ricevimento richiesto',
                extension: 'Manca l\'estensione del file di avviso di ricevimento richiesta'
              }
            },
            status: 'Manca lo stato di avviso di ricevimento richiesto',
            number: {
              exception: 'Manca il numero di avviso di ricevimento richiesto'
            },
            receiving: {
              date: {
                time: {
                  extension: 'Manca la data di ricezione del consiglio di ricevimento richiesta'
                }
              }
            },
            validity: {
              document: 'Manca il documento di validità del consiglio di ricevimento richiesto'
            },
            document: {
              format: 'Manca il formato del documento di consiglio di ricevimento richiesto'
            },
            centre: 'Manca il centro di consulenza per la ricezione'
          },
          request: {
            compressed: {
              invoice: {
                flag: 'Richiesta richiesta compressa flag di richiesta mancante'
              }
            },
            invoice: {
              file: 'Manca il file di richiesta richiesta'
            }
          }
        },
        party: {
          not: {
            found: 'Partecipante non trovato'
          },
          project: {
            not: {
              found: 'Servizio non trovato o disabilitato'
            }
          },
          to: {
            delete: {
              not: {
                found: 'Partecipante non trovato'
              }
            }
          },
          commercial: {
            relation: {
              channel: {
                not: {
                  found: 'Canale del partecipante non trovato'
                }
              }
            }
          },
          deletion: 'Si è verificato un errore durante l\'eliminazione del partecipante',
          country: {
            not: {
              found: 'Paese del partecipante non trovato'
            }
          },
          media: {
            type: {
              not: {
                found: 'Tipo di media del partecipante non trovato'
              }
            },
            deletion: 'Si è verificato un errore durante l\'eliminazione dei supporti dei partecipanti',
            to: {
              delete: {
                not: {
                  found: 'Si è verificato un errore durante l\'eliminazione dei supporti dei partecipanti.'
                }
              }
            },
            invalid: {
              email: {
                format: 'e-mail media dei partecipanti non valida'
              }
            }
          }
        },
        commercial: {
          relation: {
            party: {
              not: {
                found: 'Relazione commerciale partecipante non trovata o disabilitata'
              }
            }
          }
        },
        incompatible: {
          integrated: {
            party: {
              for: {
                commercial: {
                  relation: 'Partecipante non valido, mancante ruolo valido'
                }
              }
            }
          },
          centre: {
            role: 'Ruolo del centro invalido',
            media: {
              data: {
                role: 'Ruolo del centro invalido'
              }
            }
          },
          party: {
            media: {
              data: {
                role: 'Ruolo del partecipante non valido'
              }
            }
          }
        },
        communication: {
          method: {
            not: {
              found: 'Metodo di comunicazione del partecipante non trovato'
            }
          }
        },
        centre: {
          role: {
            type: {
              not: {
                found: 'Center rol non trovato'
              }
            }
          },
          to: {
            delete: {
              not: {
                found: 'Centro non trovato'
              }
            }
          },
          deletion: 'Si è verificato un errore durante l\'eliminazione del centro',
          party: {
            not: {
              found: 'Centro del partecipante non trovato'
            }
          },
          not: {
            found: 'Centro non trovato'
          },
          country: {
            not: {
              found: 'centro del paese non trovato'
            }
          },
          media: {
            type: {
              not: {
                found: 'Tipo di media del centro non trovato'
              }
            },
            deletion: 'Errore durante l\'eliminazione del centro',
            to: {
              delete: {
                not: {
                  found: 'Si è verificato un errore durante l\'eliminazione del supporto centrale. Supporto centrale non trovato'
                }
              }
            },
            invalid: {
              email: {
                format: 'Email media del centro non valida'
              }
            }
          }
        },
        media: {
          type: {
            not: {
              found: 'Il canale di contatto specificato non è stato trovato'
            }
          }
        },
        centremedia: {
          project: {
            not: {
              found: 'Centro del servizio non trovato'
            }
          }
        },
        duplicate: {
          partymedia: {
            value: 'Media dei partecipanti duplicato'
          },
          centremedia: {
            value: 'Media dei partecipanti duplicato'
          }
        },
        recadvLine: {
          currency: {
            not: {
              found: 'Valuta della linea di avviso ricevuta non trovata'
            }
          },
          unitOfMeasure: {
            notFound: 'Unità di misura della linea di avviso di ricevimento non trovata'
          }
        },
        document: {
          generation: {
            format: {
              class: {
                not: {
                  found: 'Classe di mappatura del formato del documento non trovata'
                }
              }
            }
          }
        },
        unzipped: {
          request: {
            invoice: {
              file: 'La richiesta di fattura è configurata per trasportare solo un file di fattura zippato, ma ha uno decompresso'
            },
            attachments: 'La richiesta di fattura è configurata per trasportare solo allegati zippati, ma ha solo uno decompresso'
          }
        },
        zipped: {
          request: {
            invoice: {
              file: 'La richiesta di fattura è configurata per trasportare solo un file di fattura non compresso, ma ha un file zippato'
            },
            attachments: 'La richiesta di fattura è configurata per portare solo un allegato non compresso, ma la richiesta ha uno o più zip'
          }
        },
        different: {
          invoice: {
            number: 'Il numero di fattura della richiesta è diverso da quello estratto dal file di fattura allegato'
          },
          seller: {
            tax: {
              identification: {
                number: 'L\'ID IVA del venditore dalla richiesta è diverso da quello estratto dal file di fattura attatached'
              }
            }
          }
        }
      }
    }
  },
  // Errores/mensajes en Integración de factura

  translation: {
    instances: {
      added: 'Aggiunta traduzione di istanze'
    },
    processingtime: 'Durata nel completamento della traduzione'
  },
  error_code: {
    document: {
      entrieszip: {
        '': 'Impossibile decomprimere lo zip',
        format: {
          invalid: 'Struttura/formato del file di input errato'
        }
      },
      attachments: {
        directory: {
          name: {
            invalid: 'Il nome della directory degli allegati non è valido'
          }
        }
      },
      file: {
        name: {
          invalid: 'Il nome di uno dei file di input non è valido'
        },
        format: 'Errore nel formato del file di input'
      },
      read: {
        country: 'Errore durante la lettura del file, non è possibile determinare il Paese'
      }
    },
    ai: {
      translationfail: 'Errore nella traduzione AI del file'
    },
    ruleinformation: {
      notfound: 'Regola non trovata'
    }
  },
  EXTRACTION_INVOICE: {
    ERROR: 'Si è verificato un errore durante l\'estrazione della fattura dal file compresso'
  },
  EXTRACTION_ATTACHMENT: {
    ERROR: 'Si è verificato un errore durante l\'estrazione degli allegati dal file compresso'
  },
  TRANSLATION_MAP: {
    ERROR: 'Si è verificato un errore durante l\'applicazione della mappa alla fattura'
  },
  SIGNATURE: {
    '': 'Fase della firma del file',
    ERROR: 'Si è verificato un errore durante la firma della fattura'
  },
  signature: {
    sax: {
      exception: {
        parsing: {
          document: 'Si è verificato un errore durante la firma della fattura, formato errato'
        }
      }
    },
    signature: {
      exception: {
        signing: 'Si è verificato un errore durante la firma della fattura'
      }
    }
  },
  RECOGNITION: {
    '': 'Fase di riconoscimento del file di input',
    ERROR: 'Si è verificato un errore durante il riconoscimento del file'
  },
  vltrader: {
    senddt: 'Data di invio',
    sender: {
      host: 'Ospite',
      mailbox: 'Mailbox'
    },
    sendid: 'Invio identificativo',
    totalattempts: 'Numero di tentativi',
    transfer: {
      enddt: 'Data di fine della spedizione',
      resulttext: 'Risultato di spedizione',
      startdt: 'Data di inizio della spedizione',
      status: 'Invio dello stato dei risultati',
      transferid: 'Identificatore di consegna'
    }
  },
  wsserver: {
    profile: 'Profilo',
    requestid: 'Identificatore della richiesta'
  },
  DUPLICATED_INVOICE_ERROR: 'Errore per fattura  duplicata',
  EDICOM_CDR_NEGATIVE: 'CDR negativo',
  996: '996',
  CIF_REQUIRED: 'La Partita Iva è un campo obbligatorio',
  ACTION_REQUIRED: 'L\'azione è un campo obbligatorio',
  DESCRIPTION_REQUIRED: 'La descrizione è un campo obbligatorio',
  CANAL_REQUIRED: 'Il canale è un campo obbligatorio',
  EMAIL_REQUIRED: 'L\'email è un campo obbligatorio',
  PARTY_BUYER_NOTFOUND: 'L\'impresa del cliente non esiste',
  PROJECT_PARTY_DISABLED: 'L\'azienda è disabilitata per il servizio indicato',
  PARTY_DISABLED: 'L\'azienda è disabilitata',
  COMMUNICATION_METHOD_NOTFOUND: 'Il metodo di comunicazione non esiste',
  EMAIL_INVALID: 'L\'email non è corretta',
  ACTION_UNEXPECTED: 'L\'operazione non è corretta',
  READ_FILE_BUYERS_ERROR: 'Errore imprevisto durante la lettura del file di contrattazione delle imprese clienti',
  UPDATE_PARTY_ERROR: 'Errore di aggiornamento dei dati dell\'impresa',
  CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Errore durante la creazione del metodo di consegna associato alla società',
  CREATE_PARTY_MEDIA_ERROR: 'Errore durante la creazione dell\'email associata alla società cliente',
  CREATE_USER_PARTY_ERROR: 'Errore durante la creazione dell\'utente associato alla società cliente',
  CREATE_PARTY_ERROR: 'Errore durante la creazione della società',
  CREATE_USER_ERROR: 'Errore durante la creazione dell\'utente',
  CREATE_PROJECT_PARTY_ERROR: 'Errore durante la creazione della relazione tra il progetto e la società',
  CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Errore nella creazione della relazione commerciale tra l\'impresa sponsor e l\'impresa cliente',
  EDICOM_ACK_NEGATIVE: 'ACK negativo',
  NO_PERSON_CODE_VALID: 'Codice persona non valido',
  PARTY_NIF_EXIST: 'La società NIF esiste già',
  PARTY_GLN_EXIST: 'La società GLN esiste già',
  WITHOUT_DATA_REQUIRED: 'Dati obbligatori mancanti',
  WITHOUT_DATA_REQUIRED_INVALID: 'Dati obbligatori mancanti o non validi',
  LOGO_ERROR: 'Errore con il logo',
  MIME_TYPE_LOGO_ERROR: 'Errore di formato del logo',
  FILE_BASE64_ERROR: 'Errore del file Base64',
  NO_COUNTRY_CODE_VALID: 'Codice del paese non valido',
  CENTRE_ERROR: 'Errore del centro',
  COMMUNICATION_METHOD_ERROR: 'Errore del metodo di comunicazione',
  EMAIL_ERROR: 'Errore di posta elettronica',
  PARTY_USER_ERROR: 'Impossibile assegnare l\'utente all\'entità',
  PROJECT_PARTY_NIF_NOT_EXIST: 'Non cè compagnia con questo NIF',
  CREATED: 'Creato',
  DELETED: 'Eliminato',
  UPDATED: 'Aggiornato',
  EDICOM_CDR_POSITIVE: 'CDR positivo',
  CENTRE_NOT_EXIST: 'Non esiste la sede',
  USER_EXIST: 'L\'utente esiste già',
  USER_NOT_EXIST: 'L\'utente non esiste',
  USER_NOT_LOCKED: 'Utente non bloccato',
  USER_NOT_REMOVED: 'Utente non rimosso',
  USER_NOT_PROJECT: 'L\'utente non è del servizio',
  USER_NIF_EXIST: 'C\'è già un utente con questo NIF',
  PROJECT_NOSENDER: 'Metodo di spedizione errato. Il progetto non è trasmesso',
  SELLER_NOSPONSOR: 'Metodo di spedizione errato. La società non è uno sponsor.',
  PROJECT_NO_DELIVERY_METHOD: 'Metodo di spedizione non trovato per il progetto.',

  // Códigos para propiedades de auditorías
  invoice: {
    integrated: {
      b2bintegration: 'Numero di fattura B2B correttamente integrato',
      ws: 'Numero di fattura per webservice integrato con successo',
      upload: 'Numero di fattura integrato con successo'
    },
    note: {
      media: {
        type: {
          not: {
            found: 'Media type non trovato'
          }
        },
        invalid: {
          email: {
            format: 'Email media della fattura non valida'
          }
        }
      },
      document: {
        not: {
          found: 'Documento fattura non trovato'
        }
      },
      recadv: {
        not: {
          found: 'Avviso sulla ricevuta della nota della fattura non trovata'
        }
      },
      attachment: {
        category: {
          not: {
            found: 'Categoria allegato nota fattura non trovata'
          }
        },
        user: {
          not: {
            found: 'Utente allegato nota fattura non trovato'
          }
        }
      }
    },
    project: {
      not: {
        found: 'Servizio di fattura non trovato'
      },
      category: {
        not: {
          found: 'Categoria del progetto di fattura non trovata'
        }
      }
    },
    sender: {
      not: {
        found: 'Mittente del destinatario della fattura non trovato'
      }
    },
    receiver: {
      not: {
        found: 'Ricevitore di fatture non trovato'
      }
    },
    thirdparty: {
      not: {
        found: 'Fattura di terze parti non trovata'
      }
    },
    status: {
      not: {
        found: 'Stato fattura non trovato'
      }
    },
    currency: {
      not: {
        found: 'Valuta della fattura non trovata'
      }
    },
    document: {
      format: {
        not: {
          found: 'Formato del documento di fattura non trovato'
        }
      },
      class: {
        not: {
          found: 'Classe del documento di fattura non trovata'
        }
      },
      type: {
        not: {
          found: 'Tipo di documento di fattura non trovato'
        }
      }
    },
    type: {
      not: {
        found: 'Tipo di fattura non trovato'
      }
    },
    validity: {
      document: {
        not: {
          found: 'Documento di validità della fattura non trovato'
        }
      }
    },
    communication: {
      method: {
        not: {
          found: 'Metodo di comunicazione della fattura non trovato'
        }
      }
    },
    auditdocument: {
      not: {
        found: 'Documento di revisione fattura non trovato'
      }
    },
    accounting: {
      close: {
        not: {
          found: 'Conteggio fattura chiuso non trovato'
        }
      }
    },
    recept: {
      comm: {
        method: {
          not: {
            found: 'Metodo di comunicazione per la ricezione della fattura non trovato'
          }
        }
      }
    },
    internal: {
      status: {
        not: {
          found: 'Stato interno fattura non trovato'
        }
      }
    },
    batch: {
      not: {
        found: 'Fattura della fattura non trovata'
      }
    },
    channel: {
      not: {
        found: 'Canale di fattura non trovato'
      }
    },
    seller: {
      centre: {
        not: {
          found: 'Centro venditore non trovato'
        },
        roletype: {
          not: {
            found: 'Tipo di ruolo del centro venditore non trovato'
          }
        }
      }
    },
    buyer: {
      centre: {
        not: {
          found: 'Centro acquisti non trovato'
        },
        roletype: {
          not: {
            found: 'Tipo di ruolo centrale acquirente non trovato'
          }
        }
      }
    },
    tax: {
      type: {
        not: {
          found: 'Tipo di imposta sulla fattura non trovata'
        }
      },
      currency: {
        not: {
          found: 'Valuta imposta fattura non trovata'
        }
      }
    },
    user: {
      does: {
        not: {
          belong: {
            to: {
              party: 'L\'utente della richiesta non appartiene alla parte del suo codice fiscale del venditore'
            }
          }
        }
      }
    }
  },
  recadv_code: {
    integrated: {
      b2bintegration: 'Numero di consigli di ricevimento B2B integrati'
    },
    status: {
      not: {
        found: 'Stato dell\'avviso di ricevimento non trovato'
      }
    },
    validity: {
      document: {
        not: {
          found: 'Documento di validità del consiglio di ricezione non trovato'
        }
      }
    },
    document: {
      format: {
        not: {
          found: 'Formato del documento di consiglio di ricevimento non trovato'
        }
      }
    },
    centre: {
      not: {
        found: 'Centro di consulenza per le ricevute non trovato'
      }
    }
  },
  unexpected: {
    error: 'Errore imprevisto durante l\'elaborazione della richiesta o del suo documento'
  },
  FACTURAE_INVALID: 'Fattura non valida',
  validation: {
    noDocumentType: 'Il tipo di documento deve essere impostato',
    retry: 'Le convalide devono riprovarsi',
    invoicePeriodDates: 'La data di inizio del periodo di fatturazione deve essere precedente alla data di fine',
    invoiceCorrectivePeriodDates: 'La data di inizio del periodo di rettifica deve essere precedente alla data di fine',
    signature: 'La fattura non è firmata',
    nif: 'Partita Iva non valida',
    attachmentformat: 'Tipo di allegato non consentito, sono supportate solo le estensioni: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
    attachmentformat321: 'Tipo di allegato non consentito, sono supportate solo le estensioni: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
    error: 'Formato file errato',
    invoicedocument: 'Il campo "valore" del tipo documento "Numero sequenza / riga" deve essere di tipo numerico',
    ep: {
      errorclientnoepcanarias: 'Per fatturare i servizi nelle Isole Canarie, controlla entrambi gli indicatori di stabile organizzazione.',
      errorclientnoepceuta: 'Per fatturare i servizi nelle Ceuta, controlla entrambi gli indicatori di stabile organizzazione.',
      clientepproveedorpencanarias: 'Per fatturare i servizi nella Penisola deseleziona l indicatore relativo alla tua stabile organizzazione nelle Isole Canarie.',
      clientepproveedorpenceuta: 'Per fatturare i servizi nella Penisola deseleziona l indicatore relativo alla tua stabile organizzazione a Ceuta.',
      clientepproveedornocanarias: 'Per fatturare i servizi alle Isole Canarie, controlla l indicatore della tua stabile organizzazione.',
      clientepproveedornoceuta: 'Per fatturare i servizi a Ceuta, controlla l indicatore della tua stabile organizzazione.',
      clientecanariasceuta: 'Per fatturare i servizi nelle Isole Canarie, deseleziona la casella relativa alla tua stabile organizzazione a Ceuta.',
      errorclientnoepceutacanarias: 'Per fatturare i servizi a Ceuta, deseleziona la casella relativa alla tua stabile organizzazione nelle Isole Canarie.'
    },
    buyer: {
      address: "L'identificazione del tipo di residenza non è corretta per la società acquirente.",
      noAddress: 'Non esiste un indirizzo per la società acquirente',
      noCountry: 'Non esiste un paese per la società acquirente',
      noPostCode: 'Non esiste un codice postale per la società acquirente',
      invalidPostCode: 'Il codice postale assegnato alla società acquirente non deve essere inferiore a 5 cifre',
      noProvince: 'Non esiste una provincia per la società acquirente',
      noTown: 'Non esiste una città per la società acquirente',
      centres: {
        rol: 'Nessun centro dell\'acquirente è stato incluso per il tipo di ruolo richiesto: {argumento}.',
        rolbyvalues: 'Nessun centro dell\'acquirente è stato incluso per il tipo di ruolo richiesto: {argumento}.',
        roletype: {
          notfound: 'Il ruolo di centro da convalidare per l\'acquirente non esiste: {argumento}'
        }
      }
    },
    buyerCentre: {
      noAddress: 'Non esiste un indirizzo per il centro acquisti',
      noCountry: 'Non esiste un paese per il centro acquisti',
      noPostCode: 'Non esiste un codice postale per il centro acquisti',
      invalidPostCode: 'Il codice postale assegnato al centro acquisti non deve essere inferiore a 5 cifre',
      noProvince: 'Non esiste una provincia per il centro acquisti',
      noTown: 'Non esiste una città per il centro acquisti'
    },
    seller: {
      address: "L'identificazione del tipo di residenza non è corretta per la società venditrice.",
      noAddress: 'Non esiste un indirizzo per la società venditrice',
      noCountry: 'Non esiste un paese per la società venditrice',
      noPostCode: 'Non esiste un codice postale per la società venditrice',
      invalidPostCode: 'Il codice postale assegnato alla società venditrice non deve essere inferiore a 5 cifre',
      noProvince: 'Non esiste una provincia per la società venditrice',
      noTown: 'Non esiste una città per la società venditrice',
      centres: {
        rol: 'Nessun centro del venditore è stato incluso per il tipo di ruolo richiesto: {argumento}.',
        rolbyvalues: 'Nessun centro del venditore è stato incluso per il tipo di ruolo richiesto: {argumento}.',
        roletype: {
          notfound: 'Il ruolo di centro da convalidare per il venditore non esiste: {argumento}'
        }
      }
    },
    sellerCentre: {
      noAddress: 'Non esiste un indirizzo per il centro vendita',
      noCountry: 'Non esiste un paese per il centro vendita',
      noPostCode: 'Non esiste un codice postale per il centro vendita',
      invalidPostCode: 'Il codice postale assegnato al centro vendita non deve essere inferiore a 5 cifre',
      noProvince: 'Non esiste una provincia per il centro vendita',
      noTown: 'Non esiste una città per il centro vendita'
    },
    party: {
      noTaxId: 'Il numero di identificazione fiscale deve essere impostato',
      noProject: 'Servizio deve essere impostato',
      buyer: {
        notInProject: 'Il acquirente non esiste nel progetto o è disabilitato',
        invalidName: 'Il nome dell\'azienda acquirente non è corretto, deve corrispondere all\'espressione regolare {argumento}\nDovrebbe essere {argumento1}',
        addressvalue: 'Il indirizzo del destinatario della fattura non è valido, deve essere Paseo Conde de los Gaitanes n 177 per fatture dalla penisola, o Calle Juan de Quesada n 9 per fatture dalle Isole Canarie.'
      },
      seller: {
        notInProject: 'Il venditore non esiste nel progetto o è disabilitato',
        invalidName: 'Il nome dell\'azienda venditore non è corretto, deve corrispondere all\'espressione regolare {argumento}\nDovrebbe essere {argumento1}'
      },
      noSeller: 'Il numero di identificazione fiscale del venditore deve essere impostato',
      noBuyer: 'Il numero di identificazione fiscale dell\'acquirente deve essere impostato',
      noRelation: 'Nel progetto non esiste una relazione commerciale tra venditore e acquirente',
      noSponsor: 'Il partecipante non è sponsor nel progetto',
      disabled: 'Il partecipante è disabilitata',
      disabledInProject: 'Il partecipante è disabilitato nel progetto',
      invalidExpresion: 'L\'espressione regolare per convalidare il nome della società con NIF {argumento} non è corretta'
    },
    parties: {
      noSponsor: 'Nessuna delle due parti è uno sponsor nel progetto.'
    },
    centre: {
      role: {
        type: 'Il ruolo di centro non è valido per il formato'
      },
      roletype: {
        notfound: 'Il ruolo di centro selezionato non esiste'
      },
      noCentreCode: 'Il codice Center deve essere impostato',
      noParty: 'Il partecipante deve essere impostata',
      buyer: {
        notInParty: 'Uno o più centri acquirenti non esistono per l\'azienda o sono disabilitati'
      },
      seller: {
        notInParty: 'Uno o più centri venditti non esistono per l\'azienda o sono disabilitati'
      },
      noCentreUnique: 'I centri devono essere unici'
    },
    document: {
      noDocument: 'Le documento devono essere impostate'
    },
    phisical: {
      gln: 'Casella di posta fisica obbligatoria'
    },
    schematron: {
      error: 'Errore nella convalida della fattura: {argumento}'
    },
    kosit: {
      error: 'Errore nella convalida della fattura: {argumento}'
    },
    invoice: {
      currency: 'Valuta non inclusa',
      currencyExchange: 'Tasso di cambio errato o non riportato',
      currencyExchangeDate: 'Data del tasso di cambio errata o non riportata',
      iban: 'Il formato del IBAN sbagliato',
      ibanNull: 'IBAN disinformato',
      registrationData: 'I dati del registro di commercio inseriti in fattura non corrispondono ai dati registrati nel B2B',
      sequenceNumber: 'La posizione dell ordine è obbligatoria per l ordine indicato{argumento}',
      correctiveSign01pos: 'Factura rectificativa de tipo Rectificación Integra deben ser positivas',
      correctiveSign02pos: 'Factura rectificativa de tipo Rectificación por diferencias deben ser positivas',
      correctiveSign03pos: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser positivas',
      correctiveSign04pos: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser positivas',
      correctiveSign01neg: 'Factura rectificativa de tipo Rectificación Integra deben ser negativas',
      correctiveSign02neg: 'Factura rectificativa de tipo Rectificación por diferencias deben ser negativas',
      correctiveSign03neg: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser negativas',
      correctiveSign04neg: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser negativas',
      noInvoice: 'Nessuna compagnia è stata inserit',
      noInvoiceLine: 'Nessuna riga di fattura è stata inclusa o uno o più sono nulle',
      noInvoiceNumber: 'Nessun numero di fattura è stato inserito',
      noParty: 'Nessuna compagnia è stata inserita',
      noProject: 'Nessun servizio è stato inserito',
      duplicate: 'Fattura  duplicata {argumento}',
      issuedate: 'La data della fattura non corrisponde alla fattura precedente ricevuta con la data di emissione {argumento}',
      dates: 'La data dell\'operazione deve essere inferiore o uguale alla data di rilascio',
      invalidOperationDate: 'La data dell\'operazione non può essere successiva al giorno {argumento} ({argumento1} giorno e {argumento2} mesi dalla data di emissione)',
      invalidOperationDateEnd: 'La data dell\'operazione non può essere successiva al giorno {argumento} (Ultimo giorno del mese {argumento2} dalla data di emissione)',
      invalidInvoicingPeriod: 'La data di fine del periodo di fatturazione non può essere superiore al {argumento} ({argumento1} giorno e {argumento2} mesi dalla data di emissione)',
      invalidInvoicingPeriodEnd: 'La data di fine del periodo di fatturazione non può essere superiore al {argumento} (Ultimo giorno del mese {argumento2} dalla data di emissione)',
      invalidWithholdingAmount: 'La trattenuta in garanzia dovrebbe essere {argumento}',
      invalidNegativeWithholdingAmount: 'La trattenuta in garanzia deve essere positiva',
      simultaneousTransactionAndContract: 'La fattura non può indicare contemporaneamente contratto e ordine; deve indicare esattamente uno dei due',
      contractNotFoundRecadv: 'Non è stata trovata alcuna certificazione/ricevuta con numero {argumento}, stato {argumento1} per fornitore, cliente e ordine specificati nella fattura',
      recadvNotFound: 'La recensione {argumento} della riga {argumento1} non è stata pubblicata dall acquirente, o non è in uno stato fatturabile.',
      contractNotFound: 'Deve indicare certificazione/ricezione, line {argumento}',
      duplicateContractFoundRecadv: 'È stata trovata più di una reception',
      orderNotFound: 'Deve indicare l ordine, line {argumento}',
      orderContractNotFound: 'Deve indicare ordine e certificazione/ricevuta, line {argumento}',
      differentOrder: 'L\'ordine indicato nel file ({argumento}) non corrisponde a quello registrato ({argumento1})',
      currencyNotEur: 'Sono accettate solo fatture in euro',
      igicNotInCanary: 'La fattura include l\'imposta IGIC: \n {argumento} \n {argumento1}',
      ipsiNotInCeuta: 'La fattura include l\'imposta IPSI: \n {argumento} \n {argumento1}',
      tooMuchAttachments: 'La fattura supera il massimo di file allegati configurati ({argumento} file/s)',
      notAllowedAttachedExtension: 'L\'estensione dell\'allegato non è consentita. È consentito {argumento}',
      taxesNotInProject: 'Le seguenti tasse non sono incluse nel progetto: {argumento}',
      taxRateNotRegistered: 'Per l\'imposta {argumento}, sono ammesse solo le aliquote (%): {argumento1}',
      notAllowedFileFormat: 'Il formato del file ({argumento}) non è consentito. Sono consentiti i formati: {argumento1}',
      noIssueDate: 'Nessuna data di emissione è stata inserita',
      noOperationDate: 'Nessuna data di operazione è stata inserita',
      noIssuerType: 'Nessun tipo di emittente è stato inserito',
      issuerType: 'Il tipo di emittente della fattura non è valido',
      issuerTypeError: 'I dati necessari non sono inseriti per eseguire la convalida',
      noModalityType: 'La modalità fattura non corrisponde a uno dei valori accettati',
      modalityType: 'Il tipo di fattura deve essere individuale',
      modalityTypeError: 'I dati necessari non sono inseriti per eseguire la convalida',
      taxCeroLegalText: 'Per l  imposta 0 è necessario informare un testo legale',
      specificCanary: 'Convalida specifica delle Isole Canarie, IVA positiva',
      specificCeuta: 'Convalida specifica de Ceuta, IVA positiva',
      noIgicIva: 'La fattura non contiene un metodo di pagamento',
      exitsPaymentDetails: 'La factura no contiene método de pago',
      receiverTransactionReferenceNotFound: 'La fattura {argumento} non contiene il numero d\'ordine né nell\'intestazione né nelle righe',
      documentValuesRecadv: 'Riga {argumento}. L\'argomento {argumento1} \'{argumento2}\' non corrisponde a quello indicato nella ricezione',
      documentValuesRecadvDeliveryNote: 'Riga {argumento}. L\'argomento {argumento1} \'{argumento2}\'  della ricevuta non corrisponde a quanto indicato nella fattura',
      lineDataFromRecadv: 'Riga {argumento}. La riga dell\'ordine: {argumento1} non corrisponde a nessuna riga della ricevuta',
      lineDataFromRecadvValue: 'Riga {argumento}. {argumento1} : {argumento2}, non corrisponde alla riga della ricezione',
      lineDataFromRecadvTax: 'Riga {argumento}. L\'imposta con tipo {argumento1}, e con percentuale {argumento2} non corrisponde alla riga della ricevuta',
      project: {
        notSender: 'Il progetto non ha attivato il ruolo di emissione indicato per la fattura',
        notReceiver: 'Il progetto non ha attivato il ruolo di ricezione indicato per la fattura'
      },
      noRole: 'Il ruolo della fattura (emittente o destinatario) deve essere stabilito',
      communication: {
        method: 'Il metodo di comunicazione della fattura non è contratto per il tuo progetto'
      },
      lines: {
        invalidOperationDate: 'Numero di riga {argumento3}. La data dell\'operazione non può essere successiva al giorno {argumento} ({argumento1} giorno e {argumento2} mesi dalla data di emissione)',
        invalidOperationDateEnd: 'Numero di riga {argumento3}. La data dell\'operazione non può essere successiva al giorno {argumento} (Ultimo giorno del mese {argumento2} dalla data di emissione)',
        invalidInvoicingPeriod: 'Numero di riga {argumento3}. La data di fine del periodo di fatturazione non può essere superiore al {argumento} ({argumento1} giorno e {argumento2} mesi dalla data di emissione)',
        invalidInvoicingPeriodEnd: 'Numero di riga {argumento3}. La data di fine del periodo di fatturazione non può essere superiore al {argumento} (Ultimo giorno del mese {argumento2} dalla data di emissione)',
        total: {
          error: 'La riga totale senza tasse non corrisponde al prodotto della quantità per prezzo unitario',
          discountscharges: {
            error: 'La riga totale con addebiti e sconti non corrisponde all\'importo lordo della riga'
          }
        },
        positive: 'Prezzi e quantità devono essere positivi',
        negative: 'Tutti i prezzi devono essere negativi e le quantità positive',
        sametax: 'La fattura non può contenere la stessa imposta sulla stessa riga',
        totalPositive: 'L importo totale della fattura deve essere positivo'
      },
      total: {
        error: 'La fattura totale senza addebiti o sconti generali non corrisponde alla somma delle righe totali con sconti e addebiti',
        discountscharges: {
          error: 'La fattura totale con spese generali e sconti non corrisponde alla fattura totale al lordo delle imposte',
          taxes: {
            error: 'Il totale della fattura non corrisponde al totale della fattura al lordo delle imposte più le imposte totali passate e meno le imposte totali trattenute'
          }
        },
        taxes: {
          error: 'Il totale delle imposte dichiarate non corrisponde alla somma delle imposte'
        }
      },
      totalexecutable: {
        error: 'Il totale eseguibile della fattura non corrisponde al totale da pagare meno sussidi, anticipazioni e ritenute e più forniture e spese finanziarie'
      },
      accounting: {
        error: 'La fattura non soddisfa nessuna delle convalide contabili'
      },
      centre: {
        mask: 'Maschera centrale non valida',
        rol: 'Ruolo centrale non valido'
      },
      corrective: {
        method: 'Metodo di correzione {argumento} non supportato dal destinatario della fattura correttiva'
      },
      buyer: {
        centre: 'Centro acquirente non informato'
      },
      noOrder: 'Nessun ordine è stato incluso nella linea di ricezione',
      order: {
        noLine: 'L\'ordine {argumento} incluso nella linea di ricezione non può essere trovato',
        missingData: 'Dati obbligatori mancanti su una o più righe dell\'ordine {argumento}'
      },
      recadv: {
        additionalInfo: 'Il valore {argumento} della proprietà {argumento1} non è presente nelle informazioni aggiuntive della fattura.',
        noAdditionalInfo: 'La fattura non contiene le informazioni aggiuntive relative alla ricezione {argumento}',
        additionalInfoNoProperty: 'La proprietà {argumento1} non è stata inclusa nelle informazioni aggiuntive della ricezione {argumento}.',
        noData: 'Non sono state incluse informazioni nella ricezione {argumento}',
      }
    },
    recadv: {
      noRecadv: 'Nessuna ricezione è stata inserita',
      noRecadvNumber: 'Nessun numero di ricezione è stato inserito',
      noSeller: 'Nessuna società di vendita è stata inserita',
      noBuyer: 'Nessuna compagnia acquirente è stata inserita',
      duplicate: 'Ricev duplicato'
    },
    sign: {
      noParty: 'Nessuna compagnia è stata inserita',
      noSign: 'La società emittente non ha una firma delegata'
    },
    order: {
      noOrder: 'Il numero dell\'ordine è obbligatorio',
      noUnique: 'Il numero dell\'ordine deve essere univoco sulla fattura',
      noOrderIssuer: 'Il numero dell\'emittente dell\'ordine è obbligatorio',
      noUniqueIssuer: 'Il numero d\'ordine dell\'emittente deve essere univoco sulla fattura',
      invalidPatternIssuer: 'Il formato del numero dell\'ordine dell\'emittente non è valido',
      noPattern: 'Il modello non è configurato',
      invalidPattern: 'Il numero dell\'ordine incluso non è conforme al formato richiesto dal destinatario',
      error: 'Sono necessari più dati da convalidare il numero dell\'ordine'
    },
    documentCycle: {
      noOrder: 'Non sono state incluse informazioni sufficienti sull\'ordine',
      orderResponseRequired: "Non è possibile generare la bolla di consegna se l'ordine non è stato precedentemente accettato",
      order: {
        type: {
          noParams: 'La classe del ciclo è errata, devi indicare parametri aggiuntivi indicando il tipo e il sottotipo da convalidare'
        },
        invalid: {
          type: 'Non è possibile creare una fattura per questo ordine, deve avere il tipo "{argumento}"',
          subtype: 'Non è possibile creare una fattura per questo ordine, deve avere il sottotipo "{argumento}"'
        }
      }
    },
    expediente: {
      noExp: 'Il numero del file è obbligatorio',
      noUnique: 'Il numero del file deve essere univoco sulla fattura',
      noPattern: 'Il modello non è configurato',
      invalidPattern: 'Il numero di file incluso non è conforme al formato richiesto dal destinatario',
      error: 'Sono necessari più dati da convalidare il numero di file'
    },
    contract: {
      noContract: 'Il numero di contratto è obbligatorio',
      invalidPattern: 'Il numero di contratto incluso non è conforme al formato richiesto dal destinatario',
      noUnique: 'Il numero del file deve essere univoco sulla fattura',
      noPattern: 'Il modello non è configurato',
      error: 'Sono necessari più dati da convalidare il numero di contratto'
    },
    transaction: {
      noTransaction: 'Il numero della transazione è obbligatorio'
    },
    invoiceCorrective: {
      dates: 'La data iniziale e finale del periodo fiscale non sono valide',
      number: 'Il numero di fattura è obbligatorio per le fatture di tipo rettifica completa e rettifica per differenze',
      noNumber: 'Il numero della fattura è obbligatorio per le fatture di tipo rettifica',
      invalidPattern: 'Il formato del numero di fattura rettificato non è valido',
      noValue: 'Non è stato allegato alcun documento con valore',
      noOrderValue: 'Deve indicare l ordine del destinatario',
	  required: 'Il campo "Correzione" è obbligatorio per una fattura rettificativa'
    },
    project: 'Servizio non esiste o è disabilitato',
    project: {
      disabled: 'Servizio non esiste o è disabilitato',
      noProject: 'Servizio deve essere impostato',
      attachment: {
        notfound: 'La directory degli allegati della fattura del progetto da integrare non esiste'
      }
    },
    issue: {
      date: {
        future: 'La data di emissione è successiva alla sua data di creazione di {argumento} giorni. La data massima di emissione consentita è: {argumento1}',
        past: 'La data di emissione è precedente alla sua data di creazione di {argumento} giorni. La data minima di emissione consentita è: {argumento1}'
      }
    },
    commercial: {
      relation: {
        channel: 'La relazione commerciale tra venditore, acquirente e canale non esiste'
      }
    },
    channel: {
      not: {
        found: 'Il canale non esiste'
      }
    },
    invoiceNumber: {
      error: 'Non è stato possibile convalidare il formato del numero di fattura: mancano i dati richiesti',
      noPattern: 'Nessun modello di numero di fattura configurato',
      invalidPattern: 'Formato numero di fattura non valido'
    },
    b2bvalidationws: {
      nourl: 'Non esiste una URL associata al WS o non è valida',
      metadataerror: 'Si prodursi un errore cercando di ottenere l\'archivio di metadati.',
      connectionerror: 'Si prodursi un errore durante la connessione col servizio del cliente.',
      wrongresponse: 'Il WS cliente restituì una respesta scorretta.',
      errorresponse: 'Il WS cliente restituì una risposta di ERRORE.'
    },
    valid: {
      iban: 'Errore di convalida dell IBAN.'
    },
    payment: {
      mean: 'Errore: la fattura non contiene metodi di pagamento supportati.'
    },
    file: {
      size: 'Errore: la fattura e gli allegati superano la dimensione massima consentita.'
    },
    nif: {
      codpais: 'Errore nella convalida del codice paese in NIF {argumento}. Il paese deve essere indicato davanti al NIF.'
    },
    line: {
      noDescription: 'Alcune linee non hanno descrizione',
      transactionReference: 'Tutte le righe devono contenere IssuerTransactionReference e/o ReceiverTransactionReference',
      sequence: {
        number: 'Tutte le righe devono avere lo stesso sequence number'
      }
    },
    noPublicOrganismCode: 'L\'ente pubblico proponente non è stato informato – DIR3',
    delivery: {
      noDeliveryDate: 'La data di consegna è obbligatoria',
      duplicate: {
        '': 'Esiste già una note di consegna con il numero della bolla di consegna nello stato corretto',
        issueyear: 'Esiste già una note di consegna con il numero della bolla di consegna nello stato corretto nell\'anno in corso'
      },
      lines: {
        noBatch: 'Alcune linee non hanno un numero di lotto',
        noSerialNumber: 'Alcune linee non hanno un numero di serie',
        noExpirationDate: 'Alcune linee non hanno una data di scadenza',
        invalidDate: 'Alcune linee hanno una data di scadenza non successiva alla data di consegna',
        noQuantity: "La somma degli importi delle sottorighe non è uguale all'importo della riga madre",
        noSubline: 'Alcune righe della bolla di consegna non presentano righe secondarie',
        package: {
          invalidGtin14: 'Non è possibile associare linee con diversi codici GTIN14 allo stesso imballaggio. Le linee associate all\'imballaggio con SSCC {argumento} hanno codici GTIN14 diversi.'
        }
      }
    }
  },
  invalid: {
    validation: {
      code: {
        exception: 'Uno o più codici di convalida mancano di un metodo di convalida collegato'
      }
    },
    persontypecode: 'Si è verificato un errore durante la creazione della festa. Codice del tipo di persona non valido',
    name: {
      format: 'Nome del partecipante non valido, i caratteri devono essere in utf8'
    },
    facturae32: {
      xml: {
        format: 'Il formato del file di fattura Facturae 3.2 non è corretto o .xml'
      },
      schema: 'La fattura Facturae 3.2 contiene campi che non superano la convalida dello schema: '
    },
    facturae321: {
      xml: {
        format: 'Il formato del file di fattura Facturae 3.2.1 non è corretto o .xml'
      },
      schema: 'La fattura Facturae 3.2.1 contiene campi che non superano la convalida dello schema: '
    },
    facturae322: {
      xml: {
        format: 'Il formato del file di fattura Facturae 3.2.2 non è corretto o .xml'
      },
      schema: 'Il tipo di fattura Facturae 3.2.2 contiene campi che non superano la convalida dello schema: '
    },
    facturapdf: {
      xml: {
        format: 'Il formato del file di fattura PDF non è corretto o .xml'
      },
      schema: 'La fattura PDF contiene campi che non superano la convalida dello schema: '
    },
    edi: {
      date: {
        format: 'El formato de la fecha no es correcto'
      }
    },
    facturad01b: {
      edi: {
        format: 'Il formato del file di fatturazione non è corretto o .edi'
      }
    },
    facturad93a: {
      edi: {
        format: 'Il formato del file di fatturazione non è corretto o .edi'
      }
    },
    facturad96a: {
      edi: {
        format: 'Il formato del file di fatturazione non è corretto o .edi'
      }
    },
    facturad97a: {
      edi: {
        format: 'Il formato del file di fatturazione non è corretto o .edi'
      }
    },
    fatturapa12: {
      xml: {
        format: 'Il formato del file di fatturazione non è corretto o .xml'
      },
      schema: 'La fattura di tipo fatturapa12 contiene campi che non superano la convalida dello schema: '
    },
    recadv: {
      xml: {
        format: 'Il formato del file di consigli di ricevimento non è corretto o .xml'
      },
      schema: 'L\'avviso di ricevimento contiene campi che non superano la convalida dello schema: {argumento}'
    },
    fatturapaSemplificata1: {
      xml: {
        format: 'Il formato del file di fatturapa semplificato non è corretto o .xml'
      },
      schema: 'La fattura di tipo fatturapa sempleficato contiene campi che non superano la convalida dello schema: {argumento}'
    },
    fatturapa12cades: {
      xml: {
        format: 'Il formato del file di fatturapa 1.2 cades non è corretto o .xml'
      },
      schema: 'La fattura di tipo fatturapa 1.2 cades contiene campi che non superano la convalida dello schema: {argumento}'
    },
    fatturapaSemplificatacades: {
      xml: {
        format: 'Il formato del file di fatturapa semplificato non è corretto o .xml'
      },
      schema: 'La fattura di tipo fatturapa semplificato contiene campi che non superano la convalida dello schema: {argumento}'
    }
  },
  unable: {
    to: {
      save: {
        file: {
          in: {
            repository: 'Il file non può essere salvato'
          }
        }
      },
      get: {
        repository: {
          file: 'Si è verificato un errore durante il recupero del file'
        }
      },
      delete: {
        repository: {
          file: 'Il file non può essere cancellato'
        }
      }
    }
  },
  no: {
    repository: {
      date: 'È necessaria una data per salvare il file',
      project: {
        name: 'È necessario un nome di progetto per salvare il file'
      },
      file: 'Il file deve essere impostato per salvarlo',
      subpath: 'Subpath deve essere impostato per salvare il file'
    },
    file: {
      to: {
        save: {
          extension: 'L\'estensione del file deve essere impostata per salvare il file'
        }
      }
    },
    pathcomplete: {
      flag: 'Il percorso completo deve essere impostato per salvare il file'
    }
  },
  repository: {
    path: {
      not: {
        found: 'Percorso non trovato per salvare il file'
      }
    }
  },
  missing: {
    required: {
      party: {
        data: 'Si è verificato un errore durante la creazione del partecipante. I dati dei partecipanti devono essere impostati (CIF, nome e paese)',
        commercial: {
          relation: {
            data: 'Mancano dati relativi alle relazioni commerciali dei partecipanti'
          }
        },
        media: {
          value: 'Il valore del supporto del partecipante deve essere impostato',
          type: 'Il tipo di media del partecipante deve essere impostato',
          to: {
            delete: 'Si è verificato un errore durante l\'eliminazione dei supporti dei partecipanti. Manca il media dei partecipanti'
          }
        },
        documentcycle: {
          buyer: 'Manca il compratore del ciclo del documento',
          sourcetype: 'Manca il tipo di documento di origine del ciclo del documento',
          destinationtype: 'Manca il tipo di documento di destinazione del ciclo del documento',
          class: {
            source: 'Manca il senso della classe del ciclo del documento'
          }
        }
      },
      partyproject: 'Si è verificato un errore durante la creazione del partecipante. Servizio deve essere impostato',
      projectparty: {
        data: 'Dati del partecipante al progetto mancanti',
        role: 'I ruoli dei partecipanti devono essere impostati',
        enable: 'Il flag attivo del progetto deve essere impostato'
      },
      communicationmethod: {
        data: 'Mancano i dati del metodo di comunicazione del partecipante'
      },
      partycentre: {
        roletype: {
          data: 'Mancano dati di ruolo al centro'
        }
      },
      centre: {
        role: 'Ruoli al centro mancanti',
        data: 'Dati centrali mancanti',
        media: {
          value: 'Il valore del supporto centrale deve essere impostato',
          type: 'Il tipo di supporto centrale deve essere impostato',
          to: {
            delete: 'Si è verificato un errore durante l\'eliminazione del centro intermedio. Manca il supporto centrale'
          }
        }
      },
      invoice: {
        note: {
          media: {
            value: 'Il valore del supporto della fattura deve essere impostato',
            type: 'Il tipo di supporto della fattura deve essere impostato',
            default: {
              flag: 'L\'impostazione predefinita del valore del supporto della fattura deve essere impostata'
            },
            role: 'Il ruolo dei media delle fatture deve essere impostato'
          },
          issue: {
            date: 'Manca la data di emissione della fattura richiesta'
          },
          document: {
            name: 'Nome del documento della nota di fattura mancante mancante',
            format: 'Formato del documento della nota di fattura mancante mancante',
            type: 'Tipo di documento nota di fattura mancante mancante'
          },
          recadv: {
            data: 'Mancano i dati di avviso relativi alla ricevuta della nota di fatturazione'
          }
        },
        integration: {
          file: {
            '': 'Manca il file della fattura',
            extension: 'Estensione del file di integrazione della fattura richiesta mancante',
            size: 'Dimensione del file di integrazione della fattura mancante mancante'
          }
        },
        project: 'Manca la fattura del servizio',
        seller: {
          '': 'Partecipante venditore di fattura non trovato',
          centre: {
            code: 'Codice centro venditore del venditore richiesto mancante'
          }
        },
        buyer: {
          '': 'Parte acquirente della fattura non trovata',
          centre: {
            code: 'Codice centro acquisti acquirente fattura mancante'
          }
        },
        number: 'Numero della fattura mancante',
        sender: 'Manca la festa del mittente della fattura',
        receiver: 'Manca la parte ricevente della fattura',
        status: 'Manca lo stato della fattura',
        document: {
          format: 'Formato del documento di fattura richiesto mancante',
          class: 'Classe di documento di fattura richiesta mancante',
          type: 'Tipo di documento di fattura richiesto mancante'
        },
        validity: {
          document: 'Documento di validità della fattura richiesto mancante'
        },
        correctedflag: 'Manca la flag di correzione della fattura richiesta',
        metadata: {
          file: {
            extension: 'Estensione del file di metadati della fattura richiesta mancante'
          }
        },
        attachment: {
          extension: 'Manca l\'estensione per l\'allegato della fattura richiesta'
        },
        tax: {
          type: 'Manca il tipo di imposta sulla fattura richiesta',
          baseamount: 'Importo della base imponibile della fattura richiesto mancante',
          currency: 'Manca la valuta di imposta della fattura richiesta'
        },
        event: 'Evento di fattura richiesto',
        property: {
          '': 'Manca la proprietà della fattura richiesta',
          value: 'Valore di proprietà fattura richiesto mancante'
        },
        outstanding: {
          amount: 'Importo residuo della fattura richiesta mancante'
        },
        executable: {
          amount: 'Importo eseguibile fattura mancante mancante'
        },
        communication: {
          reception: {
            name: 'Nome di ricezione della comunicazione richiesto mancante'
          }
        }
      },
      media: {
        type: 'Il tipo di supporto deve essere impostato'
      },
      centremedia: {
        project: 'Il centro di servizio deve essere impostato',
        role: 'Center media rol deve essere impostato'
      },
      partymedia: {
        role: 'Il ruolo dei media dei partecipanti deve essere impostato'
      }
    },
    update: {
      party: {
        taxid: 'Si è verificato un errore durante l\'aggiornamento della parte. Il numero di identificazione fiscale deve essere impostato'
      }
    },
    search: {
      party: {
        taxid: 'Si è verificato un errore durante la ricerca della parte. Il numero di identificazione fiscale deve essere impostato'
      }
    },
    commercial: {
      relation: {
        partytaxid: 'Il numero di identificazione fiscale deve essere impostato',
        role: 'Il ruolo del partecipante deve essere impostato'
      }
    },
    recadv: {
      integration: {
        file: {
          '': 'Manca il file di integrazione del consiglio di ricevimento richiesto',
          extension: 'Manca l\'estensione del file di avviso di ricevimento richiesta'
        }
      },
      status: 'Manca lo stato di avviso di ricevimento richiesto',
      number: {
        exception: 'Manca il numero di avviso di ricevimento richiesto'
      },
      receiving: {
        date: {
          time: {
            extension: 'Manca la data di ricezione del consiglio di ricevimento richiesta'
          }
        }
      },
      validity: {
        document: 'Manca il documento di validità del consiglio di ricevimento richiesto'
      },
      document: {
        format: 'Manca il formato del documento di consiglio di ricevimento richiesto'
      },
      centre: 'Manca il centro di consulenza per la ricezione'
    },
    request: {
      compressed: {
        invoice: {
          flag: 'Richiesta richiesta compressa flag di richiesta mancante'
        }
      },
      invoice: {
        file: 'Manca il file di richiesta richiesta'
      }
    }
  },
  party: {
    not: {
      found: 'Partecipante non trovato'
    },
    project: {
      not: {
        found: 'Servizio non trovato o disabilitato'
      }
    },
    to: {
      delete: {
        not: {
          found: 'Partecipante non trovato'
        }
      }
    },
    commercial: {
      relation: {
        channel: {
          not: {
            found: 'Canale del partecipante non trovato'
          }
        }
      }
    },
    deletion: 'Si è verificato un errore durante l\'eliminazione del partecipante',
    country: {
      not: {
        found: 'Paese del partecipante non trovato'
      }
    },
    media: {
      type: {
        not: {
          found: 'Tipo di media del partecipante non trovato'
        }
      },
      deletion: 'Si è verificato un errore durante l\'eliminazione dei supporti dei partecipanti',
      to: {
        delete: {
          not: {
            found: 'Si è verificato un errore durante l\'eliminazione dei supporti dei partecipanti.'
          }
        }
      },
      invalid: {
        email: {
          format: 'e-mail media dei partecipanti non valida'
        }
      }
    }
  },
  commercial: {
    relation: {
      party: {
        not: {
          found: 'Relazione commerciale partecipante non trovata o disabilitata'
        }
      }
    }
  },
  incompatible: {
    integrated: {
      party: {
        for: {
          commercial: {
            relation: 'Partecipante non valido, mancante ruolo valido'
          }
        }
      }
    },
    centre: {
      role: 'Ruolo del centro invalido',
      media: {
        data: {
          role: 'Ruolo del centro invalido'
        }
      }
    },
    party: {
      media: {
        data: {
          role: 'Ruolo del partecipante non valido'
        }
      }
    }
  },
  communication: {
    method: {
      not: {
        found: 'Metodo di comunicazione del partecipante non trovato'
      }
    }
  },
  centre: {
    role: {
      type: {
        not: {
          found: 'Center rol non trovato'
        }
      }
    },
    to: {
      delete: {
        not: {
          found: 'Centro non trovato'
        }
      }
    },
    deletion: 'Si è verificato un errore durante l\'eliminazione del centro',
    party: {
      not: {
        found: 'Centro del partecipante non trovato'
      }
    },
    not: {
      found: 'Centro non trovato'
    },
    country: {
      not: {
        found: 'centro del paese non trovato'
      }
    },
    media: {
      type: {
        not: {
          found: 'Tipo di media del centro non trovato'
        }
      },
      deletion: 'Errore durante l\'eliminazione del centro',
      to: {
        delete: {
          not: {
            found: 'Si è verificato un errore durante l\'eliminazione del supporto centrale. Supporto centrale non trovato'
          }
        }
      },
      invalid: {
        email: {
          format: 'Email media del centro non valida'
        }
      }
    }
  },
  media: {
    type: {
      not: {
        found: 'Il canale di contatto specificato non è stato trovato'
      }
    }
  },
  centremedia: {
    project: {
      not: {
        found: 'Centro del servizio non trovato'
      }
    }
  },
  duplicate: {
    partymedia: {
      value: 'Media dei partecipanti duplicato'
    },
    centremedia: {
      value: 'Media dei partecipanti duplicato'
    }
  },
  recadvLine: {
    currency: {
      not: {
        found: 'Valuta della linea di avviso ricevuta non trovata'
      }
    },
    unitOfMeasure: {
      notFound: 'Unità di misura della linea di avviso di ricevimento non trovata'
    }
  },
  document_code: {
    generation: {
      format: {
        class: {
          not: {
            found: 'Classe di mappatura del formato del documento non trovata'
          }
        }
      }
    }
  },
  unzipped: {
    request: {
      invoice: {
        file: 'La richiesta di fattura è configurata per trasportare solo un file di fattura zippato, ma ha uno decompresso'
      },
      attachments: 'La richiesta di fattura è configurata per trasportare solo allegati zippati, ma ha solo uno decompresso'
    }
  },
  zipped: {
    request: {
      invoice: {
        file: 'La richiesta di fattura è configurata per trasportare solo un file di fattura non compresso, ma ha un file zippato'
      },
      attachments: 'La richiesta di fattura è configurata per portare solo un allegato non compresso, ma la richiesta ha uno o più zip'
    }
  },
  different: {
    invoice: {
      number: 'Il numero di fattura della richiesta è diverso da quello estratto dal file di fattura allegato'
    },
    seller: {
      tax: {
        identification: {
          number: 'L\'ID IVA del venditore dalla richiesta è diverso da quello estratto dal file di fattura attatached'
        }
      }
    }
  },
  // Fin errores/mensajes en Integración de factura
  projects: {
    filters: {
      creation_date: {
        value: 'Data'
      },
      name: {
        value: 'Nome dei servizio',
        placeholder: 'Nome'
      },
      code: {
        value: 'Codice dei servizio',
        placeholder: 'Codice'
      },
      security_code: {
        value: 'Codice di sicurezza',
        placeholder: 'Code'
      },
      enabled: {
        value: 'Abilitato',
        placeholder: 'Selezionare...'
      },
      issuing: {
        value: 'Emittente',
        placeholder: 'Selezionare...'
      },
      reception: {
        value: 'Ricezione',
        placeholder: 'Selezionare...'
      },
      party_nif: {
        value: 'Identificazione del partecipante',
        placeholder: 'NIF'
      },
      party_name: {
        value: 'Nome del partecipante',
        placeholder: 'Nome'
      }
    },
    entity_table: {
      name: 'Servizio',
      code: 'Codice',
      security_code: 'Codice di sicurezza',
      issuing: 'Emittente',
      reception: 'Ricezione',
      creation_date: 'Data',
      enabled: 'Abilitato'
    },
    buttons: {
      new_project: 'Nuovo servizio'
    },
    error: {
      tamanomaximo: {
        code: "Lunghezza massima del campo 'Codice di Servizio': 50 caratteri",
        name: "Lunghezza massima del campo 'Nome di Servizio': 40 caratteri",
        security_code: "Lunghezza massima del campo 'Codice di Sicurezza': 64 caratteri",
        new_name: "Lunghezza massima del campo 'Nome': 40 caratteri"
      },
      required: {
        name: 'Campo obbligatorio: Nome',
        code: 'Campo obbligatorio: Codice',
        enable: 'Campo obbligatorio: Attivo',
        isSender: 'Campo obbligatorio: Emissione',
        isReceiver: 'Campo obbligatorio: Reception'
      },
      exist: 'Il metodo di consegna scelto è già inserito',
      validityexist: "Esistono già dati validi nel servizio per quel tipo e quel ruolo. È necessario eliminare la validità esistente se si desidera aggiungerne un'altra.",
      validationexist: "I dati di convalida esistono già nel servizio per quel tipo, formato e ruolo. Dovrai eliminare la convalida esistente se desideri aggiungerne un'altra.",
      statusexist: 'Esiste già lo stato per visualizzare il servizio associato al servizio',
      statuschangeexist: 'La categoria associata al servizio esiste già',
      categoryexist: 'Ya existe la categoría asociada al servicio',
      mimeexist: 'La configurazione mime associata al servizio esiste già',
      mime: {
        invalidMimeFrom: 'L\'email mime origine inserita non è valida',
        invalidMimeSender: 'L\'email mime mittente inserita non è valida',
        invalidMimeReplyTo: 'L\'email mime a cui rispondere inserita non è valida'
      },
      wrongLogoSize: "La dimensione dell'immagine supera il massimo consentito: 256 KBs",
      wrongLogoExtension: 'Sono supportate solo le immagini in formato JPG / JPEG / PNG',
      adminParties_name_exist: 'Si è verificato un errore. Esiste già un servizio con questo nome o codice',
      format_email: "Il formato dell'e-mail non è corretto.",
      format_phone: 'Il formato del telefono non è corretto.',
      partyTypeAndProject: 'Il tipo di azienda non corrisponde al ruolo del servizio',
      signDocument_fileNull: 'Un file deve essere allegato',
      signDocument_wrongExtension: "L'estensione dell'allegato deve essere PDF",
      signDocument_invalidPdf: 'Il contenuto del documento non è un PDF valido',
      roleOfParte_isEmpty: "Ci deve essere almeno un ruolo per l'azienda",
      commercialrelation_insert: "Indica solo l'acquirente o il venditore.",
      existRelation: 'Operazione non completata. La relazione esiste già.',
      partyCountryNotEqual: 'L\'identificatore esiste già sulla piattaforma per un altro paese',
      partydisabled: 'Non è possibile aggiungere la società, esiste ma è disabilitata',
      partyAlreadyAdded: 'La società è già assegnata, controlla i dati',
      noMediaCorrect: 'I dati di contatto non sono corretti, controlla il tipo di azienda dei dati.',
      email_empty: 'Devi inserire le informazioni di un contatto',
      contact_duplicado: "L'email per quel servizio esiste già",
      contact_noMore: 'Non puoi aggiungere più contatti con questo tipo',
      adminparties: {
        required: {
          userType: 'Campo obbligatorio: Tipo di persona',
          name: 'Campo obbligatorio: Nome',
          firstSurname: 'Campo obbligatorio: Primo cognome',
          corporateName: 'Campo obbligatorio: Nome commerciale',
          country: 'Campo obbligatorio: Nazione',
          postcode: 'Campo obbligatorio: Codice postale',
          address: 'Campo obbligatorio: Indirizzo',
          town: 'Campo obbligatorio: Cittadino',
          province: 'Campo obbligatorio: Provincia',
          nif: 'Campo obbligatorio: Codice fiscale'
        },
        invalid: {
          name: 'Il campo" Nome "non è valido',
          firstSurname: 'Il campo "Primo cognome" non è valido',
          secondSurname: 'Il campo" Secondo cognome "non è valido',
          postcode: 'Il campo" Codice postale "non è valido',
          postcode_max: 'La lunghezza del campo" Codice postale "non è corretta',
          nif: 'Il campo" Codice fiscale "non ha un formato valido',
          nif_max: 'La lunghezza del campo" ID fiscale "non è corretta',
          email: "L'email inserita non è valida",
          phoneNumber: 'Il numero di telefono del contatto non è valido'
        }
      }
    },
    validations: {
      name: 'Convalida',
      value: 'Valore',
      role: 'Significato del documento',
      document_type: 'Tipo di documento',
      emission: 'Emisione',
      reception: 'Ricezione',
      comm_method: 'Metodo di comunicazione',
      country: 'nazione',
      document_format: 'Formato documento'
    },
    validities: {
      validity: 'Validità (giorni)',
      country: 'Paese',
      role: 'Significato del documento',
      document_type: 'Tipo di documento',
      emission: 'Emisione',
      reception: 'Ricezione'
    },
    pendingtasks: {
      status: 'Stato',
      module: 'Modulo'
    },
    rejectionCategories: {
      name: 'Nome',
      visible: 'Visible'
    },
    emailType: {
      type: 'Tipología email',
      value: 'Email'
    },
    visualization: {
      name: 'Visualizzazione'
    }
  },

  new_project: {
    title: 'Creare servizio',
    new_project_form: {
      name: {
        label: 'Nome',
        placeholder: ''
      },
      code: {
        label: 'Codice',
        placeholder: ''
      },
      issuing: {
        label: 'Emittente',
        placeholder: 'Selezionare...'
      },
      enable: {
        label: 'Abilitato',
        placeholder: 'Selezionare...'
      },
      reception: {
        label: 'Ricezione',
        placeholder: 'Selezionare...'
      },
      indra_project: {
        label: 'Appaltatore',
        placeholder: 'Selezionare...'
      }
    },
    load: {
      upload_logo: 'Caricamento logo',
      save_changes: 'Salvataggio dei dati del servizio'
    },
    notify: {
      upload_logo: 'Il logo è stato caricato correttamente. Ricorda di premere "Salva modifiche"',
      save_changes: 'Servizio creato correttamente'
    }
  },

  project_detail: {
    info_message: 'Alcuni campi sono modificabili. Ricorda di premere il pulsante "Salva" per memorizzare le modifiche',
    title_delete_communication: 'Alcune società di servizi hanno credenziali per quel metodo, controlla se dovresti eliminarle prima di continuare, vuoi continuare comunque?',
    expand_all_accordion: 'Espandi tutto',
    collapse_all_accordion: 'Comprimi tutto',
    buttons: {
      management_services_parties: 'Vedere aziende associate',
      add_logo: 'Carica',
      add_configuration_data: 'Carica',
      add_delivery_methods: 'Carica',
      add_logo_tooltip: 'Carica logo',
      add_configuration_data_tooltip: 'Carica dati di configurazione',
      add_mime_configuration: 'Carica',
      add_mime_configuration_tooltip: 'Carica dati di configurazione mime',
      add_delivery_methods_tooltip: 'Carica metodo di consegna',
      add_validity_document: 'Carica',
      add_validity_document_tooltip: 'Caricare validità',
      add_validation_tooltip: 'Carica di validazione',
      add_visualization_tooltip: 'Carica display',
      add_pendingtask: 'Carica',
      add_pendingtask_tooltip: 'Carica è stato di attività in sospeso',
      add_rejectionCategory: 'Carica',
      add_rejectionCategory_tooltip: 'Carica categoria',
      add_emailype_tooltip: 'Carica tipología de email',
      add_documentFormat_data_tooltip: 'Carica un formato di documento'
    },
    project_detail_edit_form: {
      name: 'Nome di servizio',
      code: 'Codice di servizio',
      enable: 'Attivo/inattivo',
      security_code: 'Codice di sicurezza',
      issuing: 'Emissione',
      reception: 'Ricezione',
      is_indra_project: 'Appaltatore'
    },
    validation: {
      error_code: 'El código no cumple con el formato requerido {0}'
    },
    facturar: 'Fattura',
    configuration_data: 'Dati di configurazione',
    no_configuration_data: 'This project doesn\'t have any configuration data',
    configuration_data_table: {
      code: 'Configuration',
      project_type: 'Project type'
    },
    mime_required: 'Devi inserire almeno uno dei valori',
    mime_configuration_data: 'Dati di configurazione mime',
    mime_configuration: 'Dati di configurazione mime',
    no_mime_configuration_data: 'Questo servizio non ha dati di configurazione mime',
    mime_configuration_table: {
      mime_from: 'Da',
      mime_sender: 'Mittente',
      mime_reply_to: 'Rispondi a'
    },

    delivery_methods: 'Delivery methods',
    delivery_methods_credentials: 'Modalità di consegna delle credenziali',
    no_delivery_methods: 'Questo servizio non prevede dati di configurazione',
    validations: 'Convalide',
    addCharge_or_discount: 'Addebiti e sconti',
    no_chargeDiscount: 'Il servizio non ha addebiti né sconti',
    visualize_pdf: 'Visualizzazione PDF',
    no_active_validations: 'Il progetto non ha validazioni attive',
    validity_document: 'Validità dei documenti',
    no_validity_document: 'Questo servizio non ha documenti validi',
    rejectionCategories: 'Categoria di rifiuto',
    no_rejectionCategories: 'Questo servizio non ha categoria di rifiuto',
    rejectionCategory_table: {
      category: 'Categoria',
      visible: 'Visible'
    },
    emailType: 'Tipo di tipologia',
    no_emailType: 'Questo servizio non ha configurazioni di email configurate',
    pendingtasks: 'Impostazioni di stato',
    no_pendingtasks: 'Questo servizio non ha stati configurati',
    pendingtask_table: {
      status: 'Stato da visualizzare nelle attività in sospeso',
      statuschange: 'Cambio di stato',
      statusplaceholder: 'Stato'
    },
    emailTypePlaceholder: 'Tipo email',
    validity_document_table: {
      days: 'Validità (giorni)',
      country: 'Paese',
      document_type: 'Tipo di documento',
      role: 'Ruolo'
    },

    dialog_add_logo: {
      title: 'Carica logo'
    },
    dialog_add_configuration_data: {
      title: 'Aggiungere dati di configurazionea',
      configuration: {
        label: 'Configurazione',
        placeholder: 'Seleziona una configurazione'
      },
      type: {
        label: 'Type',
        placeholder: 'Seleziona un tipo'
      }
    },
    dialog_add_mime_configuration: {
      title: 'Añade los datos de configuración mime',
      mime_from: {
        label: 'Da',
        placeholder: 'Dalla posta'
      },
      mime_sender: {
        label: 'Mittente',
        placeholder: 'Posta del mittente'
      },
      mime_reply_to: {
        label: 'Rispondi a',
        placeholder: 'Rispondi alla posta'
      }
    },

    // Documentos y formatos
    document_format: 'Documenti e formati',
    no_document_format: 'Questo servizio non ha documenti e formati',
    dialog_add_document_format: {
      title: 'Scegli un nuovo documento e formato',
      format: {
        labelType: 'Tipo di documento',
        labelFormat: 'Formato documento',
        placeholder: 'Scegli...'
      }
    },
    document_format_table: {
      name: 'Nome',
      sender: 'Emetti/Ricevi',
      priority: 'Priorità',
      user: 'Utente',
      password: 'Password',
      party: 'Entità',
      format: 'Formato',
      documentType: 'Tipo di documento'
    },

    dialog_add_delivery_method: {
      title: 'Seleziona un nuovo metodo di consegna',
      method: {
        label: 'Metodo',
        placeholder: 'Seleziona un metodo'
      }
    },
    dialog_add_validations: {
      title: 'Scegli una nuova convalida',
      validation: {
        title: 'Convalida',
        placeholder: 'Scegli una convalida'
      }
    },
    dialog_add_visualization: {
      title: 'Scegli una nuova vista PDF',
      visualization: {
        title: 'Visualizzazione PDF',
        placeholder: 'Scegli una visualizzazione'
      }
    },
    dialog_add_validities: {
      title: "selezionare un'attività in sospeso",
      validity: {
        title: 'Compito in sospeso',
        placeholder: "selezionare un'attività in sospeso"
      }
    },
    dialog_add_pendingtask: {
      title: 'Configurazione degli stati',
      pendingtask: {
        title: 'Validità',
        placeholder: 'Scegli una validità'
      }
    },
    dialog_add_emailType: {
      title: 'Scegli un tipo di email',
      emailType: {
        title: 'Tipo di email',
        placeholder: 'Scegli il tipo di email'
      }
    },
    dialog_add_rejectionCategory: {
      title: 'Scegli una nuova categoria di rifiuto',
      rejectionCategory: {
        title: 'Categoria di rifiuto',
        placeholder: 'Scegli categoria'
      }
    },
    dialog_add_charge_or_discount: {
      title: 'Aggiungi addebito o sconto',
      type: 'Tipo',
      description: 'Descrizione'
    },
    load: {
      upload_logo: 'Carica logo',
      delete_logo: 'Elimina logo azienda',
      download_logo: 'Scarica logo',
      save_changes: 'Salva dati del servizio',
      cancel: 'Cancella',
      add_configuration: 'Aggiungere configurazione',
      delete_configuration: 'Eliminare configurazione',
      add_delivery_method: 'Aggiungere metodo di consegna',
      delete_delivery_method: 'Eliminare metodo di consegna',
      delete_validation: 'Rimozione della convalida',
      add_validation: 'Aggiunta di validazione',
      delete_validity: 'Rimozione validità',
      add_validity: 'Aggiunta validità',
      delete_PDFVisualization: 'Eliminazione della vista PDF',
      add_visualization: 'Aggiunta della vista PDF',
      delete_pendingtask: 'Rimozione di attività in sospeso',
      add_pendingtask: 'Aggiunta di attività in sospeso',
      delete_rejectionCategory: 'Rimozione della categoria di rifiuto',
      add_rejectionCategory: 'Aggiunta della categoria di rifiuto',
      delete_emailType: 'Eliminazione della tipologia di email',
      add_emailType: 'Aggiunta della tipologia di posta',
      delete_project_document_format: 'Eliminazione documento e formato',
      add_document_format: 'Aggiunta del formato del documento',
      add_delivery_note_config: 'Aggiunta della targa per le bolle di consegna emesse',
      add_project_delivery_note_type: 'Aggiunta del tipo di documento di trasporto',
      delete_project_delivery_note_type: 'Eliminazione del tipo di documento di trasporto'
    },
    notify: {
      delete_logo: 'Il logo è stato eliminato correttamente',
      save_changes: 'O serviço foi atualizado com sucesso',
      add_configuration: 'I dati di configurazione sono stati aggiunti con successo',
      delete_configuration: 'La configurazione è stata eliminata correttamente',
      add_delivery_method: 'Il metodo di consegna è stato aggiunto correttamente',
      delete_delivery_method: 'Il metodo di consegna è stato eliminato correttamente',
      delete_validation: 'Convalida rimossa correttamente',
      add_validation: 'La convalida è stata aggiunta correttamente',
      delete_validity: 'La validità è stata eliminato correttamente',
      add_validity: 'La validità è stata aggiunta correttamente',
      delete_PDFVisualization: 'Visualizzazione eliminata correttamente',
      add_PDFVisualization: 'Il display è stato aggiunto correttamente',
      noDisplayDocuments: 'Non ci sono visualizzazioni per quel tipo di documento',
      delete_pendingtask: 'Attività in sospeso eliminata correttamente',
      add_pendingtask: 'Attività in sospeso aggiunta correttamente',
      delete_rejectionCategory: 'Categoria di rifiuto eliminata correttamente',
      add_rejectionCategory: 'La categoria di rifiuto è stata aggiunta correttamente',
      delete_emailType: 'Tipologia di email eliminata correttamente',
      add_emailType: 'La tipologia e-mail è stata aggiunta correttamente',
      delete_project_document_format: 'Il documento è stato cancellato e formattato correttamente',
      add_document_format: 'Il formato del documento è stato aggiunto con successo',
      add_delivery_note_config: 'La targa è stata aggiunta correttamente',
      document_format_duplicate: 'Impossibile inserire documento e formato, documento e formato ripetuti.',
      add_project_delivery_note_exist: 'La relazione tra il progetto e il tipo di documento di trasporto esiste già',
      add_project_delivery_note_type: 'Il tipo di documento di trasporto è stato aggiunto correttamente',
      delete_project_delivery_note_type: 'Il tipo di documento di trasporto è stato eliminato con successo'
    },
    error: {
      duplicated: 'La validazione scelta è già inserita',
      document_type: {
        required: 'Non è stato indicato un tipo di documento'
      },
      validation_id: {
        required: 'Nessuna convalida indicata',
        duplicated: 'Convalida duplicata'
      },
      validity: {
        required: 'Non è stato indicato Validità (giorni)'
      },
      sender: {
        required: 'Non è stato indicato un ruolo'
      },
      visualization_id: {
        required: 'Nessuna indicazione indicata',
        duplicated: 'Display duplicato'
      },
      statusconfig: {
        required: 'Nessuno stato indicato'
      },
      emailType: {
        required: 'Nessun tipo di email indicato'
      },
      emailValue: {
        required: 'Deve essere indicata almeno una e-mail',
        duplicated: 'L\'email per quel progetto e quel tipo esiste già',
        invalid: 'L\'email non ha un formato valido'
      },
      category: {
        required: 'è richiesta una categoria'
      },
      visible: {
        required: 'A visible option is required'
      }
    }
  },

  parties: {
    filters: {
      party_name: {
        value: 'Nome dell\'azienda',
        placeholder: 'Nome'
      },
      identification_tax_number: {
        value: 'Id fiscale',
        placeholder: 'Codice'
      },
      gln: {
        value: 'GLN',
        placeholder: 'GLN'
      },
      registerDate: {
        value: 'Data di registrazione',
        placeholder: 'Data di registrazione'
      },
      buyer: {
        value: 'Acquirente',
        placeholder: 'Acquirente'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Venditore'
      },
      propietary: {
        value: 'Sponsor',
        placeholder: 'Sponsor'
      },
      active: {
        value: 'Attivo',
        placeholder: 'Attivo'
      },
      country: {
        value: 'Nazione',
        placeholder: 'Nazione'
      }
    },
    notify: {
      not_buyer_sponsor: 'Tutte le aziende devono essere acquirenti e sponsor / non sponsor',
      modify_all: 'Tutte le aziende selezionate verranno modificate. Vuoi continuare?',
      parties_updated: 'Società aggiornate',
      loadmassive_timeout: 'Il caricamento dell\'azienda è in fase di elaborazione, una volta terminato è possibile vedere il risultato nell\'audit del documento',
      loadmassive_numlinesOK: 'Numero di righe elaborate correttamente:'
    },
    entity_table: {
      name: 'Nome',
      identification_tax_number: 'Id fiscale',
      country: 'Nazione',
      province: 'Provincia',
      creation_date: 'Data di creazione',
      seller: 'Venditore',
      buyer: 'Buyer',
      third: 'Terzo',
      sponsor: 'Acquirente',
      register_location_company: 'sede dell\'azienda',
      enable: 'Attiva',
      permanentEstablishment: 'Istituzione permanente'
    },
    buttons: {
      add_party: 'Aggiungi',
      add_party_tooltip: 'Aggiungi società',
      mass_partycharge_tooltip: 'Carico di massa delle società',
      mass_partycharge: 'Carico società',
      mass_partyupdate_tooltip: 'Aggiornamento di massa di motivi sociali aziendali',
      mass_upload: 'Caricamento massivo',
      mass_partyupdate: 'Aggiornamento di massa'

    },
    mass_party_chargemsg: "Carico di massa delle società. Il file deve contenere l'estensione CSV."
  },

  new_party: {
    country_nif: {
      title: 'Aggiungi società',
      info: 'Digitare l\'identificazione fiscale e il Paese del partito per continuare',
      form: {
        country: {
          label: 'Nazione',
          placeholder: 'Selezionare...'
        },
        identification_number: {
          label: 'Codice fiscale'
        }
      }
    }
  },

  party_detail: {
    confirm_clean: 'Ricorda: se modifichi i dati dovrai rigenerare il modello di richiesta di modifica dei dati',
    title: "Dati dell'azienda",
    info_message: 'Alcuni campi sono modificabili. Ricorda di premere il pulsante "Salva" per memorizzare le modifiche',
    info_address: 'Per salvare le informazioni sull\'indirizzo fiscale, è necessario compilare tutti i campi della sezione',
    buttons: {
      admin_channels: 'Amministrazione di canali',
      admin_centres: 'Amministrazione di centri',
      upload_centre: 'Centro aggiornamenti',
      upload_centre_ok: 'Centro aggiornato correttamente',
      add_contact_data: 'Aggiungi',
      add_delivery_method: 'Aggiungi',
      add_sign_document: 'Aggiungi',
      add_contact_data_tooltip: 'Aggiungi dati di contatto',
      add_gln_data: 'Aggiungi',
      add_gln_data_tooltip: 'Aggiungi GLN',
      add_delivery_method_tooltip: 'Aggiungi il metodo di consegna',
      add_document_format_tooltip: 'Carica il formato del documento',
      add_delivery_note_type_tooltip: 'Tipo di documento di trasporto del carico',
      add_label_tooltip: 'Carica etichetta',
      add_registration_tooltip: 'Carica targa',
      add_sign_document_tooltip: 'Aggiungi il documento di segno delegato',
      add_validations_tooltip: 'Aggiungi convalida',
      mass_partyupdate: "Aggiorna il nome dell'azienda",
      add_shipping_configuration: 'Aggiungi',
      add_shipping_configuration_tooltip: 'Aggiungi il impostazioni di spedizione',
      add_paymentMeans_tooltip: 'Carica i dettagli di pagamento',
      add_document_cycle_tooltip: 'Carica ciclo di documenti'
    },
    dialog_add_payments: {
      title: 'Aggiungi i dettagli del pagamento'
    },
    party_detail_edit_form: {
      person_type: {
        label: 'Tipo di persona',
        placeholder: 'Seleziona un tipo'
      },
      corporate_name: 'Nome commerciale',
      name: 'Nome',
      gln: 'GLN',
      identification_tax_number: 'Codice fiscale',
      enable: 'Attivo',
      first_surname: 'Primo cognome',
      second_surname: 'Secondo cognome',

      // Registro mercantil
      book: 'Libro',
      folio: 'Foglio',
      volume: 'Volume',
      sheet: 'Foglia',
      section: 'Sezione',
      additional_data: 'Dati aggiuntivi',
      registerOrCompaniesLocation: 'Registro commerciale',
      taxDataCertificate: "Carica il certificato dei dati fiscali dell'agenzia delle entrate",

      // Direccion
      address: 'Indirizzo',
      province: 'Provincia',
      postcode: 'Codice postale',
      town: 'Cittadino',
      country: {
        label: 'Nazione',
        placeholder: 'Nazione'
      },

      // Datos Bancarios
      iban: 'IBAN',
      bic: 'BIC Swift',
      accountTitular: 'Titolare del conto',
      email: 'Email di comunicazione pagamento',
      ficheroCertificado: 'Caricamento del certificato di proprietà del conto bancario',
      donwloadModelo: 'Scarica la richiesta dei dati di modifica del modello',
      ficheroDatos: 'Richiesta di caricamento per modifica dati (deve essere firmata digitalmente)',
      sendProject: {
        label: 'Progetti per l invio di documentazione',
        placeholder: 'Scegli Progetto / i'
      },
      legalNif: 'Nif del legale rappresentante/procuratore',
      legalName: 'Cognome e nome del legale rappresentante/procuratore',
      legalCountry: {
        label: 'Nazione',
        placeholder: 'Nazione'
      },
      contactName: 'Cognome e nome della persona di contatto',
      contactRole: "Posizione ricoperta dalla persona di contatto nell'entità",
      contactEmail: 'Email della persona di contatto',
      contactEmailEmi: 'Email per emettere comunicazioni relative alla fatturazione elettronica',
      contactPhones: 'Telefono/i della persona di contatto',

      // Rol por servicio
      buyer: 'Acquirente',
      seller: 'Venditore',
      sponsor: 'Sponsor'
    },
    subtitle: {
      commercial_register: 'Registro commerciale',
      address: 'Direzione fiscale',
      project_role: 'Ruolo del progetto',
      bank: 'Coordinate bancarie',
      bank_legal_data: 'Dati del legale rappresentante/procuratore',
      bank_contact_data: 'Dati della persona di contatto in relazione al presente modulo'
    },

    // Carga de logo
    dialog_add_logo: {
      title: 'Carica logo'
    },

    dialog_add_party_label: {
      title: 'Scegli una nuova etichetta'
    },

    no_active_validations: 'Questa parte non ha validazioni attive',
    // Proyectos relacionados
    project_related: 'Servicios relacionados',
    no_project_data: 'Esta empresa no está asociada a ningún servicio',
    // Datos de contacto
    contact_data: 'Informazioni di contatto',
    no_contact_data: 'Questa parte non ha dati di contatto',
    party_media_table: {
      project: 'Servizio',
      media_type: 'Tipo di supporto',
      contact_data: 'Informazioni di contatto',
      party_type: 'Tipo di azienda',
      profile_info: '>>  Se si desidera modificare le informazioni di contatto, è necessario contattare il proprio cliente.'
    },
    dialog_add_contact_data: {
      title: 'Aggiungi dati di contatto',
      media_type: {
        label: 'Informazioni di contatto',
        placeholder: 'Tipo di contatto'
      },
      party_type: {
        label: 'Tipo di azienda',
        placeholder: 'Tipo di azienda'
      },
      contact_data: {
        label: 'Informazioni di contatto'
      }
    },

    // Buzones
    gln_data: 'Identificatori',
    no_gln_data: 'Questa azienda non ha identificatori',
    party_gln_table: {
      physical_gln: 'Identificatore',
	  physical_gln_type: 'Tipo'
    },
    dialog_add_gln_data: {
      title: 'Aggiungi identificatore',
      physical_gln: {
        label: 'Identificatore',
		type: 'Tipo'
      }
    },

    // Metodos de entrega
    delivery_methods: 'Metodi di consegna',
    no_delivery_methods: 'Questa parte non ha alcun metodo di consegna',
    delivery_methods_table: {
      name: 'Nome',
      sender: 'Emissione/Ricezione',
      priority: 'Priorità',
      user: 'Utente',
      password: 'Password',
      party: 'Azienda',
      countryEmission: 'Paese emittente',
      countryReception: 'Paese ricevente',
    },
    dialog_add_delivery_methods: {
      title: 'Seleziona un nuovo metodo di consegna',
      method: {
        label: 'Metodo di consegna',
        placeholder: 'Selezionare...'
      }
    },
    dialog_add_delivery_methods_credentials: {
      title: 'Credenziali del metodo di spedizione'
    },

    // Formato de documento
    document_format: 'Formati documento',
    no_document_format: 'Questo servizio non ha formati di documenti',
    dialog_add_document_format: {
      title: 'Scegli un nuovo formato di documento',
      method: {
        labelType: 'Tipo di documento',
        labelFormat: 'Formato documento',
        placeholder: 'Scegli...'
      }
    },
    document_format_table: {
      name: 'Nome',
      sender: 'Emetti/Ricevi',
      priority: 'Priorità',
      user: 'Utente',
      password: 'Password',
      party: 'Entità',
      format: 'Formato',
      documentType: 'Tipo di documento'
    },

    // Documento de firma delegada
    sign_document: 'File di segno delegati',
    no_sign_document: 'Questa parte non ha alcun file di segno delegato',
    sign_document_table: {
      project: 'Tipo/Progetto',
      filename: 'Nome del file',
      creation_date: 'Data di creazione'
    },
    // Documento de datos fiscales
    aeat_document: 'File di dati fiscali',
    no_aeat_document: 'Questa parte non ha alcun file di dati fiscali',
    aeat_document_table: {
      user: 'Utente',
      documentname: 'File',
      creation_date: 'Data di creazione'
    },
    dialog_add_sign_document: {
      title: 'Firma il caricamento del documento'
    },
    // Datos de pago
    paymentMeans: 'Dettagli di pagamento',
    no_payment_data: 'Questa azienda non dispone di informazioni di pagamento',
    payments_table: {
      paymentMeans: 'Metodo di pagamento',
      iban: 'IBAN',
      swift: 'SWIFT'
    },
    // Ciclos de documentos
    no_party_document_cycle: 'Nessun ciclo di documenti',
    document_cycle_table: {
      title: 'Cicli di documenti',
      sourceDocumentType: 'Tipo di documento di origine',
      destinationDocumentType: 'Tipo di documento di destinazione',
      buyer_centre: 'Centro dell\'azienda acquirente',
      seller: 'Azienda venditrice',
      class: 'Classe di documento di origine',
      additional: 'Parametro aggiuntivo della classe di documento di origine'
    },
    document_cycle_class_source_options: {
      source: 'Documento di origine',
      destination: 'Documento di destinazione'
    },
    dialog_add_document_cycle: {
      title: 'Aggiungi un nuovo ciclo di documenti',
      source_document_type: {
        label: 'Tipo di documento di origine',
        placeholder: 'Scegli...'
      },
      destination_document_type: {
        label: 'Tipo di documento di destinazione',
        placeholder: 'Scegli...'
      },
      seller: {
        label: 'Azienda venditrice',
        placeholder: 'Inserisci 3 caratteri'
      },
      centre_buyer: {
        label: 'Centro dell\'azienda acquirente',
        placeholder: 'Scegli...'
      },
      document_cycle: {
        label: 'Classe di documento',
        placeholder: 'Scegli...'
      },
      document_cycle_class_source: {
        label: 'Direzione del documento',
        placeholder: 'Scegli il documento a cui aggiungere la classe...'
      },
      additional_class_value: {
        title: 'Parametro aggiuntivo della classe di documento'
      }
    },

    load: {
      add_document_format: 'Aggiunta del formato del documento',
      delete_party_document_format: 'Eliminazione del formato del documento',
      delete_party_emission_deliverynote_config: 'Eliminazione della targa per le bolle di consegna emesse',
      upload_logo: 'Caricamento logo',
      delete_logo: 'Rimozione del logo',
      download_logo: 'Scaricare del logo',
      save_changes: 'Salvataggio delle modifiche',
      cancel: 'Annullamento',
      add_contact_data: 'Aggiunta di dati di contatto',
      delete_contact_data: 'Rimozione dei dati di contatto',
      add_approval_amount: 'Creazione del flusso di approvazione',
      modify_approval_amount: 'Aggiornamento del flusso di approvazione',
      delete_approval_amount: 'Rimozione del flusso di approvazione',
      add_approval_level: 'Creazione del livello di approvazione',
      delete_approval_level: 'Rimozione del livello di approvazione',
      add_gln_data: 'Aggiunta identificado',
      delete_gln_data: 'Rimozione identificador',
      add_party_label: 'Aggiunta di tag',
      delete_party_label: 'Rimozione del tag',
      add_party_delivery_note_type: 'Aggiunta del tipo di documento di trasporto',
      add_delivery_method: 'Aggiunta del metodo di consegna',
      delete_delivery_method: 'Rimozione del metodo di consegna',
      delete_party_delivery_note_type: 'Rimozione del tipo di documento di trasporto',
      upload_sign_document: 'Caricamento del file di segno delegato',
      download_sign_document: 'Scaricare del file di segno delegato',
      delete_sign_document: 'Rimozione del file di segno delegato',
      download_aeat_document: 'Scaricare del file di dati fiscali',
      add_shipping_configuration: 'Aggiunta delle impostazioni di spedizione',
      delete_shipping_configuration: 'Rimozione delle impostazioni di spedizione',
      delete_paymentMeans: 'Rimozione dei dati di pagamento',
      add_paymentMeans: 'Aggiunta dei dettagli di pagamento',
      delete_document_cycle: 'Eliminazione ciclo di documenti',
      add_party_document_cycle: 'Aggiunta ciclo di documenti'
    },
    notify: {
      add_document_format: 'Il formato del documento è stato aggiunto con successo',
      delete_party_document_format: 'Formato documento eliminato con successo',
      delete_party_emission_deliverynote_config: 'La targa è stata rimossa con successo',
      upload_logo: 'Il logo è stato caricato correttamente. Ricorda di premere "Salva modifiche"',
      delete_logo: 'Il logo è stato cancellato correttamente',
      save_changes: 'La festa è stata aggiornata correttamente',
      created: 'La festa è stata creata correttamente',
      save_changes_to_service: ' dati sono stati segnalati al servizio ',
      add_contact_data: 'I dati di contatto sono stati aggiunti correttamente',
      delete_contact_data: 'I dati di contatto sono stati rimossi correttamente',
      add_approval_amount_data: 'Dati del flusso di approvazione aggiunti correttamente',
      modify_approval_amount_data: 'Dati del flusso di approvazione modificati correttamente',
      delete_approval_amount_data: 'Rimosso il flusso di approvazione del centro',
      add_approval_level_data: 'Livello di approvazione aggiunto correttamente',
      delete_approval_level_data: 'Livello di approvazione rimosso',
      add_gln_data: 'I GLN sono stati aggiunti correttamente',
      delete_gln_data: 'I GLN sono stati rimossi correttamente',
      noLabels: 'Non ci sono etichette per quel tipo di documento',
      existLabels: 'Il tag è già associato all\'azienda',
      add_party_label: 'Il tag è stato aggiunto correttamente',
      delete_party_label: 'Il tag è stato rimosso con successo',
      add_party_delivery_note_type: 'Il tipo di documento di trasporto aggiunti correttamente',
      add_party_delivery_note_exist: 'Il rapporto tra l\'azienda e il tipo di bolla di consegna esiste già',
      delete_party_delivery_note_type: 'Il tipo di documento di trasporto rimossi correttamente',
      add_delivery_method: 'Il metodo di consegna è stato aggiunto correttamente',
      delete_delivery_method: 'Il metodo di consegna è stato rimosso correttamente',
      delete_sign_document: 'Il documento del segno delegato è stato rimosso correttamente',
      typePersonTaxIden: 'Il tipo di persona deve corrispondere a un ID fiscale corretto in Spagna',
      document_format_duplicate: 'Impossibile inserire il formato del documento, formato ripetuto.',
      add_shipping_configuration: 'La impostazioni di spedizione è stata aggiunta correttamente',
      delete_shipping_configuration: 'La impostazioni di spedizione è stata rimossa correttamente',
      add_shipping_configuration_duplicate: 'Impossibile inserire la impostazioni di spedizione, formato per quel GLN ripetuto',
      add_paymentMeans: 'Dettagli di pagamento aggiunti correttamente',
      delete_paymentMeans: 'I dati di pagamento sono stati cancellati con successo',
      payment_means_duplicate: 'I dati di pagamento esistono già per lo stesso metodo, elimina prima i dati di pagamento esistenti',
      document_cycle_duplicate: 'Il ciclo del documento per l\'azienda esiste già, rimuovere prima il ciclo del documento esistente',
      delete_document_cycle: 'Il ciclo del documento è stato eliminato correttamente',
      add_document_cycle: 'Il ciclo del documento è stato aggiunto correttamente'
    },

    // Administrar canales
    channels: {
      filters: {
        name: {
          value: 'Nome della ditta',
          placeholder: 'Nome'
        },
        buyer: {
          value: 'Acquirente',
          placeholder: 'Selezionare...'
        },
        seller: {
          value: 'Venditore',
          placeholder: 'Selezionare...'
        }
      },
      entity_table: {
        sellers: 'Società venditore',
        buyers: 'Società acquirente',
        channels: 'Canali',
        seller: 'Società venditore',
        buyer: 'Società acquirente',
        communicationsMethod: 'Communications Method'
      },
      buttons: {
        add_commercial_relation: 'Aggiungi una relazione commerciale'
      },
      dialog_add_commercial_relation: {
        title: 'Nuova relazione commerciale',
        party: 'Azienda',
        buyer: {
          label: 'Acquirente',
          placeholder: 'Selezionare...',
          write_placeholder: 'Inserisci 3 caratteri'
        },
        seller: {
          label: 'Venditore',
          placeholder: 'Selezionare...',
          write_placeholder: 'Inserisci 3 caratteri'
        }
      },
      dialog_users: {
        title: 'Utenti',
        userName: 'Nome dellutente'
      },
      notify: {
        add_commercial_relation: 'la relazione commerciale è stata creata correttamente',
        delete_commercial_relation: 'Rapporto d\'affari cancellato correttamente.'
      },
      confirm: {
        delete_commercial_relation: 'Sei sicuro di voler eliminare la relazione commerciale?'
      },
      load: {
        add_commercial_relation: 'Aggiunta di una relazione commerciale...',
        delete_commercial_relation: 'Rimozione della relazione commerciale...'
      },
      channels_data: 'Canali aziendali',
      no_channels_data: 'La compagnia non ha canali'
    },

    commercial_relation: {
      filters: {
        party_name: {
          value: 'Nome di azienda',
          placeholder: 'azienda'
        },
        buyer: {
          value: 'Acquirente',
          placeholder: 'Selezionare...'
        },
        seller: {
          value: 'Venditore',
          placeholder: 'Selezionare...'
        }
      }
    },

    // Configuración de emisión de albaranes
    emission_delivery_note_config: 'Configurazione delle targhe per le bolle di consegna emesse',
    no_emission_delivery_note_config: 'Questa azienda non dispone di configurazione delle targhe per le bolle di consegna emesse',
    emission_delivery_note_config_table: {
      platformCode: 'Codice piattaforma',
      partyPrefix: 'Codice Societario',
      packSequenceNumber: 'Numero progressivo'
    },

    // Configuración de tipos de albaranes recibidos
    reception_delivery_note_config: 'Configurazione dei tipi di bolle di accompagnamento ricevute',
    no_party_reception_delivery_note_config: 'Questa azienda non ha la configurazione dei tipi di bolle di accompagnamento ricevute',
    no_project_reception_delivery_note_config: 'Questo servizio non ha la configurazione dei tipi di bolle di accompagnamento ricevute',
    reception_delivery_note_config_table: {
      delivery_note_type: 'Tipo di bolla di consegna'
    },

    dialog_add_party_delivery_note_config: {
      title: 'Nuova registrazione',
      method: {
        platformCode: 'Codice piattaforma',
        partyPrefix: {
          title: 'Codice Societario',
          tooltip: 'Inserisci il prefisso internazionale (2 cifre) + il codice ufficiale dell\'organismo (da 5 a 9 cifre)'
        },
        packSequenceNumber: {
          title: 'Numero progressivo',
          tooltip: 'Immettere il numero di sequenza iniziale per numerare i pacchetti'
        },
        rules: {
          partyPrefix_pattern: 'Il codice azienda supporta solo tra le 7 e le 11 cifre',
          packSequenceNumber_pattern: 'Il numero di sequenza supporta solo le cifre'
        }
      }
    },
    dialog_add_party_delivery_note_type: {
      title: 'Scegli un nuovo tipo di documento di trasporto',
      method: {
        deliveyNoteType: 'Tipo di bolla di consegna'
      }
    },

    // Configuración de etiquetas para empresa compradora
    party_label_config: 'Configurazione delle etichette per le bolle di consegna ricevute',
    no_party_label_config: 'Questa azienda non dispone di etichette predisposte per i documenti di trasporto ricevuti',
    party_label_config_table: {
      name: 'Nome',
      description: 'Descrizione',
      document_type: 'Tipo di documento',
      class: 'Classe di implementazione'
    },

    dialog_add_party_label_config: {
      title: 'Nuova etichetta',
      method: {
        label: {
          title: 'Etichetta',
          placeholder: 'Scegli etichetta'
        },
        description: 'Descrizione',
        document_type: 'Tipo di documento',
        class: 'Classe di implementazione'
      }
    },

    // CONFIGURACIÓN DE ENVÍO DE LA EMPRESA
    shipping_configuration: 'Impostazioni di spedizione',
    no_shipping_configuration: 'Questa parte non ha alcuna impostazionie di spedizione',
    shipping_configuration_table: {
      documentType: 'Tipo di documento',
      documentFormat: 'Formato',
      partySeller: 'Venditore',
      deliveryPoint: 'Luogo di consegna',
      sellerGLN: 'Cass. postali venditore',
      buyerGLN: 'Cass. postali acquirente'
    },

    dialog_add_shipping_configuration: {
      title: 'Nuova impostazioni di spedizione',
      document_type: {
        label: 'Tipo di documento',
        placeholder: 'Selezionare...'
      },
      document_format: {
        label: 'Formato di documento',
        placeholder: 'Selezionare...'
      },
      gln_buyer: {
        label: 'Cassette postali fisiche dell\'acquirente',
        placeholder: 'Inserisci 3 caratteri'
      },
      gln_seller: {
        label: 'Cassette postali fisiche del venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller: {
        label: 'Venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      delivery_centre: {
        label: 'Luogo di consegna',
        placeholder: 'Inserisci 3 caratteri'
      }
    }
  },

  centres: {
    filters: {
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      gln: {
        value: 'Gln',
        placeholder: 'Gln'
      },
      province: {
        value: 'Provincia',
        placeholder: 'Provincia'
      },
      code: {
        value: 'Codice',
        placeholder: 'Codice'
      },
      mailbox: {
        value: 'Cassetta',
        placeholder: 'Cassetta'
      },
      centre_type: {
        value: 'Tipo di centro',
        placeholder: 'Tipo',
        buyer: 'Acquirente',
        seller: 'Venditore',
        both: 'Entrambi'
      }
    },
    entity_table: {
      name: 'Nome',
      dateCreationTime: 'Data di creazione',
      code: 'Codice',
      gln: 'GLN',
      town: 'Città',
      province: 'Provincia',
      country: 'Paese',
      nameCentre: 'Nome del centro',
      mailbox: 'Cassetta',
      siret: 'Identificatore internazionale',
      siret_tooltip: 'Per la Francia è necessario inserire il SIRET (14 caratteri)',
      address: 'Indirizzo',
      postcode: 'CAP',
      centreType: 'Tipo di centro'
    },
    save_changes_notify: ' Il centro è stato aggiornato correttamente',
    save_changes_load: 'Salvataggio dei dati del centro',
    no_contact_data: 'Questo centro non ha informazioni di contatto',
    no_aproval_flow_data: 'Questo centro non sono assegnati utenti per il flusso di approvazione',
    save_changes_insert_notify: 'Il centro è stato aggiunto correttamente',
    data_contact_ko: 'Non è possibile aggiungere altri contatti di questo tipo',
    data_contact_repeat: 'I dati di contatto inseriti non sono validi, vengono ripetuti',
    title_delete_user: 'Vuoi cancellare il centro?',
    delete_user_ok: 'Il centro è stato cancellato con successo',
    approval_flow: 'Livelli di approvazione',
    title_admin_approval_flow: 'Flusso di approvazione',
    title_admin_approval_flows: 'Flussi di approvazione',
    delete_approval_flow: 'Elimina flusso',
    confirm_delete_approval_flow: 'Sei sicuro di voler eliminare il flusso di approvazione?',
    cannot_delete_flow_has_levels: 'Impossibile eliminare il flusso. È necessario prima eliminare i livelli associati',
    confirm_delete_approval_level: 'Sei sicuro di voler eliminare questo livello di approvazione?',
    centre_approval_level_table: {
      level: 'Livello',
      user: 'Utente approvatore',
      notification: 'Notifica utente approvatore'
    },
    data_approval_level_repeat: 'Il livello di approvazione inserito esiste già per l utente',
    data_approval_level_not_valid: 'Esiste un livello di approvazione inferiore non assegnato',
    data_approval_level_empty: 'Esamina i campi del modulo obbligatori',
    approval_level_delete_not_allowed: 'Ci sono livelli più alti. Se desideri eliminare l elemento, registrane prima uno nuovo per questo livello.',
    approval_amount_empty: 'L importo minimo è obbligatorio e deve essere maggiore o uguale a 0',

    // Role Centro
    centre_roles: 'Ruolo di centro',
    no_centre_role: 'Questo centro non ha alcun ruolo',
    centre_roles_table: {
      name: 'Ruolo'
    },

    buttons: {
      mass_upload: 'Caricamento massivo',
      centre_massive_charge: 'Caricamento massivo',
      centre_massive_tooltip: 'Caricamento massivo di centri',
      add_centre_role: {
        label: 'Aggiungere',
        content: 'Aggiunta del ruolo di centro'
      },
      download_csv_approval_flow_tooltip: 'Exporta i flussi di approvazione in CSV',
      download_csv_approval_flow: 'CSV flussi'
    },

    dialog_add_centre_role: {
      title: 'Aggiunta del ruolo di centro',
      role_type: {
        label: 'Ruolo di centro',
        placeholder: 'Tipo di ruolo'
      }
    },

    approval_flow_data: {
      amount: 'Importo minimo',
      code: 'Codice del centro',
      description: 'Descrizione del flusso di approvazione',
      purchase_order: 'Tieni conto dell ordine',
      amountTo: 'Importo massimo'
    },
    centre_massive_charge: {
      title: 'Caricamento massivo di centri',
      message: 'Il file deve contenere l estensione CSV.',
    },
    dialog_add_approval_level: {
      title: 'Aggiungi il livello di approvazione',
      level: {
        label: 'Livello di approvazione',
        placeholder: 'Livello di approvazione'
      },
      user: {
        label: 'Utente approvatore',
        placeholder: 'Utente'
      },
      notification: {
        label: 'Inviare una notifica in attesa di approvazione?',
        placeholder: 'Sì / No'
      }
    },

    load: {
      add_centre_role: 'Aggiunta del ruolo di centro ...',
      delete_centre_role: 'Eliminazione del ruolo di centro ...',
      text_load_data: 'Caricamento dati ...',
      text_load_init_data: 'Caricamento delle informazioni iniziali ...'
    },

    notify: {
      loadmassive_numlinesOK: 'NNumero di righe elaborate correttamente:',
      add_centre_role: 'Ruolo di centro creato con successo.',
      delete_centre_role: 'Ruolo di centro eliminato con successo.',
      error_duplicate_role: 'Il ruolo selezionato è già assegnato a quel centro'
    }
  },

  users: {
    filters: {
      registration_date: {
        value: 'Data-ora Reg.'
      },
      username: {
        value: 'Nome utente',
        placeholder: 'Nome utente'
      },
      complete_name: {
        value: 'Nome/Cognome',
        placeholder: 'Nome',
        placeholder_first_surname: 'Cognome 1',
        placeholder_second_surname: 'Cognome 2'
      },
      trial: {
        value: 'Tentativi',
        placeholder: 'Numero di tentativi'
      },
      active: {
        value: 'Attivo',
        placeholder: 'Selezionare...'
      },
      last_connection_date: {
        value: 'Ultima data di connessione',
        placeholder: 'Ultima data di connessione'
      },
      identification_number: {
        value: 'Numero identificativo',
        placeholder: 'Numero identificativo'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      party: {
        value: 'Azienda',
        placeholder: 'Azienda'
      },
      party_type: {
        value: 'Tipo Azienda',
        placeholder: 'Tipo'
      },
      is_party_sponsor: {
        value: 'sponsor della compagnia',
        placeholder: 'Selezionare...'
      },
      email: {
        value: 'Email',
        placeholder: 'Email'
      }
    },
    error: {
      usuarioKo: 'l\'utente {argumento} non esiste'
    },
    // - CREATE USER
    createuser: {
      steps: {
        user: 'Utente',
        data: 'Dati',
        entity: 'Entità',
        profile: 'Profili'
      },
      newuser: {
        title: 'Nuovo utente',
        username: 'Nome utente',
        email: 'Email',
        success: 'utente creato correttamente'
      },
      datauser: {
        title: 'Informazioni generali sull\'utente {username}',
        name: 'Nome',
        firstSurname: 'Primo cognome',
        secondSurname: 'Secondo cognome',
        taxIdentificationNumber: 'Numero di identificazione fiscale'
      },
      party: {
        partyTaxIdentificationNumber: 'Numero di identificazione fiscale partito'
      },
      entitiesuser: {
        title: 'Assegnazione di entità all\'utente {username}'
      },
      profilesuser: {
        title: 'Profili utente {username}'
      },
      error: {
        userExistsWithDifferentMail: "L'utente esiste già ed è associato a un altro indirizzo e-mail. Controlla l'indirizzo email o richiedi un altro utente.",
        usernameExists: 'Il nome utente esiste già nel sistema.',
        validation: {
          required: {
            username: 'Campo obbligatorio: Utente',
            mail: 'Campo obbligatorio: Email',
            name: 'Campo obbligatorio: Nome',
            first_surname: 'Campo obbligatorio: Primo cognome',
            partyId: 'Il parametro partyId è richiesto',
            projectId: 'Il parametro projectId è richiesto',
            userId: 'Il parametro userId è richiesto',
            userMediaId: 'Il parametro userMediaId è richiesto',
            userentities: 'È obbligatorio assegnare qualche entità',
            rolesAuthorities: 'È obbligatorio assegnare un profilo/permesso'
          },
          maxLength_username: 'Lunghezza massima del campo "Utente": 64 caratteri',
          minLength_username: 'Lunghezza minima del campo "Utente": 3 caratteri',
          forbidden_word: "Cambia il campo 'Utente', non puoi usare quel valore come utente",
          format_mail: "'Email' non ha un formato valido",
          maxLength_mail: 'Lunghezza massima del campo "Email": 255 caratteri',
          maxLength_name: 'Lunghezza massima del campo "Utente": 50 caratteri',
          invalid_name: 'Il campo "Nome" non è valido',
          maxLength_first_surname: 'Lunghezza massima del campo "Primo cognome": 50 caratteri',
          invalid_first_surname: 'Il campo "Primo cognome" non è valido',
          maxLength_TaxID: 'Lunghezza massima del campo "Numero di identificazione fiscale": 20 caratteri',
          exist_TaxID: "C'è già un utente con quel NIF",
          maxLength_second_surname: 'Lunghezza massima del campo "Secondo cognome": 50 caratteri',
          invalid_second_surname: 'Il campo "Secondo cognome" non è valido',
          not_asociated_project: "Il progetto non esiste o non è associato all'utente.",
          not_asociated_user: "L'utente non esiste o non è associato all'utente",
          not_asociated_rol: "Il ruolo non esiste o non è associato all'utente",
          not_asociated_permission: "L'autorizzazione non esiste o non è associata all'utente.",
          not_asociated_party: "La società non esiste o non è associata all'utente",
          not_exist: 'Non esiste alcuna relazione tra il progetto e la società',
          userEntity_notfound: "L'utente non esiste o non ha i privilegi per vedere le loro entità."
        }
      },
      created: "L'utente è stato creato correttamente"
    },

    users_entity_table: {
      username: 'Utente',
      complete_name: 'Nome/Cognome',
      creation_datetime: 'Data di registrazione',
      trail: 'Tentativi',
      last_connection_date: 'Ultima connessione',
      password_expiration_date: 'Scadenza password',
      id_number: 'Numero identificativo',
      enable: 'Abilitare',
      email: 'Email',
      what_show: 'Cosa vuoi vedere?',
	  service_account_tooltip: "Selezionato: questo utente è per l'integrazione.<br>Deselezionato: questo utente è per il portale",
      enable_tooltip: 'Selezionato: questo utente è attivo.<br>Non selezionato: questo utente è inattivo'
    },
    users_pagination: {
      csv: 'CSV',
      showing: 'Mostrando'
    },
    users_multiple_selection: {
      csv: 'CSV',
      massive_reset: 'Reset completo',
      confirm_massive_reset_title: 'Reset massivo degli utenti',
      confirm_massive_reset_message: 'Tutti gli utenti selezionati verranno reimpostati, sei sicuro?'
    },
    users_filters: {
      button_new_user: 'Nuovo utente',
      button_reset_users: 'Ripristino di massa',
      button_reset_users_tt: 'Ripristino',
      button_mass_usercharge: 'Carico di massa',
      username_placeholder: 'Nome utente',
      filter_form: {
        no_match: 'Senza risultati',
        placeholder_first_value: 'Seleziona un filtro',
        button_add_filter: 'Inserisci'
      }
    },
    user_reset_tooltip: 'Separare le usernames con punto e virgola (;)',
    user_mass_userchargemsg: "Carico utente di massa. Il file deve contenere l'estensione CSV.",
    user_upload: 'seleziona un file',
    no_date: 'Senza data',
    load: {
      reset_password: 'Reimpostazione della password...'
    },
    notify: {
      reset_ok: 'Il reset è andato bene.'
    },
    massive_upload: {
      username: {
        required: 'Il campo utente è obbligatorio',
        maxLength: 'Il nome utente supera la lunghezza massima consentita',
        forbidden_word: 'Non è possibile utilizzare quel valore per l\'utente'
      },
      mail: {
        required: 'Il campo email è obbligatorio',
        novalid: 'Formato e-mail non valido',
        maxLength: 'L\'email supera la lunghezza massima consentita',
        emailKO: 'L\'email dell\'utente non può essere modificata. L\'utente esiste in altri progetti'
      },
      firstSurname: {
        maxLength: 'Il primo cognome supera la lunghezza massima consentita',
        invalid: 'Il campo Cognome non è valido',
        required: 'È richiesto il campo Cognome'
      },
      name: {
        maxLength: 'Il nome supera la lunghezza massima consentita',
        invalid: 'Campo Nome non valido',
        required: 'Il campo Nome è obbligatorio'
      },
      nif: {
        maxLength: 'Il NIF supera la lunghezza massima consentita',
        exist: 'Un utente con lo stesso NIF esiste già'
      },
      entities: {
        invalid: 'Il formato del campo entità non è corretto'
      },
      enabled: {
        invalid: 'Campo Abilitato non valido'
      },
      parties: {
        required: 'Il campo Aziende è obbligatorio',
        noexist: 'La società non esiste'
      },
      error: {
        projectParty: 'La società non appartiene al servizio',
        centreParty: 'Il centro non appartiene alla società'
      },
      centre: {
        noexist: 'Il centro non esiste'
      },
      rol: {
        required: 'Il campo Profili è obbligatorio',
        noexist: 'Il ruolo non esiste'
      }
    }
  },
  plannedProcesses: {
    filters: {
      group: {
        value: 'Gruppo',
        placeholder: 'Gruppo'
      },
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      description: {
        value: 'Descrizione',
        placeholder: 'Descrizione'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      jobclass: {
        value: 'Classe di esecuzione',
        placeholder: 'Classe di esecuzione'
      }
    },
    plannedProcesses_table: {
      group: 'Gruppo',
      name: 'Nome',
      description: 'Descrizione',
      status: 'Stato',
      jobclass: 'Classe di esecuzione',
      triggerCron: 'Pianificazione'
    },
    plannedProcesses_button: {
      pause: 'Pausa',
      resume: 'Riprendi',
      interrupt: 'Interrompi',
      pauseAll: 'Pausa',
      resumeAll: 'Riprendi',
      standby: 'In attesa',
      shutdown: 'Stop',
      start: 'Inizio',
      pauseAll_tooltip: 'Interrompi tutte le attività',
      resumeAll_tooltip: 'Avvia tutte le attività',
      standby_tooltip: 'Ferma tutto il quarzo',
      shutdown_tooltip: 'Spegni il quarzo, non può essere avviato in seguito, solo riavviando',
      start_tooltip: 'Avvia il quarto, dopo uno STANDBY'
    },
    text1: 'Significato di ogni campo: [Secondi] [Minuti] [Ore] [Giorno del mese Mese] [Giorno della settimana] [Anno (campo facoltativo)]',
    text2: 'Le singole sottoespressioni possono contenere intervalli (-) e/o elenchi (,).',
    text3: "Il carattere '*': 'tutti' i possibili valori di questo campo.",
    text4: "Il carattere '/': specifica gli incrementi nei valori. Ad esempio, se metti '0/15' nel campo Minuti, significa 'ogni 15 minuti dell'ora'.",
    text5: "Il '?': per i campi del giorno del mese e del giorno della settimana, indica 'nessun valore specifico'."
  },
  mailTemplates: {
    editor: {
      toolbar: {
        bold_tooltip: 'Grassetto',
        italic_tooltip: 'Corsivo',
        underline_tooltip: 'Sottolineato',
        orderedList_tooltip: 'Elenco numerato',
        bulletList_tooltip: 'Elenco puntato',
        link_tooltip: 'Inserisci link',
        image_tooltip: 'Inserisci immagine',
        showHtml_tooltip: 'Visualizza/modifica HTML',
        undo_tooltip: 'Annulla',
        redo_tooltip: 'Ripeti',
        alignLeft_tooltip: 'Allinea a sinistra',
        alignCenter_tooltip: 'Centra',
        alignRight_tooltip: 'Allinea a destra',
        justify_tooltip: 'Giustifica',
        outdent_tooltip: 'Diminuisci rientro',
        indent_tooltip: 'Aumenta rientro',
        sourceCode_tooltip: 'Codice sorgente',
        preview_tooltip: 'Anteprima',
        table_tooltip: 'Tabella',
        removeFormat_tooltip: 'Cancella formattazione',
        fontFamily_tooltip: 'Tipo di carattere',
        fontSize_tooltip: 'Dimensione carattere'
      },
      source: {
        code: 'Codice',
        preview: 'Anteprima'
      }
    },
    filters: {
      mailType: {
        value: 'Tipo di email',
        placeholder: 'Tipo di email'
      },
      language: {
        value: 'Lingua',
        placeholder: 'Lingua'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      userHostServer: {
        value: 'Server email (utente/from/ospite)',
        placeholder: 'Server email (utente/from/ospite)'
      }
    },
    mailTemplates_table: {
      userHostServer: 'Server email (utente/from/ospite)',
      mailType: 'Tipo di email',
      language: 'Lingua',
      project: 'Servizio'
    },
    detail: {
      subject: 'Affari',
      body: 'Corpo del messaggio',
      delete_template: 'Elimina modello email',
      delete_template_ok: 'Modello di email eliminato correttamente',
      save_changes: 'Modello di email aggiornato correttamente',
      create_template_ok: 'Modello creato correttamente',
      confirm: {
        title_delete_template: 'Sei sicuro di voler eliminare questo modello?'
      }
    },
    new_template: 'Nuovo modello',
    create_template: 'Creare modello',
    add_template: 'Modello di salvataggio',
    clone: {
      title: 'Modello clone',
      label: 'Clone'
    },
    error: {
      duplicated: 'Esiste già un modello per quel tipo di email, progetto e lingua',
      notFound: 'È necessario compilare tutti i campi necessari per eseguire l\'aggiornamento'
    }
  },
  communicationm: {
    filters: {
      id: {
        value: 'Id',
        placeholder: 'Id'
      },
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      docTypeName: {
        value: 'Tipo di documento',
        placeholder: 'Tipo di documento'
      },
      enabled: {
        value: 'Attivo',
        placeholder: 'Scegli...',
        enabled: 'Abilitato',
        disabled: 'Disabilitato'
      },
      description: {
        value: 'descrizione',
        placeholder: 'descrizione'
      },
      creationDateTimeFrom: {
        value: 'Data di creazione da',
        placeholder: 'Data di creazione da'
      },
      creationDateTimeTo: {
        value: 'Data di creazione a',
        placeholder: 'Data di creazione a'
      }
    },
    communicationm_table: {
      id: 'Id',
      name: 'Nome',
      countryReception: 'Paese di ricezione',
      docTypeName: 'Tipo di documento',
      creationDateTime: 'Data di creazione',
      description: 'descrizione',
      enable: 'Attivo',
      disabled: 'Inattivo',
      byCountryEmission: 'Emissione per paese',
    },
    msg_generics: {
      saving: 'Salvataggio dei dati di comunicazione',
      enable: 'Abilitato',
      disable: 'Disabilitato',
      no_match: 'Nessuna corrispondenza trovata',
      advanced_search: 'Ricerca avanzata',
      search: 'Cerca',
      popover_clean_filters: 'Pulisci filtri'
    },
    notify: {
      save_changes: 'Lo stato è stato aggiornato',
      error_save_changes: 'Lo stato non è stato aggiornato'
    }
  },
  articles: {
    filters: {
      id: {
        value: 'ID articolo', placeholder: 'Inserisci l’ID dell’articolo'
      },
      seller: {
        value: 'Venditore', placeholder: 'Seleziona venditori'
      },
      buyer: {
        value: 'Acquirente', placeholder: 'Seleziona acquirenti'
      },
      itemCode: {
        value: 'Codice articolo (esatto)', placeholder: 'Inserisci il codice esatto'
      },
      itemCodeLike: {
        value: 'Codice articolo (like)', placeholder: 'Inserisci il codice (caratteri jolly permessi)'
      },
      startIndexOfLikeCharacters: {
        value: 'Indice minimo like', placeholder: 'Inserisci l’indice minimo'
      },
      description: {
        value: 'Descrizione (like)', placeholder: 'Inserisci la descrizione'
      },
      creationDateTimeFrom: {
        value: 'Data di creazione da', placeholder: 'Seleziona data iniziale'
      },
      creationDateTimeTo: {
        value: 'Data di creazione a', placeholder: 'Seleziona data finale'
      },
      futureGrossPriceDate: {
        value: 'Aggiornamento prezzo futuro da', placeholder: 'Seleziona data'
      },
      pendingUpdate: {
        value: 'In attesa di aggiornamento',
        placeholder: 'Seleziona un’opzione'
      },
      enabled: { value: 'Attivo', placeholder: 'Seleziona stato' },
    },
    table: {
      seller: 'Venditore',
      buyer: 'Acquirente',
      itemCode: 'Codice articolo',
      itemDescription: 'Descrizione',
      grossPrice: 'Prezzo lordo',
      futureGrossPriceDate: 'Prossimo cambio prezzo',
      futureGrossPrice: 'Nuovo prezzo',
      creationDateTime: 'Data di creazione',
      enable: 'Attivo'
    },
    msg_generics: {
      enabled: 'Abilitato',
      filter_table_menu: 'Menu colonne',
      popover_clean_filters: 'Pulisci filtri',
      load_init: 'Caricamento risultati…',
      order_table: 'Ordinamento tabella…',
      size_table: 'Aggiornamento dimensione pagina…',
      pagination_table: 'Cambio pagina…',
      saving: 'Salvataggio modifiche…',
      filter_date: 'Filtraggio per data…',
      filter_delete: 'Rimozione filtro…',
      filter_delete_all: 'Rimozione di tutti i filtri…',
      no_match: 'Nessuna corrispondenza',
      advanced_search: 'Ricerca avanzata',
      disabled: 'Disabilitato'
    },
    notify: {
      save_changes: 'Modifiche salvate correttamente',
      error_save_changes: 'Errore nel salvataggio delle modifiche',
      no_articles_found: 'Nessun articolo trovato con i filtri specificati',
      updating: 'Aggiornamento in corso...',
      updated: 'Aggiornamento completato con successo',
      error_updating: 'Errore durante l\'aggiornamento degli articoli'
    },
    buttons: {
      add_article: 'Aggiungi',
      article_created: 'Articolo creato con successo',
      cancel_new_article: 'Annulla'
    }
  },
  profiles: {
    new: 'Nuovo profilo',
    filters: {
      name: {
        value: 'Profilo',
        placeholder: 'Nome profilo'
      },
      description: {
        value: 'Descrizione',
        placeholder: 'Descrizione'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      }
    },
    notify: {
      add_profile: 'Profilo creato correttamente',
      delete_profile: 'Profilo cancellato correttamente',
      save_changes: 'Il profilo è stato aggiornato correttamente'
    },
    confirm: {
      delete_profile: 'Sei sicuro di eliminare il profilo?'
    },
    load: {
      add_profile: 'Aggiunta del profilo ...',
      delete_profile: 'Rimozione del profilo ...'
    },
    profiles_table: {
      name: 'Profilo',
      description: 'Descrizione',
      project: 'Servizio'
    },
    profiles_auth: {
      name: 'Nome',
      description: 'Descrizione',
      module: 'Modulo'
    }
  },
  form_new_role: {
    new_role: 'Creare un nuovo profilo',
    service: 'Servizio',
    role: 'Profilo*',
    delete: 'Cancellabile',
    description: 'Descrizione*',
    submit: 'Send',
    permisos: 'Permessi',
    dialog: {
      delete: 'È cancellabile?',
      service: 'Scegli il servizio',
      permisos: 'Scegli le autorizzazioni'
    }
  },
  taxes: {
    new: 'Nuova imposta',
    filters: {
      type: {
        value: 'Tipo di imposta',
        placeholder: 'Tipo di imposta'
      },
      rate: {
        value: 'Tariffa',
        placeholder: 'Tariffa'
      },
      enabled: {
        value: 'Abilitato',
        placeholder: 'Selezionare...'
      },
      country: {
        value: 'Paese',
        placeholder: 'Paese'
      },
      validity_date_from: {
        value: 'Data di validità da',
        placeholder: 'Data di validità da'
      },
      validity_date_to: {
        value: 'Data valida fino a',
        placeholder: 'Data valida fino a'
      },
      legal_text: {
        value: 'Testo legale',
        placeholder: 'Testo legale'
      },
      taxable_event: {
        value: 'Evento imponibile'
      }
    },
    notify: {
      add_tax: 'Imposta creata con successo.',
      delete_tax: 'La tassa è stata cancellata.',
      save_changes: 'La tassa è stata aggiornata.'
    },
    confirm: {
      delete_tax: "Sei sicuro di eliminare l'imposta?"
    },
    load: {
      add_tax: 'Aggiunta imposta...',
      delete_tax: 'Eliminazione imposta...'
    },
    taxes_table: {
      type: 'Tipo di imposta',
      rate: 'Tariffa',
      country: 'Paese',
      validity_date_from: 'Data di validità da',
      validity_date_to: 'Data valida fino a',
      enable: 'Abilitato'
    },
    rules_form: {
      validity_date_msg: 'La data di validità da non può essere successiva alla data di validità fino a',
      duplicated_text: 'Valore duplicato. Il testo legale associato alla tassa esiste già.'
    },
    validity_date: 'Data valida',
    delete_tax: 'Elimina',
    delete_tax_tooltip: 'Elimina imposta',
    no_legalTex: 'Tassa senza testi legali',
    add_legalText_tooltip: 'Carica testo legale'
  },
  userInformation: {
    title: 'Informazioni',
    validity_date: 'Periodo di validità',
    message: 'Messaggio',
    message_placeholder: 'Scrivi il messaggio da mostrare',
    close: 'Chiudi',
    dont_show_again: 'Non mostrare più questo messaggio',
    rules: {
      message_required: 'Inserire un messaggio',
      date_range: 'La data di inizio non può essere successiva alla data di fine'
    },
    notify: {
      warning: 'Avviso',
      error: 'Errore',
      saved_title: 'Salvato',
      deleted_title: 'Eliminato',
      created: 'Messaggio creato correttamente',
      updated: 'Messaggio aggiornato correttamente',
      deleted: 'Messaggio eliminato correttamente',
      load_error: 'Impossibile caricare il messaggio informativo',
      save_error: 'Impossibile salvare il messaggio informativo',
      delete_error: 'Impossibile eliminare il messaggio informativo'
    }
  },
  mailServer: {
    new: 'Nuovo server di posta',
    notify: {
      add_mailServer: 'Server di posta creato con successo',
      delete_mailServer: 'Server di posta eliminato con successo.',
      save_changes: 'Server di posta aggiornato con successo'
    },
    confirm: {
      delete_mailServer: 'Sei sicuro di eliminare il server di posta?'
    },
    load: {
      add_mailServer: 'Aggiungo server di posta...',
      delete_mailServer: 'Eliminazione server di posta...'
    },
    mailServer_table: {
      host: 'Ospite',
      user: 'Utente',
      password: 'Password ',
      mailfrom: 'Indirizzo email di origine',
      port: 'Porta',
      auth: 'Autenticazione',
      protocol: 'Protocollo',
      idClient: 'ID Cliente',
      idTenant: 'ID dell’organizzazione',
      clientSecret: 'Segreto del Cliente',
      validityDateTo: 'Data di validità dell\'accesso',
      saveToSentItems: 'Salva email inviate'
    },
    test_error: 'Impossibile stabilire la connessione al server di posta',
    test_ok: 'La connessione al server di posta è riuscita',
    auth_error: 'Si è verificato un errore di autenticazione',
    delete_mailServer: 'Elimina',
    delete_mailServer_tooltip: 'Elimina server di posta',
    test_tooltip: 'Verifica connessione',
    test: 'Verifica',
    duplicate_error: 'siste già un server di posta con questi dati'
  },
  user_detail: {
    info_user: 'Informazioni utente',
    new_role: 'Creare profilo',
    user_detail_edit_form: {
      name: 'Nome',
      first_surname: 'Primo cognome',
      second_surname: 'Secondo cognome',
      id_number: 'Numero di identificazione fiscale',
      department: 'Dipartimento',
      enable: 'Stato disabilitato/abilitato'
    },
    delete_user: 'Elimina',
    delete_user_tooltip: 'Elimina utente',
    duplicate_user: 'Duplicato',
    duplicate_user_tooltip: 'Utente duplicato',
    reset_pass_user: 'Resetta la password',
    user_media: 'Media dell\'utente',
    no_user_media: 'Este usuario no tiene ningún date de contacto',
    add_user_media: 'Aggiungi',
    add_user_media_tooltip: 'Aggiungi media utente',
    user_media_table: {
      media_type_name: 'Tipo di contatto',
      value: 'Contatto'
    },
    dialog_add_user_media: {
      title: 'Media dell\'utente',
      media_type_name: 'Tipo di contatto',
      value: 'Contatto',
      button_add: 'Inserisci'
    },
    dialog_change_user_email: {
      title: 'Nuova email dell\'utente',
      old_email: 'Email corrente',
      new_email: 'Nuova email',
      button_add: 'Aggiornare'
    },
    user_entity: 'Entità utente',
    no_user_entity: 'Questo utente non ha alcuna entità utente',
    add_user_entity: 'Aggiungi',
    add_user_entity_tooltip: 'Aggiungi entità utente',
    user_entity_table: {
      project_name: 'Nome del servizio',
      party_tax_identification_number: 'Numero di identificazione fiscale/società',
      centre_code: 'Codice/Centro'
    },
    dialog_add_user_entity: {
      title: 'Entità utente',
      project_name: 'Nome del servizio',
      option_all_project: 'Tutti',
      party_tax_identification_number: 'Numero di identificazione fiscale/società',
      option_all_party: 'Tutti',
      centre_code: 'Codice/centro',
      option_all_centre: 'Tutti',
      button_add: 'Aggiungi'
    },
    roles_authorities: 'Profili/Autorità',
    no_user_authorities: 'Questo utente non dispone delle autorizzazioni',
	no_user_authorities_sign: 'Questo utente non dispone delle autorizzazioni necessarie per questa azienda',
    option_all_project_roles_authorities: 'Tutti',
    roles: 'Profili',
    authorities: 'Autorità',
    add_new_role: 'Aggiungere',
    save_roles_authorities: 'Salvare',
    add_new_role_tooltip: 'Aggiungi nuovo profilo',
    save_roles_authorities_tooltip: 'Salva I Cambiamenti',
    cancel_roles_authorities: 'Annulla',
    cancel_roles_authorities_tooltip: 'Annulla I Cambiamenti',
    load: {
      delete_user_media: 'Eliminazione dei media dell\'utente...',
      add_user_media: 'Aggiunta di media utente...',
      add_user_entity: 'Aggiunta di entità utente...',
      delete_user_entity: 'Eliminazione entità utente...',
      change_roles_user: 'Modifica delle autorizzazioni dell\'utente...',
      init_user_data: 'Caricamento dei dati dell\'utente...',
      change_user_email: 'Aggiornamento email dell\'utente ...'
    },
    notify: {
      reset_password_ok: 'Nuova password è stata inviata per e-mail',
      delete_user_media: 'Supporto utente cancellato correttamente.',
      add_user_media: 'Supporto utente aggiunto correttamente.',
      add_role: 'Il profilo è stato creato correttamente.',
      add_user_entity: 'Entità utente aggiunta correttamente.',
      add_user_entity_repeat: 'L\'utente ha già assegnato questa entità',
      add_user_entity_validateko: 'Questa entità è stata contemplata prima',
      delete_user_entity: 'Entità utente cancellata correttamente.',
      delete_user_entityko: 'L\'utente deve avere almeno un\'entità',
      delete_user_ok: 'Utente cancellato correttamente',
      save_user_entityko: 'Questa entità è stata contemplata prima',
      change_user_email: 'Email dell\'utente aggiornata con successo.'
    },
    confirm: {
      title_delete_user: 'Sei sicuro di cancellare questo utente?',
      message_delete_user: "Questa azione eliminerà tutte le informazioni relative all'utente. Si consiglia di disattivare l'utente.",
      confirm_button_delete_user: 'Elimina',
      title_reset_password: 'Sei sicuro di voler cambiare la password di questo utente?',
      confirm_button_reset_password: 'Reset',
      title_delete_user_media: 'Sei sicuro di voler eliminare questo media utente?',
      confirm_button_delete_user_media: 'Elimina',
      title_delete_user_entity: 'Sei sicuro di voler eliminare questa entità utente?',
      confirm_button_delete_user_entity: 'Elimina',
      change_user_email: 'L\'utente deve avere un\'email come informazioni di contatto. Per eliminare l\'email corrente è necessario inserire una nuova email.',
	  service_account_title: 'Accesso tramite servizio',
	  service_account_ok_message: 'Questo utente può accedere solo tramite canali di integrazione.',
	  service_account_ko_message: "Questo utente può accedere solo tramite il portale.",
	  service_account_ok: 'Accesso tramite servizio aggiornato'
    }
  },

  // Recepciones emitidas y recibidas
  recadv: {
    number: {
      max: 'Il numero di ricev non può superare i 20 caratteri'
    },
    filters: {
      creation_date: {
        value: 'Data-ora di registrazione'
      },
      buyer: {
        value: 'Acquirente',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      delivery_date: {
        value: 'Le date di consegna variano',
        placeholder: 'Le date di consegna variano'
      },
      reception_date: {
        value: 'Gamma di date di ricezione',
        placeholder: 'Gamma di date di ricezione'
      },
      recadv_number: {
        value: 'Nº ricev',
        placeholder: 'Ricev'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      order_number: {
        value: 'Numero d\'ordine',
        placeholder: 'Ordine'
      },
      delivery_number: {
        value: 'Numero bolla di consegna',
        placeholder: 'Bolla di consegna'
      },
      invoice_recadv: {
        value: 'Numero di fattura',
        placeholder: 'Fattura'
      }
    },
    recadv_entity_table: {
      buyer: 'Acquirente',
      seller: 'Venditore',
      num_recadv: 'N.Ricev',
      date_receiving: 'D. ricevente',
      date_creation: 'D. Registrazione',
      status: 'Stato',
      services: 'Servizio',
      invoice_recadv: 'N.Fattura',
      buyer_centre: 'Centro dell\'acquirente',
      delivery_centre: 'Luogo di consegna',
      seller_centre: 'Centro del venditore',
      csv_title: 'Esporta in CSV. Informazione',
      csv_message: 'Impossibile esportare più di {argumento} record, restringere la ricerca',
      csv_details_message: 'Non puoi esportare righe di più di 200 documenti, restringi la ricerca',
	  total_amount: "Importo totale",
    },

    recadv_entity_table_detail: {
      code: 'Codice articolo',
      lineNumber: 'Nº lin',
      itemCodeSeller: 'Cod. oggetto del venditore',
      itemCodeAcquirente: 'Cod. oggetto dell acquirente',
      deliveryNoteNumber: 'Blocco di consegna',
      deliveryNoteLine: 'Linea bolla di consegna',
      description: 'Descrizione',
      order: 'Ordine',
      despatch_quantity: 'Quantità di spedizione',
      received_quantity: 'Quantità ricevuta',
      accepted_quantity: 'Quantità accettata',
      measure: 'Unità di misura',
      price: 'Prezzo unitario',
      currency: 'Moneta',
      status: 'Stato',
      options: 'Opzioni',
      subtype: 'Sottotipo'
    },
    recadv_related_documents_table: {
      date: 'Data di relazione',
      destinationDocument: 'Dº documento',
      destinationDocumentType: 'Tipo di documento'
    },
    recadv_detail: {
      recadv_line_no_data: 'Questo ordine non ha righe',
      create_invoice_buttons: 'Creare',
      activate_recadv_buttons: 'Attiva',
      rejected_recadv_buttons: 'Respinto',
      recadv_line_no_date: 'Questo recadv non ha linee',
      related_documents_no_data: 'Questo ricev non ha documenti correlati',
      download_pdf_buttons: 'Scarica',
      download_pdf_buttons_tooltip: 'Scarica PDF ricev',
      rejected_recadv_lineError: 'Linea di inquadratura',
      create_invoice_buttons_tooltip: 'Creare fattura',
      activate_recadv_buttons_tooltip: 'Attiva ricev',
      rejected_recadv_buttons_tooltip: 'Respinto ricev',
      download_pdfmultiple_buttons: 'Scarica ricev/s',
      reception_lines: 'Linee di ricezione',
      edit: 'Modifica',
      related_documents: 'Documenti correlati',
      dialog_rejected_recadv: {
        title: 'Respinto ricev',
        value: 'Motivo',
        placeholder: 'Motivo respinto',
        motive_required: 'Motivo richiesto'
      },

      change_state: {
        label: 'Cambio di stato',
        placeholder: 'Scegli uno stato di ricezione',
        load: 'Aggiornamento dei dati della ricevuta ...'
      },

      dialog_new_check_line_recadv: {
        title: 'Nuova linea di accoglienza',
        title_edit: 'Modifica linea di ricezione',
        description: 'Descrizione dell oggetto',
        quantity: 'quantità',
        priceUnit: 'Prezzo unit.',
        date_required: 'Campo obbligatorio',
        measure: 'misurare',
        measureUnit: {
          PCE: 'Pezzi',
          KGM: 'Chilogrammi',
          MTR: 'Metro lineare',
          TNE: 'Tonnellata',
          LTR: 'Litro',
          MTQ: 'Metro cubo',
          DMQ: 'Dcm. cubo',
          CENT: 'Centinaia',
          MILL: 'Millares',
          MTK: 'M. quadri',
          BOX: 'Scatola',
          BOTL: 'Bottiglia',
          NTBK: 'Taccuino',
          GRM: 'Grammo',
          GRSA: 'Lordo',
          SHEE: 'Foglia',
          GAME: 'Gioco',
          PAR: 'Paio',
          OVLL: 'Palla',
          CARR: 'Reel',
          PACK: 'Pacchetto',
          DOCE: 'Dozzina',
          K: 'K',
          R: 'R',
          B: 'B',
          UN: 'Unità'
        },
        search_measure: 'Elija unidad de medida'
      },

      notify: {
        submit_edit_recadv_ok: 'Lo stato della ricevuta è stato modificato con successo',
        recadv_rejected: 'Il ricev è stato rifiutato correttamente',
        recadv_activate: 'Il ricev è stato attivato',
        download_pdf: 'Il Scaricare del file {file} è stato corretto.',
        recadv_new_line: 'Una nuova linea di debug è stata registrata correttamente',
        recadv_edit_line: 'La linea di offset è stata modificata con successo'
      },
      load: {
        recadv_rejected: 'Rifiutando ricev',
        recadv_activate: 'Attivazione di ricezione'
      },
      confirm: {
        title_recadv_activate: 'La ricezione {recadvID}, dal provider {sellerName}, verrà attivata. Vuoi continuare?',
        confirm_button_recadv_activate: 'Ok'
      }
    }
  },
  // Albaranes
  delivery: {
    number: {
      max: 'Il numero di consegna non può superare i 30 caratteri'
    }
  },
  // Pedidos emitidos y recibidos
  order: {
    number: {
      max: 'Il numero di ordine non può superare i 20 caratteri'
    },
    filters: {
      creation_date: {
        value: 'Data-ora di registrazione'
      },
      buyer: {
        value: 'Acquirente',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Inserisci 3 caratteri'
      },
      delivery_date: {
        value: 'Le date di consegna variano',
        placeholder: 'Le date di consegna variano'
      },
      order_date: {
        value: 'Gamma di date di ordine',
        placeholder: 'Gamma di date di ordine'
      },
      issue_date: {
        value: 'Intervallo date di emissione',
        placeholder: 'Intervallo date'
      },
      order_number: {
        value: 'Numero di ordine',
        placeholder: 'Ordine'
      },
      deliveryNote_number: {
        value: 'N. bolla di consegna',
        placeholder: 'Bolla di consegna'
      },
      invoice_number: {
        value: 'Numero di fattura',
        placeholder: 'Fattura'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      invoice_order: {
        value: 'Numero di fattura',
        placeholder: 'Fattura'
      },
      orderType: {
        value: 'Tipo',
        placeholder: 'Tipo di ordine'
      },
      orderSubType: {
        value: 'Sottotipo',
        placeholder: 'Sottotipo di ordine'
      },
      deliveryDateFrom: {
        value: 'Data di consegna da',
        placeholder: 'Data di consegna da'
      },
      deliveryDateTo: {
        value: 'Data di consegna fino',
        placeholder: 'Data di consegna fino'
      },
      no_error_status: {
        value: 'Stati esclusi',
        placeholder: 'Stati esclusi',
        rejected: 'Stati rifiutati'
      }
    },
    order_entity_table: {
      buyer: 'Acquirente',
      seller: 'Venditore',
      num_order: 'N.Ordine',
      date_creation: 'D. registrazione',
      date_issue: 'D. intervallo',
      status: 'Stato',
      services: 'Servizio',
      invoice_order: 'N.Fattura',
      buyer_centre: 'Centro dell\'acquirente',
      seller_centre: 'Centro del venditore',
      delivery_centre: 'Luogo di consegna',
      order_type: 'Tipo',
      delivery_date_from: 'D. di consegna da',
      delivery_date_to: 'D. di consegna fino',
      csv_title: 'Esporta in CSV. Informazione',
      csv_message: 'Impossibile esportare più di {argumento} record, restringere la ricerca',
      csv_details_message: 'Non puoi esportare righe di più di 100 documenti, restringi la ricerca'
    },
    order_entity_table_detail: {
      code: 'Codice articolo',
      lineNumber: 'Riga Nº',
      itemCode: 'Codice articolo',
      itemCodeSeller: 'Cód. articolo venditore',
      itemCodeBuyer: 'Cód. articolo acquirente',
      gtin14Code: 'Cód. GTIN14',
      delivery_centre: 'Luogo di consegna',
      quantity: 'Quantità',
      description: 'Descrizione',
      order: 'Ordine',
      despatch_quantity: 'Quantità di spedizione',
      received_quantity: 'Quantità ricevuta',
      accepted_quantity: 'Quantità accettata',
      measure: 'Unità di misura',
      unitPrice: 'Prezzo unitario',
      totalAmount: 'Prezzo totale della linea',
      deliveryDate: 'Data di consegna',
      documentStatus: 'Line status',
      currency: 'Moneta',
      status: 'Stato',
      options: 'Opzioni',
      notes: 'Notas',
      quantityTradeUnit: 'Quantità confezione',
      measureTradeUnit: 'Unità di misura confezione',
      netPrice: 'Prezzo netto',
      grossPrice: 'Prezzo lordo',
      quantityRemaining: 'Quantità pendente',
      change_state: {
        title: 'Cambio di stato di linea di ordine',
        label: 'Cambio di stato di linea',
        placeholder: 'Scegli uno stato della linea',
        load: 'Aggiornamento dei dati di linea di ordine ...'
      }
    },
    order_related_documents_table: {
      date: 'Data di relazione',
      destinationDocument: 'Nº documento',
      destinationDocumentType: 'Tipo di documento'
    },
    order_charges_discounts_table: {
      chargeDiscountTypeCode: 'Descrizione',
      charge: 'Tipo',
      charge_code: {
        TD: 'Sconti commerciali',
        EAB: 'Sconti pagamento anticipato',
        ABH: 'Sconti sulla quantità o sulla discesa',
        ACQ: 'Società Canonica degli Autori',
        MC: 'Tasso di farina di carne',
        VEJ: 'Punto verde',
        AA: 'Tassa pubblicitaria'
      },
      rate: 'Aliquota (in %)',
      baseAmount: 'Importo base',
      amount: 'Importo',
      currencyCode: 'Valuta',
      sequence: 'Sequenza'
    },
    order_detail: {
      create_invoice_buttons: 'Creare',
      activate_order_buttons: 'Attiva',
      rejected_order_buttons: 'Respinto',
      order_line_no_data: 'Questo ordine non ha linee',
      related_documents_no_data: 'Questo ordine non ha documenti correlati',
      charge_discounts_no_data: 'Questo ordine non prevede spese né sconti',
      download_pdf_buttons: 'Scarica',
      download_pdf_buttons_tooltip: 'Scarica PDF ordine',
      rejected_order_lineError: 'Linea di inquadratura',
      create_invoice_buttons_tooltip: 'Creare fattura',
      create_deliveryNote_buttons_tooltip: 'Creare bolla di consegna',
      activate_order_buttons_tooltip: 'Attiva ordine',
      rejected_order_buttons_tooltip: 'Respinto ordine',
      download_pdfmultiple_buttons: 'Scarica ordine/s',

      change_line_status_buttons_tooltip: 'Cambio di stato di linea di ordine',
      change_line_status_buttons: 'Cambio stato',

      order_lines: 'Linee di ordine',
      related_documents: 'Documenti correlati',
      charge_discount: 'Tariffe e sconti',
      edit: 'Modifica',
      order_reponse: 'Order responses',
      order_reponse_download_tooltip: 'Scarica risposta',
      order_reponse_number: 'Response No.',
      order_reponse_name: 'Nome',
      order_reponse_date: 'D. registrazione',
      order_response_no_data: 'Questo ordine non ha responses',

      dialog_rejected_order: {
        title: 'Respinto ordine',
        value: 'Motivo',
        placeholder: 'Motivo respinto',
        motive_required: 'Motivo richiesto'
      },

      dialog_new_check_line_order: {
        title: 'Nuova linea di accoglienza',
        title_edit: 'Modifica linea di ordine',
        description: 'Descrizione dell oggetto*',
        quantity: 'quantità*',
        priceUnit: 'Prezzo unit.*',
        date_required: 'Campo obbligatorio'
      },
      dialog_accept_order: {
        title: 'Accetta ordine e genera risposta',
        orderResponseNumberLabel: 'Numero per la risposta alla ordine'
      },
      change_state: {
        label: 'Cambio di stato',
        placeholder: 'Scegli uno stato di ordine',
        load: 'Aggiornamento dei dati di ordine ...'
      },
      notify: {
        submit_edit_order_ok: 'Lo stato di ordine è stato modificato con successo',
        order_rejected: 'Il ordine è stato rifiutato correttamente',
        order_activate: 'Il ordine è stato attivato',
        download_pdf: 'Il Scaricare del file {file} è stato corretto.',
        order_new_line: 'Una nuova linea di debug è stata registrata correttamente',
        order_edit_line: 'La linea di offset è stata modificata con successo',
        line_error: 'Non è possibile selezionare righe non valide per creare la fattura'
      },
      load: {
        order_rejected: 'Rifiutando ordine',
        order_activate: 'Attivazione di ordine'
      },
      confirm: {
        title_order_activate: 'La ordine {orderID}, dal provider {sellerName}, verrà attivata. Vuoi continuare?',
        title_order_reject: 'La ordine {orderID}, dal provider {sellerName}, verrà rifiutata. Vuoi continuare?',
        confirm_button_order_activate: 'Ok'
      }
    }
  },
  // reporte de ventas.
  sales_report: {
    number: {
      max: 'Il numero del rapporto non può superare i 35 caratteri'
    },
    filters: {
      service: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Seleziona un venditore'
      },
      buyer: {
        value: 'Acquirente',
        placeholder: 'Seleziona un acquirente'
      },
      store: {
        value: 'Punto vendita',
        placeholder: 'Seleziona un punto vendita'
      },
      document_number: {
        value: 'N° rapporto',
        placeholder: 'Numero rapporto'
      },
      sale_date: {
        value: 'Rango data di vendita',
        placeholder: 'Seleziona un rango di data di vendita'
      },
      article_code: {
        value: 'Codice articolo',
        placeholder: 'Codice articolo'
      },
      creation_date: {
        value: 'Data-ora di registrazione'
      }
    },
    sales_report_entity_table: {
      slsrpt_number: 'N° rapporto',
      service: 'Servizio',
      seller: 'Venditore',
      buyer: 'Acquirente',
      centre_buyer: 'Punto vendita',
      issue_date: 'Data emissione',
      creation_date_time: 'Data registrazione',
      status: 'Stato',
      expiration_date_time: 'Data scadenza',
      csv_title: 'Esporta in CSV. Informazioni',
      csv_message: 'Non è possibile esportare più di {argumento} record, restringi la ricerca'
    },
    sales_report_entity_table_detail: {
      lineNumber: 'N° linea',
      itemCode: 'Codice articolo',
      itemDescription: 'Descrizione articolo',
      quantitySales: 'Quantità venduta',
      quantityReturn: 'Quantità restituita',
      salesDate: 'Data di vendita',
      centre_buyer: 'Punto vendita'
    },
    sales_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Scarica il PDF del rapporto di vendita',
      sales_report_lines: 'Linee del rapporto di vendita',
      edit: 'Modifica',
      related_documents: 'Documenti correlati',
      related_documents_no_data: 'Questo rapporto non ha documenti correlati',
      sales_report_line_no_data: 'Questo rapporto non ha linee',
      notify: {
        download_pdf: 'Il file {file} è stato scaricato correttamente.'
      },
      load: {
        download_pdf: 'Download del PDF del rapporto di vendita ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Scaricare CSV',
      download_original_tooltip: 'Scarica originale'
    }
  },
  // reporte de inventario.
  inventory_report: {
    number: {
      max: 'Il numero del rapporto non può superare i 35 caratteri'
    },
    filters: {
      service: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Seleziona un venditore'
      },
      buyer: {
        value: 'Acquirente',
        placeholder: 'Seleziona un acquirente'
      },
      store: {
        value: 'Punto di inventario',
        placeholder: 'Seleziona un punto di inventario'
      },
      document_number: {
        value: 'N° rapporto',
        placeholder: 'Numero rapporto'
      },
      quantity_incoming_date: {
        value: 'Rango data di inventario',
        placeholder: 'Seleziona un rango di data di inventario'
      },
      article_code: {
        value: 'Codice articolo',
        placeholder: 'Codice articolo'
      },
      creation_date: {
        value: 'Data-ora di registrazione'
      }
    },
    inventory_report_entity_table: {
      invrpt_number: 'N° rapporto',
      service: 'Servizio',
      seller: 'Venditore',
      buyer: 'Acquirente',
      centre_buyer: 'Punto di inventario',
      issue_date: 'Data emissione',
      creation_date_time: 'Data registrazione',
      status: 'Stato',
      expiration_date_time: 'Data scadenza',
      csv_title: 'Esporta in CSV. Informazioni',
      csv_message: 'Non è possibile esportare più di {argumento} record, restringi la ricerca'
    },
    inventory_report_entity_table_detail: {
      lineNumber: 'N° linea',
      itemCode: 'Codice articolo',
      itemDescription: 'Descrizione articolo',
      quantityTarget: 'Quantità in inventario',
      quantityIncoming: 'Quantità in entrata',
      quantityStock: 'Quantità in stock',
      quantityIncomingDate: 'Data di inventario',
      centre_buyer: 'Punto vendita'
    },
    inventory_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Scarica il PDF del rapporto di inventario',
      inventory_report_lines: 'Linee del rapporto di inventario',
      edit: 'Modifica',
      related_documents: 'Documenti correlati',
      related_documents_no_data: 'Questo rapporto non ha documenti correlati',
      inventory_report_line_no_data: 'Questo rapporto non ha linee',
      notify: {
        download_pdf: 'Il file {file} è stato scaricato correttamente.'
      },
      load: {
        download_pdf: 'Download del PDF del rapporto di inventario ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Scaricare CSV',
      download_original_tooltip: 'Scarica originale'
    }
  },
  // Traduzioni REMADV
  remadv: {
    buttons: {
      download_csv_tooltip: 'Scarica CSV remadv',
      download_original_tooltip: 'Scarica originale'
    },
    remadv_entity_table: {
      service: 'Servizio',
      seller: 'Venditore',
      buyer: 'Compratore',
      invoicee_centre: 'Centro fatturato',
      remadv_number: 'Nº avviso di liquidazione',
      invoice_number: 'Nº fattura',
      issue_date: 'Data emissione',
      document_date: 'Data documento',
      total_amount: 'Importo liquidazione',
      currency: 'Moneta',
      creation_date_time: 'Data creazione',
      status: 'Stato',
      payment_date: 'Data pagamento',
      notes: 'Note'
    },
    lines_remadv_entity_table: {
      line_number: 'Nº linea',
      document_number: 'Nº documento',
      document_date: 'Data emissione',
      description: 'Descrizione',
      centre_code: 'Fatturatore',
      document_amount: 'Totale',
      currency: 'Moneta',
      payment_date: 'Data pagamento'
    },
    remadv_detail: {
      remadv_lines: 'Linee avviso di liquidazione',
      remadv_line_no_data: 'Questo avviso di liquidazione non ha linee'
    },
    csv_title: 'Esporta in CSV. Informazioni',
    csv_message: 'Non è possibile esportare più di {argumento} record, si prega di restringere la ricerca',
    csv_details_message: 'Non è possibile esportare linee di più di 100 documenti, si prega di restringere la ricerca',
    filters: {
      service: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Seleziona un venditore'
      },
      buyer: {
        value: 'Compratore',
        placeholder: 'Seleziona un compratore'
      },
      centre_payer: {
        value: 'Centro fatturato',
        placeholder: 'Seleziona un centro fatturato'
      },
      remadv_number: {
        value: 'Nº avviso di liquidazione',
        placeholder: 'Nº avviso di liquidazione'
      },
      invoice_number: {
        value: 'Numero fattura',
        placeholder: 'Numero fattura'
      },
      issue_date: {
        value: 'Intervallo data emissione',
        placeholder: 'Seleziona un intervallo data emissione'
      },
      document_date: {
        value: 'Intervallo data documento',
        placeholder: 'Seleziona un intervallo data documento'
      },
      total_amount_from: {
        value: 'Importo liquidazione da',
        placeholder: 'Importo liquidazione da'
      },
      total_amount_to: {
        value: 'Importo liquidazione fino a',
        placeholder: 'Importo liquidazione fino a'
      },
      validation: {
        amount_range: 'L\'importo iniziale non può essere maggiore dell\'importo finale'
      },
      creation_date: {
        value: 'Data-ora di registrazione'
      }
    }
  },
  cmr: {
    cmr_entity_table_detail: {
      cargo_general_data: 'Carico',
      cargo_general_data_tooltip: 'Dati generali del carico',
      sent: 'Inviato',
      deleteAttach: 'Elimina allegato', 
      general_data: 'Dati generali',
      document_control: 'Documento di controllo',
      cmr: 'CMR',
      cmrNumber: 'Nº lettere di vettura',
      group: 'Gruppo',
      order: 'Ordine',
      loadparty: 'Compagnia di carico',
      load: 'Centro carico',
      shipper: 'Caricatore',
      buyer: 'Destinatario',
      seller_centre: 'Centro carico',
      buyer_centre: 'Centro consegna',
      loadcode: 'Codice centro di carico',
      loaddirection: 'Indirizzo di carico',
      deliveryparty: 'Compagnia di consegna',
      delivery: 'Centro consegna',
      deliverycode: 'Codice centro di consegna',
      deliverydirection: 'Indirizzo di consegna',
      numpackages: 'Num paquetes',
      dateCreation: 'D. registrazione',
      status: 'Stato',
      service: 'Servizio',
      weight: 'Peso',
      cmrlines: 'Righe della lettera di vettura',
      cmrObservation: 'Osservazioni/Incidenze del documento di trasporto',
      addObservationTitle: 'Aggiungi osservazione/incidenza',
      addObservationOk: 'Osservazione/incidenza aggiunta correttamente al documento di trasporto',
      observation: 'Osservazione/incidenza',
      deleteObservation: 'Elimina osservazione/incidenza',
      addLineTitle: 'Aggiungi linea',
      deleteLineTitle: 'Elimina linea',
      deleteLine: 'Elimina linea',
      deleteLineOk: 'Linea eliminata correttamente',
      cannot_delete_last_line: 'Non è possibile eliminare l\'ultima riga',
      must_keep_one_line: 'Deve esistere almeno una riga, se si desidera eliminare questa riga è necessario aggiungere prima una nuova riga',
      addLineOk: 'Linea aggiunta correttamente',
      sendlink: 'Invia',
      sendlink_tooltip: 'Accetta/Inviami il link',
      sendlink_ok: 'Link inviato correttamente',
      sendlink_confirm: '¿Desea confirmar y enviar el enlace?',
      changeplates: 'Dati di trasporto',
      changeplates_tooltip: 'Cambio di conducente, targa e dettagli del vettore',
      changeplates_confirm: 'Vuoi modificare le targhe del veicolo?',
      changeplates_ok: 'Dati aggiornati correttamente',
      changeobservations: 'Osservazioni/Incidenze',
      changeobservations_tooltip: 'Aggiungi osservazione/incidenza',
      changegeneralobservations: 'Osservazioni',
      changegeneralobservations_tooltip: 'Osservazioni generali',
      changeobservations_confirm: 'Vuoi modificare le osservazioni?',
      changeobservations_ok: 'Osservazioni/incidenze aggiornate correttamente',
      updatestatus: 'Stato',
      updatestatus_tooltip: 'Modifica stato',
      updatestatus_ok: 'Stato aggiornato correttamente',
      plate: 'Targa veicolo trattore',
      trailerplate: 'Targa semirimorchio',
      secondTrailerplate: 'Targa rimorchio',
      cmrnolines: 'Questa lettera di vettura non ha righe',
      cmrnoObservations: 'Questo documento di trasporto non contiene annotazioni/incidenze',
      events: 'Eventi',
      download_attach: 'Descargando adjunto',
      linecode: 'Codice',
      linecodeseller: 'Codice articolo del venditore',
      download_pdf: 'Scarica PDF',
      download_original: 'Originale',
      download_metadata: 'Metadata',
      line: 'Linea',
      history: 'Cronologia delle modifiche',
      no_history: 'Non ci sono modifiche storiche',
      creation_date: 'Data della modifica',
      description: 'Descrizione/Naturaleza',
      csv_title: 'Esporta in CSV. Informazione',
      csv_message: 'Impossibile esportare più di {argumento} record, restringere la ricerca',
      transportist_data: 'Dati del trasportatore',
      transportist_search: {
        title: 'Cerca trasportatore',
        col_name: 'Nome',
        col_nif: 'Codice fiscale',
        col_email: 'Email'
      },
      warn_required_fields: 'Dati opzionali nei bozze che devono essere completati prima di inviare il documento al trasportatore',
      charger_observations: 'Osservazioni del caricatore',
      transportist_observations: 'Osservazioni del trasportatore',
      observation_type: 'Tipo di osservazione/incidenza',
      transportist_name: 'Nome del trasportatore',
      transportist_nif: 'NIF del trasportatore',
      transportist_email: 'Email del trasportatore',
      emailTransportist: 'Email del trasportatore/conducente',
      email_conductor: 'Email del conducente',
      conductor: 'Conducente',
      email_link_note: 'Questa è l\'email a cui verrà inviato il link del pdf',
      observation_type_values: {
        INCIDENCE: 'Incidente',
        UNPLANNEDSTOP: 'Fermata non pianificata',
        DELIVERYNOTES: 'Note di consegna',
        DELAY: 'Ritardo',
        MERCHANDISESTATUS: 'Stato della merce',
        OTHER: 'Altro'
      },
      transportist_default: 'Trasportatore',
      send_date: 'D. spedizione',
      send_date_long: 'Data di spedizione',
      update_cmr: 'Aggiornamento informazioni...',
      submit_edit_ok: 'Informazioni aggiornate correttamente',
      confirm_update_status: 'Sei sicuro di voler cambiare lo stato della lettere di vettura?',
      confirm_sign_pdf: 'Sei sicuro di voler firmare il PDF?',
      confirm_sign_pdf_ok: 'PDF firmato correttamente',
      confirm_draft: 'Sei sicuro di voler inviare la lettere di vettura come bozza?',
      load_signing: 'Firma del PDF in corso ...',
      biometric_signature: {
        title: 'Firma biometrica del documento',
        no_pdf: 'Non c\'è documento PDF da firmare',
        init_error: 'Errore durante l\'inizializzazione del sistema di firma',
        error: 'Errore durante il processo di firma',
        saving: 'Salvando documento firmato...',
        success: 'Documento firmato e salvato correttamente'
      },
      send_tosign_tooltip: 'Inviare a firma',
      send_tosign: 'Inviare a firma',
      modify_tooltip: 'Modificare documento di trasporto',
      modify: 'Modificare',
      create_ecmr: 'Creare documento di trasporto',
      change_state: {
        label: 'Cambiamento di stato',
        placeholder: 'Scegli uno stato della lettere di vettura',
        load: 'Aggiornamento dei dati della lettere di vettura ...'
      }
    },
    cmr_event_type: {
      CHANGE_STATUS: 'Cambiamento di stato',
      CHANGE_STATUS_INI: 'Stato iniziale',
      CHANGE_STATUS_END: 'Stato finale',
      CHANGE_STATUS_MOTIVE: 'Motivo del cambiamento di stato',
      CHANGE_STATUS_USER: 'Utente che ha cambiato lo stato',
      SEND_MAIL: 'Inviata per posta',
      RECEIVED: 'Ricevuto',
      ISSUED: 'Rilasciato',
      ASSIGNED_ORDER: 'Ordine assegnato',
      DO_NOT_DOWNLOAD: 'Non scarica',
      NO_LOAD: 'Non carica',
      LOADED_PACKAGE: 'Pacchetto carico',
      UNLOADED_PACKAGE: 'Pacchetto scaricato',
      CHANGE_DRIVER: 'Cambio conducente',
      SEND_PDF: 'Invia PDF',
      COMMENTS: 'Osservazioni',
      INTEGRATION: 'Integrazione',
      CHANGE_PLATE: 'Cambio di targhe',
      CHANGE_CARGO: 'Modifica dei dati generali del carico',
      CHANGE_AUTHORIZATION: 'Cambio di autorizzazione',
      CHANGE_SEND_DATE: 'Cambio della data di invio',
      CHANGE_OBSERVATIONS: 'Cambio delle osservazioni/incidenze'
    },
    filters: {
      num_cmr: {
        value: 'Nº lettere di vettura',
        placeholder: 'Nº lettere di vettura'
      },
      order: {
        value: 'Ordine',
        placeholder: 'Ordine'
      },
      group: {
        value: 'Gruppo',
        placeholder: 'Gruppo'
      },
      date_creation: {
        value: 'D. registrazione',
        placeholder: 'D. registrazione'
      },
      vehicle_plate: {
        value: 'Targa veicolo trattore',
        placeholder: 'Targa veicolo trattore'
      },
      trailer_plate: {
        value: 'Targa semirimorchio',
        placeholder: 'Targa semirimorchio'
      },
      second_trailer_plate: {
        value: 'Targa rimorchio',
        placeholder: 'Targa rimorchio'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      },
      service: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      sender_party: {
        value: 'Compagnia di carico',
        placeholder: 'Inserisci 3 caratteri'
      },
      receiver_party: {
        value: 'Compagnia di consegna',
        placeholder: 'Inserisci 3 caratteri'
      },
      sender_centre: {
        value: 'Centro carico',
        placeholder: 'Centro carico'
      },
      receiver_centre: {
        value: 'Centro consegna',
        placeholder: 'Centro consegna'
      },
      transportist: {
        value: 'Trasportatore',
        placeholder: 'Trasportatore'
      },
      send_date: {
        value: 'D. invio',
        placeholder: 'D. invio'
      }
    }
  },
  coacsu: {
    coacsu_entity_table: {
      service: "Servizio",
      seller: "Venditore",
      buyer: "Acquirente",
      centre_buyer: "Centro",
      coacsu_number: "N. Riepilogo conto commerciale",
      issue_date: "Data di emissione",
      creation_date_time: "Data di registrazione",
      total_amount: "Importo totale",
      actions: "Azioni"
    },
    filters: {
      service: { value: "Servizio", placeholder: "Servizio" },
      buyer: { value: "Acquirente", placeholder: "Scrivi 3 caratteri" },
      seller: { value: "Venditore", placeholder: "Scrivi 3 caratteri" },
      coacsu_number: { value: "N. Riepilogo conto commerciale", placeholder: "Numero" },
      invoice_number: { value: "N. fattura", placeholder: "Numero" },
      issue_date: { value: "Data di emissione", placeholder: "" },
      total_amount_from: { value: "Importo", placeholder: "Importo liquidazione da" },
      total_amount_to: { value: "Importo fino a", placeholder: "Importo liquidazione fino a" },
      creation_date: { value: "Data-ora di registrazione", placeholder: "" }
    },
    buttons: {
      download_csv_tooltip: "Scarica CSV",
      download_original_tooltip: "Scarica originale"
    },
    tooltip: {
      detail: "Vedi dettaglio"
    },
    breadcrumb: {
      coacsu_lines_view: "Riepilogo conto commerciale"
    },
    detail: {
      information: "Informazioni",
      seller: "Venditore",
      buyer: "Acquirente",
      code: "Codice",
      name: "Nome",
      role: "Ruolo",
      address: "Indirizzo",
      summary: "Riepilogo",
      coacsuNumber: "N. COACSU",
      status: "Stato",
      issueDate: "Emissione",
      paymentDate: "Scadenza",
      lineNumber: "N. linea",
      invoiceNumber: "N. documento",
      total: "Totale",
      currency: "Valuta",
      no_lines: "Nessuna linea",
      lines_title: "Linee riepilogo conto commerciale"
    }
  },
  deliverynote: {
    filters: {
      buyer: {
        value: 'Acquirente',
        placeholder: 'Acquirente'
      },
      seller: {
        value: 'Venditore',
        placeholder: 'Venditore'
      },
      num_deliverynote: {
        value: 'N. della bolla di consegna',
        placeholder: 'N. della bolla di consegna'
      },
      date_creation: {
        value: 'D. di registrazione',
        placeholder: 'D. di registrazione'
      },
      date_issue: {
        value: 'Intervallo di date di emissione',
        placeholder: 'Intervallo di date di emissione'
      },
      status: {
        value: 'Condizione',
        placeholder: 'Condizione'
      },
      services: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      buyer_centre: {
        value: 'Centro acquirente',
        placeholder: 'Centro acquirente'
      },
      seller_centre: {
        value: 'Centro venditore',
        placeholder: 'Centro venditore'
      },
      delivery_centre: {
        value: 'Luogo di consegna',
        placeholder: 'Luogo di consegna'
      },
      delivery_date: {
        value: 'Intervallo di date di consegna',
        placeholder: 'Intervallo di date di consegna'
      },
      invoice_number: {
        value: 'Numero di fattura',
        placeholder: 'Fattura'
      }
    },
    delivery_entity_table: {
      buyer: 'Acquirente',
      seller: 'Venditore',
      num_deliverynote: 'N. della bolla di consegna',
      date_creation: 'D. di registrazione',
      date_issue: 'D. di emissione',
      status: 'Condizione',
      delivery_type: 'Tipo di bolla di consegna',
      services: 'Servizio',
      buyer_centre: 'Centro acquirente',
      seller_centre: 'Centro venditore',
      delivery_centre: 'Luogo di consegna',
      delivery_date: 'Scadenza',
      order_number: 'N. di ordine',
      csv_title: 'Esporta in CSV. Informazione',
      csv_message: 'Impossibile esportare più di {argumento} record, restringere la ricerca',
      csv_details_message: 'Non puoi esportare righe di più di 100 documenti, restringi la ricerca'
    },
    delivery_entity_table_detail: {
      lineNumber: 'Numero di riga',
      itemCode: 'Cod. articolo',
      itemCodeSeller: 'Cod. articolo fornitore',
      itemCodeBuyer: 'Cod. articolo acquirente',
      codeCentreDeliveryPoint: 'Luogo di consegna',
      quantity: 'Quantità in attesa',
      description: 'Descrizione',
      order: 'Numero di ordine',
      despatch_quantity: 'Quantità pubblicizzata',
      received_quantity: 'Quantità ricevuta',
      accepted_quantity: 'Quantità accettata',
      measure: 'Unità di misura',
      unitPrice: 'Prezzo unitario',
      totalAmount: 'Prezzo totale',
      documentStatus: 'Stato della linea',
      serialNumber: 'Numero di serie',
      batch: 'Numero di lotto',
      expirationDate: 'Data di scadenza',
      currency: 'Distintivo',
      status: 'Condizione',
      options: 'Opzioni',
      notes: 'Gradi',
      quantityTradeUnit: 'Quantità di imballaggio',
      measureTradeUnit: 'Unità di misura di imballaggio',
      assignedQuantity: 'Quantità assegnata',
      assignedMeasureUnit: 'Unità di misura assegnata',
      netPrice: 'Prezzo netto',
      grossPrice: 'Prezzo lordo',
      gtin14Code: 'Cód. GTIN14'
    },
    delivery_related_documents_table: {
      date: 'Data di relazione',
      destinationDocument: 'Dº documento',
      destinationDocumentType: 'Tipo di documento'
    },
    deliverynote_detail: {
      activate_deliverynote_buttons: 'Attiva',
      rejected_deliverynote_buttons: 'Respinto',
      deliverynote_line_no_date: 'Questa bolla di consegna non ha righe',
      download_pdf_buttons: 'Scarica',
      download_pdf_buttons_tooltip: 'Scarica PDF bolla di consegna',
      activate_deliverynote_buttons_tooltip: 'Accetta bolla di consegna',
      reject_deliverynote_buttons_tooltip: 'Rifiuta bolla di consegna',
      reject_deliverynote_lineError: 'Linea di squilibrio',
      related_documents_no_data: 'Questa bolla di consegna non ha documenti correlati',
      source_related_documents: 'Documenti correlati di origine',
      destination_related_documents: 'Documenti correlati a destinazione',
      deliverynote_lines: 'Righe bolla di consegna',
      edit: 'Modifica',
      send_to_draft_tooltip: 'Invia a bozza',
      send_to_draft: 'Bozza',

      change_state: {
        label: 'Cambio di stato',
        placeholder: 'Scegli uno stato della distinta di imballaggio',
        load: 'Aggiornamento dei dati della bolla di consegna ...'
      },

      dialog_rejected_deliverynote: {
        title: 'Rifiuto della bolla di consegna',
        value: 'Motivo',
        placeholder: 'Motivo del rifiuto',
        motive_required: 'Motivo obbligatorio'
      },

      dialog_new_check_line_deliverynote: {
        title: 'Nuova riga della bolla di consegna',
        title_edit: 'Modifica riga bolla di consegna',
        description: "Descrizione dell'articolo *",
        quantity: 'Quantità *',
        priceUnit: 'Prezzo unitario *',
        date_required: 'Campo obbligatorio'
      },

      notify: {
        submit_edit_deliverynote_ok: 'Lo stato della bolla di consegna è stato modificato con successo',
        deliverynote_rejected: 'La bolla di consegna è stata respinta correttamente',
        deliverynote_activate: 'La bolla di consegna è stata attivata',
        deliverynote_new_line: 'Una nuova linea di squilibrio è stata registrata correttamente',
        deliverynote_edit_line: 'La linea di squilibrio è stata modificata con successo',
        delivery_point_centre_not_found: 'Non è stato trovato il centro del luogo di consegna indicato'
      },
      load: {
        deliverynote_rejected: 'Rifiuto della bolla di consegna',
        deliverynote_activate: 'Attivazione della bolla di consegna'
      },
      confirm: {
        title_deliverynote_activate: 'Verrà attivata la bolla di consegna {deliveryId}, dal venditore {sellerName}. Vuoi continuare?',
        title_deliverynote_reject: 'La bolla di consegna {deliveryId}, del provider {sellerName}, verrà rifiutata. Vuoi continuare?',
        confirm_button_deliverynote_activate: 'OK'
      }
    },
    package_type: {
      TRANSPORT: 'Trasporto',
      PALLET: 'Pallet',
      HALF_PALLET: 'Mezza pallet',
      BOX: 'Scatola'
    },
    package: {
      invalid: {
        sscc: 'Il codice SSCC indicato sull\'imballaggio non è valido. Deve essere composto da 18 cifre',
        ssccExist: 'Il codice SSCC indicato per l\'imballaggio non è valido. C\'è già un documento di trasporto con quel codice SSCC',
        delete: 'Non è possibile eliminare l\'imballaggio dalla bolla di consegna perché è associato a un imballaggio o a righe',
        noLogistic: 'L\'imballaggio non può essere aggiunto a una bolla di consegna non logistica',
        lineCentreDeliveryPoint: 'Non è possibile associare linee a luoghi di consegna diversi allo stesso imballaggio',
        typeLevel: 'Impossibile aggiungere un imballaggio di tipo {argumento} all\'interno di un imballaggio di tipo {argumento1}'
      },
      max: {
        levels: 'L\'imballaggio che desideri aggiungere supera il numero massimo di livelli della bolla di consegna'
      },
      all: {
        hasLines: 'Tutti gli imballaggi di ultimo livello sulla bolla di consegna devono avere almeno una riga associata',
        linesHasPackage: 'Tutte le righe della bolla di consegna devono riportare la marcatura imballaggio'
      },
      line: {
        notFound: {
          package: 'L\'imballaggio indicato nella riga della bolla di consegna non è stato trovato',
          parent: 'L\'imballaggio principale indicato per l\'imballaggio della riga della bolla di consegna non è stato trovato'
        }
      }
    }
  },
  // Genrals emitidos y recibidos
  genral: {
    filters: {
      creation_date: {
        value: 'Data-ora di registrazione'
      },
      buyer: {
        value: 'Trasmettitore',
        placeholder: 'Inserisci 3 caratteri'
      },
      seller: {
        value: 'Ricevitore',
        placeholder: 'Inserisci 3 caratteri'
      },
      delivery_date: {
        value: 'Le date di consegna variano',
        placeholder: 'Le date di consegna variano'
      },
      genral_date: {
        value: 'Gamma di date di genral',
        placeholder: 'Gamma di date di genral'
      },
      issue_date: {
        value: 'Intervallo date di emissione',
        placeholder: 'Intervallo date'
      },
      description: {
        value: 'Testo',
        placeholder: 'Testo'
      },
      genral_number: {
        value: 'Numero di genral',
        placeholder: 'Genral'
      },
      project: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      status: {
        value: 'Stato',
        placeholder: 'Stato'
      }
    },
    genral_entity_table: {
      seller: 'Recettore',
      buyer: 'Emittente',
      num_genral: 'N. genral',
      description: 'Testo',
      date_creation: 'D. registrazione',
      date_issue: 'D. intervallo',
      status: 'Stato',
      csv_title: 'Esporta in CSV. Informazione',
      csv_message: 'Impossibile esportare più di {argumento} record, restringere la ricerca',
      services: 'Servizio'
    },
    genral_detail: {
      activate_genral_buttons: 'Attiva',
      rejected_genral_buttons: 'Respinto',
      download_pdf_buttons: 'Scarica',
      download_pdf_buttons_tooltip: 'Scarica PDF genral',
      activate_genral_buttons_tooltip: 'Attiva genral',
      rejected_genral_buttons_tooltip: 'Respinto genral',
      download_pdfmultiple_buttons: 'Scarica genral/s',
      download_pdfmultiple_buttons_tooltip: 'Scarica genral\\s',

      edit: 'Modifica',
      dialog_rejected_genral: {
        title: 'Respinto genral',
        value: 'Motivo',
        placeholder: 'Motivo respinto',
        motive_required: 'Motivo richiesto'
      },

      notify: {
        genral_rejected: 'Il genral è stato rifiutato correttamente',
        genral_activate: 'Il genral è stato attivato',
        download_pdf: 'Il Scaricare del file {file} è stato corretto.'
      },
      load: {
        genral_rejected: 'Rifiutando genral',
        genral_activate: 'Attivazione di genral'
      },
      confirm: {
        title_genral_activate: 'La ordine {genralID}, dal provider {sellerName}, verrà attivata. Vuoi continuare?',
        title_genral_reject: 'La ordine {genralID}, dal provider {sellerName}, verrà rifiutata. Vuoi continuare?',
        confirm_button_genral_activate: 'Ok'
      }
    }
  },
  // Coacsu
  coacsu: {
    filters: {
      service: {
        value: 'Servizio',
        placeholder: 'Servizio'
      },
      document_number: {
        value: 'Numero documento',
        placeholder: 'Numero documento'
      },
      article_code: {
        value: 'Codice articolo',
        placeholder: 'Codice articolo'
      },
      sale_date: {
        value: 'Data vendita',
        placeholder: 'Data vendita'
      }
    }
  },
  document_type: {
    INVOICE: 'Fattura',
    PURCHASEORDER: 'Ordine',
    DELIVERYNOTE: 'bolla d accompagnamento',
    RECEIVEADVICE: 'Ricezione',
    SALES_REPORT: 'Rapporto sulle vendite',
    INVENTORY_REPORT: "Rapporto sull'inventario"
  },
  charge_type: {
    CHARGE: 'Addebito',
    DISCOUNT: 'Sconto'
  },
  // Validaciones genericas
  validations: {
    maxlenght: 'Max "{maxlenght}" caratteri',
    minlenght: 'Minimo "{minlenght}" caratteri',
    required: 'Il campo "{field}" è richiesto',
    data: {
      VALIDATION_ATTACHMENT_RENFE: 'Allegati Renfe',
      VALIDATION_B2BINVOICEVALIDATION_WS: 'Servizio SOAP cliente',
      VALIDATION_BUYER: 'Azienda cliente nel progetto e abilitata',
      VALIDATION_BUYER_CENTRES: 'Centro clienti in azienda e abilitato',
      VALIDATION_COMMERCIAL_RELATION_CHANNEL: 'Rapporto commerciale con il canale',
      VALIDATION_COMMERCIAL_RELATION: 'Esistenza di relazioni commerciali',
      VALIDATION_DOCUMENT_SIGN: 'Firma delegata',
      VALIDATION_DUPLICATION: 'Duplicazioni',
      VALIDATION_DUPLICATION_ISSUEYEAR: 'Duplicazioni con l\'anno di emissione',
      VALIDATION_EIFFAGEINVOICEVALIDATION_WS: 'Usa Eiffage WS',
      VALIDATION_INTRASTAT_REQUIRED: 'Intracomunità obbligatoria',
      VALIDATION_INVOICE_ACCOUNTING: 'Tutte le convalide contabili della fattura',
      VALIDATION_INVOICE_CORRECTIVE: 'Esistenza di dati obbligatori di rettifica obbligatori',
      VALIDATION_INVOICE_CORRECTIVE_MANDATORY: 'Numero di fattura a cui rettifica obbligatorio',
      VALIDATION_INVOICE_TOTAL: 'Fattura totale senza sconti e senza spese generali',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES: 'Fattura totale con sconti e spese generali',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES_TAXES: 'Fattura totale',
      VALIDATION_INVOICE_TOTAL_TAXES: 'Totale imposte pari alla somma delle imposte',
      VALIDATION_INVOICE_TOTALEXECUTABLE: 'Eseguibile totale della fattura',
      VALIDATION_INVOICENUMBER_FORMAT: 'Formato numero fattura',
      VALIDATION_ISSUEDATE_FUTURE: 'Data di emissione non superiore',
      VALIDATION_ISSUEDATE_PAST: 'Data di emissione non precedente',
      VALIDATION_ISSUER_TYPE: 'Tipo di fattura emittente',
      VALIDATION_ISSUER_TYPE_RENFE: 'Digitare la fattura del mittente per il progetto Renfe',
      VALIDATION_LINE_DESCRIPTION: 'Descrizione obbligatoria delle righe della fattura',
      VALIDATION_LINES_TOTAL: 'Linea totale senza tasse',
      VALIDATION_LINES_TOTAL_DISCOUNTS_CHARGES: 'Totale riga con sconti e spese di linea',
      VALIDATION_MODALITY: 'Tipo di fattura individuale',
      VALIDATION_OPERATION_AND_ISSUE_DATE: 'Data di maturazione',
      VALIDATION_RECEIVER_CONTRACT: 'ReceiverContractReference obbligatorio',
      VALIDATION_RECEIVER_CONTRACT_FIRSTLINE: 'ReceiverContractReference obbligatorio solo nella prima riga o intestazione',
      VALIDATION_RECEIVER_TRANSACTION_FIRSTLINE: "Emittente dell'ordine obbligatorio solo nella prima riga o intestazione",
      VALIDATION_RECEIVER_CONTRACT_FORMAT: 'Formato ReceiverContractReference',
      VALIDATION_RECEIVER_CONTRACT_UNIQUE: 'ReceiverContractReference unico',
      VALIDATION_RECEIVER_EXP: 'FileReference obligatorio',
      VALIDATION_RECEIVER_EXP_FIRSTLINE: 'FileReference obligatorio solo en primera linea o cabecera',
      VALIDATION_RECEIVER_EXP_FORMAT: 'Formato FileReference',
      VALIDATION_RECEIVER_EXP_UNIQUE: 'FileReference unico',
      VALIDATION_RECEIVER_ORDER: "Destinatario dell'ordine obbligatorio",
      VALIDATION_RECEIVER_ORDER_FORMAT: "Formato del destinatario dell'ordine",
      VALIDATION_RECEIVER_ORDER_UNIQUE: "Destinatario dell'ordine único",
      VALIDATION_ISSUER_ORDER: "Emittente dell'ordine obbligatorio",
      VALIDATION_ISSUER_ORDER_FORMAT: "Formato dell'emittente dell'ordine",
      VALIDATION_ISSUER_ORDER_UNIQUE: "Emittente dell'ordine único",
      VALIDATION_RENFE_WS: 'Usa Renfe WS',
      VALIDATION_SELLER: 'Esistenza di una società fornitrice, come fornitore nel progetto e abilitata',
      VALIDATION_SELLER_BUYER_NOSPONSOR: 'Esistenza di uno sponsor nel cliente o fornitore',
      VALIDATION_SELLER_CENTRES: 'Esistenza di un centro fornitori nell\'azienda, con un fornitore e un ruolo abilitato',
      VALIDATION_UNIQUE_CENTRES_BUYER: 'Centri uguali per l\'acquirente. Centro unico',
      VALIDATION_UNIQUE_CENTRES_SELLER: 'Centri uguali per il venditore. Centro unico.',
      VALIDATION_INVOICE_PUBLICORGANISM: 'Ente pubblico proponente – DIR3',
      VALIDATION_LINE_CODE: 'Esistenza di codice per ogni riga',
      VALIDATION_LINE_ORDER_EXIST: "Esistenza in BBDD dell'ordine registrato",
      VALIDATION_LINE_TRANSACTIONREFERENCE: 'Issuer o Receiver TransactionReference obbligatorio',
      VALIDATION_LINE_EXIST: 'Esistenza di linee',
      VALIDATION_CURRENCY_EXCHANGE: 'Tasso di cambio e data del tasso di cambio obbligatorio se valuta diversa dal parametro',
      VALIDATION_IBAN: 'IBAN obbligatorio per bonifici e addebiti diretti',
      VALIDATION_REGISTRATION_DATA: 'Abbinamento dei dati del registro di commercio di venditore con quelli registrati nel B2B',
      VALIDATION_SEQUENCE_NUMBER_BY_ORDER_FORMAT: 'Posizione dell ordine obbligatoria se l ordine incontra la maschera',
      VALIDATION_CORRECTIVE_SIGN: 'Segno positivo sulle fatture con CorrectionMethod uguale al parametro',
      VALIDATION_INVOICE_BUYER_CENTRE: 'Centro clienti obbligatorio',
      VALIDATION_INVOICE_CENTRE_MASK: 'Formato maschera centro',
      VALIDATION_INVOICE_CENTRE_ROL: 'Tipo di ruolo centro',
      VALIDATION_NO_INTEGRATE_REJECTED_INVOICE: 'Convalida della fattura rifiutata non integrata',
      VALIDATION_REGISTRATION_DATA_INDRAFE: 'Abbinamento dei dati del registro di commercio di venditore con quelli registrati nel B2B Indrafe',
      VALIDATION_BUYER_CENTRES_ROL: 'Tipo di ruolo obbligatorio nel centro acquisti',
      VALIDATION_SELLER_CENTRES_ROL: 'Tipo di ruolo obbligatorio nel centro vendite',
      VALIDATION_BUYER_CENTRES_ROL_BYVALUES: 'Validación centro comprador contiene el rol',
      VALIDATION_SELLER_CENTRES_ROL_BYVALUES: 'Validación centro vendedor contiene el rol',
      VALIDATION_CENTRE_VOCENTO_WS: 'Custom Vocento: validazione del centro via WS',
      VALIDATION_LINE_DELIVERY_BATCH: 'Esistenza di numero di lotto per ogni riga della bolla di consegna',
      VALIDATION_LINE_DELIVERY_SERIAL: 'Esistenza di numero di serie per ogni riga della bolla di consegna',
      VALIDATION_LINE_DELIVERY_EXPIRATION: 'Esistenza di data di scandenza per ogni riga della bolla di consegna',
      VALIDATION_LINE_DELIVERY_DATES: 'Data di scandenza successiva alla data di consegna per ogni riga della bolla di consegna',
      VALIDATION_SENDATE_FUTURE: 'Data di invio deve essere attuale o futura',
      VALIDATION_LINE_DELIVERY_QUANTITY: "La somma degli importi delle sottorighe deve essere uguale all'importo della riga madre",
      VALIDATION_LINE_DELIVERY_SUBLINE_REQUIRED: 'Esistenza di una sottolinea per riga della bolla di consegna',
      VALIDATION_LINE_DOCUMENT_CANAL: 'Convalida documenti fattura CYII',
      VALIDATION_VALID_IBAN: 'Convalida IBAN fattura',
      VALIDATION_PAYMENT_MEAN: 'Convalida dei metodi di pagamento',
      VALIDATION_FILE_SIZE: 'Convalida della dimensione massima del file',
      VALIDATION_INVOICE_CORRECTIVE_METHOD: 'Convalida dei metodi di correzione nelle fatture correttive',
      VALIDATION_NIF_CODPAIS: 'Convalida del codice paese in NIF',
      VALIDATION_LINE_SEQUENCE_NUMBER: 'Convalida del sequence number univoco',
      VALIDATION_PARTY_NAME: 'Ragione sociale sulla fattura',
      VALIDATION_INVOICE_OPERATIONDATE: 'Convalidare la data dell\'operazione rispetto alla data di emissione',
      VALIDATION_INVOICE_INVOICINGPERIOD: 'Convalidare la data di fine del periodo di fatturazione rispetto alla data di emissione',
      VALIDATION_INVOICE_WITHHOLDINGAMOUNT: 'Validazione sulla trattenuta in garanzia',
      VALIDATION_INVOICE_TRANSACTIONXORCONTRACT: 'Contratto e ordine non possono essere indicati contemporaneamente',
      VALIDATION_INVOICE_CORRECTCONTRACTANDTRANSACTION: 'Il contratto e l\'ordine dell\'archivio devono corrispondere a quelli registrati',
      VALIDATION_INVOICE_EURCURRENCY: 'Valuta in euro',
      VALIDATION_INVOICE_IGICINCANARY: 'Tassa IGIC e indirizzo alle Isole Canarie obbligatori',
      VALIDATION_INVOICE_IPSIINCEUTA: 'Imposta IPSI e domicilio a Ceuta obbligatori',
      VALIDATION_LINE_DELIVERY_PACKAGE_GTIN14: 'Lo stesso codice GTIN14 per tutte le linee associate a un imballaggio di consegna',
      VALIDATION_INVOICE_ATTACHEDFILESNUMBER: 'Validare il numero di allegati',
      VALIDATION_INVOICE_ATTACHEDFILESEXTENSION: 'Validare l\'estensione del file allegato',
      VALIDATION_INVOICE_TAXESINPROJECT: 'Convalida le tasse e le aliquote attive nel servizio',
      VALIDATION_INVOICE_FILEFORMAT: 'Validazione del formato del file di input',
      VALIDATION_LINE_TAX0_LEGALTEXT: 'Per l imposta 0 è necessario informare un testo legale',
      VALIDATION_CORRECTIVE_ORDERORCONTRACT: 'Convalida dell\'ordine o contratto richiesta nella fattura rettificativa',
      VALIDATION_CORRECTIVE_REQUIRED: 'Il campo "Correzione" è obbligatorio per una fattura rettificativa',
      VALIDATION_PARTY_BUYER_ADDRESS_VALUE: 'Convalida affinché l indirizzo dell\' acquirente sia lo stesso configurato',
      VALIDATION_SPECIFIC_CANARY: 'Convalide specifiche per fatture provenienti da fornitori canari puri (100% canario)',
      VALIDATION_SPECIFIC_CEUTA: 'Convalide specifiche per fatture provenienti da fornitori Ceuta puri (100% Ceuta)',
      VALIDATION_PHYSICAL_GLN_REQUIRED: "Convalida obbligatoria della casella di posta per l'invio di formatos Edi",
      VALIDATION_INVOICE_NOIGICIVA: 'Conferma che una fattura non può avere IGIC e IVA contemporaneamente',
      VALIDATION_INVOICE_EXITSPAYMENTDETAILS: 'Convalida che una fattura contiene un metodo di pagamento',
      VALIDATION_LINE_RECADVPRICEQUANTITYPOSITIVE: 'Convalida che tutte le righe di un effetto da una ricezione abbiano un importo e una quantità positivi',
      VALIDATION_LINE_CORRECTIVEPRICENEGATIVE: 'Conferma che tutte le righe di una bozza correttiva hanno un prezzo negativo',
      VALIDATION_INVOICELINES_SAMETAX: 'Verifica che una fattura non contenga la stessa imposta sulla stessa riga',
      VALIDATION_INVOICELINES_NONEGATIVE: 'Convalida che tutte le righe contenga un importo e una quantità positivi',
      VALIDATION_INVOICE_RECEIVERTRANSACTIONREFERENCE: 'Validazione dell ordine di ricezione, se esiste e viene riportato su tutte le righe o nell intestazione',
      VALIDATION_INVOICE_FROMRECADV: 'Convalidare l esistenza della ricezione indicata nella fattura',
      VALIDATION_INVOICE_DOCUMENTVALUESFROMRECADV: 'Verificare che i documenti della fattura corrispondano a quelli della ricevuta.',
      VALIDATION_INVOICE_ADDITIONALINFOFROMRECADV: 'Personalizzata red.es: verificare che le informazioni aggiuntive della fattura contengano le proprietà della ricevuta',
      VALIDATION_INVOICE_LINEDATAFROMRECADV: 'Convalidare le informazioni relative alla riga della fattura al momento della ricezione',
      VALIDATION_CENTRE_PERMANET_ESTABLISHMENT: 'Stabile organizzazione secondo acquirente e venditore per bozze',
      VALIDATION_INVOICE_ISSUEDATE_REJECTED: "Verificare che la data di emissione corrisponda a quella di un'altra fattura negativa già esistente.",
      VALIDATION_RULES_KOSIT: 'Validazione delle regole KoSIT',
      VALIDATION_RULES_SCHEMATRON: 'Validazione delle regole Schematron'
    }
  },

  error: {
    e400: 'Errori di convalida si sono verificati sulla richiesta.',
    e400_create_invoice: "Si è verificato un errore durante la creazione della fattura, contatta l'amministratore.",
    e401_login: "L'utente e/o la password non sono corretti.",
    e401: 'Sessione scaduto o utente non autorizzato.',
    e403: "L'utente non ha il permesso necessario per realizzare questa azione",
    e403_service: "L'utente non ha il permesso necessario per l'accesso",
    e404: 'File non trovato.',
    e409: 'Il supporto selezionato esiste già per questo utente',
    e409_create_invoice: 'Esiste già una fattura con questo numero di fattura per lo stesso fornitore',
    e428_login: "L'utente ha l'autenticazione a due fattori attiva, inserisci il codice",
    e401_two_factor_auth: 'Il codice è scaduto o non è corretto',
    e500: 'Si è verificato un errore imprevisto.',
    e500_user: "Errore durante la creazione dell'utente. Verificare con l'amministratore.",
    default: 'Errore di connessione server. Riprovare più tardi',
    recadv_rejected: 'Impossibile fatturare la ricezione perché è rifiutata',
    validation_intrastat_required: 'Il campo codice merce e il campo peso sono obbligatori',
    password_expired: 'La tua password è scaduta, devi cambiarla.',
    file_size: {
      exceeded: 'Taglia non consentita. La dimensione massima è {argumento}'
    },
    invalid_image: 'Formato immagine non valido',
    retry: 'Si è verificato un errore. Per favore, riprova più tardi.',
    user: "Non è possibile eliminare l'utente perché è associato a processi nel sistema relativi alle fatture, è necessario disabilitare l'utente"
  },

  global_error: 'Si è verificato un errore. Contatta il tuo amministratore.',
  user_not_found: 'Utente non trovato',

  // Paises
  countries: {
    country_AFG: 'Afghanistan',
    country_ALA: 'Isole Åland',
    country_ALB: 'Albany',
    country_DEU: 'Germania',
    country_AND: 'Andorra',
    country_AGO: 'Angola',
    country_AIA: 'Anguilla',
    country_ATA: 'Antartide',
    country_ATG: 'Antigua e Barbuda',
    country_SAU: 'Arabia Saudita',
    country_DZA: 'Algeria',
    country_ARG: 'Argentina',
    country_ARM: 'Armenia',
    country_ABW: 'Aruba',
    country_AUS: 'Australia',
    country_AUT: 'Austria',
    country_AZE: 'Azerbaigian',
    country_BHS: 'Isole Bahamas',
    country_BGD: 'Bangladesh',
    country_BRB: 'Barbados',
    country_BHR: 'Baresh',
    country_BEL: 'Belgio',
    country_BLZ: 'Belize',
    country_BEN: 'Benn',
    country_BMU: 'Bermudas',
    country_BLR: 'Bielorussia',
    country_MMR: 'Myanmar',
    country_BOL: 'Stato plurinazionale di Bolivia',
    country_BIH: 'Bosnia ed Herzegovin',
    country_BWA: 'Botsuana',
    country_BRA: 'Brasile',
    country_BRN: 'Brun Darussalam',
    country_BGR: 'Bulgaria',
    country_BFA: 'Burkina Faso',
    country_BDI: 'Burindi',
    country_BTN: 'But',
    country_CPV: 'Capo verde',
    country_KHM: 'Cambogia',
    country_CMR: 'Camerun',
    country_CAN: 'Canada',
    country_QAT: 'Catar',
    country_BES: 'Bonaire, Saint Eustatius e Saba',
    country_TCD: 'Chad',
    country_CHL: 'Cile',
    country_CHN: 'Cina',
    country_CYP: 'Cipro',
    country_COL: 'Colombia',
    country_COM: 'Comore',
    country_PRK: 'Repubblica popolare della Corea',
    country_KOR: 'Repubblica della Corea',
    country_CIV: 'Costa d\'Avorio',
    country_CRI: 'Costa Rica',
    country_HRV: 'Croazia',
    country_CUB: 'Cuba',
    country_CUW: 'Curacao',
    country_DNK: 'Danimarca',
    country_DMA: 'Dominica',
    country_ECU: 'Ecuador',
    country_EGY: 'Egitto',
    country_SLV: 'El Salvador',
    country_ARE: 'Emirati Arabi Uniti',
    country_ERI: 'Eritrea',
    country_SVK: 'Slovacchia',
    country_SVN: 'Slovenia',
    country_ESP: 'Spagna',
    country_USA: 'Stati Uniti',
    country_EST: 'Esponia',
    country_ETH: 'Etiopia',
    country_PHL: 'Filippine',
    country_FIN: 'Finlandia',
    country_FJI: 'Figi',
    country_FRA: 'Francia',
    country_GAB: 'Gabon',
    country_GMB: 'Gambia',
    country_GEO: 'Georgia',
    country_GHA: 'Ghana',
    country_GIB: 'Gibilterra',
    country_GRD: 'Granada',
    country_GRC: 'Gracia',
    country_GRL: 'Groenlandia',
    country_GLP: 'Guadalupe',
    country_GUM: 'Guam',
    country_GTM: 'Guatemala',
    country_GUF: 'Guayana francese',
    country_GGY: 'Guernsey',
    country_GIN: 'Guinea',
    country_GNB: 'Guinea-Bis',
    country_GNQ: 'Guinea Equatoriale',
    country_GUY: 'Guyana',
    country_HTI: 'Haiti',
    country_HND: 'Honduras',
    country_HKG: 'Hong Kong',
    country_HUN: 'Ungheria',
    country_IND: 'India',
    country_IDN: 'Indonesia',
    country_IRQ: 'Irak',
    country_IRN: 'Go (l\'Isl. Repubblica Islamica di)',
    country_IRL: 'Irlanda',
    country_BVT: 'Isola di Bouvet',
    country_IMN: 'Isola di Man',
    country_CXR: 'Isola di Natale',
    country_NFK: 'Isola Norfolk',
    country_ISL: 'Islanda',
    country_CYM: 'Isole Caim',
    country_CCK: 'Isole Cocos (Keeling)',
    country_COK: 'Isole Cook',
    country_FRO: 'Isole Fær',
    country_SGS: 'Georgia del Sud e Isole Sandwich del Sud',
    country_HMD: 'Isole Heard e McDonald',
    country_FLK: 'Isole Falkland (Isole Falkland)',
    country_MNP: 'Isole Marianne Settentrionali',
    country_MHL: 'Isole Marshall',
    country_PCN: 'Pitcairn',
    country_SLB: 'Isole Salom',
    country_TCA: 'Isole Turks e Caicos',
    country_UMI: 'Isole Minori degli Stati Uniti d\'America',
    country_VGB: 'Isole Vergini (Britanniche)',
    country_VIR: 'Isole Vergini (EE_UU_)',
    country_ISR: 'Israele',
    country_ITA: 'Italia',
    country_JAM: 'Jamaica',
    country_JPN: 'Jap',
    country_JEY: 'Jersey',
    country_JOR: 'Giordania',
    country_KAZ: 'Kazajist',
    country_KEN: 'Kenia',
    country_KGZ: 'Kirguist',
    country_KIR: 'Kiribati',
    country_KWT: 'Kuwait',
    country_LAO: 'Lao, (la) Repubblica democratica popolare',
    country_LSO: 'Lesotho',
    country_LVA: 'Lettonia',
    country_LBN: 'Libano',
    country_LBR: 'Liberia',
    country_LBY: 'Libia',
    country_LIE: 'Liechtenstein',
    country_LTU: 'Lituania',
    country_LUX: 'Lussemburgo',
    country_MAC: 'Macao',
    country_MDG: 'Madagascar',
    country_MYS: 'Malesia',
    country_MWI: 'Malawi',
    country_MDV: 'Maldive',
    country_MLI: 'Malè',
    country_MLT: 'Malta',
    country_MAR: 'Morocco',
    country_MTQ: 'Martinica',
    country_MUS: 'Mauricio',
    country_MRT: 'Mauritius',
    country_MYT: 'Mayotte',
    country_MEX: 'Messico',
    country_FSM: 'Micronesia (gli Stati federati di)',
    country_MDA: 'Moldavia (la Repubblica de)',
    country_MCO: 'Principato di Monaco',
    country_MNG: 'Mongolia',
    country_MNE: 'Montenegro',
    country_MSR: 'Montserrat',
    country_MOZ: 'Mozambico',
    country_NAM: 'Namibia',
    country_NRU: 'Nauru',
    country_NPL: 'Nepal',
    country_NIC: 'Nicaragua',
    country_NER: 'Niger',
    country_NGA: 'Nigeria',
    country_NIU: 'Niue',
    country_NOR: 'Norvegia',
    country_NCL: 'Nuova Caledonia',
    country_NZL: 'Nuova Zelanda',
    country_OMN: 'Oman',
    country_NLD: 'Paesi Bassi',
    country_PAK: 'Pakistan',
    country_PLW: 'Palau',
    country_PSE: 'Stato della Palestina',
    country_PAN: 'Panama',
    country_PNG: 'Papua Nuova Guinea',
    country_PRY: 'Paraguay',
    country_PER: 'Perù',
    country_PYF: 'Polinesia Francese',
    country_POL: 'Polonia',
    country_PRT: 'Portogallo',
    country_PRI: 'Porto Rico',
    country_GBR: 'Regno Unito',
    country_CAF: 'Repubblica centrafricana',
    country_CZE: 'Repubblica ceca',
    country_MKD: 'Macedonia (ex Repubblica iugoslava di)',
    country_COG: 'Congo',
    country_COD: 'Congo (Repubblica Democratica di)',
    country_DOM: 'Repubblica Dominicana',
    country_REU: 'Reuni',
    country_RWA: 'Ruanda',
    country_ROU: 'Romania',
    country_RUS: 'Russia, (la) Federazione di',
    country_ESH: 'Sahara occidentale',
    country_WSM: 'Samoa',
    country_ASM: 'Samoa americane',
    country_BLM: 'San Bartolom',
    country_KNA: 'Saint Kitts e Nevis',
    country_SMR: 'San Marino',
    country_MAF: 'San Marten (parte francese)',
    country_SPM: 'San Pedro e Miquel',
    country_VCT: 'Saint Vincent e Grenadine',
    country_SHN: 'Sant\'Elena, Ascensione e Trist de Acu',
    country_LCA: 'Santa Lucia',
    country_STP: 'San Tom e Principe',
    country_SEN: 'Senegal',
    country_SRB: 'Serbia',
    country_SYC: 'Seychelles',
    country_SLE: 'Sierra Leone',
    country_SGP: 'Singapore',
    country_SXM: 'Sint Maarten (parte olandese)',
    country_SYR: 'Siria (la) Repubblica araba',
    country_SOM: 'Somalia',
    country_LKA: 'Sri Lanka',
    country_SWZ: 'Swaziland',
    country_ZAF: 'Sud Africa',
    country_SDN: 'Sudan',
    country_SSD: 'Sudan del Sud',
    country_SWE: 'Svezia',
    country_CHE: 'Svizzera',
    country_SUR: 'Suriname',
    country_SJM: 'Svalbard and Jan Mayen',
    country_THA: 'Thailandia',
    country_TWN: 'Taiwun (provincia della Cina)',
    country_TZA: 'Tanzania, Repubblica Unita di',
    country_TJK: 'Tagikistan',
    country_IOT: 'Territorio britannico dell\'Oceano Indiano (il)',
    country_ATF: 'Territori francesi meridionali (il)',
    country_TLS: 'Timorese',
    country_TGO: 'Togo',
    country_TKL: 'Tokelau',
    country_TON: 'Tonga',
    country_TTO: 'Trinidad e Tobago',
    country_TUN: 'Tunisia',
    country_TKM: 'Turkmenistan',
    country_TUR: 'Turchia',
    country_TUV: 'Tuvalu',
    country_UKR: 'Ucrania',
    country_UGA: 'Uganda',
    country_URY: 'Uruguay',
    country_UZB: 'Uzbekistan',
    country_VUT: 'Vanuatu',
    country_VAT: 'Santa Sede [Stato della Città del Vaticano]',
    country_VEN: 'Venezuela, Repubblica Bolivariana di',
    country_VNM: 'Viet Nam',
    country_WLF: 'Wallis and Futuna',
    country_YEM: 'Yemen',
    country_DJI: 'Gibuti',
    country_ZMB: 'Zambia',
    country_ZWE: 'Zimbabue'
  },

  // Permisos
  authorities: {
    ADMIN_GROUP: 'Gestione  di gruppi di centri',
    ADMIN_PROFILE: 'Gestione di profili',
    ADVANCED_ADMIN_USER: 'Gestione utenti avanzata',
    ADVANCED_ADMIN_PARTY: 'Gestione di imprese avanzata',
    ADMIN_USER: 'Gestione di utenti',
    ADMIN_CERTIFICATE: 'Gestione dei certificati',
    ADMIN_TAX: 'Amministrazione fiscale',
    ADMIN_ARTICLE: 'Amministrazione di articoli',
	ADMIN_METHODS: 'Amministrazione delle modalità di comunicazione',
    ADMIN_DOCUMENTATION: 'Amministrazione della documentazione',
    ADMIN_QUARTZ: 'Gestione di processi pianificati',
    ADMIN_MAP: 'Gestione di mappe',
    ADMIN_GROUP_PARTY: 'Gestione di gruppi di imprese',
    ADMIN_CENTRE: 'Gestione dei centri',
    ADMIN_PARTY: 'Gestione delle imprese',
    ADMIN_PROJECT: 'Gestione di servizio',
    AUDITORY_ACTION: 'Revisione delle azioni dell\'utente o del sistema',
    AUDITORY_DOCUMENT: 'Revisione dei documenti',
    BILLING_MANAGEMENT: 'Fatturazione',
    DELETE_INVOICE_ATTACHMENTS: 'Rimuovere gli allegati della fattura',
    UPLOAD_INVOICE: 'Carica la fattura attraverso il file',
    SEARCH_INVOICE_SALES: 'Ricerca di fattura firmata di vendita',
    SEARCH_INVOICE_PURCHASES: 'Ricerca di fattura firmata di acquisto',
    SEARCH_REPORT_EMITTED: 'Ricerca di report emessi',
    SEARCH_REPORT_RECEIVED: 'Ricerca di report ricevuti',
    SEARCH_INVOICE_THIRD: 'Ricerca di fattura da terzi',
    SEARCH_INVOICE_DRAFT: 'Ricerca di bozza di fattura',
    SEARCH_ACCOUNTING_CLOSE: 'Consultazione delle chiusure contabili',
    SEARCH_INVOICE_SENDER: 'Ricerca di fatture firmate inviate',
    ADD_INVOICE_ATTACHMENTS: 'Aggiungere allegati alla fattura',
    SEARCH_INVOICE_RECEIVER: 'Ricerca di fatture firmate ricevute',
    VIEW_INVOICE_PDF: 'Vedi PDF delle fatture',
    VIEW_INVOICE_ATTACHMENT: 'Vedi gli allegati alla fattura',
    VIEW_INVOICE_EVENTS: 'Visualizza gli eventi della fattura',
    VIEW_INVOICE_DOCUMENTS: 'Visualizza i documenti di intestazione nelle bozze',
    GET_PAYMENT_DATA: 'Consultare i dati di pagamento/incasso fatture',
    CHANGE_INVOICE_STATUS: 'Cambio di stato della fattura',
    SEARCH_ISSUE: 'Ricerca di incidenti',
    CREATE_ISSUE: 'Creazione di incidenza',
    STATISTICS_MANAGEMENT: 'Statistiche',
    UPDATE_ISSUE: 'Aggiornare stato dell\'incidenza',
    ADD_ISSUE: 'Creazione di incidenti',
    DELETE_ISSUE: 'Rimuovi gli incidenti',
    DOWNLOAD_INVOICE_WS: 'Scarica fatture dal servizio Web',
    INTEGRATION_INVOICE_WS: 'Integrazione di fatture tramite servizio Web',
    SEARCH_STATUS_INVOICE_WS: 'Controllare lo stato della fattura tramite il servizio Web',
    ADMIN_DELIVERY_METHODS: 'Gestione dei parametri di consegna',
    CANCEL_INVOICE: 'Richiedi annullamento fattura',
    COPY_INVOICE: 'Copiare fattura',
    CREATE_PROJECT: 'Creazione di servizi',
    CREATE_PARTY: 'Creazione di società',
    MODIFY_PROJECT: 'Modifica servizio',
    PROJEC_DELIVERY_METHOD: 'Gestione dei metodi di erogazione dei servizi',
    PARTY_DELIVERY_METHOD: 'Gestione dei metodi di consegna aziendali',
    PARAMS_DELIVERY_METHOD: 'Gestione dei parametri di consegna',
    CREATE_CENTRE: 'Creazione di centri',
    FORWARD_INVOICE_EMITTED: 'Inoltro delle fatture',
    FORWARD_INVOICE_RECEIVED: 'Inoltro delle fatture',
    CREATION_PARTY_WS: 'Recupero del business',
    UPDATE_PARTY_WS: 'Aggiornamento dell\'impresa',
    ADMIN_USER_WS: 'Gestione di utenti',
    CREATION_USER_WS: 'Creazione di utenti',
    UPDATE_USER_WS: 'Modifica degli utenti',
    REMOVE_USER_WS: 'Eliminazione degli utenti',
    UNLOCK_USER_WS: 'Sbloccare gli utenti',
    RESET_USER_WS: 'Gli utenti resettati',
    DRAFT_ACCOUNTING_CLOSE: 'Bozza di contabili chiuse',
    CREATE_GROUP: 'Creazione di gruppi di centri',
    ADMIN_INDRA: 'Gestione di Indra',
    SEARCH_ACCOUNTING_CLOSE_DRAFT: 'Ricerca di bozze di chiusura',
    CHECK_STATUS: 'Consultazione dello stato online',
    SEARCH_PENDING_TASKS: 'Consultazione di attività in sospeso',
    CONSULT_DOCUMENTATION: 'Consultare la documentazione',
    CONSULT_SIGNDOCUMENT: 'Consultare i documenti delle firme delegate',
    UPLOAD_SIGNDOCUMENT: 'Carica i documenti delle firme delegate',
    DELETE_SIGNDOCUMENT: 'Elimina i documenti delle firme delegate',
    CREATE_COVER: 'Creare una copertina di ripristino',
    SEARCH_RECADV_SENDER: 'Consultare le ricevute emesse',
    SEARCH_RECADV_RECEIVER: 'Consultare le  ricevute ricevute',
    INVOICE_VALIDATION_WS: 'WS Convalida della fattura',
    CHANGE_INVOICE_STATUS_WS: 'WS Modifica stato fattura',
    VIEW_INVOICE_BY_LINK: 'Visualizzazione della fattura tramite link esterno',
    REJECT_RECADV: 'Rifiutare ricevimenti',
    MODIFY_RECADV: 'Modificare ricevimenti',
    RECADV_CREATE_INVOICE: 'Creare una fattura dai ricevimenti',
    RECADV_CREATE_INVOICE_PARCIAL: 'Creare fattura da ricevute parziali',
    SEARCH_ORDER_SENDER: 'Consultare gli ordini emessi',
    SEARCH_ORDER_RECEIVER: 'Consultare gli ordini ricevuti',
    SEARCH_GENRAL_SENDER: 'Consulta i genral emessi',
    SEARCH_GENRAL_RECEIVER: 'Consulta i genral ricevuti',
    SEARCH_SALES_REPORT_VIEW: 'ricerca del rapporto di vendita',
    SEARCH_INVENTORY_REPORT_VIEW: 'Consultare il rapporto di inventario',
    MULTIPLE_CHANGE_STATUS: 'Cambiamento multiplo dello stato nelle attività in sospeso',
    SEARCH_DELIVERY_SENDER: 'Consultare le note di consegna emesse',
    SEARCH_DELIVERY_RECEIVER: 'Consultare le note di consegna ricevute',
    EDIT_INVOICE_DATA: 'Editar metadatos de la factura',
    EDIT_INVOICE_NOTE: 'Modifica le note della fattura',
    EDIT_CARRIER_CMR: 'Modifica i dati del trasportista nelle lettere di vettura CMR',
    EDIT_CHARGER_CMR: 'Modifica i dati del caricatore nelle lettere di vettura CMR',
    EDIT_CENTRE_PERMANENT_ESTABLISHMENT: 'Modificare ed eliminare i centri dotati di stabile organizzazione',
    ADMIN_APPROVAL_FLOW_BY_LEVELS: 'Amministrazione dei flussi di approvazione per livelli e utenti',
    USER_APPROVAL_FLOW_BY_LEVELS: 'Approvare, rifiutare e inviare fatture nel flusso di approvazione per livelli e utenti',
    SEARCH_OCR_DOCUMENTS: 'Consultazione dei documenti OCR pendenti di validazione',
    VIEW_INVOICE_NOTE: 'Visualizza le note della fattura',
    VIEW_ADMINISTRATIVE_CENTRES: 'Vedi colonne di centri amministrativi',
    VIEW_DISTRIBUTION_CENTRES: 'Visualizzazione della distribuzione nella selezione centrale',
    DOWNLOAD_DOCUMENT_WS: 'Scaricare di documenti',
    UPDATE_DOCUMENT_WS: 'Aggiorna documento',
    CREATE_INVOICE_DRAFT: 'Creare una bozza di fattura',
    ATTACHMENT_HIDDEN: 'Allegato non visibile',
    VIEW_REQUEST_REDIGITALIZATION: 'Applicazione di ridigitalizzazione',
    VIEW_INVALID_INVOICE_COLOR: 'Visualizza lo stato della fattura non valida in rosso',
    SEARCH_CHANNEL: 'Consulta per canali',
    VIEW_COMERCIAL_RELATION: 'Vedi relazioni d\'affari',
    VIEW_RELATION_CHANNEL: 'Guarda i rapporti commerciali con il canale',
    CREATE_COMERCIAL_RELATION: 'Creare relazioni commerciali',
    CHANGE_MASTER_DATA: 'Modifica dei dati anagrafici',
    CHANGE_ROLE: 'Cambia ruolo',
    NO_EDIT_DATA_USER: 'Utente dei dati senza modifica',
    SIGNATURE_DELEGATION: 'Delega della firma',
    CHANGE_STATUS_PENDINGTASKS: 'Cambio di stati in sospeso',
    CHANGE_STATUS_ORDER: 'Cambio di stato dello ordini',
    CHANGE_STATUS_DELIVERYNOTE: 'Modifica dello stato di una bolla di consegna',
    CHANGE_STATUS_RECADV: 'Modifica dello stato di una ricevuta',
    VIEW_INVOICE_BPM_EVENTS: 'Visualizza gli eventi BPM della fattura',
    CHANGE_STATUS_RECADV_WS: 'Cambio ricezione WS',
    CHECK_STATUS_RECADV_WS: 'Controlla lo stato dei ricevimenti WS',
    INTEGRATION_RECADV_WS: 'Integrazione ricezione WS',
    INTEGRATION_ORDER_WS: 'Integrazione ordini WS',
    VIEW_METADATA: 'Vedi i metadati',
    VIEW_ORDER_METADATA: "Visualizza i metadati dell'ordine",
    VIEW_RECADV_METADATA: 'Visualizza i metadati di ricezione',
    VIEW_ORDER_ORIGINAL: 'Visualizza ordini originali',
    VIEW_RECADV_ORIGINAL: 'Visualizza ricevute originali',
    VIEW_DESADV_METADATA: 'Visualizza i metadati della bolla di consegna',
    VIEW_DESADV_ORIGINAL: 'Visualizza le note di consegna originali',
    ORDER_CREATE_INVOICE: 'Creare una fattura di ordini',
    ORDER_CREATE_DELIVERY_NOTE: 'Creare un documento di trasporto da un ordine',
    CREATE_INVOICE_FROM_DELIVERY_NOTE: 'Creare una fattura di una bolla di consegna',
    VIEW_BANK_DATA: 'Vedi i dettagli bancari',
    DOWNLOAD_DELIVERY_NOTE_WS: 'Scarica dote di consegna dal servizio Web',
    DOWNLOAD_INVOIC_FORMATTED: 'Scarica l\'custodito formattato....',
    RECADV_ATTACH: 'Consenti allegati ai ricevimenti',
    CHANGE_PARTY_MEDIA: 'Modifica i dati di contatto dell\'azienda',
    VIEW_CMR: 'vedere le lettere di vettura',
    CREATE_CMR_DRAFT: 'Creare una lettera di vettura',
    VIEW_CMR_DRAFT_SELLER_CENTRES: 'Visualizza dai centri venditori le bozze di lettere di vettura create',
    VIEW_CMR_DRAFT_BUYER_CENTRES: 'Visualizza dai centri acquirenti le bozze di lettere di vettura create',
    CREATE_INVOICE_FROM_RECADV: 'Consente di compilare determinati campi durante la creazione della fattura dalla reception',
    CHANGE_CENTRE_ROLE: 'Cambio ruolo de centros',
    MODIFY_PAYMENT_METHODS: 'Modifica i metodi di pagamento dell\'azienda',
    CREATE_CORRECTIVE_INVOICE: 'Creazione di fattura correttiva da fattura emessa',
    NO_VIEW_INVOICE_SERIES_CODE: 'Nessun accesso al numero di serie',
    TOTAL_IRPF: 'IRPF nei totali delle fatture',
    NO_VIEW_RECADV_PDF: 'Nessun accesso al pdf dalla reception',
    ADD_BUYER_CENTRE: 'Aggiungi centro acquirenti',
    VIEW_MENU: 'Visualizza il menu',
    VIEW_SALES_REPORT_ORIGINAL: 'Visualizza report vendite originale',
    VIEW_SALES_REPORT_METADATA: 'Visualizza metadati report vendite',
    VIEW_INVENTORY_REPORT_ORIGINAL: 'Visualizza report inventario originale',
    VIEW_INVENTORY_REPORT_METADATA: 'Visualizza metadati report inventario',
    SEARCH_REMADV_VIEW: 'Consulta avviso di liquidazione',
    VIEW_REMADV_ORIGINAL: 'Visualizza avviso di liquidazione originale',
    VIEW_REMADV_METADATA: 'Visualizza metadati avviso di liquidazione',
    SEARCH_COACSU_VIEW: 'Consulta riepilogo delle consegne',
    VIEW_COACSU_ORIGINAL: 'Visualizza riepilogo delle consegne originale',
    VIEW_COACSU_METADATA: 'Visualizza metadati riepilogo delle consegne',
    CREATE_COACSU: 'Creare un riepilogo del conto commerciale'
  },
  authorities_module: {
    INVOICE: 'Fatture',
    ADMIN: 'Amministrazione',
    AUDITORY: 'Revisione',
    BILLING: 'Fatturazione',
    ISSUE: 'Incidenze',
    STATISTICS: 'Statistica',
    WEBSERVICE: 'Servizio web',
    GROUP: 'Gruppo centrale',
    DOCUMENTATION: 'Documentacion',
    RECADV: 'Reception',
    PURCHASEORDER: 'Ordinativo',
    DELIVERY: 'Nota di consegna',
    GENRAL: 'Genral',
    ORDERRSP: "Risposta dell'ordine",
    GENERAL: 'Genral note',
    CMR: 'CMR',
    SALESREPORT: 'Rapporto sulle vendite',
    INVENTORYREPORT: "Rapporto sull'inventario",
    COACSU: 'Riepilogo del conto commerciale',
    REMADV: 'Avviso di pagamento'
  },
  auditaction: {
    create: 'Creazione',
    update: 'Aggiorna',
    delete: 'Eliminato',
    resend: 'Reinvia',
    reprocess: 'Rielaborare',
    updateStatus: 'Aggiornamento dello stato',
    sendInvoice: 'Invia fattura',
    cancel: 'Cancellazione',
    demand: 'Richiesta',
    checkStatus: 'Controlla stato',
    sendData: 'Invia dati',
    reject: 'Rifiuta',
    send: 'Invio'
  },
  functionalGroup: {
    ROLE: 'Profili',
    PROJECT: 'Progetto',
    PARTY: 'Società',
    CENTRE: 'Centro',
    USER: 'Utente',
    TAXES: 'Tasse',
    ISSUE: 'Incidenti',
    CERTIFICATE: 'Certificati',
    EMAIL: 'Personalizza email',
    DOCUMENTATION: 'Documentazione',
    INVOICE: 'Fattura',
    ORDER: 'Ordine',
    GENRAL: 'Genral',
    DELIVERYNOTE: 'Bolla di consegna',
    RECADV: 'Ricezione',
    ORDERRSP: "Risposta all'ordine",
    COMMUNICATION_METHOD: 'Metodo di consegna',
    CMR: 'CMR'
  },

  // Tipos de medio de contacto
  mediaType: {
    email: 'Email',
    telefono_fijo: 'Telefono fisso',
    telefono_movil: 'Telefono cellulare',
    telefono_trabajo: 'Telefono di lavoro',
    fax: 'Fax',
    email_to_report_issued: 'Invio di rapporti',
    contact_person: 'Referente'
  },

  // Impuestos
  adminTaxes: {
    tax: {
      VAT: 'IVA',
      IGIC: 'IGIC',
      IGI: 'IGIC',
      EXT: 'EXT',
      ENV: 'ENV',
      IRPF: 'IRPF',
      IPSI: 'IPSI',
      ITPAJD: 'ITPAJD',
      IE: 'IE',
      ICIO: 'ICIO',
      IPS: 'IPS',
      RLEA: 'RLEA',
      IGFEI: 'IGFEI',
      Otros: 'Altri',
      Ra: 'Reddito doganale',
      IGTECM: 'IGTECM',
      IECDPCAC: 'IECDPCAC',
      IMVDN: 'IMVDN',
      IMSN: 'IMSN',
      IMGSN: 'IMGSN',
      IMPN: 'IMPN',
      REIVA: 'REIVA',
      REIGIC: 'REIGIC',
      REIPSI: 'REIPSI',
      IVPEE: 'IVPEE',
      IPCNG: 'IPCNG',
      IACNG: 'IACNG',
      IDEC: 'IDEC',
      ILTCC: 'ILTCC',
      IRNR: 'IRNR',
      ISS: 'ISS',
      IIIMAB: 'IIIMAB',
      OTH: 'OTH',
      ITRT01: 'RT01',
      ITRT02: 'RT02',
      ACT: 'ACT'
    }
  },

  tax_type: {
    VAT: 'Imposta sul valore aggiunto',
    IGIC: 'Imposta generale indiretta nelle isole Canarie',
    EXT: 'Esonerare',
    ENV: 'Tassa ambientale',
    IRPF: 'Imposta sul reddito delle persone fisiche',
    IPSI: 'Imposta sulla produzione, i servizi e le importazioni',
    IGI: '@:tax_type.IGIC',
    ITPAJD: 'Imposta di trasferimento e imposta di bollo',
    IE: 'Imposta speciale',
    ICIO: 'Tasse su edifici, installazioni e lavori',
    IPS: 'Imposta sulla produzione, i servizi e le importazioni',
    RLEA: 'Supplemento per il finanziamento delle funzioni di liquidazione delle compagnie assicurative',
    IGFEI: 'Imposta sui gas fluorurati a effetto serra',
    Otros: 'Altri',
    Ra: 'Reddito doganale',
    IGTECM: 'Imposta generale sulle società di traffico applicate a Ceuta e Melilla',
    IECDPCAC: 'Accise sui carburanti derivati dalla benzina nella Comunità autonoma Canaria',
    IIIMAB: 'Tasse su strutture che influenzano l\'ambiente nelle Baleari',
    IMVDN: 'Tassa di soggiorno in case non occupate in Navarra',
    IMSN: 'Terreni fiscali municipali in Navarra',
    IMGSN: 'Tassa municipale sulla spesa di lusso in Navarra',
    IMPN: 'Tassa comunale sulla pubblicità in Navarra',
    REIVA: 'Regime IVA speciale per le agenzie di viaggio',
    REIGIC: 'Schema speciale IGIC per agenzie di viaggio',
    REIPSI: 'Schema speciale IPSI per agenzie di viaggio',
    IVPEE: 'Valore fiscale della produzione di energia elettrica',
    IPCNG: 'Imposta sulla produzione di combustibile nucleare esaurito e scorie radioattive derivanti dalla produzione di energia nucleare',
    IACNG: 'Imposta sull\'immagazzinamento del combustibile nucleare esaurito e dei residui radioattivi presso le strutture centralizzate',
    IDEC: 'Imposta sui depositi presso istituti di credito',
    ILTCC: 'Tasse su tabacco da fiuto fabbricato nelle isole Canarie',
    IRNR: 'Imposta sul reddito per non residenti',
    ISS: 'L\'imposta sulle società',
    ITRT01: 'Fatturapa tassa RT01',
    ITRT02: 'Fatturapa tassa RT02',
    OTH: 'OTH',
    ACT: 'Tasse di alcol'
  },

  // Recepciones estados
  recadv_status: {
    RECEIVED: 'Ricevuto',
    REJECTED: 'Diminuito',
    REJECTED_SELLER: 'Rejected supplier',
    ERROR: 'Errore',
    FULLY_INVOICED: 'Completamente fatturato',
    PARTIALLY_INVOICED: 'In parte fatturati',
    ORIGINAL: 'Originale',
    MODIFIED: 'Modificato'
  },
  // Recepciones subtype
  recadv_subtype: {
    GOODS: 'Goods',
    SERVICES: 'Services'
  },
  // pedidos estados
  order_status: {
    RECEIVED: 'Ricevuto',
    REJECTED: 'Diminuito',
    ACCEPTED: 'Accettato',
    REJECTED_SELLER: 'Rejected supplier',
    ERROR: 'Errore',
    FULLY_INVOICED: 'Completamente fatturato',
    PARTIALLY_INVOICED: 'In parte fatturati',
    ORIGINAL: 'Originale',
    MODIFIED: 'Modificato',
    DISPATCHED: 'Rilasciato',
    PARTIALLY_SENT: 'Expedido parcialmente',
    FULLY_SENT: 'Expedido totalmente'
  },
  order_type: {
    ORDER: 'Normale',
    BLANKET_ORDER: 'Commerciale',
    RUSH_ORDER: 'Urgente',
    CONSIGNMENT_ORDER: 'In consegna',
    CROSS_DOCKING_ORDER: 'Cross-docking',
    INFO: 'Informativo'
  },
  // Subtipos de pedido
  order_subtype: {
    INVOICED_NOT_REPLENISHED: 'Fatturato non rifornito',
    FULL_DELIVERY: 'Consegna completa',
    REPLENISHED_NOT_INVOICED: 'Rifornito non fatturato',
    REPLENISHED_INVOICED: 'Rifornito e fatturato'
  },
  // genrals estados
  genral_status: {
    RECEIVED: 'Ricevuto',
    REJECTED: 'Diminuito',
    ACCEPTED: 'Accettato',
    REJECTED_SELLER: 'Rejected supplier',
    ERROR: 'Errore',
    FULLY_INVOICED: 'Completamente fatturato',
    PARTIALLY_INVOICED: 'In parte fatturati',
    ORIGINAL: 'Originale',
    MODIFIED: 'Modificato'
  },
  party_gln_type: {
      GLN: 'GLN',
      EAS: 'EAS',
      SIREN: 'SIREN',
      SIRET: 'SIRET',
	  ENDPOINTID: 'ENDPOINTID'
    },
  // Metodos de entrega y de recepcion
  communication_method: {
    INDRAFIN: 'Indra financial',
    ALAVA: 'DF Alava',
    ANDALUCIA: 'Meeting Andalucia',
    AOC: 'AOC',
    CANARIAS: 'Canarie',
    DIPUTACION_VIZCAYA: 'DF Vizcaya',
    EMAIL: 'Email',
    EMAIL_PDF: 'Email PDF',
    FACE: 'FACe',
    GUIPUZCOA: 'DF Guipuzcoa',
    G_VALENCIA: 'Generalitat Valenciana',
    G_VASCO_EUROBITS: 'Government Vasco',
    NO_ENTREGA: 'Nessuna consegna',
	NO_ENTREGA_RECEPCION: 'Nessuna consegna',
    XUNTA_GALICIA: 'Xunta de Galicia',
    OSAKIDETZA: 'Osakidetza',
    EMAIL_SIGNED: 'Email custodito',
    EMAIL_SIGNED_ATTACH: 'Email custodito e allegata',
    EMAIL_PDF_SIGNED: 'Email PDF custodito',
    EMAIL_PDF_SIGNED_ATTACH: 'Email PDF, allegati e custodito',
    EMAIL_PDF_ATTACH: 'Email PDF e allegati',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF e allegati uniti',
    EMAIL_LINK: 'Email con link',
    PAPER: 'Carta',
    BANKIA: 'Bankia',
    CONSORCIO_AGUAS_BILBAO: 'Aguas Bilbao',
    ESPUBLICO: 'Espublico',
    AOC_WS: 'AOC webService',
    AYUNTAMIENTO_VITORIA: 'Municipio di Vittoria',
    AYUNTAMIENTO_BOADILLA: 'Municipio di Boadilla',
    VOCENTO: 'Vocento',
    MMA: 'Mutua',
    REE: 'Red el\u00E9ctrica',
    AYUNTAMIENTO_AMOREBIETA: 'Municipio di Amorebieta',
    SENADO: 'Senato',
    WS: 'Servizio Web',
    UPLOAD: 'Carica',
    MANUAL: 'Manuale',
    AYUNTAMIENTO_TORRELODONES: 'Municipio di Torrelodones',
    ADIF: 'Adif',
    RENFE: 'Renfe',
    AYUNTAMIENTO_SANTURCE: 'Municipio di Santurce',
    VAN: 'VAN',
    FACEB2B: 'FaceB2B',
    SFACTURA: 'sFactura',
    DOWNLOAD: 'SCARICARE',
    OHLSAP: 'OHLSap',
    OHLGCONS: 'OHLGcons',
    METADATA: 'Dati di consegna',
    METADATA_ATTACH: 'Consegna dati e allegati',
    METADATA_ATTACH_PDF: 'Consegna dati, allegati e PDF',
    ZIPALL: 'Consegna completa',
    ZIPALL_FILES_NAMES_COUNT: 'Redeia',
    ERPEIFFAGE: 'Eiffage',
    ERPPACSA: 'Pacsa',
    ERPSARRION: 'Sarrion',
    ITALIA: 'Italia',
    INDRA: 'SAP Indra',
    AYUNTAMIENTO_COLMENAR_VIEJO: 'Municipio di Colmenar Viejo',
    AYUNTAMIENTO_GALDAKAO: 'Municipio di Galdakao',
    AYUNTAMIENTO_GORLIZ: 'Municipio di Gorliz',
    ECOSYSTEM: 'Ecosystems',
    CECABANK: 'Cecabank',
    REDES: 'Redes',
    ADQUIRA: 'Adquira',
    VAN_EDICOM: 'VAN EDICOM',
    VAN_ARIBA: 'VAN ARIBA',
    VAN_SERES: 'VAN SERES',
    VAN_INDRA: 'VAN INDRA',
    PAVENTURA: 'Port Aventura',
    CANAL_ISABEL_II: 'Canal Isabel II',
    SEDEB2B: 'Sede B2B',
    VWGROUP: 'Grupo Volkswagen',
	PEPPOL: 'Peppol',
    ELECTRONET: 'Electronet',
    BSFACTURA: 'BS Fatture',
    MAPFRE: 'Mapfre',
    PGN: 'PGN',
    RSI: 'RSI',
    INDRAFE: 'Indra',
    INDITEX: 'Inditex',
    INDRAFEREC: 'Indra ricezione',
    B2BCONNECT: 'B2BConnect',
    TSHIFT: 'TShift',
    INDRATOVODAFONE: 'IndraToVodafone',
    COMEX: 'Comex',
    RECKITT: 'Reckitt',
    RECKITT_DELIVERYNOTE: 'Reckitt',
    LEKEITIO: 'Lekeitio',
    AYUNTAMIENTO_ORDUNA: 'Municipio di Orduna',
    LEA_ARTIBAI: 'Lea Artibai',
    AYUNTAMIENTO_OROZKO: 'Municipio di Orozko',
    AYUNTAMIENTO_GUENES: 'Municipio di Guenes',
    AYUNTAMIENTO_SESTAO: 'Municipio di Sestao',
    AYUNTAMIENTO_ESCORIAL: 'Municipio di Escorial',
    AYUNTAMIENTO_MUSKIZ: 'Municipio di Muskiz',
    AYUNTAMIENTO_LEMOA: 'Municipio di Lemoa',
    JCM: 'Junta de Castilla La Mancha',
    FCC: 'Fcc',
    AYUNTAMIENTO_BILBAO: 'Municipio di Bilbao',
    CAIXAF: 'Caixa Factura',
    CAIXA: 'Caixa WS',
    JUNTA_ANDALUCIA: 'JDA',
    DEFAULT: 'Metodo già assegnato',
    LA_RIOJA: 'La Rioja',
    ARGENTINA: 'AFIP Argentina',
    DISANET: 'Disanet',
    FIRMAE: 'Firma-e',
    LYNTIAEMISSION: 'Lyntia',
    LYNTIARECEPTION: 'Lyntia',
    CANALRECEPTION: 'Canal',
    LYNTIA_ACCESS_EMISSION: 'Elanta',
    LYNTIA_ACCESS_RECEPTION: 'Elanta',
    RUMANIA: 'Rumania',
    FRANCE: 'Francia',
    INDRAFEHANA: 'IndraFE',
    INDRAFINHANA: 'IndraFin',
    COMEXHANA: 'IndraComex',
    AYUNTAMIENTO_ABADINO: 'Municipio di Abadiño',
    AYUNTAMIENTO_BALMASEDA: 'Municipio di Balmaseda',
    AYUNTAMIENTO_BERRIZ: 'Municipio di Berriz',
    AYUNTAMIENTO_BUSTURIA: 'Municipio di Busturia',
    AYUNTAMIENTO_DERIO: 'Municipio di Derio',
    AYUNTAMIENTO_ERANDIO: 'Municipio di Erandio',
    AYUNTAMIENTO_FORUA: 'Municipio di Forua',
    AYTO_GERNIKA_LUMO: 'Municipio di Gernika Lumo',
    AYUNTAMIENTO_LOIU: 'Municipio di Loiu',
    AYUNTAMIENTO_SANTURTZI: 'Municipio di Santurtzi',
    AYTO_GAUTEGIZ_ARTEAGA: 'Municipio di Gautegiz Arteaga',
    AYUNTAMIENTO_BERRIATUA: 'Municipio di Berriatua',
    AYUNTAMIENTO_TRAPAGARAN: 'Municipio di Trapagaran',
    AYUNTAMIENTO_ARTEA: 'Municipio di Artea',
    AYUNTAMIENTO_ABANTO: 'Municipio di Abanto',
    AYUNTAMIENTO_BARRIKA: 'Municipio di Barrika',
    AYUNTAMIENTO_ELORRIO: 'Municipio di Elorrio',
    AYUNTAMIENTO_ERENO: 'Municipio di Ereño',
    AYUNTAMIENTO_IURRETA: 'Municipio di Iurreta',
    AYUNTAMIENTO_LEMOIZ: 'Municipio di Lemoiz',
    AYUNTAMIENTO_LEZAMA: 'Municipio di Lezama',
    AYTO_MARURI_JATABE: 'Municipio di Maruri Jatabe',
    AYUNTAMIENTO_PLENTZIA: 'Municipio di Plentzia',
    AYUNTAMIENTO_SOPUERTA: 'Municipio di Sopuerta',
    AYUNTAMIENTO_ZALDIBAR: 'Municipio di Zaldibar',
    AYUNTAMIENTO_ZAMUDIO: 'Municipio di Zamudio',
    AYUNTAMIENTO_ZARATAMO: 'Municipio di Zaratamo',
    AYUNTAMIENTO_ZIERBENA: 'Municipio di Zierbena',
    AYUNTAMIENTO_ETXEBARRI: 'Municipio di Etxebarri',
    CONSOR_TRANSPOR_BIZKAIA: 'Consorzio Trasporti di Bizkaia',
    MDAD_MERINDAD_DURANGO: 'Comunità della Merindad di Durango',
    AYUNTAMIENTO_GORDEXOLA: 'Municipio di Gordexola',
    AYUNTAMIENTO_MENDATA: 'Municipio di Mendata',
    AYUNTAMIENTO_BERMEO: 'Municipio di Bermeo',
    AYUNTAMIENTO_GETXO: 'Municipio di Getxo',
    AULA_CULTURA_GETXO: 'Sala della Cultura di Getxo',
    RESIDENCIA_MPAL_GETXO: 'Residenza Municipale di Getxo',
    AYUNTAMIENTO_LEIOA: 'Municipio di Leioa',
    AYUNTAMIENTO_LEGAZPI: 'Municipio di Legazpi',
    AYUNTAMIENTO_ZUIA: 'Municipio di Zuia',
    AYUNTAMIENTO_ORTUELLA: 'Municipio di Ortuella',
    PARLAMENTO_VASCO: 'Parlamento Basco',
    AYUNTAMIENTO_ARANTZAZU: 'Municipio di Aranzazu',
    AYUNTAMIENTO_BAKIO: 'Municipio di Bakio',
    AYUNTAMIENTO_GARAI: 'Municipio di Garai',
    AYUNTAMIENTO_SONDIKA: 'Municipio di Sondika',
    AYUNTAMIENTO_URDULIZ: 'Municipio di Urduliz',
    AYUNTAMIENTO_BEDIA: 'Municipio di Bedia',
    AYUNTAMIENTO_ALONSOTEGI: 'Municipio di Alonsotegi',
    AYUNTAMIENTO_ARAKALDO: 'Municipio di Arakaldo',
    AYUNTAMIENTO_AREATZA: 'Municipio di Areatza',
    AYTO_ARRIGORRIAGA: 'Municipio di Arrigorriaga',
    AYUNTAMIENTO_BERANGO: 'Municipio di Berango',
    AYUNTAMIENTO_DURANGO: 'Municipio di Durango',
    AYUNTAMIENTO_GALDAMES: 'Municipio di Galdames',
    AYUNTAMIENTO_GAMIZ_FIKA: 'Municipio di Gamiz-Fika',
    AYUNTAMIENTO_ISPASTER: 'Municipio di Ispaster',
    AYUNTAMIENTO_IZURTZA: 'Municipio di Izurtza',
    AYUNTAMIENTO_MANARIA: 'Municipio di Manaria',
    AYUNTAMIENTO_MORGA: 'Municipio di Morga',
    AYUNTAMIENTO_MUXIKA: 'Municipio di Muxika',
    AYTO_TRUCIOS_TURTZIOZ: 'Municipio di Trucios-Turtzioz',
    AYUNTAMIENTO_UBIDE: 'Municipio di Ubide',
    AYTO_UGAO_MIRABALLES: 'Municipio di Ugao-Miraballes',
    MDAD_URIBE_KOSTA: 'Mancomunidad Uribe Kosta',
    AYUNTAMIENTO_ZEANURI: 'Municipio di Zeanuri',
    AYUNTAMIENTO_ZEBERIO: 'Municipio di Zeberio',
    AYTO_ZIORTZA_BOLIBAR: 'Municipio di Ziortza-Bolibar',
    ARARTEKO: 'Ararteko',
    AYUNTAMIENTO_BASAURI: 'Municipio di Basauri',
    AYUNTAMIENTO_AJANGIZ: 'Municipio di Ajangiz',
    AYUNTAMIENTO_AMOROTO: 'Municipio di Amoroto',
    AYTO_ARRANKUDIAGA: 'Municipio di Arrankudiaga',
    ARRATIAKO_UDALEN: 'Arratiako Udalen Mankomunitatea',
    AYUNTAMIENTO_ARRATZU: 'Municipio di Arratzu',
    AYUNTAMIENTO_ARRIETA: 'Municipio di Arrieta',
    AYTO_ARTZENTALES: 'Municipio di Artzentales',
    AYUNTAMIENTO_ATXONDO: 'Municipio di Atxondo',
    AYUNTAMIENTO_AULESTI: 'Municipio di Aulesti',
    AYTO_IBARRANGELU: 'Municipio di Ibarrangelu',
    AYUNTAMIENTO_DIMA: 'Municipio di Dima',
    AYUNTAMIENTO_EA: 'Municipio di Ea',
    MDAD_ENCARTACIONES: 'Mancomunidad de las Encartaciones',
    AYUNTAMIENTO_ERRIGOITI: 'Municipio di Errigoiti',
    AYUNTAMIENTO_ETXEBARRIA: 'Municipio di Etxebarria',
    AYUNTAMIENTO_FRUIZ: 'Municipio di Fruiz',
    AYUNTAMIENTO_GATIKA: 'Municipio di Gatika',
    AYUNTAMIENTO_IGORRE: 'Municipio di Igorre',
    AYTO_VALLE_CARRANZA: 'Municipio di Valle de Carranza',
    AYUNTAMIENTO_KORTEZUBI: 'Municipio di Kortezubi',
    AYUNTAMIENTO_LARRABETZU: 'Municipio di Larrabetzu',
    AYUNTAMIENTO_LAUKIZ: 'Municipio di Laukiz',
    AYUNTAMIENTO_MALLABIA: 'Municipio di Mallabia',
    AYTO_MARKINA_XEMEIN: 'Municipio di Markina-Xemein',
    AYUNTAMIENTO_MENDEXA: 'Municipio di Mendexa',
    AYUNTAMIENTO_MENAKA: 'Municipio di Menaka',
    AYUNTAMIENTO_MUNDAKA: 'Municipio di Mundaka',
    AYUNTAMIENTO_MUNITIBAR: 'Municipio di Munitibar',
    AYUNTAMIENTO_MURUETA: 'Municipio di Murueta',
    AYUNTAMIENTO_NABARNIZ: 'Municipio di Nabarniz',
    AYUNTAMIENTO_OTXANDIO: 'Municipio di Otxandio',
    AYTO_SUKARRIETA_PEDERNALES: 'Municipio di Sukarrieta-Pedernales',
    MDAD_TXORIERRI: 'Mancomunidad de Txorierri',
    MDAD_BUSTURIALDE: 'Mancomunidad de Busturialde',
    AYUNTAMIENTO_LANESTOSA: 'Municipio di Lanestosa',
    UDAL_SAREAK: 'Udal Sareak',
    REDE_ES: 'Red.es'
  },
  // modulos estados de tareas pendientes
  module: {
    ACCOUNTING_CLOSE: 'Chiusure contabili',
    PENDING_TASKS_CHANGE_STATUS: 'Cambiare lo stato in cose da fare',
    PENDING_TASKS: 'Cose da fare',
    CMR: 'CMR',
    CONTROLDOCUMENT: 'Controllo documenti',
    CONTROLDOCUMENTLINK: 'Controllo documenti link'
  },
  job_status: {
    RUNNING: 'Corsa',
    NORMAL: 'In attesa',
    PAUSED: 'In pausa',
    NONE: 'Nessuno',
    COMPLETE: 'Completato',
    ERROR: 'Errore',
    BLOCKED: 'Bloccato'
  },
  // Estado de la factura
  invoice_status: {
    ANNULLED: 'Annullata',
    ERROR: 'Errore',
    REJECTED: 'Respinto',
    RECEIVED: 'Ricevuto',
    CANCELLED: 'Cancellata',
    DISAGREEMENT: 'Non conforme',
    PENDING_OF_SIGNING: 'In attesa di firma',
    PENDING_OF_SEND: 'In attesa di invio',
    PENDING_OF_VERIFYING: 'In attesa di verifica',
    PENDING_OF_GENERATE: 'Generazione in attesa',
    PENDING_OF_REPORTING: 'In attesa di report',
    REPORTED: 'Reportata',
    YIELDED: 'Ceduto',
    COMPENSATED: 'Compensato',
    PENDING_OF_COMPENSATION: 'Risarcimento in corso',
    PENDING_OF_CONFIRM: 'Essere confermato',
    COLLECTED: 'Addebitato',
    PENDING: 'In attesa di',
    PENDING_OF_ACCEPTING: 'In attesa di accettazione',
    PENDING_OF_VALIDATION: 'In attesa di convalida',
    IN_PROCESS: 'In corso',
    OPENED: 'Aperta',
    SIGNED: 'Firmato',
    SENDED: 'Inviata',
    REGISTERED: 'Registrato dal cliente',
    ACCEPTED: 'Accettata',
    ACCOUNTED: 'Contabilizzata',
    PENDING_OF_PAYMENT: 'Pagamento in sospeso',
    PARTIALLY_PAID: 'Parzialmente retribuito',
    PARTIALLY_ACCEPTED: 'Parzialmente accettato',
    PAID: 'Pagata',
    RETAINED: 'Purificato',
    AWAITING_PAYMENT: 'In attesa di pagamento',
    CONSOLIDATED: 'Consolidato',
    DELIVERED: 'Consegnato',
    DELIVERYCONFIRMED: 'Consegna confermata',
    SENT_TO_PAYMENT: 'Inviato a pagamento',
    INVOICE_RESPONSE: 'Pagamento in sospeso',
    WITHOUT_INTERNAL_STATUS: 'Senza stato interno',
    REJECTED_REDIGITALIZATION: 'Redigitalizada',
    INVOICE_SIGNATURE: 'Fattura in firmas',
    PROPOSALS_SIGNATURE: 'Proposta in firmas',
    SEND_PROPOSED_STATE: 'Inviato stato proposto',
    SENT: 'Inviata',
    WAITING_CALLBACK: 'In attesa di risposta',
    RETAINED_PAYMENT: 'Pagamento trattenuto',
    VALIDATIONACCEPTED: 'Convalida accettata',
    VALIDATIONERROR: 'Errore di convalida',
    LOADING: 'Caricamento',
    FINISH: 'Completato',
    CHANGE_DRIVER: 'Cambio di conducente',
    ON_RUTE: 'In percorso',
    DRAFT: 'Bozza',
    ACCEPT: 'Accettato',
    VISUALIZED: 'Visualizzato',
  },

  // Campo enviada
  invoice_sent_flag: {
    SENT: 'Spedito',
    PENDING_OF_SEND: 'Spedizione in attesa',
    NOT_SENT: 'Non spedito'
  },

  // Estado del albaran
  deliverynote_status: {
    SENT: 'Spedire',
    ACCEPTED: 'Accettato',
    ERROR: 'Errore',
    REJECTED: 'Respinto',
    RECEIVED: 'Ricevuto',
    FULLY_INVOICED: 'Completamente fatturato',
    PARTIALLY_INVOICED: 'Parzialmente fatturato',
    PARTIALLY_RECEIVED: 'Ricevuto parzialmente',
    IN_PROCESS: 'In corso',
    PENDING_OF_SEND: 'Pre-emesso',
    PARTIALLY_SENT: 'Expedido parcialmente',
    FULLY_SENT: 'Expedido totalmente'
  },

  // Estado de cmr
  cmr_status: {
    PENDING_OF_SEND: 'Pendiente de envío',
    LOADING: 'Cargando',
    IN_PROCESS: 'En curso',
    FINISH: 'Finalizado',
    CHANGE_DRIVER: 'Cambio de conductor',
    CANCELLED: 'Viaje cancelado',
    ANNULLED: 'Annullata',
    SENT: 'Inviato',
    ON_RUTE: 'In percorso',
    DRAFT: 'Bozza',
    REJECTED: 'Respinto',
    ACCEPT: 'Accettato',
    VISUALIZED: 'Visualizzato',
    ERROR: 'Errore',
  },

  // Divisas
  currency: {
    AUD: 'Dollaro australiano',
    ALL: 'Lek albanese',
    DZD: 'Dinaro algerino',
    ARS: 'Peso argentino',
    AWG: 'Aruba Florin',
    GBP: 'Sterlina',
    BSD: 'Dollaro delle Bahamas',
    BHD: 'Dinaro del Bahrain',
    BDT: 'Taka dal Bangladesh',
    BBD: 'Dollaro delle Barbados',
    BYR: 'Rublo bielorusso',
    BZD: 'Dollaro Belize',
    BMD: 'Dollaro delle Bermuda',
    BTN: 'Ngultrum del Bhutan',
    BOB: 'Boliviano',
    BWP: 'Pula dal Botswana',
    BRL: 'Real brasiliano',
    BND: 'Dollaro del Brunei',
    BGN: 'Lev bulgaro',
    BIF: 'Franco Burundi',
    CAD: 'Dollaro canadese',
    CNY: 'Yuan cinese',
    KHR: 'Riel cambogiano',
    CVE: 'Scudo di Capo Verde',
    KYD: 'Dollaro delle Isole Cayman',
    XOF: 'Franco CFA (BCEAO)',
    XAF: 'Franco CFA (BEAC)',
    CLP: 'Peso cileno',
    COP: 'Peso colombiano',
    KMF: 'Franco comorano',
    CRC: 'Colonia Costa Rica',
    HRK: 'Kuna croata',
    CUP: 'Peso cubano',
    CZK: 'Czech koruna',
    DKK: 'Danish crown',
    DJF: 'Djiboutian Franco',
    DOP: 'Dominican peso',
    EUR: 'Euro',
    XCD: 'East Caribbean Dollar',
    EGP: 'Egyptian pound',
    SVC: 'The Colon of El Salvador',
    EEK: 'Estonian kroon',
    ETB: 'Ethiopian Birr',
    FKP: 'Malawian pound',
    FJD: 'Fiji dollar',
    GMD: 'Gambian Dalasi',
    GTQ: 'Guatemala Quetza',
    GNF: 'Guinean franc',
    GYD: 'Guyanese dollar',
    GHS: 'Cedi ghanes',
    HKD: 'Hong Kong dollar',
    HTG: 'Haitian Gourde',
    HNL: 'Honduran Lempira',
    HUF: 'Hungarian Forint',
    IDR: 'Indonesian rupee',
    INR: 'Indian rupee',
    ISK: 'Icelandic krona',
    IRR: 'Iranian rial',
    IQD: 'Iraqi Dinar',
    ILS: 'Israeli Shekel',
    JPY: 'Japanese Yen',
    JOD: 'Jordanian Dinar',
    KZT: 'Tenge kazako',
    KES: 'Chelín keniano',
    KRW: 'Won coreano',
    KWD: 'Dinar kuwaití',
    KGS: 'Kirguistán Som',
    MOP: 'Pataca de Macao',
    MKD: 'Dinar macedonio',
    MWK: 'Kwacha malawiano',
    MYR: 'Ringgit malayo',
    MVR: 'Rupia de Maldivas',
    MRO: 'Ouguiya de Mauritania',
    MUR: 'Rupia mauricia',
    MXN: 'Peso mexicano',
    MDL: 'Leu moldavo',
    MNT: 'Tugrik mongol',
    MAD: 'Dirham marroquí',
    MMK: 'Kyat de Myanmar',
    NAD: 'Dólar de Namibia',
    NPR: 'Rupia nepalí',
    ANG: 'Guilder antillano',
    NZD: 'Dólar neozelandés',
    NIO: 'Córdoba nicaragüense',
    NGN: 'Naira nigeriano',
    KPW: 'Won de Corea del Norte',
    NOK: 'Corona noruega',
    OMR: 'Rial omaní',
    XPF: 'Franco CFP',
    PKR: 'Pakistani rupee',
    PAB: 'Panamanian Balboa',
    PGK: 'Kina of Papua New Guinea',
    PYG: 'Paraguayan Guarani',
    PEN: 'New Sun peruan',
    PHP: 'Philippine Peso',
    PLN: 'Polish Zloty',
    QAR: 'Qatar Riyal',
    RON: 'Read Romanian',
    RUB: 'Russian ruble',
    RWF: 'Rwandan franc',
    CHF: 'Swiss franc',
    WST: 'Samoa Tala',
    STD: 'Dobra of São Tomé',
    SAR: 'Saudi Riyal',
    SCR: 'Seychelles Rupee',
    SLL: 'Leone from Sierra Leone',
    SGD: 'Singapore Dollars',
    SKK: 'Slovak koruna',
    SBD: 'Solomon Islands Dollar',
    SOS: 'Somali Shilling',
    ZAR: 'South African Rand',
    LKR: 'Sri Lanka Rupee',
    SHP: 'Saint Helena Pound',
    SDG: 'Sudanese pound',
    SZL: 'Lilangeni from Swaziland',
    SEK: 'Swedish krona',
    SYP: 'Syrian pound',
    THB: 'Thai Baht',
    TRY: 'Turkish Lira',
    TWD: 'Taiwan Dollars',
    TZS: 'Tanzanian shilling',
    TOP: 'Paubanga the Tongan dollar',
    TTD: 'Trinidad and Tobago Dollar',
    TND: 'Tunisian Dinar',
    USD: 'American dollar',
    AED: 'United Arab Emirates Dirham',
    UGX: 'Ugandan shilling',
    UAH: 'Grivnia from Ukraine',
    UYU: 'Uruguayan Peso',
    UZS: 'Uzbekistan Sum',
    VUV: 'Vanuatu Vatu',
    VND: 'Dong of Vietnam',
    VES: 'Venezuelan Bolívar',
    YER: 'Yemeni rial',
    ZMK: 'Zambian kwacha',
    PES: 'Peso',
    JMD: 'DolLaro delle Jamaica'
  },

  // Estados de auditoría
  auditory_status: {
    DELIVERED: 'Delivered',
    DELIVERYCONFIRMED: 'Delivery confirmed',
    DIVIDED: 'Divided',
    ERROR: 'Error',
    DELETED: 'Deleted',
    CREATED: 'Created',
    UPDATED: 'Updated',
    EXTRACTED: 'Extracted',
    GENERATED: 'Generated',
    INCOMINGERROR: 'Incoming error',
    INTEGRATED: 'Integrated',
    PENDINGOFDELIVERY: 'Pending of delivery',
    DISCARDED: 'Scartato',
    RECEIVED: 'Received',
    RECOGNIZED: 'Recognized',
    SIGNED: 'Signed',
    DISAGREEMENT: 'Non conforme',
    PENDING_OF_SIGNING: 'Pending of signature',
    TRANSFORMED: 'Transformed',
    ERROR_WS_DOCUMENT: 'Error in the service of integration document',
    ERROR_WS_NOTIFICATION: 'Error in the service of integration notifications',
    SENT_TO_PAYMENT: 'Sent to payment',
    WAITING_CALLBACK: 'In attesa di risposta',
    WARNING: 'Avvertimento',
    VALIDATIONACCEPTED: 'Convalida accettata',
    VALIDATIONERROR: 'Errore di convalida'
  },

  // Tipo de documento auditoría
  auditory_doc_type: {
    INVOICE: 'Fatture',
    DIGITIZEDINVOICE: 'Digitized invoice',
    ATTACHMENT: 'Attachments',
    UPDATE_STATUS: 'Status di fatture',
    UPDATE_INTERNAL_STATUS: 'Internal status di fatture',
    INVOICE_RESPONSE: 'Invoice file response',
    BATCHFILE: 'Batch',
    RECADV: 'Ricev',
    OTHER: 'Others',
    RECEIVEADVICE: 'Reception',
    PURCHASEORDER: 'Ordinativo',
    ORDER: 'Ordinativo',
    ORDERRSP: "Risposta dell'ordine",
    DELIVERYNOTE: 'Nota di consegna',
    GENRAL: 'Genral',
    GENERAL: 'Genral note',
    CMR: 'CMR',
    USER: 'Utenti',
    PARTY: 'Aziende',
    STATUS: 'Stato',
    SALESREPORT: 'Rapporto sulle vendite',
    INVENTORYREPORT: "Rapporto sull'inventario",
    REMADV: "Avviso di liquidazione",
    COACSU: "Riepilogo conto commerciale",
    CONTROLDOCUMENT: "Documento di controllo",
  },

  // Tipos de formatos de documentos auditoria
  auditory_doc_format: {
    FACTURAE32: 'FACTURAE32',
    FACTURAE321: 'FACTURAE321',
    INVOIC_D96A: 'INVOIC_D96A',
    INVOIC_D97A: 'INVOIC_D97A',
    INVOIC_D93A: 'INVOIC_D93A',
    XML_AECOC: 'XML_AECOC',
    PDF: 'PDF',
    PDF_A: 'PDF-A',
    UBL20: 'UBL20',
    ZIP: 'ZIP',
    CSV: 'CSV',
    PLAIN_ALTCLI: 'ALTO AEREO CLIENTE',
    XML_ENVEST: 'XML STATI DI SPEDIZIONE',
    TXT: 'TXT',
    PLAIN_ENVRES: 'RISPOSTA DI SPEDIZIONE PIANA',
    XML_SANTILLANA: 'XML SANTILLANA',
    XML_B2B_RECADV: 'XML B2B RECEPCION',
    INVOIC_D01B: 'INVOIC_D01B',
    PLAIN_ALTPRO: 'PLAIN_ALTPRO',
    FACTURAE322: 'FACTURAE322',
    FATTURAPA12: 'FATTURAPA12',
    FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
    FATTURAPA12_CADES: 'FATTURAPA12_CADES',
    FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
    XML_B2B_ORDER: 'XML B2B Ordinativo',
    XML_B2B_ORDERRSP: "XML B2B Risposta dell'ordine",
    XML_B2B_DELIVERYNOTE: 'XML B2B Nota di consegna',
    XML_B2B_INVOICE: 'XML B2B METADATI',
    GENRAL_D96A: 'GENRAL D96A',
    CSV_B2B_PARTY: 'CSV Aziende',
    DIGITALIZED_DELIVERYNOTE: 'Nota di consegna digitalized',
    CXML_INVOICE: 'CXML',
    FEV1: 'FEV1',
    FATTURAPA11: 'FATTURAPA11',
    FATTURAPA10: 'FATTURAPA10',
    FISI: 'FISI',
    UBL21: 'UBL21',
    ORDERS_D96A: 'ORDERS_D96A',
    FACTURAE30: 'FACTURAE30',
    FACTURAE31: 'FACTURAE31',
    XCBL40: 'XCBL40',
    '3C3': 'RosettaNet',
    XML_B2B_CMR: 'XML_B2B_CMR',
    DESADV_D96A: 'DESADV_D96A',
    XML_B2B_GENRAL: 'XML_B2B_GENRAL',
    CSV_B2B_USER: 'CSV_B2B_USER',
    XML_B2B_INVOICE_STATUS: 'XML_B2B_INVOICE_STATUS',
    XML_B2B_RECADV_STATUS: 'XML_B2B_RECADV_STATUS',
    XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
    CII: 'CII',
    XML_CANONICAL_B2B_INVOICE: 'XML CANONICAL B2B INVOICE',
  },

  // Protocolos de comunicación en auditoría
  auditory_communication_protocol: {
    SSH_FTP: 'SFTP',
    WS: 'Webservice',
    AS2: 'AS2',
    EMAIL: 'Electronic mail',
    OTX: 'VAN',
    FILESYSTEM: 'Consegna interna',
    VALIDATION_WS: 'WS convalida',
    REST: 'Servizio di riposo',
    WEB: 'Portale Web'
  },

  // Modulos  auditoria
  auditory_module: {
    EXCHANGE_WS_SEND: 'Invio di fatture',
    EXCHANGE_WS_STATUS: 'Query sullo stato',
    EXCHANGE_WS_CHANGE: 'Cambio di stato',
    EXCHANGE_WS_DOWNLOAD: 'Scarica',
    MASSIVE_PARTY: 'Carico di massa delle società',
    PARTY: 'Società',
    CENTRE: 'Centri',
    PAYMENT: 'Dati di pagamento',
    USER: 'Utenti',
    WS_VALIDATION: 'WS di validazione',
    RECADV: 'Ricevimenti',
    EDITRACK_DOCUMENT_INTEGRATION: 'Integrazione Editrack',
    EDITRACK_DOCUMENT_NOTIFICATION: 'Notifica Editrack',
    CMR: 'DECA',
    ORDER: 'Ordinativo',
    DELIVERY_NOTE: 'Nota di consegna',
    SIGNATURE_PLATFORM: 'Piattaforma di firma'
  },

  // Categorias de documentos
  documentation_category: {
    EXAMPLE: 'Esempio',
    FUNCTIONAL_ANALYSIS: 'Analisi funzionale',
    INTEGRATION_DOCUMENT: 'Documento di integrazione',
    OFFER: 'Offerta',
    USER_MANUAL: 'Manuale dell utente',
    INFORMATIVE_DOCUMENT: 'Documento informativo',
    USER_INFORMATION: "Informazioni per l'utente"

  },

  // Idioma documentos
  documentation_language: {
    spanish: 'Spagnolo',
    english: 'Inglese',
    italian: 'Italiano',
    portuguese: 'Portoghese',
    french: 'Francese'
  },

  // Estados de cierres contables
  status_accounting_close: {
    Abierto: 'Opened',
    Cerrado: 'Closed'
  },

  // Clases de documento
  document_class: {
    COPY: 'Copy',
    ORIGINAL: 'Originale',
    DUPLICATE: 'Duplicate',
    ADDITIONAL_TRANSMISSION: 'Additional',
    REPLACE: 'Rettificativa',
    ADDITION: 'Addition'
  },

  // Clases de ciclos de documentos
  document_cycle_class: {
    DELIVERY_VALIDATION_PACKAGE_GTIN14: 'Convalida GTIN14 delle righe de la bolla di consegna',
    INVOICE_LINES_EDITABLE_FIELDS: 'Valida in base al sottotipo delle linee di ricezione se le linee devono essere create e se sono modificabili',
    INVOICE_FROM_ORDER_TYPE_SUBTYPE: 'Convalida il tipo e/o sottotipo dell\'ordine per creare una fattura con alcuni campi non modificabili',
    VALIDATION_ORDER_RESPONSE_REQUIRED: "Convalida dell'esistenza della precedente risposta all'ordine"
  },

  // Tipos de factura
  invoice_type: {
    PROFORMA: 'Proforma',
    COMMERCIAL: 'Commercial',
    CREDIT_NOTE: 'Feed',
    DEBIT_NOTE: 'Debit note',
    CONSOLIDATED: 'Consolidated',
    SELF_BILLED: 'Self invoice'
  },

  // Tipo de documento de factura
  invoice_document_type: {
    FC: 'Fattura completa',
    FA: 'Fattura abbreviata',
    AF: 'Autofattura',
    AN: 'Fattura acconto',
    PF: 'Fattura proforma',
    NL: 'Non logistico'
  },

  delivery_note_type: {
    NO_LOGISTIC: 'Non logistico',
    LOGISTIC_TWO_LEVELS: 'Logistica a 2 livelli. Merce generica',
    LOGISTIC_THREE_LEVELS: 'Logistica a 3 livelli. Consumo di massa'
  },

  // Tipos de servicios
  project_type: {
    seller: 'Emisione',
    buyer: 'Ricezione',
    both: 'Both'
  },

  // Tipos de empresa
  party_type: {
    seller: 'Seller',
    buyer: 'Buyer',
    third: 'Terzo',
    both: 'Both'
  },
  // Método de entrega
  party_type_meth: {
    emission: 'Emisione',
    reception: 'Ricezione',
    both: 'Both'
  },

  // Método de entrega project
  project_type_meth: {
    emission: 'Emissione',
    reception: 'Ricezione'
  },

  chart_legend: {
    from_others: 'Fatture',
    from_orders: 'Fatture da ordini',
    from_recadvs: 'Fatture da ricevimenti',
    from_deliverynotes: 'Fatture da bolle di consegna',
    invoices_emitted: 'Fatture emesse',
    invoices_received: 'Fatture ricevute',
    parties_registered: 'Società registrate',
    invoices_redigitized: 'Fatture ridigitalizzate',
    invoices_rejected: 'Fatture respinte'

  },
  // Tipos de tabla
  chart_type: {
    title: 'Tipo di tabella',
    economic: 'Volume economico',
    invoice: 'Numero di fatture'
  },
  // Tipos de persona
  person_type: {
    physical: 'Physical',
    legal: 'Legal'
  },
  // Forma de pago
  paymentmethod: {
    CASH: 'Efficace',
    CHECK: 'Controllare',
    CONFIRMING: 'Confermando',
    TRANSFER: 'Trasferimento'
  },
  // Formato de document
  document: {
    format: {
      FACTURAE32: 'FACTURAE32',
      FACTURAE321: 'FACTURAE321',
      FACTURAE322: 'FACTURAE322',
      FATTURAPA12: 'FATTURAPA12',
      FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
      FATTURAPA12_CADES: 'FATTURAPA12_CADES',
      FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
      INVOIC_D96A: 'INVOIC_D96A',
      INVOIC_D97A: 'INVOIC_D97A',
      INVOIC_D93A: 'INVOIC_D93A',
      XML_AECOC: 'XML_AECOC',
      PDF: 'PDF',
      PDF_A: 'PDF-A',
      ZIP: 'ZIP',
      CSV: 'CSV',
      UBL20: 'UBL20',
      PLAIN_ALTCLI: 'Piani dimissione clienti',
      XML_ENVEST: 'XML invio stati',
      PLAIN_ENVRES: 'Piano invio risposta',
      XML_SANTILLANA: 'XML SANTILLANA',
      XML_B2B_RECADV: 'XML B2B RECEPCION',
      INVOIC_D01B: 'INVOIC_D01B',
      PLAIN_ALTPRO: 'PLAIN_ALTPRO',
      XML_B2B_ORDER: 'XML B2B Ordinativo',
      XML_B2B_ORDERRSP: "XML B2B Risposta dell'ordine",
      XML_B2B_DELIVERYNOTE: 'XML B2B Nota di consegna',
      XML_B2B_INVOICE: 'XML B2B METADATI',
      GENRAL_D96A: 'GENRAL D96A',
      CSV_B2B_PARTY: 'CSV Aziende',
      DIGITALIZED_DELIVERYNOTE: 'Nota di consegna digitalized',
      CXML_INVOICE: 'CXML',
      FEV1: 'FEV1',
      FATTURAPA11: 'FATTURAPA11',
      FATTURAPA10: 'FATTURAPA10',
      FISI: 'FISI',
      UBL21: 'UBL21',
      ORDERS_D96A: 'ORDERS_D96A',
      FACTURAE30: 'FACTURAE30',
      FACTURAE31: 'FACTURAE31',
      XCBL40: 'XCBL40',
      XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
      CII: 'CII',
      XML_CANONICAL_B2B_INVOICE: 'XML CANONICAL B2B INVOICE',
    }
  },
  categories: {
    OTHERS: 'Altrui',
    AUTOMATIC: 'Automatico',
    INCORRECT_ATTACHS: 'Allegati: documentazione mancante o errata',
    INCORRECT_CENTER: 'Centro sbagliato',
    INCORRECT_DETAIL: 'Concetto errato o mancanza di dettagli',
    PARTY_CONTRACTING: 'Assunzione di società',
    INCORRECT_FISCAL: ' Dati fiscali errati',
    INCORRECT_RELATION: 'Documenti correlati errati',
    ACCOUNTING_NOT_EXIST: 'Fattura a cui si corregge che non è stata contabilizzata o che non esiste',
    DUPLICATED_INVOICE: 'Fattura duplicata',
    INCORRECT_DELIVERY_DATE: 'Data / periodo di consegna del servizio errati',
    INCORRECT_AMOUNTS: 'Importi errati',
    REDIGITALIZATION: 'Ridigitalizzare',
    INCORRECT_ENTRY: 'Requisiti di ingresso errati',
    PAPER: 'Trascritto su carta',
    WRONG_CAPTURED: 'Campo male catturato',
    NO_CAPTURED: 'Campo non catturato',
    WRONG_FIELD_CAPTURED: 'Campo catturato errato',
    NO_CATEGORY: 'Senza categoria',
    INCORRECT_OCR_DATA: "Convalida dell'OCR"
  },

  // Tipo de extension de factura
  extension_type: {
    FACEB2B: 'Estensione FACe B2B'
  },

  // Roles para centros
  centre_role_type: {
    payer: 'Pagador',
    payee: 'Receptor del cobro',
    invoicee: 'Fatturati',
    finalclient: 'Cliente final',
    ship_to: 'Luogo di consegna',
    ship_from: 'Envío desde',
    receiver: 'Receptor',
    buyer: 'Comprador',
    collector: 'Cobrador',
    seller: 'Vendedor',
    payment_receiver: 'Receptor del pago',
    collection_receiver: 'Receptor del cobro',
    issuer: 'Emisor',
    fiscal: 'Fiscal'
  },
  centre_role_type_order: {
    payer: 'Pagador',
    payee: 'Receptor del cobro',
    invoicee: 'Fatturati',
    finalclient: 'Cliente final',
    ship_to: 'Luogo di consegna',
    ship_from: 'Envío desde',
    receiver: 'Receptor',
    buyer: 'Comprador',
    collector: 'Cobrador',
    seller: 'Vendedor',
    payment_receiver: 'Receptor del pago',
    collection_receiver: 'Receptor del cobro',
    issuer: 'Emisor',
    fiscal: 'Fiscal'
  },
  // Estadísticas
  statistic: {
    emitted_title: 'Volume delle fatture emesse',
    received_title: 'Volume delle fatture ricevute',
    other_title: 'Fatture generate da un altro documento, ordine, ricevuta o bolla di consegna',
    topseller_title: 'I 20 principali fornitori per volume economico e numero di fatture',
    parties_title: 'Volume di società registrate',
    rejected_invoice_title: 'Fatture: Tipologie di scarto e motivi della risgittonatura',
    symbol: 'Fatture',
    party_type: 'Tipo di società',
    party_sponsor: 'Sponsor',
    invoice_status_title: 'Stato della fattura',
    total_party: 'Totale aziende accumulate'
  },
  // Documentacion
  documentation: {
    documentation_entity_table: {
      project: 'Servizio',
      name: 'Nome',
      category: 'Categoria',
      language: 'Lingua'
    },
    buttons: {
      new_document: 'Caricare documento',
      download_multiple: 'Scarica il documento/s'
    },
    dialog_add_documentation: {
      title: 'Aggiungi documentazione',
      deletefile: 'Elimina il file della documentazione',
      updatetitle: 'Aggiornare documentazione',
      project: {
        label: 'Servizio',
        placeholder: 'Scegli un servizio'
      },
      categoria: {
        label: 'Categoria',
        placeholder: 'Scegli una categoria'
      },
      nombre: {
        label: 'Nome del documento'
      },
      url: {
        label: 'URL'
      },
      idioma: {
        label: 'Lingua',
        placeholder: 'Scegli una lingua'
      },
      urlorfile_required: 'URL o file richiesto'
    },
    error: {
      validation: {
        parametro_obligatorio_idioma: 'La lingua è obbligatoria',
        parametro_obligatorio_nombre: 'Il nome è obbligatorio',
        parametro_obligatorio_documentation: 'Il file o url è richiesto',
        duplicated: 'La documentazione per il servizio esiste già',
        size_exceeded: 'La dimensione del file supera il limite consentito di 10 MB',
      },
      error_generico: 'Errore durante il caricamento della documentazione'
    }
  },

  documentation_detail: {
    buttons: {
      document: 'Documento',
      eraseDocument: 'Rimuovere'
    },
    documentation_detail_form: {
      project: 'Servizio',
      name: 'Nome',
      category: 'Categoria',
      language: 'Lingua'
    },
    confirm: {
      title_delete_documentation: 'Sei sicuro di voler eliminare questo documento?',
      confirm_button_delete_documentation: 'Rimuovere',
      title_upload_documentation: 'Sei sicuro di voler sostituire questo documento?',
      confirm_button_upload_documentation: 'Sostituire'
    },
    notify: {
      delete_document_ok: 'Documento eliminato con successo.',
      upload_document_ok: 'La documentazione è stata aggiornato correttamente.'
    },
    load: {
      download: 'Scaricare il documento ...',
      delete_document: 'Eliminazione del documento ...',
      upload_document: 'Caricamento  del documento ...'
    }
  },
  NO_PENDING_TASK_STATUS: 'Non sono stati trovati stati configurati per il servizio selezionato.',
  display_documents: {
    PDF_INDRA: 'PDF Indra',
    PDF_OHL_PERU: 'PDF per OHL Perú',
    PDF_RENFE: 'PDF per Renfe',
    PDF_INDRAFE: 'PDF per IndraFE',
    PDF_SARQUAVITAE: 'PDF per Sarquavitae',
    PDF_RENFE_RECADV: 'PDF per ricevimenti Renfe',
    PDF_CATEGORY: 'PDF allegato classificato',
    PDF_TOYOTA: 'PDF per Toyota Canarias',
    PDF_IDCSALUD: 'PDF per IDC Salud',
    PDF_RECADV: 'Ricevimenti PDF di default',
    PDF_ENDESA: 'PDF per Endesa',
    PDF_QUIRON_RECADV: 'PDF per Quiron',
    PDF_ORDER: 'PDF per Ordini',
    PDF_QUIRON_ORDER: 'PDF per Ordini di Quiron',
    PDF_DELIVERYNOTE: 'PDF per nota di consegna',
    PDF_GENRAL: 'PDF per Genral',
    PDF_RENFE_SUPPLIER_DATA: 'PDF per provider',
    PDF_RENFE_SOCIETIES_RECADV: 'PDF per società di accoglienza',
    PDF_REDSYS: 'PDF per Redsys',
    PDF_GNUBILA: 'PDF per Gnubila',
    PDF_OHL: 'PDF per OHL',
    PDF_ORDER_INDRA: 'PDF per Ordini Indra',
    PDF_NISSAN: 'PDF per Nissan',
    PDF_GONVARRI: 'PDF per Gonvarri',
    PDF_CONSUM: 'PDF per Consum',
    PDF_TELEFONICATECH: 'PDF per Telefonica Tech',
    PDF_DRAFT_INDRA: 'PDF temporaneo per bozze',
    PDF_OTIS: 'PDF per Otis',
    PDF_LYNTIA_GLOBAL: 'PDF Lyntia Global Fontibre',
    PDF_LYNTIA_CODINET: 'PDF Lyntia Codinet',
    PDF_LYNTIA_NETWORKS: 'PDF Lyntia Networks',
    PDF_LYNTIA_TOWERNET: 'PDF Lyntia Towernet',
    PDF_LYNTIA_ELANTA: 'PDF Lyntia Elanta',
    PDF_CANAL: 'PDF per Canal',
    PDF_REDEIA: 'REDEIA PDF',
    PDF_RENFE_AMERICA: 'PDF Renfe of America',
    PDF_CORREOS_EXPRESS: 'PDF Correos Express',
    PDF_CMR_MAHOU: 'PDF CMR Mahou',
    PDF_CMR_TKAS: 'PDF CMR TKAS',
    PDF_CMR_ECMR: 'PDF documento di trasporto',
    PDF_ACCIONA_ENERGIA: 'PDF Acciona Energia',
    PDF_ABOGACIA: 'PDF Abogacia',
    PDF_DOCUMENTO_CONTROL_MAHOU: 'PDF documento di controllo Mahou',
  },

  display_labels: {
    PDF_DELIVERYNOTE_LABEL: 'PDF per etichette generiche di nota',
    PDF_ALCAMPO_DELIVERYNOTE_LABEL: 'PDF per etichette di nota di Alcampo',
    PDF_CARREFOUR_DELIVERYNOTE_LABEL: 'PDF per etichette di nota di Carrefour',
    PDF_BONPREU_DELIVERYNOTE_LABEL: 'PDF per etichette di nota di Bon Preu',
    PDF_ECI_DELIVERYNOTE_LABEL: 'PDF per etichette di nota di ECI'
  },

  email_type: {
    NEW_USER: 'Nuovo nome utente e password',
    RESET_PASSWORD: 'Recuperare la password',
    NEW_INVOICE: 'Email informativa nuova fattura',
    EMAIL_PDF_ATTACH: 'Email PDF e allegati',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF e allegati uniti',
    EMAIL_SIGNED: 'Email custodito',
    EMAIL_PDF_SIGNED: 'Email PDF e custodito',
    EMAIL_PDF_SIGNED_ATTACH: 'Email PDF, custodito e allegati',
    EMAIL_LINK: 'Email con link',
    INVOICE_ERROR_DELIVERY_METHOD: 'Metodo di consegna non contratto',
    BILLING_REPORT_SERVICE: 'Notifica di servizio',
    ACK_EMAIL_ERROR: 'Errore durante l\'invio dell\'email ACK',
    ERROR_CMR: 'Notifica di errore per documento di controllo',
    ANNULLED_CMR: 'Notifica di annullamento per documento di controllo',
    INVALID_STATUS: 'Errore di spedizione',
    RESUMEN_BOLETAS_ERROR: 'CDR in sintesi delle schede',
    NEW_RECADV: 'Nuova accoglienza',
    NEW_ORDER: 'Nuovo ordine',
    ERROR_RRVV: 'Email con notifica di errore per ricevimenti stimati',
    ERROR_ORDER: 'Email con notifica di errore per ordine',
    BILLINGINACTIVE_REPORT: 'Rapporto fatture inattive',
    NEW_INVOICE_PENDING_ACCEPTANCE: 'Nuova fattura in attesa di accettazione',
    ANEXO_DOCUMENTATION: 'Nuova proposta di pagamento',
    INVALID_INVOICE_NOTE_URL: 'Notifica di accesso errato tramite url alla richiesta di fatturazione',
    REDIGITALIZATION_REQUEST: 'Richiesta di ridigitalizzazione',
    BILLING_REPORT_SERVICES: 'Notifica di più servizi',
    ERROR: 'Email di notifica errori per supporto',
    VALIDATE_FORMAT_ERROR: 'Errore di integrazione con il tipo di email',
    EMAIL_PDF: 'Email PDF',
    INTEGRATION_REJECTED: 'Email per i fornitori quando la fattura con stato rifiutato è integrata',
    INVOICE_TIME_EXCEED_NOTIFICATION_EMISSION: 'Email per i fornitori quando l\'SDI non è in grado di consegnare la fattura',
    INVOICE_TIME_EXCEED_NOTIFICATION_RECEPTION: 'Email per i destinatari quando la SDI non ha ricevuto notifiche',
    CHANGE_STATUS_ERROR: 'Email per avvertire che non è possibile cambiare lo stato',
    NEW_DELIVERY_NOTE: 'Nuova bolla di consegna',
    CHANGE_STATUS_DELIVERYNOTE: 'Modifica della bolla di consegna',
    CHANGE_STATUS_RECADV: 'Modifica dello stato di una ricevuta',
    WS_DOCUMENT: 'Invio di documenti aziendali da parte di WS',
    PARTY_DATA: 'Invio di documenti aziendali via e-mail',
    EMAIL_TO_REPORT_ISSUED: 'Email per inviare il report CSV delle fatture emesse',
    INTEGRATION_OCR_ERROR: 'Email di notifica degli errori di integrazione nelle fatture OCR',
    EMAIL_NOTIFICATION_CUSTOMER: 'Email che viene inviata nella chiamata al cliente per inviare la fattura',
    EMAIL: 'Email',
    EMAIL_SIGNED_ATTACH: 'Email custodito e allegati',
    EMAIL_INVOICE_NO_OCR: 'Invio centralizzato di notifiche elettroniche di fatturazione',
    EMAIL_THIRDPARTY: 'Email per l\'invio di fatture a terzi',
    ERROR_CENTRE: 'Email di notifica degli errori di integrazione nelle centri',
    VERIFY_2FA: "E-mail per notificare il codice per l'autenticazione a due fattori",
    APPROVAL_FLOW: 'Email per l\'approvazione delle fatture',
    EMAIL_BILLING_REPORT: 'Email con il report di fatturazione di Indra e Telefónica',
    REDES_NOTIFICATION: 'Notifica di errore sul sito web delle reception di red.es',
    SHIPMENT_NOTIFICATION: "Notifica all'acquirente dell'invio della fattura a destinazione ws"
  },
  configuration_table: {
    GENERATE_ACK: 'Ack file generation',
    GENERATE_ENVEST: 'Generazione del file di invio dello stato della fattura (ENVEST)',
    GENERATE_ENVRES: 'Generazione del file di invio della risposta in batch della fattura',
    GENERATE_ACK_EMAIL: 'Invio di e-mail con ack',
    GENERATE_ACK_ERROR_EMAIL: 'Invio di e-mail con errori ack',
    GENERATE_ACK_ERROR_EMAIL_WITHOUT_ATTACH: 'Invio di e-mail con errori ack senza allegati',
    GENERATE_ACK_EMAIL_WITHOUT_ATTACH: 'Invio del file ack senza allegati',
    GENERATE_PDF417: 'Generazione del codice per le fatture firmate',
    GET_CHANNEL: 'Ottenere il canale',
    MANUAL_SEND: 'Spedizione manuale di attività in sospeso',
    GENERATE_PARTY_REPORT: 'Invio di file aziendali alla digitalizzazione',
    SEND_ALL_INVOICES: 'Invio di tutte le fatture indipendentemente dallo stato',
    PENDING_INVOICES_XML_REPORT: 'Creazione di Report in XML con fatture in stato non definitivo',
    SEND_EMAIL_INVOICE_RECEIVED: 'Invio di un\'e-mail che indica che è stata ricevuta una nuova fattura',
    STATUS_RECADV_FILE: 'Generazione del file xml degli stati di ricezione',
    NO_INTEGRATE_REJECTED_INVOICE_EMISION: 'Fatture in uscita respinte non integrate e respinte',
    NO_INTEGRATE_DUPLICATED_INVOICE: 'Non integrare fatture duplicate',
    SET_SPONSOR: 'Quando si crea o si modifica una società di servizi, le verrà assegnato il ruolo di sponsor.',
    NEW_PARTY_CREATE_CENTRE: 'Creare il centro dell azienda anche se non vuole se stessa come sponsor',
    GENERATE_ORDRSP: "Generazione del file di risposta dell'ordine",
    GENERATE_B2B_STATUS: 'Generazione del file di stato della fattura',
    DELIVERY_INVOICE_TO_ISSUER: 'Consegna della fattura al emittente in base alla configurazione',
    STATUS_RETAINED_INVOICE: 'Non inviare fatture fino alla data di emissione',
    CHANGE_SIGNED_TO_OPENED: 'Modifica dello stato per aprire quando si consulta una fattura firmata, un PDF o un custodito',
    GENERATE_REPORT_ISSUED: "Report CSV delle fatture emesse aggiornato dall'ultima esecuzione",
    NO_DELIVER_INVOICE: 'Non inviare fatture registrate con metodo di consegna',
    STATUS_SIGNED_FROM_INVOICE_RECEIVED: 'Le fatture firmate e ricevute da Editrack (RVA) rimangono nello stato firmato',
    SET_EMISSION_NULL_IF_SPONSOR: 'Integrazione della fattura con flag di emissione nullo se entrambe le società sono sponsor',
    SET_EMISSION_NULL_IF_SPONSOR_AF: 'Integrazione della Autofattura con flag di emissione nullo se entrambe le società sono sponsor',
    PENDING_TASK_REJECT_VALIDATION: 'Convalida per il rifiuto delle attività in sospeso',
    PENDING_TASK_SEND_VALIDATION: 'Convalida per l\'invio di una fattura a sap da attività in sospeso',
    CREATE_USER_NO_SPONSOR_PARTY: "Creare un utente aziendale nella contrattazione dell'azienda non sponsor dall'integrazione della fattura",
    CREATE_USER_THIRD_PARTY: "Creare un utente di terze parti nel contratto della terza parte dall'integrazione della fattura",
    SEND_TO_THIRDPARTY: 'Processi invio fatture via email a terzi',
    INVOICE_RECADV_MISSING_ORDER_VALIDATION: 'Convalida dei dati dell\'ordine per la creazione di una fattura da una ricezione',
    HIDDEN_INVOICE_EXTENSION: "Elimina l'estensione nella vista bozze",
    NOT_SEND_INTEGRATION_NOTIFICATION: "La notifica di integrazione e lo stato del documento (RECADV e/o ORDINE) non vengono inviati.",
    ADD_COUNTRY_PARTY_TO_MANUAL_INVOICE: 'Aggiungi il paese ai NIF delle società dalla creazione manuale',
    SEND_EMAIL_WITH_COPY_TO_ORIGIN: "Invia una copia dell'e-mail per il tipo e-mail configurato all'origine configurata",
    UPDATE_FLAG_OTP_AUTHENTICATION: 'Attivare autenticazione OTP',
    APPROVAL_FLOW_BY_LEVELS_AND_USERS: 'Flusso di approvazione per livelli e utenti',
    SEE_ONLY_GENERAL_SIGN_DOCUMENT: 'Visualizza solo i documenti di firma delegata generale',
    GET_PERMANENT_ESTABLISHMENT: 'Visualizza solo i centri che sono organizzazioni permanenti',
    GET_TAXES_PROJECT: 'Visualizza le tasse associate al progetto',
    GET_TAXES_BUSINESS_RULE_REE: 'Visualizza le tasse in base alle regole aziendali per le tasse REE',
    GENERATE_TEXT_COLLECTION_ADDITIONAL_INFO: 'Testo fisso nelle informazioni aggiuntive sul metodo di pagamento nei bozze',
    INVOICE_INTEGRATION_NO_CERTIFICATE_VALIDATION: 'Le fatture contrattuali per l integrazione entrano senza passare attraverso la convalida dell ordine di certificazione',
    GENERATE_TEXT_WITHHOLDING_REASON: 'Testo fisso per motivi di trattenuta nelle bozze',
    DRAFT_CORRECTIVE_INVOICE_ONLY: 'Dalle bozze è possibile creare solo fatture correttive',
    DRAFT_INVOICE_DOCUMENT_FILTER: 'Tipi di documenti limitati a livello generale e a livello di linea in un progetto',
    INVOICE_REJECT_RELEASE_RECADV: 'Rilascia la certificazione in caso di rifiuto di una fattura',
    CREATE_DOCUMENT_RELATION: 'Crea una relazione tra documenti',
    INVOICE_STATUS_RECADV_INVOICED: 'Fattura dal ricevimento, stato fatturato in base al prezzo per quantità',
    CALCULATE_NEGATIVE_RETENTION: 'Le trattenute sulle fatture negative verranno aggiunte all\'importo totale eseguibile',
    RECADV_SUBTYPE_DEFAULT_GOODS: 'Nelle ricevute di merce in difetto nel caso in cui non venga informato nulla della tipologia ricevuta',
    HIDDEN_COMMUNICATION_METHOD: 'Rimuovi la visualizzazione dei metodi di spedizione nelle bozze',
    DRAFT_DOCUMENT_HEADER: 'Prendi i documenti a livello di intestazione dalle righe',
    INVOICE_INSTALLMENTS_DATERANGE: 'Data di scadenza (in mesi) per le bozze di progetto',
    GENERATE_INVOICE_INSTALLMENTS: 'Carica i dati di scadenza nei totali provvisori per impostazione predefinita',
    ATTACHMENTS_REPOSITORY: 'Allega i documenti del repository il cui nome soddisfa un certo modello',
    ATTACHMENTS_REPOSITORY_SUBDIRECTORY_DATE: 'Allega i documenti del repository il cui nome soddisfa un determinato modello contenuto nella sottodirectory data',
    CHANGE_OPERATION_PERIOD_DATES: 'Consente di modificare le date dell\'operazione e il periodo fiscale nelle bozze',
    NOTIFY_ERROR_TO_PROJECT_PARTY_EMAIL_CONTACT: "Oltre a notificare l'emittente, se appare sulla fattura, all'e-mail configurata nell'amministrazione dell'azienda nel servizio",
    DRAFT_NO_CHANGE_CURRENCY: 'Non modificare la valuta nelle bozze',
    ALLOWED_EMAIL_DOMAINS: 'Domini di posta elettronica consentiti',
    WITHHOLDINGAMOUNT_ABSOLUTE_TO_ACCOUNTING: 'Trattenute assolute per la contabilità',
    REQUIRED_FIELDS_FOR_FIRST_LEVEL_APPROVAL: 'Campi aggiuntivi per il primo livello di approvazione',
    VOCENTO_VALIDATION_WS: 'Personalizzato Vocento : Convalida dei dati aggiuntivi di Vocento',
    VOCENTO_CENTRE_VALIDATION_WS: 'Convalida centre sulle fatture Vocento da parte di WS',
    SHIPMENT_NOTIFICATION: "Notifica all'acquirente dell'invio della fattura a destinazione ws",
    UPDATE_ALL_STATUS_INVOICENOTE: 'Aggiornamento degli stati negativi tramite VAN',
    NO_INTEGRATE_DOCUMENT_ERROR: 'Non integrare il documento con stato di errore',
    CONFIGURATION_CONTROLDOCUMENT_SENDLINK: 'Per l\'invio automatico dei documenti di controllo',
    CONFIGURATION_BILLING_SPONSOR_REPORT: 'Aggiungere aziende sponsor al report di fatturazione',
    METADATA_FROM_PATH: 'Ottenere il file di metadati dal percorso e non rigenerarlo',
    REPLACE_NIF: 'Sostituire il NIF di origine con il NIF configurato',
	EXTERNAL_PDF: 'PDF esterno non generato da Ecosystems B2B'
  },
  recaptcha: {
    error: 'Devi selezionare la casella CAPTCHA',
    text: 'Hai effettuato diversi tentativi di accesso senza successo. Si prega di controllare il CAPTCHA per continuare'
  },
  mailServer: {
    new: 'Nuovo server di posta',
    notify: {
      add_mailServer: 'Server di posta creato con successo',
      delete_mailServer: 'Server di posta eliminato con successo.',
      save_changes: 'Server di posta aggiornato con successo'
    },
    confirm: {
      delete_mailServer: 'Sei sicuro di eliminare il server di posta?'
    },
    load: {
      add_mailServer: 'Aggiungo server di posta...',
      delete_mailServer: 'Eliminazione server di posta...'
    },
    mailServer_table: {
      host: 'Ospite',
      user: 'Utente',
      password: 'Password',
      mailfrom: 'Indirizzo email di origine',
      port: 'Porta',
      auth: 'Auth',
      protocol: 'Protocollo',
      idClient: 'ID Cliente',
      idTenant: 'ID dell\'organizzazione',
      clientSecret: 'Segreto del Cliente',
      validityDateTo: 'Data di validità dell\'accesso',
      saveToSentItems: 'Salva email inviate'
    },
    test_error: 'Impossibile stabilire la connessione al server di posta',
    test_ok: 'La connessione al server di posta è riuscita',
    auth_error: 'Si è verificato un errore di autenticazione',
    delete_mailServer: 'Elimina',
    delete_mailServer_tooltip: 'Elimina server di posta',
    test_tooltip: 'Verifica connessione',
    test: 'Verifica',
    duplicate_error: 'Esiste già un server di posta con questi dati',
    password_too_long: 'La password è troppo lunga. Si prega di utilizzare una password più corta',
    data_integrity_error: 'Errore di integrità dei dati durante il salvataggio del server di posta'
  },
  unit_of_measure: {
    title: 'Unità di misura',
    UND: 'Unità',
    HUR: 'Ore',
    KGM: 'Chilogrammi',
    LTR: 'Litri',
    OTR: 'Altri',
    BOX: 'Scatole',
    BDJ: 'Vassoi',
    BID: 'Batteria',
    BOL: 'Borse',
    BOM: 'Damigiane',
    BTL: 'Bottiglie',
    BOT: 'Barattolo',
    CLT: 'Centilitri',
    CMT: 'Centimetri',
    GAR: 'Caraffe',
    GRM: 'Grammi',
    KMT: 'Chilometri',
    MTR: 'Metri',
    MMT: 'Millimetri',
    PKG: 'Pacchi',
    ROL: 'Rotoli',
    SOB: 'Buste',
    MT3: 'Metro cubo',
    WAT: 'Watt',
    HOJ: 'Fogli',
    JUG: 'Giochi',
    CEN: 'Centinaia',
    PAR: 'Coppia',
    CAR: 'Bobina',
    NTB: 'Taccuino',
    MT2: 'Metro quadro',
    PCE: 'Parti',
    XCA: 'Casse',
    TNE: 'Tonnellate',
  }

}
